import Konva from 'konva';
import { empty, showNotification } from '../../utils';

const initialValues = {
    name: 'Stephen K. Chao',
    name1: '',
    name2: '',
    // credentials: 'MD',
    // title1: 'Assistant Professor',
    // title2: 'Medical Director',
    // title3: '',
    department1: '',
    department2: '',
    department3: '',
    phone: '',
    clinic: '',
    fax: '',
    pager: '',
    address: '',
    address2: '',
    address3: '',
    city: '',
    state: '',
    zip: '',
    // email: 'Stephen.K.Chao@uth.tmc.edu',
    showEmail: 1,
    open1: '',
    open2: '',
    open3: '',
    nameDivided: 0,
    // cell: '',
    showCell: 1,
    locationNames: [],
    locationPhones: [],
    locationFaxes: [],
    locationNursePhones: [],
    locationAddresses1: [],
    locationAddresses2: [],
    locationAddresses3: [],
    locationSuites: [],
    locationCities: [],
    locationStates: [],
    locationZips: [],
    locations: 0,
    templateCode: 'p1t1',
    color: 1,
    titles: [],
    personsNames: [],
    personsTitles: [],
    contact1Phone: '',
    contact1Type: '',
    contact2Phone: '',
    contact2Type: '',
    frontDividers: null,
    backDividers: null,

    // New UTH July 2022
    front: 1,
    back: 1,
    suiteRoom: '',
    firstName: '',
    middleName: '',
    lastName: '',
    credentials: '',
    primaryTitle: '',
    title1: '',
    title2: '',
    title3: '',
    secondaryTitle: '',
    title4: '',
    email: '',
    main: '',
    direct: '',
    cell: '',
    nursePhone: '',
    fontType: '',
    website: '',
    prevFront: '',
    prevBack: '',
    prevLogo: '',
    nameSize: 6,
    addressSize: 6,
    titlesSize: 6,
    yStep: 16,
    sectionStep: 10,
    phoneLabelSize: 6,
    phoneLabelX: 38,
    phoneLabelY: 2,
    addEnvelopes: 0,
    letterheadPersons: [],

    prescriptionPadDoctors: [],
    additionalField: 0,
    showSocialMediaIcons: 0,
    prevShowSocialMediaIcons: 0,
    phoneLabel1: 'Main',
    phoneLabel2: 'Direct',
    phoneLabel3: 'Cell',
    phoneOtherLabel1: '',
    phoneOtherLabel2: '',
    phoneOtherLabel3: '',

    user: null,
};
let canvasValues = initialValues;

let frontStage = null;
let frontBackgroundLayer = null;
let frontDataLayer = null;
let frontNameText = null;
let frontName1Text = null;
let frontName2Text = null;
let frontCredentialsText = null;
let frontTitle1Text = null;
let frontTitle2Text = null;
let frontTitle3Text = null;
let frontDepartment1Text = null;
let frontDepartment2Text = null;
let frontDepartment3Text = null;
let frontPhoneText = null;
let frontPhoneSuffixText = null;
let frontPhoneType = null;
let frontClinicText = null;
let frontClinicType = null;
let frontFaxText = null;
let frontFaxSuffixText = null;
let frontFaxType = null;
let frontAddress1Text = null;
let frontAddress2Text = null;
let frontAddress3Text = null;
let frontAddressDividerText = null;
let frontLocationText = null;
let frontEmailText = null;
let frontCellText = null;
let frontCellSuffixText = null;
let frontNursePhoneText = null;
let frontOpen1Text = null;
let frontWebsiteText = null;
let frontPText = null;
let frontFText = null;
let frontLocationNames = [];
let frontLocationPhones = [];
let frontLocationFaxes = [];
let frontLocationAddresses1 = [];
let frontLocationAddresses2 = [];
let frontLocationStateAddresses = [];
let frontPTexts = [];
let frontFTexts = [];
let frontLogo1Img = null;
let frontLogo2Img = null;
let frontLogo3Img = null;
let frontBackgroundRect = null;
let frontNames = [];
let frontTitles = [];
let frontTitles2 = [];
let frontSuiteRoomText = null;
let frontLine1 = null;
let frontLine2 = null;
let frontLine3 = null;
let frontLine4 = null;
let mainPhoneText = null;
let mainDaysText = null;
let mainDividerText = null;
let mainHoursText = null;
let frontDivider1Text = null;
let frontDivider2Text = null;

let backStage = null;
let backBackgroundLayer = null;
let backDataLayer = null;
let backNameText = null;
let backTitle1Text = null;
let backTitle2Text = null;
let backTitle3Text = null;
let backDepartment2Text = null;
let backDepartment3Text = null;
let backPhoneText = null;
let backPagerText = null;
let backClinicText = null;
let backFaxText = null;
let backEmailText = null;
let backOpen1Text = null;
let backOpen2Text = null;
let backOpen3Text = null;
let backCellText = null;
let backLocationNames = [];
let backLocationAddresses1 = [];
let backLocationAddresses2 = [];
let backLocationAddresses3 = [];
let backLocationStateAddresses = [];
let backLocationPhones = [];
let backLocationFaxes = [];
let backLocationNursePhones = [];
let backLocationDividers = [];
let backLogoImage = null;
let backPrimaryTitleText = null;
let backSecondaryTitleText = null;
let backTitle4Text = null;
let backMainText = null;
let backDirectText = null;
let backWebsiteText = null;
let backMainSuffixText = null;
let backDirectSuffixText = null;
let backCellSuffixText = null;
let backLogo1Img = null;

let AGaramondProItalicLoaded = false;
let AGaramondProRegularLoaded = false;
let AGaramondProSemiboldLoaded = false;
let AriblkLoaded = false;
let RobotoLoaded = false;
let RobotoCondensedLoaded = false;
let UniversLTStdLoaded = false;
let UniversLTStdBlackLoaded = false;
let AGaramondProSemiboldItalicLoaded = false;
let EBGaramondLoaded = false;
let UniversLTStdOblLoaded = false;
let LinotypeUniversLTStdLightLoaded = false;
let AGaramondProBoldLoaded = false;
let fontsTries = 0;
let nameLimit = 270;
let prevTitlesSize = 6;

let scale = 1.5;
let canvasWidth = 0;
let canvasHeight = 0;

export const setTemplateCodeCanvas = (code) => {
    canvasValues.templateCode = code;
}

export const checkFontsLoaded = () => {
    fontsTries++;
    if (fontsTries >= 25) {
        return true;
    }

    if (document.fonts.check('1rem AGaramondProItalic')) {
        AGaramondProItalicLoaded = true;
    }
    if (document.fonts.check('1rem AGaramondProRegular')) {
        AGaramondProRegularLoaded = true;
    }
    if (document.fonts.check('1rem Ariblk')) {
        AriblkLoaded = true;
    }
    if (document.fonts.check('1rem AGaramondProSemibold')) {
        AGaramondProSemiboldLoaded = true;
    }
    if (document.fonts.check('1rem Roboto')) {
        RobotoLoaded = true;
    }
    if (document.fonts.check('1rem "Roboto Condensed"')) {
        RobotoCondensedLoaded = true;
    }
    if (document.fonts.check('1rem "UniversLTStd"')) {
        UniversLTStdLoaded = true;
    }
    if (document.fonts.check('1rem "UniversLTStdBlack"')) {
        UniversLTStdBlackLoaded = true;
    }
    if (document.fonts.check('1rem "AGaramondProSemiboldItalic"')) {
        AGaramondProSemiboldItalicLoaded = true;
    }
    if (document.fonts.check('1rem "EB Garamond"')) {
        EBGaramondLoaded = true;
    }
    if (document.fonts.check('1rem "UniversLTStdObl"')) {
        UniversLTStdOblLoaded = true;
    }
    if (document.fonts.check('1rem "LinotypeUniversLTStd"')) {
        LinotypeUniversLTStdLightLoaded = true;
    }
    if (document.fonts.check('1rem "AGaramondProBold"')) {
        AGaramondProBoldLoaded = true;
    }

    return AGaramondProItalicLoaded
        && AGaramondProRegularLoaded
        && AriblkLoaded
        && AGaramondProSemiboldLoaded
        && RobotoLoaded
        && RobotoCondensedLoaded
        && UniversLTStdLoaded
        && UniversLTStdBlackLoaded
        && AGaramondProSemiboldItalicLoaded
        && EBGaramondLoaded
        && UniversLTStdOblLoaded
        && LinotypeUniversLTStdLightLoaded
        && AGaramondProBoldLoaded;
}

export const initTemplateCode = (code) => {
    canvasValues.templateCode = code;
}

export const initCanvas = () => {
    if (!checkFontsLoaded()) {
        setTimeout(() => {
            initCanvas();
        }, 100);
        return;
    }

    cleanCanvas();

    canvasValues.front = 1;
    canvasValues.back = 1;
    canvasValues.prevFront = '';
    canvasValues.prevBack = '';
    canvasValues.prevLogo = '';

    initFrontCanvas();
    initBackCanvas();
}

export const initFrontCanvas = () => {
    if (['p1t1', 'p1t2', 'p1t3', 'p1t4', 'p1t5', 'p1t6', 'p1t7', 'p1t8', 'p1t9', 'p1t11', 'p1t13', 'p1t14', 'p1t15', 'p1t16'].includes(canvasValues.templateCode)) {
        scale = 1.5;
        canvasWidth = 350;
        canvasHeight = 200;
    } else if (['p2t1', 'p2t3'].includes(canvasValues.templateCode)) {
        scale = 0.7;
        canvasWidth = 850;
        canvasHeight = 1100;
    } else if (['p10t1', 'p10t2', 'p10t3', 'p10t4', 'p10t5', 'p10t6', 'p10t7', 'p10t8', 'p10t9', 'p10t10'].includes(canvasValues.templateCode)) {
        scale = 0.85;
        canvasWidth = 850;
        canvasHeight = 1100;
    } else if (['p3t1', 'p3t3', 'p3t4', 'p3t6', 'p11t1', 'p11t2', 'p11t3', 'p11t4', 'p11t5', 'p11t6', 'p11t7', 'p11t22', 'p11t23', 'p11t25'].includes(canvasValues.templateCode)) {
        scale = 0.8;
        canvasWidth = 950;
        canvasHeight = 412.5;
    } else if (['p11t24'].includes(canvasValues.templateCode)) {
        scale = 1.05;
        canvasWidth = 650;
        canvasHeight = 475;
    } else if (['p12t1', 'p12t2', 'p12t3', 'p12t4', 'p12t5', 'p12t6', 'p12t7', 'p12t8', 'p12t9', 'p12t10'].includes(canvasValues.templateCode)) {
        scale = 0.78;
        canvasWidth = 650;
        canvasHeight = 475;
    } else if (['p3t2', 'p3t5'].includes(canvasValues.templateCode)) {
        scale = 1.05;
        canvasWidth = 650;
        canvasHeight = 475;
    } else if (['p4t1'].includes(canvasValues.templateCode)) {
        scale = 0.9;
        canvasWidth = 600;
        canvasHeight = 950;
    } else if (['p9t1', 'p9t2', 'p9t3', 'p9t4', 'p9t5', 'p9t6', 'p9t7', 'p9t8', 'p9t9', 'p9t10', 'p9t11', 'p9t12', 'p9t13', 'p9t14', 
        'p9t15', 'p9t16', 'p9t17', 'p9t18', 'p9t19', 'p9t20', 'p9t21', 'p9t22', 'p9t23'].includes(canvasValues.templateCode)) {
        scale = 1.5;
        canvasWidth = 350;
        canvasHeight = 200;
    } else if (['p11t8', 'p11t9', 'p11t10', 'p11t11', 'p11t12', 'p11t13', 'p11t14'].includes(canvasValues.templateCode)) {
        scale = 0.7;
        canvasWidth = 950;
        canvasHeight = 600;
    } else if (['p11t15', 'p11t16', 'p11t17', 'p11t18', 'p11t19', 'p11t20', 'p11t21'].includes(canvasValues.templateCode)) {
        scale = 0.9;
        canvasWidth = 650;
        canvasHeight = 475;
    } else if (['p18t2'].includes(canvasValues.templateCode)) {
        scale = 1.1;
        canvasWidth = 550;
        canvasHeight = 425;
    } else if (['p18t3'].includes(canvasValues.templateCode)) {
        scale = 1.2;
        canvasWidth = 400;
        canvasHeight = 550;
    } else if (['p20t1', 'p20t2', 'p20t3', 'p20t4', 'p20t5', 'p20t6', 'p20t7', 'p20t8', 'p20t9'].includes(canvasValues.templateCode)) {
        scale = 1.5;
        canvasWidth = 350;
        canvasHeight = 600;
    } else if (['p21t1'].includes(canvasValues.templateCode)) {
        scale = 0.8;
        canvasWidth = 900;
        canvasHeight = 1200;
    } else if (['p21t2'].includes(canvasValues.templateCode)) {
        scale = 0.75;
        canvasWidth = 1000;
        canvasHeight = 1300;
    }

    frontStage = new Konva.Stage({
        container: 'front-canvas',
        width: canvasWidth * scale,
        height: canvasHeight * scale
    });

    frontBackgroundLayer = new Konva.Layer();
    frontStage.add(frontBackgroundLayer);

    frontDataLayer = new Konva.Layer();
    frontDataLayer.moveUp();
    frontStage.add(frontDataLayer);

    let rect = new Konva.Rect({
        x: 0 * scale,
        y: 0 * scale,
        width: canvasWidth * scale,
        height: canvasHeight * scale,
        fill: '#ffffff',
    });
    frontBackgroundLayer.add(rect);

    if (canvasValues.templateCode === 'p1t1' || canvasValues.templateCode === 'p1t2') {
        // initP1T1FrontCanvas();
    } else if (canvasValues.templateCode === 'p1t3') {
        // initP1T3FrontCanvas();
    } else if (canvasValues.templateCode === 'p1t4') {
        // initP1T4FrontCanvas();
    } else if (canvasValues.templateCode === 'p1t5') {
        // initP1T5FrontCanvas();
    } else if (canvasValues.templateCode === 'p1t6') {
        // initP1T6FrontCanvas();
    } else if (canvasValues.templateCode === 'p1t7') {
        // initP1T7FrontCanvas();
    } else if (canvasValues.templateCode === 'p1t8') {
        initP1T8FrontCanvas();
    } else if (canvasValues.templateCode === 'p1t9') {
        initP1T9FrontCanvas();
    } else if (canvasValues.templateCode === 'p1t11') {
        initP1T11FrontCanvas();
    } else if (canvasValues.templateCode === 'p1t13') {
        initP1T13FrontCanvas();
    } else if (canvasValues.templateCode === 'p1t14') {
        initP1T14FrontCanvas();
    } else if (canvasValues.templateCode === 'p1t15') {
        initP1T15FrontCanvas();
    } else if (canvasValues.templateCode === 'p1t16') {
        initP1T16FrontCanvas();
    } else if (canvasValues.templateCode === 'p2t1') {
        initP2T1FrontCanvas();
    } else if (canvasValues.templateCode === 'p2t3') {
        initP2T3FrontCanvas();
    } else if (canvasValues.templateCode === 'p3t1') {
        initP3T1FrontCanvas();
    } else if (canvasValues.templateCode === 'p3t2') {
        initP3T2FrontCanvas();
    } else if (canvasValues.templateCode === 'p3t3') {
        initP3T3FrontCanvas();
    } else if (canvasValues.templateCode === 'p3t4') {
        initP3T4FrontCanvas();
    } else if (canvasValues.templateCode === 'p3t5') {
        initP3T5FrontCanvas();
    } else if (canvasValues.templateCode === 'p3t6') {
        initP3T6FrontCanvas();
    } else if (canvasValues.templateCode === 'p4t1') {
        // initP4T1FrontCanvas();
    } else if (['p9t1', 'p9t2', 'p9t3', 'p9t4', 'p9t5', 'p9t6', 'p9t7', 'p9t8', 'p9t9', 'p9t10'].includes(canvasValues.templateCode)) {
        initP9FrontCanvas();
    } else if (canvasValues.templateCode === 'p9t11') {
        initP9T11FrontCanvas();
    } else if (canvasValues.templateCode === 'p9t12') {
        initP9T12FrontCanvas();
    } else if (canvasValues.templateCode === 'p9t13') {
        initP9T13FrontCanvas();
    } else if (canvasValues.templateCode === 'p9t14') {
        initP9T14FrontCanvas();
    } else if (canvasValues.templateCode === 'p9t15') {
        initP9T15FrontCanvas();
    } else if (canvasValues.templateCode === 'p9t16') {
        initP9T16FrontCanvas();
    } else if (canvasValues.templateCode === 'p9t17') {
        initP9T17FrontCanvas();
    } else if (canvasValues.templateCode === 'p9t18') {
        initP9T18FrontCanvas();
    } else if (canvasValues.templateCode === 'p9t19') {
        initP9T19FrontCanvas();
    } else if (canvasValues.templateCode === 'p9t20') {
        initP9T20FrontCanvas();
    } else if (canvasValues.templateCode === 'p9t21') {
        initP9T21FrontCanvas();
    } else if (canvasValues.templateCode === 'p9t22') {
        initP9T22FrontCanvas();
    } else if (canvasValues.templateCode === 'p9t23') {
        initP9T23FrontCanvas();
    } else if (['p10t1', 'p10t2', 'p10t4', 'p10t5', 'p10t6', 'p10t7'].includes(canvasValues.templateCode)) {
        initP10FrontCanvas();
    } else if (canvasValues.templateCode === 'p10t8') {
        initP10T8FrontCanvas();
    } else if (canvasValues.templateCode === 'p10t9') {
        initP10T9FrontCanvas();
    } else if (canvasValues.templateCode === 'p10t10') {
        initP10T10FrontCanvas();
    } else if (['p10t3'].includes(canvasValues.templateCode)) {
        initP10T3FrontCanvas();
    } else if (['p11t1', 'p11t2', 'p11t3', 'p11t4', 'p11t5', 'p11t6', 'p11t7'].includes(canvasValues.templateCode)) {
        initP11No10FrontCanvas();
    } else if (canvasValues.templateCode === 'p11t22') {
        initP11T22FrontCanvas();
    } else if (canvasValues.templateCode === 'p11t23') {
        initP11T23FrontCanvas();
    } else if (canvasValues.templateCode === 'p11t24') {
        initP11T24FrontCanvas();
    } else if (canvasValues.templateCode === 'p11t25') {
        initP11T25FrontCanvas();
    } else if (['p11t8', 'p11t9', 'p11t10', 'p11t11', 'p11t12', 'p11t13', 'p11t14'].includes(canvasValues.templateCode)) {
        initP11A10FrontCanvas();
    } else if (['p11t15', 'p11t16', 'p11t17', 'p11t18', 'p11t19', 'p11t20', 'p11t21'].includes(canvasValues.templateCode)) {
        initP11A6FrontCanvas();
    } else if (['p12t7'].includes(canvasValues.templateCode)) {
        initP12T7FrontCanvas();
    } else if (['p12t8'].includes(canvasValues.templateCode)) {
        initP12T8FrontCanvas();
    } else if (['p12t9'].includes(canvasValues.templateCode)) {
        initP12T9FrontCanvas();
    } else if (['p12t10'].includes(canvasValues.templateCode)) {
        initP12T10FrontCanvas();
    } else if (['p18t2'].includes(canvasValues.templateCode)) {
        initP18T2FrontCanvas();
    } else if (['p18t3'].includes(canvasValues.templateCode)) {
        initP18T3FrontCanvas();
    } else if (['p20t1', 'p20t2', 'p20t3', 'p20t4', 'p20t5', 'p20t6'].includes(canvasValues.templateCode)) {
        initP20FrontCanvas();
    } else if (canvasValues.templateCode === 'p20t7') {
        initP20T7FrontCanvas();
    } else if (canvasValues.templateCode === 'p20t8') {
        initP20T8FrontCanvas();
    } else if (canvasValues.templateCode === 'p20t9') {
        initP20T9FrontCanvas();
    } else if (canvasValues.templateCode === 'p21t1') {
        initP21T1FrontCanvas();
    } else if (canvasValues.templateCode === 'p21t2') {
        initP21T2FrontCanvas();
    }

    frontBackgroundLayer.batchDraw();
    frontDataLayer.batchDraw();
}

export const initP1T1FrontCanvas = () => {
    /* ------------ Start ----------------- */
    if (canvasValues.templateCode === 'p1t1') {
        Konva.Image.fromURL(require('./images/mcgovern-logo.svg'), (image) => {
            if (frontLogo1Img != null) {
                frontLogo1Img.destroy();
            }
            frontLogo1Img = image;

            frontDataLayer.add(image);
            image.setAttrs({
                x: (30 - 12.5) * scale,
                y: (30 - 12.5) * scale,
                width: 110 * scale,
                height: 133 * scale,
            });
            frontDataLayer.draw();
        });
    } else if (canvasValues.templateCode === 'p1t2') {
        Konva.Image.fromURL(require('./images/cizik-logo.svg'), (image) => {
            if (frontLogo1Img != null) {
                frontLogo1Img.destroy();
            }
            frontLogo1Img = image;

            frontDataLayer.add(image);
            image.setAttrs({
                x: (25 - 12.5) * scale,
                y: (25 - 12.5) * scale,
                width: 110 * scale * 1.15,
                height: 133 * scale * 1.15,
            });
            frontDataLayer.draw();
        });
    }
    /* ------------- End ------------------ */

    /* ------------ Start ----------------- */
    frontNameText = new Konva.Text({
        text: getFullName(),
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: (166 - 12.5) * scale,
        y: (32 - 12.5) * scale,
        fill: '#53565A',
    });
    frontDataLayer.add(frontNameText);

    let credentials = null;
    let y = null;
    if (frontNameText.width() > nameLimit) {
        frontNameText.text(canvasValues.name);
        credentials = canvasValues.credentials;

        if (credentials !== '') {
            y = 60;
        } else {
            y = 47;
        }

        canvasValues.nameDivided = 1;
    } else {
        credentials = '';
        y = 47;
        canvasValues.nameDivided = 0;
    }

    frontCredentialsText = new Konva.Text({
        text: credentials,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'AGaramondProRegular',
        x: (166 - 12.5) * scale,
        y: (47 - 12.5) * scale,
        fill: '#53565A',
    });
    frontDataLayer.add(frontCredentialsText);

    frontTitle1Text = new Konva.Text({
        text: canvasValues.title1,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'AGaramondProItalic',
        x: (166 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#53565A',
    });
    frontDataLayer.add(frontTitle1Text);
    /* ------------- End ------------------ */

    /* ------------ Start ----------------- */
    y = canvasValues.templateCode === 'p1t1' ? 100 : 90;
    frontDepartment1Text = new Konva.Text({
        text: canvasValues.department1,
        fontSize: convertPointsToPixels(6) * scale,
        fontFamily: 'Ariblk',
        x: (166 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#BE531C',
    });
    frontDataLayer.add(frontDepartment1Text);

    y += 12;
    frontDepartment2Text = new Konva.Text({
        text: canvasValues.department2,
        fontSize: convertPointsToPixels(6) * scale,
        fontFamily: 'Ariblk',
        x: (166 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#BE531C',
    });
    frontDataLayer.add(frontDepartment2Text);
    /* ------------- End ------------------ */

    /* ------------ Start ----------------- */
    y = canvasValues.templateCode === 'p1t1' ? 145 : 135;
    frontPhoneText = new Konva.Text({
        text: canvasValues.phone,
        fontSize: convertPointsToPixels(7.5) * scale,
        fontFamily: 'AGaramondProRegular',
        x: (166 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#53565A',
    });
    frontDataLayer.add(frontPhoneText);

    y += 12;
    frontAddress1Text = new Konva.Text({
        text: canvasValues.address,
        fontSize: convertPointsToPixels(7.5) * scale,
        fontFamily: 'AGaramondProRegular',
        x: (166 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#53565A',
    });
    frontDataLayer.add(frontAddress1Text);

    y += 12;
    frontLocationText = new Konva.Text({
        text: canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip,
        fontSize: convertPointsToPixels(7.5) * scale,
        fontFamily: 'AGaramondProRegular',
        x: (166 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#53565A',
    });
    frontDataLayer.add(frontLocationText);

    let frontEmail = canvasValues.email;
    if (parseInt(canvasValues.showEmail) === 1) {
        frontEmail = '';
    }

    y += 12;
    frontEmailText = new Konva.Text({
        text: frontEmail,
        fontSize: convertPointsToPixels(7.5) * scale,
        fontFamily: 'AGaramondProRegular',
        x: (166 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#53565A',
    });
    frontDataLayer.add(frontEmailText);

    if (canvasValues.templateCode === 'p1t2') {
        if (parseInt(canvasValues.showEmail) === 1) {
            y -= 12;
        }

        let cell = '';
        if (canvasValues.cell !== '' && parseInt(canvasValues.showCell) !== 1) {
            cell = canvasValues.cell + '   Cell';
        }

        y += 12;
        frontCellText = new Konva.Text({
            text: cell,
            fontSize: convertPointsToPixels(7.5) * scale,
            fontFamily: 'AGaramondProRegular',
            x: (166 - 12.5) * scale,
            y: (y - 12.5) * scale,
            fill: '#53565A',
        });
        frontDataLayer.add(frontCellText);
    }
    /* ------------- End ------------------ */
}

export const initP1T3FrontCanvas = () => {
    /* ------------ Start ----------------- */
    Konva.Image.fromURL(require('./images/physicians-logo.svg'), (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontDataLayer.add(image);
        image.setAttrs({
            x: (16 - 12.5) * scale,
            y: (18 - 12.5) * scale,
            width: 53 * 3.4 * scale,
            height: 15 * 3.4 * scale,
        });
        frontDataLayer.draw();
    });
    /* ------------- End ------------------ */

    /* ------------ Start ----------------- */
    frontDepartment1Text = new Konva.Text({
        text: canvasValues.department1,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: (33 - 12.5) * scale,
        y: (60 - 12.5) * scale,
        fill: '#BE531C',
    });
    frontDataLayer.add(frontDepartment1Text);

    frontNameText = new Konva.Text({
        text: getFullName(),
        fontSize: convertPointsToPixels(9.5) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: (33 - 12.5) * scale,
        y: (85 - 12.5) * scale,
        fill: '#BE531C',
    });
    frontDataLayer.add(frontNameText);

    frontTitle1Text = new Konva.Text({
        text: canvasValues.title1,
        fontSize: convertPointsToPixels(8.5) * scale,
        fontFamily: 'AGaramondProItalic',
        x: (33 - 12.5) * scale,
        y: (99 - 12.5) * scale,
        fill: '#53565A',
    });
    frontDataLayer.add(frontTitle1Text);
    /* ------------- End ------------------ */

    /* ------------ Start ----------------- */
    frontAddress1Text = new Konva.Text({
        text: canvasValues.address,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'AGaramondProRegular',
        x: (33 - 12.5) * scale,
        y: (133 - 12.5) * scale,
        fill: '#53565A',
    });
    frontDataLayer.add(frontAddress1Text);

    frontLocationText = new Konva.Text({
        text: canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'AGaramondProRegular',
        x: (33 - 12.5) * scale,
        y: (147 - 12.5) * scale,
        fill: '#53565A',
    });
    frontDataLayer.add(frontLocationText);

    frontEmailText = new Konva.Text({
        text: canvasValues.email,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'AGaramondProRegular',
        x: (33 - 12.5) * scale,
        y: (184 - 12.5) * scale,
        fill: '#53565A',
    });
    frontDataLayer.add(frontEmailText);
    /* ------------- End ------------------ */

    /* ------------ Start ----------------- */
    frontPhoneText = new Konva.Text({
        text: canvasValues.phone,
        fontSize: convertPointsToPixels(8.5) * scale,
        fontFamily: 'AGaramondProRegular',
        x: (245 - 12.5) * scale,
        y: (133 - 12.5) * scale,
        fill: '#BE531C',
    });
    frontDataLayer.add(frontPhoneText);

    frontPhoneType = new Konva.Text({
        text: 'main',
        fontSize: convertPointsToPixels(8.5) * scale,
        fontFamily: 'AGaramondProItalic',
        x: (320 - 12.5) * scale,
        y: (133 - 12.5) * scale,
        fill: '#BE531C',
    });
    frontDataLayer.add(frontPhoneType);

    frontClinicText = new Konva.Text({
        text: canvasValues.clinic,
        fontSize: convertPointsToPixels(8.5) * scale,
        fontFamily: 'AGaramondProRegular',
        x: (245 - 12.5) * scale,
        y: (147 - 12.5) * scale,
        fill: '#BE531C',
    });
    frontDataLayer.add(frontClinicText);

    frontClinicType = new Konva.Text({
        text: 'direct',
        fontSize: convertPointsToPixels(8.5) * scale,
        fontFamily: 'AGaramondProItalic',
        x: (320 - 12.5) * scale,
        y: (147 - 12.5) * scale,
        fill: '#BE531C',
    });
    frontDataLayer.add(frontClinicType);

    if (!isEmpty(canvasValues.fax)) {
        frontFaxText = new Konva.Text({
            text: canvasValues.fax,
            fontSize: convertPointsToPixels(8.5) * scale,
            fontFamily: 'AGaramondProRegular',
            x: (245 - 12.5) * scale,
            y: (161 - 12.5) * scale,
            fill: '#BE531C',
        });
        frontDataLayer.add(frontFaxText);

        frontFaxType = new Konva.Text({
            text: 'fax',
            fontSize: convertPointsToPixels(8.5) * scale,
            fontFamily: 'AGaramondProItalic',
            x: (320 - 12.5) * scale,
            y: (161 - 12.5) * scale,
            fill: '#BE531C',
        });
        frontDataLayer.add(frontFaxType);
    }

    frontOpen1Text = new Konva.Text({
        text: canvasValues.open1,
        fontSize: convertPointsToPixels(8.5) * scale,
        fontFamily: 'AGaramondProRegular',
        x: (245 - 12.5) * scale,
        y: (184 - 12.5) * scale,
        fill: '#53565A',
    });
    frontDataLayer.add(frontOpen1Text);
    /* ------------- End ------------------ */
}

export const initP1T4FrontCanvas = () => {
    /* ------------ Start ----------------- */
    Konva.Image.fromURL(require('./images/memorial-heart-logo.svg'), (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontDataLayer.add(image);
        image.setAttrs({
            x: (200 - 12.5) * scale,
            y: (28 - 12.5) * scale,
            width: 408 * 0.38 * scale,
            height: 258 * 0.38 * scale,
        });
        frontDataLayer.draw();
    });

    Konva.Image.fromURL(require('./images/uthealth-mcgovern-logo.svg'), (image) => {
        if (frontLogo2Img != null) {
            frontLogo2Img.destroy();
        }
        frontLogo2Img = image;

        frontDataLayer.add(image);
        image.setAttrs({
            x: (190 - 12.5) * scale,
            y: (110 - 12.5) * scale,
            width: 408 * 0.4 * scale,
            height: 258 * 0.4 * scale,
        });
        frontDataLayer.draw();
    });
    /* ------------- End ------------------ */

    drawFrontVariablesP1T4();
}

export const drawFrontVariablesP1T4 = () => {
    /* ------------ Start ----------------- */
    let y = 34;
    frontNameText = new Konva.Text({
        text: getFullName(),
        fontSize: convertPointsToPixels(8.5) * scale,
        fontFamily: 'Roboto Condensed',
        fontStyle: 'bold',
        x: (33 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontNameText);

    y += 16;
    frontTitle1Text = new Konva.Text({
        text: canvasValues.title1,
        fontSize: convertPointsToPixels(7.5) * scale,
        fontFamily: 'Roboto Condensed',
        x: (33 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontTitle1Text);

    y += 14;
    frontDepartment1Text = new Konva.Text({
        text: canvasValues.department1,
        fontSize: convertPointsToPixels(7.5) * scale,
        fontFamily: 'Roboto Condensed',
        x: (33 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontDepartment1Text);

    y += 14;
    frontDepartment2Text = new Konva.Text({
        text: canvasValues.department2,
        fontSize: convertPointsToPixels(7.5) * scale,
        fontFamily: 'Roboto Condensed',
        x: (33 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontDepartment2Text);
    /* ------------- End ------------------ */

    /* ------------ Start ----------------- */
    y = 120;
    frontAddress1Text = new Konva.Text({
        text: canvasValues.address,
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'Roboto Condensed',
        x: (33 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontAddress1Text);

    if (!isEmpty(canvasValues.address2)) {
        y += 12;
        frontAddress2Text = new Konva.Text({
            text: canvasValues.address2,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'Roboto Condensed',
            x: (33 - 12.5) * scale,
            y: (y - 12.5) * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontAddress2Text);
    }

    if (!isEmpty(canvasValues.address3)) {
        y += 12;
        frontAddress3Text = new Konva.Text({
            text: canvasValues.address3,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'Roboto Condensed',
            x: (33 - 12.5) * scale,
            y: (y - 12.5) * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontAddress3Text);
    }

    y += 12;
    frontLocationText = new Konva.Text({
        text: canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip,
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'Roboto Condensed',
        x: (33 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontLocationText);

    if (!isEmpty(canvasValues.phone)) {
        y += 12;
        frontPText = new Konva.Text({
            text: 'P',
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'Roboto Condensed',
            fontStyle: 'bold',
            x: (33 - 12.5) * scale,
            y: (y - 12.5) * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontPText);

        frontPhoneText = new Konva.Text({
            text: canvasValues.phone,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'Roboto Condensed',
            x: (40 - 12.5) * scale,
            y: (y - 12.5) * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontPhoneText);
    }

    if (!isEmpty(canvasValues.fax)) {
        y += 12;
        frontFText = new Konva.Text({
            text: 'F',
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'Roboto Condensed',
            fontStyle: 'bold',
            x: (33 - 12.5) * scale,
            y: (y - 12.5) * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontFText);

        frontFaxText = new Konva.Text({
            text: canvasValues.fax,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'Roboto Condensed',
            x: (40 - 12.5) * scale,
            y: (y - 12.5) * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontFaxText);
    }
    /* ------------- End ------------------ */
}

export const destroyFrontVariablesP1T4 = () => {
    if (frontNameText) {
        frontNameText.destroy();
    }
    if (frontTitle1Text) {
        frontTitle1Text.destroy();
    }
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (frontAddress3Text) {
        frontAddress3Text.destroy();
    }
    if (frontLocationText) {
        frontLocationText.destroy();
    }
    if (frontPText) {
        frontPText.destroy();
    }
    if (frontPhoneText) {
        frontPhoneText.destroy();
    }
    if (frontFText) {
        frontFText.destroy();
    }
    if (frontFaxText) {
        frontFaxText.destroy();
    }
}

export const initP1T5FrontCanvas = () => {
    /* ------------ Start ----------------- */
    Konva.Image.fromURL(require('./images/memorial-heart-texas-logo.svg'), (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontDataLayer.add(image);
        image.setAttrs({
            x: (200 - 12.5) * scale,
            y: (32 - 12.5) * scale,
            width: 408 * 0.38 * scale,
            height: 258 * 0.38 * scale,
        });
        frontDataLayer.draw();
    });

    Konva.Image.fromURL(require('./images/uthealth-mcgovern-logo.svg'), (image) => {
        if (frontLogo2Img != null) {
            frontLogo2Img.destroy();
        }
        frontLogo2Img = image;

        frontDataLayer.add(image);
        image.setAttrs({
            x: (190 - 12.5) * scale,
            y: (100 - 12.5) * scale,
            width: 408 * 0.4 * scale,
            height: 258 * 0.4 * scale,
        });
        frontDataLayer.draw();
    });
    /* ------------- End ------------------ */

    drawFrontVariablesP1T5();
}

export const drawFrontVariablesP1T5 = () => {
    /* ------------ Start ----------------- */
    let y = 32;
    frontNameText = new Konva.Text({
        text: getFullName(),
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'Roboto Condensed',
        fontStyle: 'bold',
        x: (33 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontNameText);

    y += 12;
    frontTitle1Text = new Konva.Text({
        text: canvasValues.department1,
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'Roboto Condensed',
        x: (33 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontTitle1Text);

    y += 12;
    frontDepartment1Text = new Konva.Text({
        text: canvasValues.title1,
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'Roboto Condensed',
        x: (33 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontDepartment1Text);

    y += 12;
    frontDepartment2Text = new Konva.Text({
        text: canvasValues.department2,
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'Roboto Condensed',
        x: (33 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontDepartment2Text);

    y += 12;
    frontDepartment3Text = new Konva.Text({
        text: canvasValues.department3,
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'Roboto Condensed',
        x: (33 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontDepartment3Text);
    /* ------------- End ------------------ */

    /* ------------ Start ----------------- */
    y = 98;
    for (let i = 0; i < 3; i++) {
        frontLocationNames[i] = new Konva.Text({
            text: canvasValues.locationNames[i],
            fontSize: convertPointsToPixels(6.5) * scale,
            fontFamily: 'Roboto Condensed',
            x: (33 - 12.5) * scale,
            y: (y - 12.5) * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontLocationNames[i]);

        if (!isEmpty(canvasValues.locationPhones[i])) {
            y += 10;
            frontPTexts[i] = new Konva.Text({
                text: 'P',
                fontSize: convertPointsToPixels(6.5) * scale,
                fontFamily: 'Roboto Condensed',
                fontStyle: 'bold',
                x: (33 - 12.5) * scale,
                y: (y - 12.5) * scale,
                fill: '#000',
            });
            frontDataLayer.add(frontPTexts[i]);

            frontLocationPhones[i] = new Konva.Text({
                text: canvasValues.locationPhones[i],
                fontSize: convertPointsToPixels(6.5) * scale,
                fontFamily: 'Roboto Condensed',
                x: (40 - 12.5) * scale,
                y: (y - 12.5) * scale,
                fill: '#000',
            });
            frontDataLayer.add(frontLocationPhones[i]);
        }

        if (!isEmpty(canvasValues.locationFaxes[i])) {
            y += 10;
            frontFTexts[i] = new Konva.Text({
                text: 'F',
                fontSize: convertPointsToPixels(6.5) * scale,
                fontFamily: 'Roboto Condensed',
                fontStyle: 'bold',
                x: (33 - 12.5) * scale,
                y: (y - 12.5) * scale,
                fill: '#000',
            });
            frontDataLayer.add(frontFTexts[i]);

            frontLocationFaxes[i] = new Konva.Text({
                text: canvasValues.locationFaxes[i],
                fontSize: convertPointsToPixels(6.5) * scale,
                fontFamily: 'Roboto Condensed',
                x: (40 - 12.5) * scale,
                y: (y - 12.5) * scale,
                fill: '#000',
            });
            frontDataLayer.add(frontLocationFaxes[i]);
        }

        y += 13;
    }
    /* ------------- End ------------------ */
}

export const destroyFrontVariablesP1T5 = () => {
    if (frontNameText) {
        frontNameText.destroy();
    }
    if (frontTitle1Text) {
        frontTitle1Text.destroy();
    }
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontDepartment3Text) {
        frontDepartment3Text.destroy();
    }
    for (let i = 0; i < 3; i++) {
        if (frontLocationNames[i]) {
            frontLocationNames[i].destroy();
        }
        if (frontPTexts[i]) {
            frontPTexts[i].destroy();
        }
        if (frontLocationPhones[i]) {
            frontLocationPhones[i].destroy();
        }
        if (frontFTexts[i]) {
            frontFTexts[i].destroy();
        }
        if (frontLocationFaxes[i]) {
            frontLocationFaxes[i].destroy();
        }
    }
}

export const initP1T6FrontCanvas = () => {
    /* ------------ Start ----------------- */
    Konva.Image.fromURL(require('./images/memorial-heart-logo.svg'), (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontDataLayer.add(image);
        image.setAttrs({
            x: (200 - 12.5) * scale,
            y: (20 - 12.5) * scale,
            width: 408 * 0.38 * scale,
            height: 258 * 0.38 * scale,
        });
        frontDataLayer.draw();
    });

    Konva.Image.fromURL(require('./images/uthealth-medical-logo.svg'), (image) => {
        if (frontLogo2Img != null) {
            frontLogo2Img.destroy();
        }
        frontLogo2Img = image;

        frontDataLayer.add(image);
        image.setAttrs({
            x: (225 - 12.5) * scale,
            y: (105 - 12.5) * scale,
            width: 408 * 0.35 * scale,
            height: 258 * 0.35 * scale,
        });
        frontDataLayer.draw();
    });
    /* ------------- End ------------------ */

    drawFrontVariablesP1T6();
}

export const drawFrontVariablesP1T6 = () => {
    /* ------------ Start ----------------- */
    let y = 32;
    frontNameText = new Konva.Text({
        text: getFullName(),
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'Roboto Condensed',
        fontStyle: 'bold',
        x: (33 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontNameText);

    y += 12;
    frontTitle1Text = new Konva.Text({
        text: canvasValues.department1,
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'Roboto Condensed',
        x: (33 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontTitle1Text);

    y += 12;
    frontDepartment1Text = new Konva.Text({
        text: canvasValues.title1,
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'Roboto Condensed',
        x: (33 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontDepartment1Text);

    y += 12;
    frontDepartment2Text = new Konva.Text({
        text: canvasValues.department2,
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'Roboto Condensed',
        x: (33 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontDepartment2Text);

    y += 12;
    frontDepartment3Text = new Konva.Text({
        text: canvasValues.department3,
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'Roboto Condensed',
        x: (33 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontDepartment3Text);
    /* ------------- End ------------------ */

    /* ------------ Start ----------------- */
    y = 149;
    if (
        !isEmpty(canvasValues.locationNames[1]) ||
        !isEmpty(canvasValues.locationAddresses1[1]) ||
        !isEmpty(canvasValues.locationAddresses2[1]) ||
        !isEmpty(canvasValues.locationCities[1]) ||
        !isEmpty(canvasValues.locationStates[1]) ||
        !isEmpty(canvasValues.locationZips[1]) ||
        !isEmpty(canvasValues.locationPhones[1]) ||
        !isEmpty(canvasValues.locationFaxes[1])
    ) {
        y = 96;
    }

    for (let i = 0; i < 2; i++) {
        frontLocationNames[i] = new Konva.Text({
            text: canvasValues.locationNames[i],
            fontSize: convertPointsToPixels(6.5) * scale,
            fontFamily: 'Roboto Condensed',
            x: (33 - 12.5) * scale,
            y: (y - 12.5) * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontLocationNames[i]);

        y += 10;
        frontLocationAddresses1[i] = new Konva.Text({
            text: canvasValues.locationAddresses1[i],
            fontSize: convertPointsToPixels(6.5) * scale,
            fontFamily: 'Roboto Condensed',
            x: (33 - 12.5) * scale,
            y: (y - 12.5) * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontLocationAddresses1[i]);

        if (!isEmpty(canvasValues.locationAddresses2[i])) {
            y += 10;
            frontLocationAddresses2[i] = new Konva.Text({
                text: canvasValues.locationAddresses2[i],
                fontSize: convertPointsToPixels(6.5) * scale,
                fontFamily: 'Roboto Condensed',
                x: (33 - 12.5) * scale,
                y: (y - 12.5) * scale,
                fill: '#000',
            });
            frontDataLayer.add(frontLocationAddresses2[i]);
        }

        y += 10;
        frontLocationStateAddresses[i] = new Konva.Text({
            text: getStateAddress(i),
            fontSize: convertPointsToPixels(6.5) * scale,
            fontFamily: 'Roboto Condensed',
            x: (33 - 12.5) * scale,
            y: (y - 12.5) * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontLocationStateAddresses[i]);

        if (!isEmpty(canvasValues.locationPhones[i])) {
            y += 10;
            frontPTexts[i] = new Konva.Text({
                text: 'P',
                fontSize: convertPointsToPixels(6.5) * scale,
                fontFamily: 'Roboto Condensed',
                fontStyle: 'bold',
                x: (33 - 12.5) * scale,
                y: (y - 12.5) * scale,
                fill: '#000',
            });
            frontDataLayer.add(frontPTexts[i]);

            frontLocationPhones[i] = new Konva.Text({
                text: canvasValues.locationPhones[i],
                fontSize: convertPointsToPixels(6.5) * scale,
                fontFamily: 'Roboto Condensed',
                x: (40 - 12.5) * scale,
                y: (y - 12.5) * scale,
                fill: '#000',
            });
            frontDataLayer.add(frontLocationPhones[i]);
        }

        if (!isEmpty(canvasValues.locationFaxes[i])) {
            frontFTexts[i] = new Konva.Text({
                text: 'F',
                fontSize: convertPointsToPixels(6.5) * scale,
                fontFamily: 'Roboto Condensed',
                fontStyle: 'bold',
                x: (98 - 12.5) * scale,
                y: (y - 12.5) * scale,
                fill: '#000',
            });
            frontDataLayer.add(frontFTexts[i]);

            frontLocationFaxes[i] = new Konva.Text({
                text: canvasValues.locationFaxes[i],
                fontSize: convertPointsToPixels(6.5) * scale,
                fontFamily: 'Roboto Condensed',
                x: (105 - 12.5) * scale,
                y: (y - 12.5) * scale,
                fill: '#000',
            });
            frontDataLayer.add(frontLocationFaxes[i]);
        }

        y += 13;
    }
    /* ------------- End ------------------ */
}

export const destroyFrontVariablesP1T6 = () => {
    if (frontNameText) {
        frontNameText.destroy();
    }
    if (frontTitle1Text) {
        frontTitle1Text.destroy();
    }
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontDepartment3Text) {
        frontDepartment3Text.destroy();
    }
    for (let i = 0; i < 2; i++) {
        if (frontLocationNames[i]) {
            frontLocationNames[i].destroy();
        }
        if (frontLocationAddresses1[i]) {
            frontLocationAddresses1[i].destroy();
        }
        if (frontLocationAddresses2[i]) {
            frontLocationAddresses2[i].destroy();
        }
        if (frontLocationStateAddresses[i]) {
            frontLocationStateAddresses[i].destroy();
        }
        if (frontPTexts[i]) {
            frontPTexts[i].destroy();
        }
        if (frontLocationPhones[i]) {
            frontLocationPhones[i].destroy();
        }
        if (frontFTexts[i]) {
            frontFTexts[i].destroy();
        }
        if (frontLocationFaxes[i]) {
            frontLocationFaxes[i].destroy();
        }
    }
}

export const initP1T7FrontCanvas = () => {
    Konva.Image.fromURL(require('./images/health-science-logo.svg'), (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontDataLayer.add(image);
        image.setAttrs({
            x: (25 - 12.5) * scale,
            y: (60 - 12.5) * scale,
            width: 1409 / 11 * scale,
            height: 969 / 11 * scale,
        });
        frontDataLayer.draw();
    });

    drawFrontVariablesP1T7();
}

export const drawFrontVariablesP1T7 = () => {
    frontNameText = new Konva.Text({
        text: getFullName(),
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: (166 - 12.5) * scale,
        y: (32 - 12.5) * scale,
        fill: '#53565A',
    });
    frontDataLayer.add(frontNameText);

    let credentials = null;
    let y = null;
    if (frontNameText.width() > nameLimit) {
        frontNameText.text(canvasValues.name);
        credentials = canvasValues.credentials;

        if (credentials !== '') {
            y = 60;
        } else {
            y = 47;
        }

        canvasValues.nameDivided = 1;
    } else {
        credentials = '';
        y = 47;
        canvasValues.nameDivided = 0;
    }

    frontCredentialsText = new Konva.Text({
        text: credentials,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'AGaramondProRegular',
        x: (166 - 12.5) * scale,
        y: (47 - 12.5) * scale,
        fill: '#53565A',
    });
    frontDataLayer.add(frontCredentialsText);

    frontTitle1Text = new Konva.Text({
        text: canvasValues.title1,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'AGaramondProItalic',
        x: (166 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#53565A',
    });
    frontDataLayer.add(frontTitle1Text);

    y += 12;
    frontTitle2Text = new Konva.Text({
        text: canvasValues.title2,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'AGaramondProItalic',
        x: (166 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#53565A',
    });
    frontDataLayer.add(frontTitle2Text);

    frontDepartment1Text = new Konva.Text({
        text: canvasValues.department1,
        fontSize: convertPointsToPixels(6) * scale,
        fontFamily: 'Ariblk',
        x: (166 - 12.5) * scale,
        y: (102 - 12.5) * scale,
        fill: '#BE531C',
    });
    frontDataLayer.add(frontDepartment1Text);

    y = 183;
    if (canvasValues.open1 === '') {
        y += 12;
    }

    frontOpen1Text = new Konva.Text({
        text: canvasValues.open1,
        fontSize: convertPointsToPixels(7.5) * scale,
        fontFamily: 'AGaramondProRegular',
        x: (166 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#53565A',
    });
    frontDataLayer.add(frontOpen1Text);

    if (parseInt(canvasValues.showEmail) !== 1 && canvasValues.email !== '') {
        y -= 12;
        frontEmailText = new Konva.Text({
            text: canvasValues.email,
            fontSize: convertPointsToPixels(7.5) * scale,
            fontFamily: 'AGaramondProRegular',
            x: (166 - 12.5) * scale,
            y: (y - 12.5) * scale,
            fill: '#53565A',
        });
        frontDataLayer.add(frontEmailText);
    }

    y -= 12;
    frontLocationText = new Konva.Text({
        text: canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip,
        fontSize: convertPointsToPixels(7.5) * scale,
        fontFamily: 'AGaramondProRegular',
        x: (166 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#53565A',
    });
    frontDataLayer.add(frontLocationText);

    y -= 12;
    frontAddress1Text = new Konva.Text({
        text: canvasValues.address,
        fontSize: convertPointsToPixels(7.5) * scale,
        fontFamily: 'AGaramondProRegular',
        x: (166 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#53565A',
    });
    frontDataLayer.add(frontAddress1Text);

    y -= 12;
    frontPhoneText = new Konva.Text({
        text: canvasValues.phone,
        fontSize: convertPointsToPixels(7.5) * scale,
        fontFamily: 'AGaramondProRegular',
        x: (166 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#53565A',
    });
    frontDataLayer.add(frontPhoneText);
}

export const destroyFrontVariablesP1T7 = () => {
    if (frontNameText) {
        frontNameText.destroy();
    }
    if (frontCredentialsText) {
        frontCredentialsText.destroy();
    }
    if (frontTitle1Text) {
        frontTitle1Text.destroy();
    }
    if (frontTitle2Text) {
        frontTitle2Text.destroy();
    }
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontPhoneText) {
        frontPhoneText.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontLocationText) {
        frontLocationText.destroy();
    }
    if (frontEmailText) {
        frontEmailText.destroy();
    }
    if (frontOpen1Text) {
        frontOpen1Text.destroy();
    }
}

export const initP1T8FrontCanvas = () => {
    Konva.Image.fromURL(require('./images/uthealth-utphysicians-logo.svg'), (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontDataLayer.add(image);
        image.setAttrs({
            x: 22 * scale,
            y: 22 * scale,
            width: 180 * 0.65 * scale,
            height: 152 * 0.65 * scale,
        });
        frontDataLayer.draw();
    });

    let appointmentText = new Konva.Text({
        text: 'Appointment Reminder',
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 160 * scale,
        y: 54 * scale,
        fill: '#bb6847',
    });
    frontDataLayer.add(appointmentText);

    let utphysiansText = new Konva.Text({
        text: 'UTPhysicians.com',
        fontSize: convertPointsToPixels(6.5) * scale,
        fontFamily: 'Ariblk',
        x: 30 * scale,
        y: 174 * scale,
        fill: '#bb6847',
    });
    frontDataLayer.add(utphysiansText);

    drawFrontVariablesP1T8();
}

export const drawFrontVariablesP1T8 = () => {
    frontNameText = new Konva.Text({
        text: canvasValues.name,
        fontSize: convertPointsToPixels(6) * scale,
        fontFamily: 'Ariblk',
        x: 160 * scale,
        y: 104 * scale,
        fill: '#bb6847',
    });
    frontDataLayer.add(frontNameText);

    if (canvasValues.title1 !== '') {
        frontTitle1Text = new Konva.Text({
            text: canvasValues.title1,
            fontSize: convertPointsToPixels(6) * scale,
            fontFamily: 'Ariblk',
            x: 160 * scale,
            y: 116 * scale,
            fill: '#bb6847',
        });
        frontDataLayer.add(frontTitle1Text);
    }

    let y = 174;
    if (canvasValues.fax !== '') {
        frontFaxText = new Konva.Text({
            text: 'F: ' + canvasValues.fax,
            fontSize: convertPointsToPixels(8) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 160 * scale,
            y: y * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontFaxText);
        y -= 12;
    }

    frontPhoneText = new Konva.Text({
        text: 'P: ' + canvasValues.phone,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 160 * scale,
        y: y * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontPhoneText);
    y -= 12;

    frontLocationText = new Konva.Text({
        text: canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 160 * scale,
        y: y * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontLocationText);
    y -= 12;

    let address = canvasValues.address;
    if (canvasValues.open1 !== '') {
        address += ', ' + canvasValues.open1;
    }

    frontAddress1Text = new Konva.Text({
        text: address,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 160 * scale,
        y: y * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontAddress1Text);
}

export const destroyFrontVariablesP1T8 = () => {
    if (frontNameText) {
        frontNameText.destroy();
    }
    if (frontTitle1Text) {
        frontTitle1Text.destroy();
    }
    if (frontPhoneText) {
        frontPhoneText.destroy();
    }
    if (frontFaxText) {
        frontFaxText.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontLocationText) {
        frontLocationText.destroy();
    }
}

export const initP1T9FrontCanvas = () => {
    Konva.Image.fromURL(require('./images/uthealth-utphysicians-logo.svg'), (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontDataLayer.add(image);
        image.setAttrs({
            x: 22 * scale,
            y: 22 * scale,
            width: 180 * 0.65 * scale,
            height: 152 * 0.65 * scale,
        });
        frontDataLayer.draw();
    });

    let utphysiansText = new Konva.Text({
        text: 'UTPhysicians.com',
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 30 * scale,
        y: 174 * scale,
        fill: '#bb6847',
    });
    frontDataLayer.add(utphysiansText);

    drawFrontVariablesP1T9();
}

export const drawFrontVariablesP1T9 = () => {
    frontNameText = new Konva.Text({
        text: canvasValues.name,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 160 * scale,
        y: 43 * scale,
        fill: '#bb6847',
    });
    frontDataLayer.add(frontNameText);

    frontTitle1Text = new Konva.Text({
        text: canvasValues.title1,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'AGaramondProItalic',
        x: 160 * scale,
        y: 57 * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontTitle1Text);

    frontTitle2Text = new Konva.Text({
        text: canvasValues.title2,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'AGaramondProItalic',
        x: 160 * scale,
        y: 69 * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontTitle2Text);

    let y = 86;
    if (canvasValues.title3 !== '') {
        frontTitle3Text = new Konva.Text({
            text: canvasValues.title3,
            fontSize: convertPointsToPixels(8) * scale,
            fontFamily: 'AGaramondProItalic',
            x: 160 * scale,
            y: 81 * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontTitle3Text);
        y = 98;
    }

    frontDepartment1Text = new Konva.Text({
        text: canvasValues.department1,
        fontSize: convertPointsToPixels(6) * scale,
        fontFamily: 'Ariblk',
        x: 160 * scale,
        y: y * scale,
        fill: '#bb6847',
    });
    frontDataLayer.add(frontDepartment1Text);
    y += 10;

    if (canvasValues.department2 !== '') {
        frontDepartment2Text = new Konva.Text({
            text: canvasValues.department2,
            fontSize: convertPointsToPixels(6) * scale,
            fontFamily: 'Ariblk',
            x: 160 * scale,
            y: y * scale,
            fill: '#bb6847',
        });
        frontDataLayer.add(frontDepartment2Text);
    }

    y = 186;
    if (canvasValues.email !== '') {
        y -= 12;
        frontEmailText = new Konva.Text({
            text: canvasValues.email,
            fontSize: convertPointsToPixels(8) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 160 * scale,
            y: y * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontEmailText);
    }

    if (canvasValues.fax !== '') {
        y -= 12;
        frontFaxText = new Konva.Text({
            text: canvasValues.fax !== '' ? 'F: ' + canvasValues.fax : '',
            fontSize: convertPointsToPixels(8) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 160 * scale,
            y: y * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontFaxText);
    }

    y -= 12;
    frontPhoneText = new Konva.Text({
        text: canvasValues.phone !== '' ? 'P: ' + canvasValues.phone : '',
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 160 * scale,
        y: y * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontPhoneText);

    y -= 12;
    frontLocationText = new Konva.Text({
        text: canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 160 * scale,
        y: y * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontLocationText);

    y -= 12;
    let address = canvasValues.address;
    if (canvasValues.open1 !== '') {
        address += ', ' + canvasValues.open1;
    }
    frontAddress1Text = new Konva.Text({
        text: address,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 160 * scale,
        y: y * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontAddress1Text);
}

export const destroyFrontVariablesP1T9 = () => {
    if (frontNameText) {
        frontNameText.destroy();
    }
    if (frontTitle1Text) {
        frontTitle1Text.destroy();
    }
    if (frontTitle2Text) {
        frontTitle2Text.destroy();
    }
    if (frontTitle3Text) {
        frontTitle3Text.destroy();
    }
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontPhoneText) {
        frontPhoneText.destroy();
    }
    if (frontFaxText) {
        frontFaxText.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontLocationText) {
        frontLocationText.destroy();
    }
    if (frontEmailText) {
        frontEmailText.destroy();
    }
}

export const initP1T11FrontCanvas = () => {
    Konva.Image.fromURL(require('./images/uthealth-utphysicians-logo.svg'), (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontDataLayer.add(image);
        image.setAttrs({
            x: 22 * scale,
            y: 22 * scale,
            width: 180 * 0.65 * scale,
            height: 152 * 0.65 * scale,
        });
        frontDataLayer.draw();
    });

    let utphysiansText = new Konva.Text({
        text: 'UTPhysicians.com',
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 30 * scale,
        y: 174 * scale,
        fill: '#bb6847',
    });
    frontDataLayer.add(utphysiansText);

    drawFrontVariablesP1T11();
}

export const drawFrontVariablesP1T11 = () => {
    frontNameText = new Konva.Text({
        text: canvasValues.name,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 160 * scale,
        y: 43 * scale,
        fill: '#bb6847',
    });
    frontDataLayer.add(frontNameText);

    frontTitle1Text = new Konva.Text({
        text: canvasValues.title1,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'AGaramondProItalic',
        x: 160 * scale,
        y: 57 * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontTitle1Text);

    frontTitle2Text = new Konva.Text({
        text: canvasValues.title2,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'AGaramondProItalic',
        x: 160 * scale,
        y: 69 * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontTitle2Text);

    frontDepartment1Text = new Konva.Text({
        text: canvasValues.department1,
        fontSize: convertPointsToPixels(6) * scale,
        fontFamily: 'Ariblk',
        x: 160 * scale,
        y: 86 * scale,
        fill: '#bb6847',
    });
    frontDataLayer.add(frontDepartment1Text);

    if (canvasValues.department2 !== '') {
        frontDepartment2Text = new Konva.Text({
            text: canvasValues.department2,
            fontSize: convertPointsToPixels(6) * scale,
            fontFamily: 'Ariblk',
            x: 160 * scale,
            y: 96 * scale,
            fill: '#bb6847',
        });
        frontDataLayer.add(frontDepartment2Text);
    }

    let y = 186;
    if (canvasValues.email !== '') {
        y -= 12;
        frontEmailText = new Konva.Text({
            text: canvasValues.email,
            fontSize: convertPointsToPixels(8) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 160 * scale,
            y: y * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontEmailText);
    }

    if (canvasValues.fax !== '') {
        y -= 12;
        frontFaxText = new Konva.Text({
            text: canvasValues.fax !== '' ? 'F: ' + canvasValues.fax : '',
            fontSize: convertPointsToPixels(8) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 160 * scale,
            y: y * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontFaxText);
    }

    y -= 12;
    frontPhoneText = new Konva.Text({
        text: canvasValues.phone !== '' ? 'P: ' + canvasValues.phone : '',
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 160 * scale,
        y: y * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontPhoneText);

    y -= 12;
    frontLocationText = new Konva.Text({
        text: canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 160 * scale,
        y: y * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontLocationText);

    y -= 12;
    let address = canvasValues.address;
    if (canvasValues.open1 !== '') {
        address += ', ' + canvasValues.open1;
    }
    frontAddress1Text = new Konva.Text({
        text: address,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 160 * scale,
        y: y * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontAddress1Text);
}

export const destroyFrontVariablesP1T11 = () => {
    if (frontNameText) {
        frontNameText.destroy();
    }
    if (frontTitle1Text) {
        frontTitle1Text.destroy();
    }
    if (frontTitle2Text) {
        frontTitle2Text.destroy();
    }
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontPhoneText) {
        frontPhoneText.destroy();
    }
    if (frontFaxText) {
        frontFaxText.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontLocationText) {
        frontLocationText.destroy();
    }
    if (frontEmailText) {
        frontEmailText.destroy();
    }
}

export const initP1T13FrontCanvas = () => {
    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/vectors/utp-clinic-location-front-011024.svg', (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 408 * scale,
            height: 258 * scale,
        });
        frontBackgroundLayer.draw();
    });

    drawFrontVariablesP1T13();
}

export const drawFrontVariablesP1T13 = () => {
    let y = 98;

    if (canvasValues.department2 !== '') {
        y = 102;
        frontDepartment2Text = new Konva.Text({
            text: canvasValues.department2,
            fontSize: convertPointsToPixels(8) * scale,
            fontFamily: 'UniversBold',
            x: 0 * scale,
            y: y * scale,
            fill: '#b66645',
            align: 'center',
            width: 350 * scale,
        });
        frontDataLayer.add(frontDepartment2Text);
        y -= 13;
    }

    frontDepartment1Text = new Konva.Text({
        text: canvasValues.department1,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'UniversBold',
        x: 0 * scale,
        y: y * scale,
        fill: '#b66645',
        align: 'center',
        width: 350 * scale,
    });
    frontDataLayer.add(frontDepartment1Text);

    let addressParts1 = [canvasValues.address];
    if (canvasValues.suiteRoom !== '') {
        addressParts1.push(canvasValues.suiteRoom);
    }
    let address1 = addressParts1.join(', ');

    frontAddress1Text = new Konva.Text({
        text: address1,
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'UniversLTStd',
        x: 0 * scale,
        y: 124 * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontAddress1Text);

    frontAddress2Text = new Konva.Text({
        text: canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip,
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'UniversLTStd',
        x: 0 * scale,
        y: 124 * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontAddress2Text);

    frontDivider1Text = new Konva.Text({
        text: 'I',
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'UniversBold',
        x: 0 * scale,
        y: 124 * scale,
        fill: '#b66645',
    });
    frontDataLayer.add(frontDivider1Text);

    let totalWidth = frontAddress1Text.width() + frontDivider1Text.width() + frontAddress2Text.width() + 8 * scale;
    frontAddress1Text.x((350 * scale - totalWidth) / 2);
    frontDivider1Text.x(frontAddress1Text.x() + frontAddress1Text.width() + 4 * scale);
    frontAddress2Text.x(frontDivider1Text.x() + frontDivider1Text.width() + 4 * scale);

    frontPhoneText = new Konva.Text({
        text: canvasValues.phone + ' main',
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'UniversLTStd',
        x: 0 * scale,
        y: 148 * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontPhoneText);

    if (canvasValues.fax !== '') {
        frontFaxText = new Konva.Text({
            text: canvasValues.fax + ' fax',
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'UniversLTStd',
            x: 0 * scale,
            y: 148 * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontFaxText);

        frontDivider2Text = new Konva.Text({
            text: 'I',
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'UniversBold',
            x: 0 * scale,
            y: 148 * scale,
            fill: '#b66645',
        });
        frontDataLayer.add(frontDivider2Text);

        totalWidth = frontPhoneText.width() + frontDivider2Text.width() + frontFaxText.width() + 8 * scale;
        frontPhoneText.x((350 * scale - totalWidth) / 2);
        frontDivider2Text.x(frontPhoneText.x() + frontPhoneText.width() + 4 * scale);
        frontFaxText.x(frontDivider2Text.x() + frontDivider2Text.width() + 4 * scale);
    } else {
        totalWidth = frontPhoneText.width();
        frontPhoneText.x((350 * scale - totalWidth) / 2);
    }
}

export const getAddressLineP1T13 = () => {
    let addressParts1 = [canvasValues.address];
    if (canvasValues.suiteRoom !== '') {
        addressParts1.push(canvasValues.suiteRoom);
    }
    let addressPart1 = addressParts1.join(', ');

    return addressPart1 + ' I ' + canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip;
}

export const destroyFrontVariablesP1T13 = () => {
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontPhoneText) {
        frontPhoneText.destroy();
    }
    if (frontFaxText) {
        frontFaxText.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (frontLocationText) {
        frontLocationText.destroy();
    }
    if (frontLine1) {
        frontLine1.destroy();
    }
    if (frontDivider1Text) {
        frontDivider1Text.destroy();
    }
    if (frontDivider2Text) {
        frontDivider2Text.destroy();
    }
    if (frontWebsiteText) {
        frontWebsiteText.destroy();
    }
}

export const initP1T14FrontCanvas = () => {
    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/vectors/utp-appointment-card-front-250924.svg', (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 408 * scale,
            height: 258 * scale,
        });
        frontBackgroundLayer.draw();
    });

    drawFrontVariablesP1T14();
}

export const drawFrontVariablesP1T14 = () => {
    let y = 114;
    if (canvasValues.department2 !== '') {
        frontDepartment2Text = new Konva.Text({
            text: canvasValues.department2,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'UniversBold',
            x: 0 * scale,
            y: y * scale,
            fill: '#b66645',
            align: 'center',
            width: 350 * scale,
        });
        frontDataLayer.add(frontDepartment2Text);
        y -= 13;
    }

    frontDepartment1Text = new Konva.Text({
        text: canvasValues.department1,
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'UniversBold',
        x: 0 * scale,
        y: y * scale,
        fill: '#b66645',
        align: 'center',
        width: 350 * scale,
    });
    frontDataLayer.add(frontDepartment1Text);

    let addressParts1 = [canvasValues.address];
    if (canvasValues.suiteRoom !== '') {
        addressParts1.push(canvasValues.suiteRoom);
    }
    let address1 = addressParts1.join(', ');

    frontAddress1Text = new Konva.Text({
        text: address1,
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'UniversLTStd',
        x: 0 * scale,
        y: 128 * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontAddress1Text);

    frontAddress2Text = new Konva.Text({
        text: canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip,
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'UniversLTStd',
        x: 0 * scale,
        y: 128 * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontAddress2Text);

    frontDivider1Text = new Konva.Text({
        text: 'I',
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'UniversBold',
        x: 0 * scale,
        y: 128 * scale,
        fill: '#b66645',
    });
    frontDataLayer.add(frontDivider1Text);

    let totalWidth = frontAddress1Text.width() + frontDivider1Text.width() + frontAddress2Text.width() + 8 * scale;
    frontAddress1Text.x((350 * scale - totalWidth) / 2);
    frontDivider1Text.x(frontAddress1Text.x() + frontAddress1Text.width() + 4 * scale);
    frontAddress2Text.x(frontDivider1Text.x() + frontDivider1Text.width() + 4 * scale);

    frontPhoneText = new Konva.Text({
        text: canvasValues.phone + ' main',
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'UniversLTStd',
        x: 0 * scale,
        y: 141 * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontPhoneText);

    if (canvasValues.fax !== '') {
        frontFaxText = new Konva.Text({
            text: canvasValues.fax + ' fax',
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'UniversLTStd',
            x: 0 * scale,
            y: 141 * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontFaxText);

        frontDivider2Text = new Konva.Text({
            text: 'I',
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'UniversBold',
            x: 0 * scale,
            y: 141 * scale,
            fill: '#b66645',
        });
        frontDataLayer.add(frontDivider2Text);

        totalWidth = frontPhoneText.width() + frontDivider2Text.width() + frontFaxText.width() + 8 * scale;
        frontPhoneText.x((350 * scale - totalWidth) / 2);
        frontDivider2Text.x(frontPhoneText.x() + frontPhoneText.width() + 4 * scale);
        frontFaxText.x(frontDivider2Text.x() + frontDivider2Text.width() + 4 * scale);
    } else {
        totalWidth = frontPhoneText.width();
        frontPhoneText.x((350 * scale - totalWidth) / 2);
    }
}

export const getAddressLineP1T14 = () => {
    let addressParts1 = [canvasValues.address];
    if (canvasValues.suiteRoom !== '') {
        addressParts1.push(canvasValues.suiteRoom);
    }
    let addressPart1 = addressParts1.join(', ');

    return addressPart1 + ' I ' + canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip;
}

export const destroyFrontVariablesP1T14 = () => {
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (frontPhoneText) {
        frontPhoneText.destroy();
    }
    if (frontFaxText) {
        frontFaxText.destroy();
    }
    if (frontDivider1Text) {
        frontDivider1Text.destroy();
    }
    if (frontDivider2Text) {
        frontDivider2Text.destroy();
    }
}

export const initP1T16FrontCanvas = () => {
    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/vectors/utp-provider-card-front-250924.svg', (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 408 * scale,
            height: 258 * scale,
        });
        frontBackgroundLayer.draw();
    });

    drawFrontVariablesP1T16();
}

export const drawFrontVariablesP1T16 = () => {
    let y = 92;
    if (canvasValues.department2 !== '') {
        y = 92;
        frontLine1 = new Konva.Line({
            points: [
                36 * scale, 110 * scale,
                313 * scale, 110 * scale
            ],
            stroke: '#231F20',
            strokeWidth: 1
        });
        frontDataLayer.add(frontLine1);
    } else {
        y = 96;
        frontLine1 = new Konva.Line({
            points: [
                36 * scale, 114 * scale,
                313 * scale, 114 * scale
            ],
            stroke: '#231F20',
            strokeWidth: 1
        });
        frontDataLayer.add(frontLine1);
    }

    if (canvasValues.title2 !== '') {
        frontTitle2Text = new Konva.Text({
            text: canvasValues.title2,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'UniversLTStdObl',
            x: 0 * scale,
            y: y * scale,
            fill: '#000',
            align: 'center',
            width: 350 * scale,
        });
        frontDataLayer.add(frontTitle2Text);
        y -= 11;
    }

    if (canvasValues.title1 !== '') {
        frontTitle1Text = new Konva.Text({
            text: canvasValues.title1,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'UniversLTStdObl',
            x: 0 * scale,
            y: y * scale,
            fill: '#000',
            align: 'center',
            width: 350 * scale,
        });
        frontDataLayer.add(frontTitle1Text);
        y -= 11;
    }

    y -= 1;
    frontNameText = new Konva.Text({
        text: canvasValues.name,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'UniversBold',
        x: 0 * scale,
        y: y * scale,
        fill: '#b66645',
        align: 'center',
        width: 350 * scale,
    });
    frontDataLayer.add(frontNameText);

    if (canvasValues.department2 !== '') {
        y = 114;
    } else {
        y = 122;
    }

    if (canvasValues.department1 !== '') {
        frontDepartment1Text = new Konva.Text({
            text: canvasValues.department1,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'UniversBold',
            x: 0 * scale,
            y: y * scale,
            fill: '#b66645',
            align: 'center',
            width: 350 * scale,
        });
        frontDataLayer.add(frontDepartment1Text);
        y += 12;
    }

    if (canvasValues.department2 !== '') {
        frontDepartment2Text = new Konva.Text({
            text: canvasValues.department2,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'UniversBold',
            x: 0 * scale,
            y: y * scale,
            fill: '#b66645',
            align: 'center',
            width: 350 * scale,
        });
        frontDataLayer.add(frontDepartment2Text);
        y += 12;
    }

    let addressParts1 = [canvasValues.address];
    if (canvasValues.suiteRoom !== '') {
        addressParts1.push(canvasValues.suiteRoom);
    }
    let address1 = addressParts1.join(', ');

    frontAddress1Text = new Konva.Text({
        text: address1,
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'UniversLTStd',
        x: 0 * scale,
        y: y * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontAddress1Text);

    frontAddress2Text = new Konva.Text({
        text: canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip,
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'UniversLTStd',
        x: 0 * scale,
        y: y * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontAddress2Text);

    frontDivider1Text = new Konva.Text({
        text: 'I',
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'UniversBold',
        x: 0 * scale,
        y: y * scale,
        fill: '#b66645',
    });
    frontDataLayer.add(frontDivider1Text);

    let totalWidth = frontAddress1Text.width() + frontDivider1Text.width() + frontAddress2Text.width() + 8 * scale;
    frontAddress1Text.x((350 * scale - totalWidth) / 2);
    frontDivider1Text.x(frontAddress1Text.x() + frontAddress1Text.width() + 4 * scale);
    frontAddress2Text.x(frontDivider1Text.x() + frontDivider1Text.width() + 4 * scale);

    y += 12;

    frontPhoneText = new Konva.Text({
        text: canvasValues.phone + ' main',
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'UniversLTStd',
        x: 0 * scale,
        y: y * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontPhoneText);

    if (canvasValues.fax !== '') {
        frontFaxText = new Konva.Text({
            text: canvasValues.fax + ' fax',
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'UniversLTStd',
            x: 0 * scale,
            y: y * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontFaxText);

        frontDivider2Text = new Konva.Text({
            text: 'I',
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'UniversBold',
            x: 0 * scale,
            y: y * scale,
            fill: '#b66645',
        });
        frontDataLayer.add(frontDivider2Text);

        totalWidth = frontPhoneText.width() + frontDivider2Text.width() + frontFaxText.width() + 8 * scale;
        frontPhoneText.x((350 * scale - totalWidth) / 2);
        frontDivider2Text.x(frontPhoneText.x() + frontPhoneText.width() + 4 * scale);
        frontFaxText.x(frontDivider2Text.x() + frontDivider2Text.width() + 4 * scale);
    } else {
        totalWidth = frontPhoneText.width();
        frontPhoneText.x((350 * scale - totalWidth) / 2);
    }

    if (canvasValues.nursePhone !== '') {
        y += 12;
        frontNursePhoneText = new Konva.Text({
            text: 'Nurse – ' + canvasValues.nursePhone,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'UniversLTStd',
            x: 0 * scale,
            y: y * scale,
            fill: '#000',
            align: 'center',
            width: 350 * scale,
        });
        frontDataLayer.add(frontNursePhoneText);
    }

    if (parseInt(canvasValues.additionalField) === 1) {
        let website = 'UTPhysicians.com';
        if (!isEmpty(canvasValues.website)) {
            website += '/' + canvasValues.website;
        }

        frontWebsiteText = new Konva.Text({
            text: website,
            fontSize: convertPointsToPixels(6) * scale,
            fontFamily: 'UniversBold',
            x: 0 * scale,
            y: 174 * scale,
            fill: '#b66645',
            align: 'center',
            width: 350 * scale,
        });
        frontDataLayer.add(frontWebsiteText);
    } else if (parseInt(canvasValues.additionalField) === 2) {
        frontWebsiteText = new Konva.Text({
            text: canvasValues.email + '@uth.tmc.edu',
            fontSize: convertPointsToPixels(6) * scale,
            fontFamily: 'UniversBold',
            x: 0 * scale,
            y: 174 * scale,
            fill: '#b66645',
            align: 'center',
            width: 350 * scale,
        });
        frontDataLayer.add(frontWebsiteText);
    }
}

export const getAddressLineP1T16 = () => {
    let addressParts1 = [canvasValues.address];
    if (canvasValues.suiteRoom !== '') {
        addressParts1.push(canvasValues.suiteRoom);
    }
    let addressPart1 = addressParts1.join(', ');

    return addressPart1 + ' I ' + canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip;
}

export const destroyFrontVariablesP1T16 = () => {
    if (frontNameText) {
        frontNameText.destroy();
    }
    if (frontTitle1Text) {
        frontTitle1Text.destroy();
    }
    if (frontTitle2Text) {
        frontTitle2Text.destroy();
    }
    if (frontTitle3Text) {
        frontTitle3Text.destroy();
    }
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontPhoneText) {
        frontPhoneText.destroy();
    }
    if (frontFaxText) {
        frontFaxText.destroy();
    }
    if (frontNursePhoneText) {
        frontNursePhoneText.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (frontLocationText) {
        frontLocationText.destroy();
    }
    if (frontLine1) {
        frontLine1.destroy();
    }
    if (frontDivider1Text) {
        frontDivider1Text.destroy();
    }
    if (frontDivider2Text) {
        frontDivider2Text.destroy();
    }
    if (frontWebsiteText) {
        frontWebsiteText.destroy();
    }
}

export const initP1T15FrontCanvas = () => {
    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/vectors/utp-provider-appointment-card-front-250924.svg', (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 408 * scale,
            height: 258 * scale,
        });
        frontBackgroundLayer.draw();
    });

    drawFrontVariablesP1T15();
}

export const drawFrontVariablesP1T15 = () => {
    let y = 92;
    if (canvasValues.department2 !== '') {
        y = 92;
        frontLine1 = new Konva.Line({
            points: [
                36 * scale, 110 * scale,
                313 * scale, 110 * scale
            ],
            stroke: '#231F20',
            strokeWidth: 1
        });
        frontDataLayer.add(frontLine1);
    } else {
        y = 96;
        frontLine1 = new Konva.Line({
            points: [
                36 * scale, 114 * scale,
                313 * scale, 114 * scale
            ],
            stroke: '#231F20',
            strokeWidth: 1
        });
        frontDataLayer.add(frontLine1);
    }

    if (canvasValues.title2 !== '') {
        frontTitle2Text = new Konva.Text({
            text: canvasValues.title2,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'UniversLTStdObl',
            x: 0 * scale,
            y: y * scale,
            fill: '#000',
            align: 'center',
            width: 350 * scale,
        });
        frontDataLayer.add(frontTitle2Text);
        y -= 11;
    }

    if (canvasValues.title1 !== '') {
        frontTitle1Text = new Konva.Text({
            text: canvasValues.title1,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'UniversLTStdObl',
            x: 0 * scale,
            y: y * scale,
            fill: '#000',
            align: 'center',
            width: 350 * scale,
        });
        frontDataLayer.add(frontTitle1Text);
        y -= 11;
    }

    y -= 1;
    frontNameText = new Konva.Text({
        text: canvasValues.name,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'UniversBold',
        x: 0 * scale,
        y: y * scale,
        fill: '#b66645',
        align: 'center',
        width: 350 * scale,
    });
    frontDataLayer.add(frontNameText);

    if (canvasValues.department2 !== '') {
        y = 114;
    } else {
        y = 122;
    }

    frontDepartment1Text = new Konva.Text({
        text: canvasValues.department1,
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'UniversBold',
        x: 0 * scale,
        y: y * scale,
        fill: '#b66645',
        align: 'center',
        width: 350 * scale,
    });
    frontDataLayer.add(frontDepartment1Text);
    y += 12;

    if (canvasValues.department2 !== '') {
        frontDepartment2Text = new Konva.Text({
            text: canvasValues.department2,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'UniversBold',
            x: 0 * scale,
            y: y * scale,
            fill: '#b66645',
            align: 'center',
            width: 350 * scale,
        });
        frontDataLayer.add(frontDepartment2Text);
        y += 12;
    }

    let addressParts1 = [canvasValues.address];
    if (canvasValues.suiteRoom !== '') {
        addressParts1.push(canvasValues.suiteRoom);
    }
    let address1 = addressParts1.join(', ');

    y += 1;
    frontAddress1Text = new Konva.Text({
        text: address1,
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'UniversLTStd',
        x: 0 * scale,
        y: y * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontAddress1Text);

    frontAddress2Text = new Konva.Text({
        text: canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip,
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'UniversLTStd',
        x: 0 * scale,
        y: y * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontAddress2Text);

    frontDivider1Text = new Konva.Text({
        text: 'I',
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'UniversBold',
        x: 0 * scale,
        y: y * scale,
        fill: '#b66645',
    });
    frontDataLayer.add(frontDivider1Text);

    let totalWidth = frontAddress1Text.width() + frontDivider1Text.width() + frontAddress2Text.width() + 8 * scale;
    frontAddress1Text.x((350 * scale - totalWidth) / 2);
    frontDivider1Text.x(frontAddress1Text.x() + frontAddress1Text.width() + 4 * scale);
    frontAddress2Text.x(frontDivider1Text.x() + frontDivider1Text.width() + 4 * scale);

    y += 12;
    frontPhoneText = new Konva.Text({
        text: canvasValues.phone + ' main',
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'UniversLTStd',
        x: 0 * scale,
        y: y * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontPhoneText);

    if (canvasValues.fax !== '') {
        frontFaxText = new Konva.Text({
            text: canvasValues.fax + ' fax',
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'UniversLTStd',
            x: 0 * scale,
            y: y * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontFaxText);

        frontDivider2Text = new Konva.Text({
            text: 'I',
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'UniversBold',
            x: 0 * scale,
            y: y * scale,
            fill: '#b66645',
        });
        frontDataLayer.add(frontDivider2Text);

        totalWidth = frontPhoneText.width() + frontDivider2Text.width() + frontFaxText.width() + 8 * scale;
        frontPhoneText.x((350 * scale - totalWidth) / 2);
        frontDivider2Text.x(frontPhoneText.x() + frontPhoneText.width() + 4 * scale);
        frontFaxText.x(frontDivider2Text.x() + frontDivider2Text.width() + 4 * scale);
    } else {
        totalWidth = frontPhoneText.width();
        frontPhoneText.x((350 * scale - totalWidth) / 2);
    }

    if (canvasValues.nursePhone !== '') {
        y += 12;
        frontNursePhoneText = new Konva.Text({
            text: 'Nurse – ' + canvasValues.nursePhone,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'UniversLTStd',
            x: 0 * scale,
            y: y * scale,
            fill: '#000',
            align: 'center',
            width: 350 * scale,
        });
        frontDataLayer.add(frontNursePhoneText);
    }
}

export const getAddressLineP1T15 = () => {
    let addressParts1 = [canvasValues.address];
    if (canvasValues.suiteRoom !== '') {
        addressParts1.push(canvasValues.suiteRoom);
    }
    let addressPart1 = addressParts1.join(', ');

    return addressPart1 + ' I ' + canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip;
}

export const destroyFrontVariablesP1T15 = () => {
    if (frontNameText) {
        frontNameText.destroy();
    }
    if (frontTitle1Text) {
        frontTitle1Text.destroy();
    }
    if (frontTitle2Text) {
        frontTitle2Text.destroy();
    }
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontPhoneText) {
        frontPhoneText.destroy();
    }
    if (frontFaxText) {
        frontFaxText.destroy();
    }
    if (frontNursePhoneText) {
        frontNursePhoneText.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (frontLine1) {
        frontLine1.destroy();
    }
    if (frontDivider1Text) {
        frontDivider1Text.destroy();
    }
    if (frontDivider2Text) {
        frontDivider2Text.destroy();
    }
}

export const initP2T1FrontCanvas = () => {
    Konva.Image.fromURL(require('./images/uthealth-utphysicians-logo.svg'), (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontDataLayer.add(image);
        image.setAttrs({
            x: 90 * scale,
            y: 60 * scale,
            width: 180 * 1.1 * scale,
            height: 152 * 1.1 * scale,
        });
        frontDataLayer.draw();
    });

    drawFrontVariablesP2T1();
}

export const drawFrontVariablesP2T1 = () => {
    frontNameText = new Konva.Text({
        text: canvasValues.name,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'Ariblk',
        x: 425 * scale,
        y: 105 * scale,
        width: 350 * scale,
        fill: '#bb6847',
        align: 'right',
    });
    frontDataLayer.add(frontNameText);

    let y = 105;
    if (canvasValues.title1 !== '') {
        y += 16;
        frontTitle1Text = new Konva.Text({
            text: canvasValues.title1,
            fontSize: convertPointsToPixels(8) * scale,
            fontFamily: 'Ariblk',
            x: 425 * scale,
            y: y * scale,
            width: 350 * scale,
            fill: '#bb6847',
            align: 'right',
        });
        frontDataLayer.add(frontTitle1Text);
    }

    y += 16;
    frontPhoneText = new Konva.Text({
        text: 'Phone: ' + canvasValues.phone,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 425 * scale,
        y: y * scale,
        width: 350 * scale,
        fill: '#000',
        align: 'right',
    });
    frontDataLayer.add(frontPhoneText);

    if (canvasValues.fax !== '') {
        y += 16;
        frontFaxText = new Konva.Text({
            text: 'Fax: ' + canvasValues.fax,
            fontSize: convertPointsToPixels(9) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 425 * scale,
            y: y * scale,
            width: 350 * scale,
            fill: '#000',
            align: 'right',
        });
        frontDataLayer.add(frontFaxText);
    }

    if (canvasValues.email !== '') {
        y += 16;
        frontEmailText = new Konva.Text({
            text: canvasValues.email,
            fontSize: convertPointsToPixels(9) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 425 * scale,
            y: y * scale,
            width: 350 * scale,
            fill: '#000',
            align: 'right',
        });
        frontDataLayer.add(frontEmailText);
    }

    y += 16;
    frontAddress1Text = new Konva.Text({
        text: canvasValues.address,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 425 * scale,
        y: y * scale,
        width: 350 * scale,
        fill: '#000',
        align: 'right',
    });
    frontDataLayer.add(frontAddress1Text);

    y += 16;
    frontAddress2Text = new Konva.Text({
        text: canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 425 * scale,
        y: y * scale,
        width: 350 * scale,
        fill: '#000',
        align: 'right',
    });
    frontDataLayer.add(frontAddress2Text);

    if (canvasValues.open1 !== '') {
        y += 16;
        frontOpen1Text = new Konva.Text({
            text: canvasValues.open1,
            fontSize: convertPointsToPixels(9) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 425 * scale,
            y: y * scale,
            width: 350 * scale,
            fill: '#000',
            align: 'right',
        });
        frontDataLayer.add(frontOpen1Text);
    }
}

export const destroyFrontVariablesP2T1 = () => {
    if (frontNameText) {
        frontNameText.destroy();
    }
    if (frontTitle1Text) {
        frontTitle1Text.destroy();
    }
    if (frontPhoneText) {
        frontPhoneText.destroy();
    }
    if (frontFaxText) {
        frontFaxText.destroy();
    }
    if (frontEmailText) {
        frontEmailText.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (frontOpen1Text) {
        frontOpen1Text.destroy();
    }
}

export const initP2T3FrontCanvas = () => {
    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/vectors/utp-letterhead.svg', (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 908 * scale,
            height: 1158 * scale,
        });
        frontBackgroundLayer.draw();
    });

    drawFrontVariablesP2T3();
}

export const drawFrontVariablesP2T3 = () => {
    let y = 57;
    frontDepartment1Text = new Konva.Text({
        text: canvasValues.department1,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'UniversBold',
        x: 0 * scale,
        y: y * scale,
        fill: '#b66645',
        align: 'right',
        width: 805 * scale,
    });
    frontDataLayer.add(frontDepartment1Text);
    y += 16;

    if (canvasValues.department2 !== '') {
        frontDepartment2Text = new Konva.Text({
            text: canvasValues.department2,
            fontSize: convertPointsToPixels(8) * scale,
            fontFamily: 'UniversBold',
            x: 0 * scale,
            y: y * scale,
            fill: '#b66645',
            align: 'right',
            width: 805 * scale,
        });
        frontDataLayer.add(frontDepartment2Text);
        y += 16;
    }

    frontAddress1Text = new Konva.Text({
        text: getAddressLine1P2T3(),
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 0 * scale,
        y: y * scale,
        fill: '#76777A',
        align: 'right',
        width: 805 * scale,
    });
    frontDataLayer.add(frontAddress1Text);
    y += 16;

    frontAddress2Text = new Konva.Text({
        text: getAddressLine2P2T3(),
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 0 * scale,
        y: y * scale,
        fill: '#76777A',
        align: 'right',
        width: 805 * scale,
    });
    frontDataLayer.add(frontAddress2Text);
    y += 16;

    frontPhoneText = new Konva.Text({
        text: canvasValues.phone,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 0 * scale,
        y: y * scale,
        fill: '#76777A',
        align: 'right',
        width: 805 * scale,
    });
    frontDataLayer.add(frontPhoneText);
    y += 16;

    if (canvasValues.fax !== '') {
        frontFaxText = new Konva.Text({
            text: canvasValues.fax,
            fontSize: convertPointsToPixels(9) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 0 * scale,
            y: y * scale,
            fill: '#76777A',
            align: 'right',
            width: 805 * scale,
        });
        frontDataLayer.add(frontFaxText);
        y += 16;
    }

    if (canvasValues.email !== '') {
        frontEmailText = new Konva.Text({
            text: canvasValues.email,
            fontSize: convertPointsToPixels(9) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 0 * scale,
            y: y * scale,
            fill: '#76777A',
            align: 'right',
            width: 805 * scale,
        });
        frontDataLayer.add(frontEmailText);
        y += 16;
    }

    if (canvasValues.website !== '') {
        frontWebsiteText = new Konva.Text({
            text: canvasValues.website,
            fontSize: convertPointsToPixels(9) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 0 * scale,
            y: y * scale,
            fill: '#76777A',
            align: 'right',
            width: 805 * scale,
        });
        frontDataLayer.add(frontWebsiteText);
        y += 16;
    }
}

export const getAddressLine1P2T3 = () => {
    let addressParts1 = [canvasValues.address];
    if (canvasValues.suiteRoom !== '') {
        addressParts1.push(canvasValues.suiteRoom);
    }
    return addressParts1.join(', ');
}

export const getAddressLine2P2T3 = () => {
    return canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip;
}

export const destroyFrontVariablesP2T3 = () => {
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (frontEmailText) {
        frontEmailText.destroy();
    }
    if (frontPhoneText) {
        frontPhoneText.destroy();
    }
    if (frontFaxText) {
        frontFaxText.destroy();
    }
    if (frontWebsiteText) {
        frontWebsiteText.destroy();
    }
}

export const initP3T1FrontCanvas = () => {
    drawFrontVariablesP3T1();
}

export const drawFrontVariablesP3T1 = () => {
    let svgImage = 'uthealth-utphysicians-logo.svg';
    if (parseInt(canvasValues.color) === 2) {
        svgImage = 'uthealth-utphysicians-logo-black.svg';
    }

    Konva.Image.fromURL(require('./images/' + svgImage), (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontDataLayer.add(image);
        image.setAttrs({
            x: 33 * scale,
            y: 33 * scale,
            width: 180 * 0.81 * scale,
            height: 152 * 0.81 * scale,
        });
        frontDataLayer.draw();
    });

    frontNameText = new Konva.Text({
        text: canvasValues.name,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'Ariblk',
        x: 200 * scale,
        y: 77 * scale,
        fill: parseInt(canvasValues.color) === 2 ? '#000' : '#76787b',
    });
    frontDataLayer.add(frontNameText);

    frontAddress1Text = new Konva.Text({
        text: canvasValues.address,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 200 * scale,
        y: 93 * scale,
        fill: parseInt(canvasValues.color) === 2 ? '#000' : '#76787b',
    });
    frontDataLayer.add(frontAddress1Text);

    let y = 93
    if (canvasValues.address2 !== '') {
        y += 15;
        frontAddress2Text = new Konva.Text({
            text: canvasValues.address2,
            fontSize: convertPointsToPixels(9) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 200 * scale,
            y: y * scale,
            fill: parseInt(canvasValues.color) === 2 ? '#000' : '#76787b',
        });
        frontDataLayer.add(frontAddress2Text);
    }

    y += 15;
    frontLocationText = new Konva.Text({
        text: canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 200 * scale,
        y: y * scale,
        fill: parseInt(canvasValues.color) === 2 ? '#000' : '#76787b',
    });
    frontDataLayer.add(frontLocationText);
}

export const destroyFrontVariablesP3T1 = () => {
    if (frontLogo1Img) {
        frontLogo1Img.destroy();
    }
    if (frontNameText) {
        frontNameText.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (frontLocationText) {
        frontLocationText.destroy();
    }
}

export const initP3T2FrontCanvas = () => {
    drawFrontVariablesP3T2();
}

export const drawFrontVariablesP3T2 = () => {
    let svgImage = 'uthealth-utphysicians-logo.svg';
    if (parseInt(canvasValues.color) === 2) {
        svgImage = 'uthealth-utphysicians-logo-black.svg';
    }

    Konva.Image.fromURL(require('./images/' + svgImage), (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontDataLayer.add(image);
        image.setAttrs({
            x: 33 * scale,
            y: 33 * scale,
            width: 180 * 0.81 * scale,
            height: 152 * 0.81 * scale,
        });
        frontDataLayer.draw();
    });

    frontNameText = new Konva.Text({
        text: canvasValues.name,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'Ariblk',
        x: 200 * scale,
        y: 77 * scale,
        fill: parseInt(canvasValues.color) === 2 ? '#000' : '#76787b',
    });
    frontDataLayer.add(frontNameText);

    frontAddress1Text = new Konva.Text({
        text: canvasValues.address,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 200 * scale,
        y: 93 * scale,
        fill: parseInt(canvasValues.color) === 2 ? '#000' : '#76787b',
    });
    frontDataLayer.add(frontAddress1Text);

    let y = 93
    if (canvasValues.address2 !== '') {
        y += 15;
        frontAddress2Text = new Konva.Text({
            text: canvasValues.address2,
            fontSize: convertPointsToPixels(9) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 200 * scale,
            y: y * scale,
            fill: parseInt(canvasValues.color) === 2 ? '#000' : '#76787b',
        });
        frontDataLayer.add(frontAddress2Text);
    }

    y += 15;
    frontLocationText = new Konva.Text({
        text: canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 200 * scale,
        y: y * scale,
        fill: parseInt(canvasValues.color) === 2 ? '#000' : '#76787b',
    });
    frontDataLayer.add(frontLocationText);
}

export const destroyFrontVariablesP3T2 = () => {
    if (frontLogo1Img) {
        frontLogo1Img.destroy();
    }
    if (frontNameText) {
        frontNameText.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (frontLocationText) {
        frontLocationText.destroy();
    }
}

export const initP3T3FrontCanvas = () => {
    // let windowRect = new Konva.Rect({
    //     x: 100 * scale,
    //     y: 240 * scale,
    //     width: 450 * scale,
    //     height: 110 * scale,
    //     fill: '#bb6847',
    //     drawBorder: true,
    //     cornerRadius: 10,
    // });
    // frontDataLayer.add(windowRect);

    Konva.Image.fromURL(require('./images/no10-window.png'), (image) => {
        frontDataLayer.add(image);
        image.setAttrs({
            x: 100 * scale,
            y: 240 * scale,
            width: 450 * scale,
            height: 110 * scale,
        });
        frontDataLayer.draw();
    });

    drawFrontVariablesP3T3();
}

export const drawFrontVariablesP3T3 = () => {
    let svgImage = 'uthealth-utphysicians-logo.svg';
    if (parseInt(canvasValues.color) === 2) {
        svgImage = 'uthealth-utphysicians-logo-black.svg';
    }

    Konva.Image.fromURL(require('./images/' + svgImage), (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontDataLayer.add(image);
        image.setAttrs({
            x: 33 * scale,
            y: 33 * scale,
            width: 180 * 0.81 * scale,
            height: 152 * 0.81 * scale,
        });
        frontDataLayer.draw();
    });

    frontNameText = new Konva.Text({
        text: canvasValues.name,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'Ariblk',
        x: 200 * scale,
        y: 77 * scale,
        fill: parseInt(canvasValues.color) === 2 ? '#000' : '#76787b',
    });
    frontDataLayer.add(frontNameText);

    frontAddress1Text = new Konva.Text({
        text: canvasValues.address,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 200 * scale,
        y: 93 * scale,
        fill: parseInt(canvasValues.color) === 2 ? '#000' : '#76787b',
    });
    frontDataLayer.add(frontAddress1Text);

    let y = 93
    if (canvasValues.address2 !== '') {
        y += 15;
        frontAddress2Text = new Konva.Text({
            text: canvasValues.address2,
            fontSize: convertPointsToPixels(9) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 200 * scale,
            y: y * scale,
            fill: parseInt(canvasValues.color) === 2 ? '#000' : '#76787b',
        });
        frontDataLayer.add(frontAddress2Text);
    }

    y += 15;
    frontLocationText = new Konva.Text({
        text: canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 200 * scale,
        y: y * scale,
        fill: parseInt(canvasValues.color) === 2 ? '#000' : '#76787b',
    });
    frontDataLayer.add(frontLocationText);
}

export const destroyFrontVariablesP3T3 = () => {
    if (frontLogo1Img) {
        frontLogo1Img.destroy();
    }
    if (frontNameText) {
        frontNameText.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (frontLocationText) {
        frontLocationText.destroy();
    }
}

export const initP3T4FrontCanvas = () => {
    drawFrontVariablesP3T4();
}

export const drawFrontVariablesP3T4 = () => {
    let color = '#b66645';
    let svgImage = 'utp-no10-envelope-color.svg';
    if (parseInt(canvasValues.color) === 2) {
        color = '#000';
        svgImage = 'utp-no10-envelope-bw.svg';
    }

    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/vectors/' + svgImage, (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontDataLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 1008 * scale,
            height: 471 * scale,
        });
        frontDataLayer.draw();
    });

    let y = 96;
    frontDepartment1Text = new Konva.Text({
        text: canvasValues.department1,
        fontSize: convertPointsToPixels(7.5) * scale,
        fontFamily: 'UniversBold',
        x: 57 * scale,
        y: y * scale,
        fill: color,
    });
    frontDataLayer.add(frontDepartment1Text);
    y += 15;

    if (canvasValues.department2 !== '') {
        frontDepartment2Text = new Konva.Text({
            text: canvasValues.department2,
            fontSize: convertPointsToPixels(7.5) * scale,
            fontFamily: 'UniversBold',
            x: 57 * scale,
            y: y * scale,
            fill: color,
        });
        frontDataLayer.add(frontDepartment2Text);
        y += 15;
    }

    y += 1;
    frontAddress1Text = new Konva.Text({
        text: getAddressLine1P3T4(),
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 57 * scale,
        y: y * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontAddress1Text);
    y += 16;

    frontAddress2Text = new Konva.Text({
        text: getAddressLine2P3T4(),
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 57 * scale,
        y: y * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontAddress2Text);
    y += 16;
}

export const getAddressLine1P3T4 = () => {
    let addressParts1 = [canvasValues.address];
    if (canvasValues.suiteRoom !== '') {
        addressParts1.push(canvasValues.suiteRoom);
    }
    return addressParts1.join(', ');
}

export const getAddressLine2P3T4 = () => {
    return canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip;
}

export const destroyFrontVariablesP3T4 = () => {
    if (frontLogo1Img) {
        frontLogo1Img.destroy();
    }
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
}

export const initP3T5FrontCanvas = () => {
    drawFrontVariablesP3T5();
}

export const drawFrontVariablesP3T5 = () => {
    let color = '#b66645';
    let svgImage = 'utp-a6-envelope-color.svg';
    if (parseInt(canvasValues.color) === 2) {
        color = '#000';
        svgImage = 'utp-a6-envelope-bw.svg';
    }

    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/vectors/' + svgImage, (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontDataLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 708 * scale,
            height: 533 * scale,
        });
        frontDataLayer.draw();
    });

    let y = 96;
    frontDepartment1Text = new Konva.Text({
        text: canvasValues.department1,
        fontSize: convertPointsToPixels(7.5) * scale,
        fontFamily: 'UniversBold',
        x: 57 * scale,
        y: y * scale,
        fill: color,
    });
    frontDataLayer.add(frontDepartment1Text);
    y += 15;

    if (canvasValues.department2 !== '') {
        frontDepartment2Text = new Konva.Text({
            text: canvasValues.department2,
            fontSize: convertPointsToPixels(7.5) * scale,
            fontFamily: 'UniversBold',
            x: 57 * scale,
            y: y * scale,
            fill: color,
        });
        frontDataLayer.add(frontDepartment2Text);
        y += 15;
    }

    y += 1;
    frontAddress1Text = new Konva.Text({
        text: getAddressLine1P3T5(),
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 57 * scale,
        y: y * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontAddress1Text);
    y += 16;

    frontAddress2Text = new Konva.Text({
        text: getAddressLine2P3T5(),
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 57 * scale,
        y: y * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontAddress2Text);
    y += 16;
}

export const getAddressLine1P3T5 = () => {
    let addressParts1 = [canvasValues.address];
    if (canvasValues.suiteRoom !== '') {
        addressParts1.push(canvasValues.suiteRoom);
    }
    return addressParts1.join(', ');
}

export const getAddressLine2P3T5 = () => {
    return canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip;
}

export const destroyFrontVariablesP3T5 = () => {
    if (frontLogo1Img) {
        frontLogo1Img.destroy();
    }
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
}

export const initP3T6FrontCanvas = () => {
    Konva.Image.fromURL(require('./images/no10-window.png'), (image) => {
        frontDataLayer.add(image);
        image.setAttrs({
            x: 100 * scale,
            y: 240 * scale,
            width: 450 * scale,
            height: 110 * scale,
        });
        frontDataLayer.draw();
    });

    drawFrontVariablesP3T6();
}

export const drawFrontVariablesP3T6 = () => {
    let color = '#b66645';
    let svgImage = 'utp-no10-envelope-color.svg';
    if (parseInt(canvasValues.color) === 2) {
        color = '#000';
        svgImage = 'utp-no10-envelope-bw.svg';
    }

    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/vectors/' + svgImage, (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontDataLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 1008 * scale,
            height: 471 * scale,
        });
        frontDataLayer.draw();
    });

    let y = 96;
    frontDepartment1Text = new Konva.Text({
        text: canvasValues.department1,
        fontSize: convertPointsToPixels(7.5) * scale,
        fontFamily: 'UniversBold',
        x: 57 * scale,
        y: y * scale,
        fill: color,
    });
    frontDataLayer.add(frontDepartment1Text);
    y += 15;

    if (canvasValues.department2 !== '') {
        frontDepartment2Text = new Konva.Text({
            text: canvasValues.department2,
            fontSize: convertPointsToPixels(7.5) * scale,
            fontFamily: 'UniversBold',
            x: 57 * scale,
            y: y * scale,
            fill: color,
        });
        frontDataLayer.add(frontDepartment2Text);
        y += 15;
    }

    y += 1;
    frontAddress1Text = new Konva.Text({
        text: getAddressLine1P3T4(),
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 57 * scale,
        y: y * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontAddress1Text);
    y += 16;

    frontAddress2Text = new Konva.Text({
        text: getAddressLine2P3T4(),
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 57 * scale,
        y: y * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontAddress2Text);
    y += 16;
}

export const getAddressLine1P3T6 = () => {
    let addressParts1 = [canvasValues.address];
    if (canvasValues.suiteRoom !== '') {
        addressParts1.push(canvasValues.suiteRoom);
    }
    return addressParts1.join(', ');
}

export const getAddressLine2P3T6 = () => {
    return canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip;
}

export const destroyFrontVariablesP3T6 = () => {
    if (frontLogo1Img) {
        frontLogo1Img.destroy();
    }
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
}

export const initP4T1FrontCanvas = () => {
    const line = new Konva.Line({
        points: [
            0 * scale, 475 * scale,
            600 * scale, 475 * scale
        ],
        dash: [5 * scale, 4 * scale],
        stroke: '#78787b',
        strokeWidth: 1
    });
    frontDataLayer.add(line);

    drawFrontVariablesP4T1();
}

export const drawFrontVariablesP4T1 = () => {
    if (parseInt(canvasValues.color) === 2) {
        frontBackgroundRect = new Konva.Rect({
            x: 0 * scale,
            y: 0 * scale,
            width: 600 * scale,
            height: 475 * scale,
            fill: '#bb6847',
        });
        frontDataLayer.add(frontBackgroundRect);
    }

    let svgImage = 'uthealth-utphysicians-logo.svg';
    if (parseInt(canvasValues.color) === 3) {
        svgImage = 'uthealth-utphysicians-logo-black.svg';
    }

    Konva.Image.fromURL(require('./images/' + svgImage), (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontDataLayer.add(image);
        image.setAttrs({
            x: 188 * scale,
            y: 570 * scale,
            width: 180 * 1.25 * scale,
            height: 152 * 1.25 * scale,
        });
        frontDataLayer.draw();
    });
}

export const destroyFrontVariablesP4T1 = () => {
    if (frontBackgroundRect) {
        frontBackgroundRect.destroy();
    }
    if (frontLogo1Img) {
        frontLogo1Img.destroy();
    }
}

export const initP9FrontCanvas = () => {
    drawFrontVariablesP9();
}

export const drawFrontVariablesP9 = () => {
    let backgroundUrl = null;
    let frontColor = '#000';
    let frontFamily = 'AGaramondProRegular';
    let logoUrl = null;

    if (parseInt(canvasValues.front) === 2) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/grey-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 3) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/orange-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 4) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/blue-background-low.jpg';
    }

    if (canvasValues.templateCode === 'p9t1') {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/cizik-logo-regular.svg';
        if (parseInt(canvasValues.front) === 2) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/cizik-logo-orange-white.svg';
        } else if (parseInt(canvasValues.front) === 3) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/cizik-logo-white.svg';
        } else if (parseInt(canvasValues.front) === 4) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/cizik-logo-orange-white.svg';
        }
    } else if (canvasValues.templateCode === 'p9t2') {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/mcgovern-logo-regular.svg';
        if (parseInt(canvasValues.front) === 2) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/mcgovern-logo-orange-white.svg';
        } else if (parseInt(canvasValues.front) === 3) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/mcgovern-logo-white.svg';
        } else if (parseInt(canvasValues.front) === 4) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/mcgovern-logo-orange-white.svg';
        }
    } else if (canvasValues.templateCode === 'p9t3') {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/md-anderson-logo-regular.svg';
        if (parseInt(canvasValues.front) === 2) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/md-anderson-logo-orange-white.svg';
        }
    } else if (canvasValues.templateCode === 'p9t4') {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/biomedical-informatics-logo-regular.svg';
        if (parseInt(canvasValues.front) === 2) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/biomedical-informatics-logo-orange-white.svg';
        } else if (parseInt(canvasValues.front) === 3) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/biomedical-informatics-logo-white.svg';
        } else if (parseInt(canvasValues.front) === 4) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/biomedical-informatics-logo-orange-white.svg';
        }
    } else if (canvasValues.templateCode === 'p9t5') {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/dentistry-logo-regular.svg';
        if (parseInt(canvasValues.front) === 2) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/dentistry-logo-orange-white.svg';
        } else if (parseInt(canvasValues.front) === 3) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/dentistry-logo-white.svg';
        } else if (parseInt(canvasValues.front) === 4) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/dentistry-logo-orange-white.svg';
        }
    } else if (canvasValues.templateCode === 'p9t6') {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/public-health-logo-regular.svg';
        if (parseInt(canvasValues.front) === 2) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/public-health-logo-orange-white.svg';
        } else if (parseInt(canvasValues.front) === 3) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/public-health-logo-white.svg';
        } else if (parseInt(canvasValues.front) === 4) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/public-health-logo-orange-white.svg';
        }
    } else if (canvasValues.templateCode === 'p9t7') {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/general-logo-regular.svg';
        if (parseInt(canvasValues.front) === 2) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/general-logo-orange-white.svg';
        } else if (parseInt(canvasValues.front) === 3) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/general-logo-white.svg';
        } else if (parseInt(canvasValues.front) === 4) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/general-logo-orange-white.svg';
        }
    } else if (canvasValues.templateCode === 'p9t8') {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/general-social-logo-regular.svg';
        if (parseInt(canvasValues.front) === 2) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/general-social-logo-orange-white.svg';
        } else if (parseInt(canvasValues.front) === 3) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/general-social-logo-white.svg';
        } else if (parseInt(canvasValues.front) === 4) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/general-social-logo-orange-white.svg';
        }
    } else if (canvasValues.templateCode === 'p9t9') {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/health-services-logo-regular.svg';
        if (parseInt(canvasValues.front) === 2) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/health-services-logo-orange-white.svg';
        } else if (parseInt(canvasValues.front) === 3) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/health-services-logo-white.svg';
        } else if (parseInt(canvasValues.front) === 4) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/health-services-logo-orange-white.svg';
        }
    } else if (canvasValues.templateCode === 'p9t10') {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/p9t10-front-regular.svg';
        if (parseInt(canvasValues.front) === 2) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/p9t10-front-orange-white.svg';
        } else if (parseInt(canvasValues.front) === 3) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/health-services-logo-white.svg';
        } else if (parseInt(canvasValues.front) === 4) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/p9t10-front-white.svg';
        }
    }

    let prevFront = '';
    if (canvasValues.prevFront !== '') {
        prevFront = parseInt(canvasValues.prevFront);
    }

    let prevLogo = '';
    if (canvasValues.prevLogo !== '') {
        prevLogo = parseInt(canvasValues.prevLogo);
    }

    let front = '';
    if (canvasValues.front !== '') {
        front = parseInt(canvasValues.front);
    }

    if (prevFront !== front) {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontBackgroundLayer.draw();

        if (backgroundUrl != null) {
            Konva.Image.fromURL(backgroundUrl, (image) => {
                if (frontLogo1Img != null) {
                    frontLogo1Img.destroy();
                }
                frontLogo1Img = image;

                frontBackgroundLayer.add(image);
                image.setAttrs({
                    x: -29 * scale,
                    y: -29 * scale,
                    width: 408 * scale,
                    height: 258 * scale,
                });
                frontBackgroundLayer.draw();

                canvasValues.prevFront = canvasValues.front;
            });
        } else {
            canvasValues.prevFront = 1;
        }
    }

    if (prevLogo !== front) {
        if (frontLogo2Img != null) {
            frontLogo2Img.destroy();
        }
        frontDataLayer.draw();

        Konva.Image.fromURL(logoUrl, (image) => {
            if (frontLogo2Img != null) {
                frontLogo2Img.destroy();
            }
            frontLogo2Img = image;

            frontDataLayer.add(image);
            image.setAttrs({
                x: -29 * scale,
                y: -29 * scale,
                width: 408 * scale,
                height: 258 * scale,
            });
            frontDataLayer.draw();

            canvasValues.prevLogo = canvasValues.front;
        });
    }

    if (canvasValues.templateCode === 'p9t9') {
        mainPhoneText = createText(frontFamily, 7, '713-500-3267', 147, 127, frontColor);
        frontDataLayer.add(mainPhoneText);

        mainDaysText = createText(frontFamily, 7, 'Monday-Friday 7 am - 4 pm', 51, 139, frontColor);
        frontDataLayer.add(mainDaysText);

        mainDividerText = createText('UniversLT49LightUltraCondensed', 7, '|', 165, 138.5, frontColor);
        frontDataLayer.add(mainDividerText);

        mainHoursText = createText(frontFamily, 7, 'Open during lunch, Noon-1 pm', 173, 139, frontColor);
        frontDataLayer.add(mainHoursText);
    }

    frontAddress1Text = createText(frontFamily, 7, canvasValues.suiteRoom, 0, 166, frontColor);
    frontDataLayer.add(frontAddress1Text);

    frontAddressDividerText = createText('UniversLT49LightUltraCondensed', 7, '|', 0, 165.5, frontColor);
    frontDataLayer.add(frontAddressDividerText);

    frontAddress2Text = createText(frontFamily, 7, canvasValues.address2, 0, 166, frontColor);
    frontDataLayer.add(frontAddress2Text);

    const totalWidth = frontAddress1Text.width() + frontAddressDividerText.width() + frontAddress2Text.width() + 8 * scale;
    frontAddress1Text.x((350 * scale - totalWidth) / 2);
    frontAddressDividerText.x(frontAddress1Text.x() + frontAddress1Text.width() + 4 * scale);
    frontAddress2Text.x(frontAddressDividerText.x() + frontAddressDividerText.width() + 4 * scale);

    canvasValues.frontDividers = {
        frontAddress1: frontAddress1Text.x() / scale,
        frontAddressDivider: frontAddressDividerText.x() / scale,
        frontAddress2Text: frontAddress2Text.x() / scale,
    };
}

export const destroyFrontVariablesP9 = () => {
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddressDividerText) {
        frontAddressDividerText.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (mainPhoneText) {
        mainPhoneText.destroy();
    }
    if (mainDaysText) {
        mainDaysText.destroy();
    }
    if (mainDividerText) {
        mainDividerText.destroy();
    }
    if (mainHoursText) {
        mainHoursText.destroy();
    }
    frontBackgroundLayer.draw();
}

export const initP9T11FrontCanvas = () => {
    drawFrontVariablesP9T11();
}

export const drawFrontVariablesP9T11 = () => {
    let backgroundUrl = null;
    let frontColor = '#000';
    let frontFamily = 'AGaramondProRegular';
    let logoUrl = null;

    if (parseInt(canvasValues.front) === 2) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/grey-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 3) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/orange-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 4) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/blue-background-low.jpg';
    }

    logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/p9t11-front-background-regular.svg';
    if (parseInt(canvasValues.front) === 2) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/p9t11-front-background-orange-white.svg';
    } else if (parseInt(canvasValues.front) === 3) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/p9t11-front-background-white.svg';
    } else if (parseInt(canvasValues.front) === 4) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/p9t11-front-background-orange-white.svg';
    }

    let prevFront = '';
    if (canvasValues.prevFront !== '') {
        prevFront = parseInt(canvasValues.prevFront);
    }

    let prevLogo = '';
    if (canvasValues.prevLogo !== '') {
        prevLogo = parseInt(canvasValues.prevLogo);
    }

    let front = '';
    if (canvasValues.front !== '') {
        front = parseInt(canvasValues.front);
    }

    if (prevFront !== front) {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontBackgroundLayer.draw();

        if (backgroundUrl != null) {
            Konva.Image.fromURL(backgroundUrl, (image) => {
                if (frontLogo1Img != null) {
                    frontLogo1Img.destroy();
                }
                frontLogo1Img = image;

                frontBackgroundLayer.add(image);
                image.setAttrs({
                    x: -29 * scale,
                    y: -29 * scale,
                    width: 408 * scale,
                    height: 258 * scale,
                });
                frontBackgroundLayer.draw();

                canvasValues.prevFront = canvasValues.front;
            });
        } else {
            canvasValues.prevFront = 1;
        }
    }

    if (prevLogo !== front) {
        if (frontLogo2Img != null) {
            frontLogo2Img.destroy();
        }
        frontDataLayer.draw();

        Konva.Image.fromURL(logoUrl, (image) => {
            if (frontLogo2Img != null) {
                frontLogo2Img.destroy();
            }
            frontLogo2Img = image;

            frontDataLayer.add(image);
            image.setAttrs({
                x: -29 * scale,
                y: -29 * scale,
                width: 408 * scale,
                height: 258 * scale,
            });
            frontDataLayer.draw();

            canvasValues.prevLogo = canvasValues.front;
        });
    }

    frontAddress1Text = createText(frontFamily, 7, canvasValues.suiteRoom, 0, 166, frontColor);
    frontDataLayer.add(frontAddress1Text);

    frontAddressDividerText = createText('UniversLT49LightUltraCondensed', 7, '|', 0, 165.5, frontColor);
    frontDataLayer.add(frontAddressDividerText);

    frontAddress2Text = createText(frontFamily, 7, canvasValues.address2, 0, 166, frontColor);
    frontDataLayer.add(frontAddress2Text);

    const totalWidth = frontAddress1Text.width() + frontAddressDividerText.width() + frontAddress2Text.width() + 8 * scale;
    frontAddress1Text.x((350 * scale - totalWidth) / 2);
    frontAddressDividerText.x(frontAddress1Text.x() + frontAddress1Text.width() + 4 * scale);
    frontAddress2Text.x(frontAddressDividerText.x() + frontAddressDividerText.width() + 4 * scale);

    canvasValues.frontDividers = {
        frontAddress1: frontAddress1Text.x() / scale,
        frontAddressDivider: frontAddressDividerText.x() / scale,
        frontAddress2Text: frontAddress2Text.x() / scale,
    };
}

export const destroyFrontVariablesP9T11 = () => {
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddressDividerText) {
        frontAddressDividerText.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (mainPhoneText) {
        mainPhoneText.destroy();
    }
    if (mainDaysText) {
        mainDaysText.destroy();
    }
    if (mainDividerText) {
        mainDividerText.destroy();
    }
    if (mainHoursText) {
        mainHoursText.destroy();
    }
    frontBackgroundLayer.draw();
}

export const initP9T12FrontCanvas = () => {
    drawFrontVariablesP9T12();
}

export const drawFrontVariablesP9T12 = () => {
    let backgroundUrl = null;
    let frontColor = '#000';
    let frontFamily = 'AGaramondProRegular';
    let logoUrl = null;

    if (parseInt(canvasValues.front) === 2) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/grey-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 3) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/orange-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 4) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/blue-background-low.jpg';
    }

    if (parseInt(canvasValues.showSocialMediaIcons) === 1) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/p9t12-front-background-icons-regular.svg';
        if (parseInt(canvasValues.front) === 2) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/p9t12-front-background-icons-orange-white.svg';
        } else if (parseInt(canvasValues.front) === 3) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/p9t12-front-background-icons-white.svg';
        } else if (parseInt(canvasValues.front) === 4) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/p9t12-front-background-icons-orange-white.svg';
        }
    } else {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/p9t12-front-background-regular.svg';
        if (parseInt(canvasValues.front) === 2) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/p9t12-front-background-orange-white.svg';
        } else if (parseInt(canvasValues.front) === 3) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/p9t12-front-background-white.svg';
        } else if (parseInt(canvasValues.front) === 4) {
            logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/p9t12-front-background-orange-white.svg';
        }
    }

    let prevFront = '';
    if (canvasValues.prevFront !== '') {
        prevFront = parseInt(canvasValues.prevFront);
    }

    let prevLogo = '';
    if (canvasValues.prevLogo !== '') {
        prevLogo = parseInt(canvasValues.prevLogo);
    }

    let front = '';
    if (canvasValues.front !== '') {
        front = parseInt(canvasValues.front);
    }

    let prevShowSocialMediaIcons = parseInt(canvasValues.prevShowSocialMediaIcons);
    let showSocialMediaIcons = parseInt(canvasValues.showSocialMediaIcons);

    if (prevFront !== front) {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontBackgroundLayer.draw();

        if (backgroundUrl != null) {
            Konva.Image.fromURL(backgroundUrl, (image) => {
                if (frontLogo1Img != null) {
                    frontLogo1Img.destroy();
                }
                frontLogo1Img = image;

                frontBackgroundLayer.add(image);
                image.setAttrs({
                    x: -29 * scale,
                    y: -29 * scale,
                    width: 408 * scale,
                    height: 258 * scale,
                });
                frontBackgroundLayer.draw();

                canvasValues.prevFront = canvasValues.front;
            });
        } else {
            canvasValues.prevFront = 1;
        }
    }

    if (prevLogo !== front || prevShowSocialMediaIcons !== showSocialMediaIcons) {
        if (frontLogo2Img != null) {
            frontLogo2Img.destroy();
        }
        frontDataLayer.draw();

        Konva.Image.fromURL(logoUrl, (image) => {
            if (frontLogo2Img != null) {
                frontLogo2Img.destroy();
            }
            frontLogo2Img = image;

            frontDataLayer.add(image);
            image.setAttrs({
                x: -29 * scale,
                y: -29 * scale,
                width: 408 * scale,
                height: 258 * scale,
            });
            frontDataLayer.draw();

            canvasValues.prevLogo = canvasValues.front;
            canvasValues.prevShowSocialMediaIcons = canvasValues.showSocialMediaIcons;
        });
    }

    frontAddress1Text = createText(frontFamily, 7, canvasValues.suiteRoom, 0, 166, frontColor);
    frontDataLayer.add(frontAddress1Text);

    frontAddressDividerText = createText('UniversLT49LightUltraCondensed', 7, '|', 0, 165.5, frontColor);
    frontDataLayer.add(frontAddressDividerText);

    frontAddress2Text = createText(frontFamily, 7, canvasValues.address2, 0, 166, frontColor);
    frontDataLayer.add(frontAddress2Text);

    const totalWidth = frontAddress1Text.width() + frontAddressDividerText.width() + frontAddress2Text.width() + 8 * scale;
    frontAddress1Text.x((350 * scale - totalWidth) / 2);
    frontAddressDividerText.x(frontAddress1Text.x() + frontAddress1Text.width() + 4 * scale);
    frontAddress2Text.x(frontAddressDividerText.x() + frontAddressDividerText.width() + 4 * scale);

    canvasValues.frontDividers = {
        frontAddress1: frontAddress1Text.x() / scale,
        frontAddressDivider: frontAddressDividerText.x() / scale,
        frontAddress2Text: frontAddress2Text.x() / scale,
    };
}

export const destroyFrontVariablesP9T12 = () => {
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddressDividerText) {
        frontAddressDividerText.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (mainPhoneText) {
        mainPhoneText.destroy();
    }
    if (mainDaysText) {
        mainDaysText.destroy();
    }
    if (mainDividerText) {
        mainDividerText.destroy();
    }
    if (mainHoursText) {
        mainHoursText.destroy();
    }
    frontBackgroundLayer.draw();
}

export const initP9T13FrontCanvas = () => {
    drawFrontVariablesP9T13();
}

export const drawFrontVariablesP9T13 = () => {
    let backgroundUrl = null;
    let frontColor = '#000';
    let frontFamily = 'AGaramondProRegular';
    let logoUrl = null;

    if (parseInt(canvasValues.front) === 2) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/grey-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 3) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/orange-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 4) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/blue-background-low.jpg';
    }

    logoUrl = 'https://ac-ut-health.s3.us-east-1.amazonaws.com/vectors/p9t113-front-regular.svg';
    if (parseInt(canvasValues.front) === 2) {
        logoUrl = 'https://ac-ut-health.s3.us-east-1.amazonaws.com/vectors/p9t13-front-orange-white.svg';
    } else if (parseInt(canvasValues.front) === 3) {
        logoUrl = 'https://ac-ut-health.s3.us-east-1.amazonaws.com/vectors/p9t13-front-white.svg';
    } else if (parseInt(canvasValues.front) === 4) {
        logoUrl = 'https://ac-ut-health.s3.us-east-1.amazonaws.com/vectors/p9t13-front-orange-white.svg';
    }

    let prevFront = '';
    if (canvasValues.prevFront !== '') {
        prevFront = parseInt(canvasValues.prevFront);
    }

    let prevLogo = '';
    if (canvasValues.prevLogo !== '') {
        prevLogo = parseInt(canvasValues.prevLogo);
    }

    let front = '';
    if (canvasValues.front !== '') {
        front = parseInt(canvasValues.front);
    }

    if (prevFront !== front) {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontBackgroundLayer.draw();

        if (backgroundUrl != null) {
            Konva.Image.fromURL(backgroundUrl, (image) => {
                if (frontLogo1Img != null) {
                    frontLogo1Img.destroy();
                }
                frontLogo1Img = image;

                frontBackgroundLayer.add(image);
                image.setAttrs({
                    x: -29 * scale,
                    y: -29 * scale,
                    width: 408 * scale,
                    height: 258 * scale,
                });
                frontBackgroundLayer.draw();

                canvasValues.prevFront = canvasValues.front;
            });
        } else {
            canvasValues.prevFront = 1;
        }
    }

    if (prevLogo !== front) {
        if (frontLogo2Img != null) {
            frontLogo2Img.destroy();
        }
        frontDataLayer.draw();

        Konva.Image.fromURL(logoUrl, (image) => {
            if (frontLogo2Img != null) {
                frontLogo2Img.destroy();
            }
            frontLogo2Img = image;

            frontDataLayer.add(image);
            image.setAttrs({
                x: -29 * scale,
                y: -29 * scale,
                width: 408 * scale,
                height: 258 * scale,
            });
            frontDataLayer.draw();

            canvasValues.prevLogo = canvasValues.front;
        });
    }

    canvasValues.addressSize = 9;
    frontAddress1Text = createText(frontFamily, canvasValues.addressSize, canvasValues.suiteRoom, 0, 166, frontColor);
    frontAddressDividerText = createText('UniversLT49LightUltraCondensed', canvasValues.addressSize, '|', 0, 165.5, frontColor);
    frontAddress2Text = createText(frontFamily, canvasValues.addressSize, canvasValues.address2, 0, 166, frontColor);

    let width = (frontAddress1Text.width() / scale) + (frontAddressDividerText.width() / scale) + (frontAddress2Text.width() / scale);
    if (width >= 265) {
        canvasValues.addressSize = 8;
        frontAddress1Text = createText(frontFamily, canvasValues.addressSize, canvasValues.suiteRoom, 0, 166, frontColor);
        frontAddressDividerText = createText('UniversLT49LightUltraCondensed', canvasValues.addressSize, '|', 0, 165.5, frontColor);
        frontAddress2Text = createText(frontFamily, canvasValues.addressSize, canvasValues.address2, 0, 166, frontColor);
    }

    frontDataLayer.add(frontAddress1Text);
    frontDataLayer.add(frontAddressDividerText);
    frontDataLayer.add(frontAddress2Text);

    const totalWidth = frontAddress1Text.width() + frontAddressDividerText.width() + frontAddress2Text.width() + 8 * scale;
    frontAddress1Text.x((350 * scale - totalWidth) / 2);
    frontAddressDividerText.x(frontAddress1Text.x() + frontAddress1Text.width() + 4 * scale);
    frontAddress2Text.x(frontAddressDividerText.x() + frontAddressDividerText.width() + 4 * scale);

    canvasValues.frontDividers = {
        frontAddress1: frontAddress1Text.x() / scale,
        frontAddressDivider: frontAddressDividerText.x() / scale,
        frontAddress2Text: frontAddress2Text.x() / scale,
    };
}

export const destroyFrontVariablesP9T13 = () => {
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddressDividerText) {
        frontAddressDividerText.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (mainPhoneText) {
        mainPhoneText.destroy();
    }
    if (mainDaysText) {
        mainDaysText.destroy();
    }
    if (mainDividerText) {
        mainDividerText.destroy();
    }
    if (mainHoursText) {
        mainHoursText.destroy();
    }
    frontBackgroundLayer.draw();
}

export const initP9T14FrontCanvas = () => {
    drawFrontVariablesP9T14();
}

export const drawFrontVariablesP9T14 = () => {
    let backgroundUrl = null;
    let frontColor = '#000';
    let frontFamily = 'AGaramondProRegular';
    let logoUrl = null;

    if (parseInt(canvasValues.front) === 2) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/grey-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 3) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/orange-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 4) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/blue-background-low.jpg';
    }

    logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/general-logo-regular.svg';
    if (parseInt(canvasValues.front) === 2) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/general-logo-orange-white.svg';
    } else if (parseInt(canvasValues.front) === 3) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/general-logo-white.svg';
    } else if (parseInt(canvasValues.front) === 4) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/general-logo-orange-white.svg';
    }

    let prevFront = '';
    if (canvasValues.prevFront !== '') {
        prevFront = parseInt(canvasValues.prevFront);
    }

    let prevLogo = '';
    if (canvasValues.prevLogo !== '') {
        prevLogo = parseInt(canvasValues.prevLogo);
    }

    let front = '';
    if (canvasValues.front !== '') {
        front = parseInt(canvasValues.front);
    }

    if (prevFront !== front) {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontBackgroundLayer.draw();

        if (backgroundUrl != null) {
            Konva.Image.fromURL(backgroundUrl, (image) => {
                if (frontLogo1Img != null) {
                    frontLogo1Img.destroy();
                }
                frontLogo1Img = image;

                frontBackgroundLayer.add(image);
                image.setAttrs({
                    x: -29 * scale,
                    y: -29 * scale,
                    width: 408 * scale,
                    height: 258 * scale,
                });
                frontBackgroundLayer.draw();

                canvasValues.prevFront = canvasValues.front;
            });
        } else {
            canvasValues.prevFront = 1;
        }
    }

    if (prevLogo !== front) {
        if (frontLogo2Img != null) {
            frontLogo2Img.destroy();
        }
        frontDataLayer.draw();

        Konva.Image.fromURL(logoUrl, (image) => {
            if (frontLogo2Img != null) {
                frontLogo2Img.destroy();
            }
            frontLogo2Img = image;

            frontDataLayer.add(image);
            image.setAttrs({
                x: -29 * scale,
                y: -29 * scale,
                width: 408 * scale,
                height: 258 * scale,
            });
            frontDataLayer.draw();

            canvasValues.prevLogo = canvasValues.front;
        });
    }

    canvasValues.addressSize = 9;
    frontAddress1Text = createText(frontFamily, canvasValues.addressSize, canvasValues.suiteRoom, 0, 166, frontColor);
    frontAddressDividerText = createText('UniversLT49LightUltraCondensed', canvasValues.addressSize, '|', 0, 165.5, frontColor);
    frontAddress2Text = createText(frontFamily, canvasValues.addressSize, canvasValues.address2, 0, 166, frontColor);

    let width = (frontAddress1Text.width() / scale) + (frontAddressDividerText.width() / scale) + (frontAddress2Text.width() / scale);
    if (width >= 265) {
        canvasValues.addressSize = 8;
        frontAddress1Text = createText(frontFamily, canvasValues.addressSize, canvasValues.suiteRoom, 0, 166, frontColor);
        frontAddressDividerText = createText('UniversLT49LightUltraCondensed', canvasValues.addressSize, '|', 0, 165.5, frontColor);
        frontAddress2Text = createText(frontFamily, canvasValues.addressSize, canvasValues.address2, 0, 166, frontColor);
    }

    frontDataLayer.add(frontAddress1Text);
    frontDataLayer.add(frontAddressDividerText);
    frontDataLayer.add(frontAddress2Text);

    const totalWidth = frontAddress1Text.width() + frontAddressDividerText.width() + frontAddress2Text.width() + 8 * scale;
    frontAddress1Text.x((350 * scale - totalWidth) / 2);
    frontAddressDividerText.x(frontAddress1Text.x() + frontAddress1Text.width() + 4 * scale);
    frontAddress2Text.x(frontAddressDividerText.x() + frontAddressDividerText.width() + 4 * scale);

    canvasValues.frontDividers = {
        frontAddress1: frontAddress1Text.x() / scale,
        frontAddressDivider: frontAddressDividerText.x() / scale,
        frontAddress2Text: frontAddress2Text.x() / scale,
    };
}

export const destroyFrontVariablesP9T14 = () => {
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddressDividerText) {
        frontAddressDividerText.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (mainPhoneText) {
        mainPhoneText.destroy();
    }
    if (mainDaysText) {
        mainDaysText.destroy();
    }
    if (mainDividerText) {
        mainDividerText.destroy();
    }
    if (mainHoursText) {
        mainHoursText.destroy();
    }
    frontBackgroundLayer.draw();
}

export const initP9T15FrontCanvas = () => {
    drawFrontVariablesP9T15();
}

export const drawFrontVariablesP9T15 = () => {
    let backgroundUrl = null;
    let frontColor = '#000';
    let frontFamily = 'AGaramondProRegular';
    let logoUrl = null;

    if (parseInt(canvasValues.front) === 2) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/grey-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 3) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/orange-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 4) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/blue-background-low.jpg';
    }

    logoUrl = 'https://ac-ut-health.s3.us-east-1.amazonaws.com/vectors/general-social-logo-regular-04292025.svg';
    if (parseInt(canvasValues.front) === 2) {
        logoUrl = 'https://ac-ut-health.s3.us-east-1.amazonaws.com/vectors/general-social-logo-orange-white-04292025.svg';
    } else if (parseInt(canvasValues.front) === 3) {
        logoUrl = 'https://ac-ut-health.s3.us-east-1.amazonaws.com/vectors/general-social-logo-white-04292025.svg';
    } else if (parseInt(canvasValues.front) === 4) {
        logoUrl = 'https://ac-ut-health.s3.us-east-1.amazonaws.com/vectors/general-social-logo-orange-white-04292025.svg';
    }

    let prevFront = '';
    if (canvasValues.prevFront !== '') {
        prevFront = parseInt(canvasValues.prevFront);
    }

    let prevLogo = '';
    if (canvasValues.prevLogo !== '') {
        prevLogo = parseInt(canvasValues.prevLogo);
    }

    let front = '';
    if (canvasValues.front !== '') {
        front = parseInt(canvasValues.front);
    }

    if (prevFront !== front) {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontBackgroundLayer.draw();

        if (backgroundUrl != null) {
            Konva.Image.fromURL(backgroundUrl, (image) => {
                if (frontLogo1Img != null) {
                    frontLogo1Img.destroy();
                }
                frontLogo1Img = image;

                frontBackgroundLayer.add(image);
                image.setAttrs({
                    x: -29 * scale,
                    y: -29 * scale,
                    width: 408 * scale,
                    height: 258 * scale,
                });
                frontBackgroundLayer.draw();

                canvasValues.prevFront = canvasValues.front;
            });
        } else {
            canvasValues.prevFront = 1;
        }
    }

    if (prevLogo !== front) {
        if (frontLogo2Img != null) {
            frontLogo2Img.destroy();
        }
        frontDataLayer.draw();

        Konva.Image.fromURL(logoUrl, (image) => {
            if (frontLogo2Img != null) {
                frontLogo2Img.destroy();
            }
            frontLogo2Img = image;

            frontDataLayer.add(image);
            image.setAttrs({
                x: -29 * scale,
                y: -29 * scale,
                width: 408 * scale,
                height: 258 * scale,
            });
            frontDataLayer.draw();

            canvasValues.prevLogo = canvasValues.front;
        });
    }

    canvasValues.addressSize = 9;
    frontAddress1Text = createText(frontFamily, canvasValues.addressSize, canvasValues.suiteRoom, 0, 166, frontColor);
    frontAddressDividerText = createText('UniversLT49LightUltraCondensed', canvasValues.addressSize, '|', 0, 165.5, frontColor);
    frontAddress2Text = createText(frontFamily, canvasValues.addressSize, canvasValues.address2, 0, 166, frontColor);

    let width = (frontAddress1Text.width() / scale) + (frontAddressDividerText.width() / scale) + (frontAddress2Text.width() / scale);
    if (width >= 265) {
        canvasValues.addressSize = 8;
        frontAddress1Text = createText(frontFamily, canvasValues.addressSize, canvasValues.suiteRoom, 0, 166, frontColor);
        frontAddressDividerText = createText('UniversLT49LightUltraCondensed', canvasValues.addressSize, '|', 0, 165.5, frontColor);
        frontAddress2Text = createText(frontFamily, canvasValues.addressSize, canvasValues.address2, 0, 166, frontColor);
    }

    frontDataLayer.add(frontAddress1Text);
    frontDataLayer.add(frontAddressDividerText);
    frontDataLayer.add(frontAddress2Text);

    const totalWidth = frontAddress1Text.width() + frontAddressDividerText.width() + frontAddress2Text.width() + 8 * scale;
    frontAddress1Text.x((350 * scale - totalWidth) / 2);
    frontAddressDividerText.x(frontAddress1Text.x() + frontAddress1Text.width() + 4 * scale);
    frontAddress2Text.x(frontAddressDividerText.x() + frontAddressDividerText.width() + 4 * scale);

    canvasValues.frontDividers = {
        frontAddress1: frontAddress1Text.x() / scale,
        frontAddressDivider: frontAddressDividerText.x() / scale,
        frontAddress2Text: frontAddress2Text.x() / scale,
    };
}

export const destroyFrontVariablesP9T15 = () => {
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddressDividerText) {
        frontAddressDividerText.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (mainPhoneText) {
        mainPhoneText.destroy();
    }
    if (mainDaysText) {
        mainDaysText.destroy();
    }
    if (mainDividerText) {
        mainDividerText.destroy();
    }
    if (mainHoursText) {
        mainHoursText.destroy();
    }
    frontBackgroundLayer.draw();
}

export const initP9T16FrontCanvas = () => {
    drawFrontVariablesP9T16();
}

export const drawFrontVariablesP9T16 = () => {
    let backgroundUrl = null;
    let frontColor = '#000';
    let frontFamily = 'AGaramondProRegular';
    let logoUrl = null;

    if (parseInt(canvasValues.front) === 2) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/grey-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 3) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/orange-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 4) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/blue-background-low.jpg';
    }

    logoUrl = 'https://ac-ut-health.s3.us-east-1.amazonaws.com/vectors/executives-regular-04292025.svg';
    if (parseInt(canvasValues.front) === 2) {
        logoUrl = 'https://ac-ut-health.s3.us-east-1.amazonaws.com/vectors/executives-orange-white-04292025.svg';
    } else if (parseInt(canvasValues.front) === 3) {
        logoUrl = 'https://ac-ut-health.s3.us-east-1.amazonaws.com/vectors/executives-white-04292025.svg';
    } else if (parseInt(canvasValues.front) === 4) {
        logoUrl = 'https://ac-ut-health.s3.us-east-1.amazonaws.com/vectors/executives-orange-white-04292025.svg';
    }

    let prevFront = '';
    if (canvasValues.prevFront !== '') {
        prevFront = parseInt(canvasValues.prevFront);
    }

    let prevLogo = '';
    if (canvasValues.prevLogo !== '') {
        prevLogo = parseInt(canvasValues.prevLogo);
    }

    let front = '';
    if (canvasValues.front !== '') {
        front = parseInt(canvasValues.front);
    }

    if (prevFront !== front) {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontBackgroundLayer.draw();

        if (backgroundUrl != null) {
            Konva.Image.fromURL(backgroundUrl, (image) => {
                if (frontLogo1Img != null) {
                    frontLogo1Img.destroy();
                }
                frontLogo1Img = image;

                frontBackgroundLayer.add(image);
                image.setAttrs({
                    x: -29 * scale,
                    y: -29 * scale,
                    width: 408 * scale,
                    height: 258 * scale,
                });
                frontBackgroundLayer.draw();

                canvasValues.prevFront = canvasValues.front;
            });
        } else {
            canvasValues.prevFront = 1;
        }
    }

    if (prevLogo !== front) {
        if (frontLogo2Img != null) {
            frontLogo2Img.destroy();
        }
        frontDataLayer.draw();

        Konva.Image.fromURL(logoUrl, (image) => {
            if (frontLogo2Img != null) {
                frontLogo2Img.destroy();
            }
            frontLogo2Img = image;

            frontDataLayer.add(image);
            image.setAttrs({
                x: -29 * scale,
                y: -29 * scale,
                width: 408 * scale,
                height: 258 * scale,
            });
            frontDataLayer.draw();

            canvasValues.prevLogo = canvasValues.front;
        });
    }

    let name = canvasValues.firstName;
    if (canvasValues.middleName !== '') {
        name += ' ' + canvasValues.middleName;
    }
    name += ' ' + canvasValues.lastName;
    if (canvasValues.credentials !== '') {
        name += ', ' + canvasValues.credentials;
    }

    let y = 105;
    frontName1Text = new Konva.Text({
        text: name,
        fontSize: convertPointsToPixels(11) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 0 * scale,
        y: y * scale,
        fill: frontColor,
        align: 'center',
        width: 350 * scale,
    });
    frontDataLayer.add(frontName1Text);
    y += 17;

    if (canvasValues.primaryTitle !== '') {
        frontTitle1Text = new Konva.Text({
            text: canvasValues.primaryTitle,
            fontSize: convertPointsToPixels(9) * scale,
            fontFamily: 'AGaramondProItalic',
            x: 0 * scale,
            y: y * scale,
            fill: frontColor,
            align: 'center',
            width: 350 * scale,
        });
        frontDataLayer.add(frontTitle1Text);
        y += 15;
    }

    let frontEmail = 0;
    let frontDivider1 = 0;
    let frontPhone = 0;

    if (canvasValues.main !== '') {
        frontEmailText = createText('AGaramondProRegular', 9, canvasValues.email, 0, y, frontColor);
        frontDivider1Text = createText('UniversLT49LightUltraCondensed', 9, '|', 0, y - 0.5, frontColor);
        frontPhoneText = createText('AGaramondProRegular', 9, canvasValues.main, 0, y, frontColor);

        frontDataLayer.add(frontEmailText);
        frontDataLayer.add(frontDivider1Text);
        frontDataLayer.add(frontPhoneText);

        const totalWidth = frontEmailText.width() + frontDivider1Text.width() + frontPhoneText.width() + 8 * scale;
        frontEmailText.x((350 * scale - totalWidth) / 2);
        frontDivider1Text.x(frontEmailText.x() + frontEmailText.width() + 4 * scale);
        frontPhoneText.x(frontDivider1Text.x() + frontDivider1Text.width() + 4 * scale);

        frontEmail = frontEmailText.x() / scale;
        frontDivider1 = frontDivider1Text.x() / scale;
        frontPhone = frontPhoneText.x() / scale;
    } else {
        frontEmailText = new Konva.Text({
            text: canvasValues.email,
            fontSize: convertPointsToPixels(9) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 0 * scale,
            y: 137 * scale,
            fill: frontColor,
            align: 'center',
            width: 350 * scale,
        });
        frontDataLayer.add(frontEmailText);
    }

    canvasValues.addressSize = 9;
    frontAddress1Text = createText(frontFamily, canvasValues.addressSize, canvasValues.suiteRoom, 0, 166, frontColor);
    frontAddressDividerText = createText('UniversLT49LightUltraCondensed', canvasValues.addressSize, '|', 0, 165.5, frontColor);
    frontAddress2Text = createText(frontFamily, canvasValues.addressSize, canvasValues.address2, 0, 166, frontColor);

    let width = (frontAddress1Text.width() / scale) + (frontAddressDividerText.width() / scale) + (frontAddress2Text.width() / scale);
    if (width >= 265) {
        canvasValues.addressSize = 8;
        frontAddress1Text = createText(frontFamily, canvasValues.addressSize, canvasValues.suiteRoom, 0, 166, frontColor);
        frontAddressDividerText = createText('UniversLT49LightUltraCondensed', canvasValues.addressSize, '|', 0, 165.5, frontColor);
        frontAddress2Text = createText(frontFamily, canvasValues.addressSize, canvasValues.address2, 0, 166, frontColor);
    }

    frontDataLayer.add(frontAddress1Text);
    frontDataLayer.add(frontAddressDividerText);
    frontDataLayer.add(frontAddress2Text);

    const totalWidth = frontAddress1Text.width() + frontAddressDividerText.width() + frontAddress2Text.width() + 8 * scale;
    frontAddress1Text.x((350 * scale - totalWidth) / 2);
    frontAddressDividerText.x(frontAddress1Text.x() + frontAddress1Text.width() + 4 * scale);
    frontAddress2Text.x(frontAddressDividerText.x() + frontAddressDividerText.width() + 4 * scale);

    canvasValues.frontDividers = {
        frontEmail: frontEmail,
        frontDivider1: frontDivider1,
        frontPhone: frontPhone,
        frontAddress1: frontAddress1Text.x() / scale,
        frontAddressDivider: frontAddressDividerText.x() / scale,
        frontAddress2Text: frontAddress2Text.x() / scale,
    };
}

export const destroyFrontVariablesP9T16 = () => {
    if (frontName1Text) {
        frontName1Text.destroy();
    }
    if (frontTitle1Text) {
        frontTitle1Text.destroy();
    }
    if (frontEmailText) {
        frontEmailText.destroy();
    }
    if (frontPhoneText) {
        frontPhoneText.destroy();
    }
    if (frontDivider1Text) {
        frontDivider1Text.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddressDividerText) {
        frontAddressDividerText.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (mainPhoneText) {
        mainPhoneText.destroy();
    }
    if (mainDaysText) {
        mainDaysText.destroy();
    }
    if (mainDividerText) {
        mainDividerText.destroy();
    }
    if (mainHoursText) {
        mainHoursText.destroy();
    }
    frontBackgroundLayer.draw();
}

export const initP9T17FrontCanvas = () => {
    drawFrontVariablesP9T17();
}

export const drawFrontVariablesP9T17 = () => {
    let backgroundUrl = null;
    let frontColor = '#000';
    let frontFamily = 'AGaramondProRegular';
    let logoUrl = null;

    if (parseInt(canvasValues.front) === 2) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/grey-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 3) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/orange-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 4) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/blue-background-low.jpg';
    }

    logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/cizik-logo-regular.svg';
    if (parseInt(canvasValues.front) === 2) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/cizik-logo-orange-white.svg';
    } else if (parseInt(canvasValues.front) === 3) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/cizik-logo-white.svg';
    } else if (parseInt(canvasValues.front) === 4) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/cizik-logo-orange-white.svg';
    }

    let prevFront = '';
    if (canvasValues.prevFront !== '') {
        prevFront = parseInt(canvasValues.prevFront);
    }

    let prevLogo = '';
    if (canvasValues.prevLogo !== '') {
        prevLogo = parseInt(canvasValues.prevLogo);
    }

    let front = '';
    if (canvasValues.front !== '') {
        front = parseInt(canvasValues.front);
    }

    if (prevFront !== front) {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontBackgroundLayer.draw();

        if (backgroundUrl != null) {
            Konva.Image.fromURL(backgroundUrl, (image) => {
                if (frontLogo1Img != null) {
                    frontLogo1Img.destroy();
                }
                frontLogo1Img = image;

                frontBackgroundLayer.add(image);
                image.setAttrs({
                    x: -29 * scale,
                    y: -29 * scale,
                    width: 408 * scale,
                    height: 258 * scale,
                });
                frontBackgroundLayer.draw();

                canvasValues.prevFront = canvasValues.front;
            });
        } else {
            canvasValues.prevFront = 1;
        }
    }

    if (prevLogo !== front) {
        if (frontLogo2Img != null) {
            frontLogo2Img.destroy();
        }
        frontDataLayer.draw();

        Konva.Image.fromURL(logoUrl, (image) => {
            if (frontLogo2Img != null) {
                frontLogo2Img.destroy();
            }
            frontLogo2Img = image;

            frontDataLayer.add(image);
            image.setAttrs({
                x: -29 * scale,
                y: -29 * scale,
                width: 408 * scale,
                height: 258 * scale,
            });
            frontDataLayer.draw();

            canvasValues.prevLogo = canvasValues.front;
        });
    }

    canvasValues.addressSize = 9;
    frontAddress1Text = createText(frontFamily, canvasValues.addressSize, canvasValues.suiteRoom, 0, 166, frontColor);
    frontAddressDividerText = createText('UniversLT49LightUltraCondensed', canvasValues.addressSize, '|', 0, 165.5, frontColor);
    frontAddress2Text = createText(frontFamily, canvasValues.addressSize, canvasValues.address2, 0, 166, frontColor);

    let width = (frontAddress1Text.width() / scale) + (frontAddressDividerText.width() / scale) + (frontAddress2Text.width() / scale);
    if (width >= 265) {
        canvasValues.addressSize = 8;
        frontAddress1Text = createText(frontFamily, canvasValues.addressSize, canvasValues.suiteRoom, 0, 166, frontColor);
        frontAddressDividerText = createText('UniversLT49LightUltraCondensed', canvasValues.addressSize, '|', 0, 165.5, frontColor);
        frontAddress2Text = createText(frontFamily, canvasValues.addressSize, canvasValues.address2, 0, 166, frontColor);
    }

    frontDataLayer.add(frontAddress1Text);
    frontDataLayer.add(frontAddressDividerText);
    frontDataLayer.add(frontAddress2Text);

    const totalWidth = frontAddress1Text.width() + frontAddressDividerText.width() + frontAddress2Text.width() + 8 * scale;
    frontAddress1Text.x((350 * scale - totalWidth) / 2);
    frontAddressDividerText.x(frontAddress1Text.x() + frontAddress1Text.width() + 4 * scale);
    frontAddress2Text.x(frontAddressDividerText.x() + frontAddressDividerText.width() + 4 * scale);

    canvasValues.frontDividers = {
        frontAddress1: frontAddress1Text.x() / scale,
        frontAddressDivider: frontAddressDividerText.x() / scale,
        frontAddress2Text: frontAddress2Text.x() / scale,
    };
}

export const destroyFrontVariablesP9T17 = () => {
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddressDividerText) {
        frontAddressDividerText.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (mainPhoneText) {
        mainPhoneText.destroy();
    }
    if (mainDaysText) {
        mainDaysText.destroy();
    }
    if (mainDividerText) {
        mainDividerText.destroy();
    }
    if (mainHoursText) {
        mainHoursText.destroy();
    }
    frontBackgroundLayer.draw();
}

export const initP9T18FrontCanvas = () => {
    drawFrontVariablesP9T18();
}

export const drawFrontVariablesP9T18 = () => {
    let backgroundUrl = null;
    let frontColor = '#000';
    let frontFamily = 'AGaramondProRegular';
    let logoUrl = null;

    if (parseInt(canvasValues.front) === 2) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/grey-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 3) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/orange-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 4) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/blue-background-low.jpg';
    }

    logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/mcgovern-logo-regular.svg';
    if (parseInt(canvasValues.front) === 2) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/mcgovern-logo-orange-white.svg';
    } else if (parseInt(canvasValues.front) === 3) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/mcgovern-logo-white.svg';
    } else if (parseInt(canvasValues.front) === 4) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/mcgovern-logo-orange-white.svg';
    }

    let prevFront = '';
    if (canvasValues.prevFront !== '') {
        prevFront = parseInt(canvasValues.prevFront);
    }

    let prevLogo = '';
    if (canvasValues.prevLogo !== '') {
        prevLogo = parseInt(canvasValues.prevLogo);
    }

    let front = '';
    if (canvasValues.front !== '') {
        front = parseInt(canvasValues.front);
    }

    if (prevFront !== front) {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontBackgroundLayer.draw();

        if (backgroundUrl != null) {
            Konva.Image.fromURL(backgroundUrl, (image) => {
                if (frontLogo1Img != null) {
                    frontLogo1Img.destroy();
                }
                frontLogo1Img = image;

                frontBackgroundLayer.add(image);
                image.setAttrs({
                    x: -29 * scale,
                    y: -29 * scale,
                    width: 408 * scale,
                    height: 258 * scale,
                });
                frontBackgroundLayer.draw();

                canvasValues.prevFront = canvasValues.front;
            });
        } else {
            canvasValues.prevFront = 1;
        }
    }

    if (prevLogo !== front) {
        if (frontLogo2Img != null) {
            frontLogo2Img.destroy();
        }
        frontDataLayer.draw();

        Konva.Image.fromURL(logoUrl, (image) => {
            if (frontLogo2Img != null) {
                frontLogo2Img.destroy();
            }
            frontLogo2Img = image;

            frontDataLayer.add(image);
            image.setAttrs({
                x: -29 * scale,
                y: -29 * scale,
                width: 408 * scale,
                height: 258 * scale,
            });
            frontDataLayer.draw();

            canvasValues.prevLogo = canvasValues.front;
        });
    }

    canvasValues.addressSize = 9;
    frontAddress1Text = createText(frontFamily, canvasValues.addressSize, canvasValues.suiteRoom, 0, 166, frontColor);
    frontAddressDividerText = createText('UniversLT49LightUltraCondensed', canvasValues.addressSize, '|', 0, 165.5, frontColor);
    frontAddress2Text = createText(frontFamily, canvasValues.addressSize, canvasValues.address2, 0, 166, frontColor);

    let width = (frontAddress1Text.width() / scale) + (frontAddressDividerText.width() / scale) + (frontAddress2Text.width() / scale);
    if (width >= 265) {
        canvasValues.addressSize = 8;
        frontAddress1Text = createText(frontFamily, canvasValues.addressSize, canvasValues.suiteRoom, 0, 166, frontColor);
        frontAddressDividerText = createText('UniversLT49LightUltraCondensed', canvasValues.addressSize, '|', 0, 165.5, frontColor);
        frontAddress2Text = createText(frontFamily, canvasValues.addressSize, canvasValues.address2, 0, 166, frontColor);
    }

    frontDataLayer.add(frontAddress1Text);
    frontDataLayer.add(frontAddressDividerText);
    frontDataLayer.add(frontAddress2Text);

    const totalWidth = frontAddress1Text.width() + frontAddressDividerText.width() + frontAddress2Text.width() + 8 * scale;
    frontAddress1Text.x((350 * scale - totalWidth) / 2);
    frontAddressDividerText.x(frontAddress1Text.x() + frontAddress1Text.width() + 4 * scale);
    frontAddress2Text.x(frontAddressDividerText.x() + frontAddressDividerText.width() + 4 * scale);

    canvasValues.frontDividers = {
        frontAddress1: frontAddress1Text.x() / scale,
        frontAddressDivider: frontAddressDividerText.x() / scale,
        frontAddress2Text: frontAddress2Text.x() / scale,
    };
}

export const destroyFrontVariablesP9T18 = () => {
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddressDividerText) {
        frontAddressDividerText.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (mainPhoneText) {
        mainPhoneText.destroy();
    }
    if (mainDaysText) {
        mainDaysText.destroy();
    }
    if (mainDividerText) {
        mainDividerText.destroy();
    }
    if (mainHoursText) {
        mainHoursText.destroy();
    }
    frontBackgroundLayer.draw();
}

export const initP9T19FrontCanvas = () => {
    drawFrontVariablesP9T19();
}

export const drawFrontVariablesP9T19 = () => {
    let backgroundUrl = null;
    let frontColor = '#000';
    let frontFamily = 'AGaramondProRegular';
    let logoUrl = null;

    if (parseInt(canvasValues.front) === 2) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/grey-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 3) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/orange-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 4) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/blue-background-low.jpg';
    }

    logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/p9t11-front-background-regular.svg';
    if (parseInt(canvasValues.front) === 2) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/p9t11-front-background-orange-white.svg';
    } else if (parseInt(canvasValues.front) === 3) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/p9t11-front-background-white.svg';
    } else if (parseInt(canvasValues.front) === 4) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/p9t11-front-background-orange-white.svg';
    }

    let prevFront = '';
    if (canvasValues.prevFront !== '') {
        prevFront = parseInt(canvasValues.prevFront);
    }

    let prevLogo = '';
    if (canvasValues.prevLogo !== '') {
        prevLogo = parseInt(canvasValues.prevLogo);
    }

    let front = '';
    if (canvasValues.front !== '') {
        front = parseInt(canvasValues.front);
    }

    if (prevFront !== front) {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontBackgroundLayer.draw();

        if (backgroundUrl != null) {
            Konva.Image.fromURL(backgroundUrl, (image) => {
                if (frontLogo1Img != null) {
                    frontLogo1Img.destroy();
                }
                frontLogo1Img = image;

                frontBackgroundLayer.add(image);
                image.setAttrs({
                    x: -29 * scale,
                    y: -29 * scale,
                    width: 408 * scale,
                    height: 258 * scale,
                });
                frontBackgroundLayer.draw();

                canvasValues.prevFront = canvasValues.front;
            });
        } else {
            canvasValues.prevFront = 1;
        }
    }

    if (prevLogo !== front) {
        if (frontLogo2Img != null) {
            frontLogo2Img.destroy();
        }
        frontDataLayer.draw();

        Konva.Image.fromURL(logoUrl, (image) => {
            if (frontLogo2Img != null) {
                frontLogo2Img.destroy();
            }
            frontLogo2Img = image;

            frontDataLayer.add(image);
            image.setAttrs({
                x: -29 * scale,
                y: -29 * scale,
                width: 408 * scale,
                height: 258 * scale,
            });
            frontDataLayer.draw();

            canvasValues.prevLogo = canvasValues.front;
        });
    }

    canvasValues.addressSize = 9;
    frontAddress1Text = createText(frontFamily, canvasValues.addressSize, canvasValues.suiteRoom, 0, 166, frontColor);
    frontAddressDividerText = createText('UniversLT49LightUltraCondensed', canvasValues.addressSize, '|', 0, 165.5, frontColor);
    frontAddress2Text = createText(frontFamily, canvasValues.addressSize, canvasValues.address2, 0, 166, frontColor);

    let width = (frontAddress1Text.width() / scale) + (frontAddressDividerText.width() / scale) + (frontAddress2Text.width() / scale);
    if (width >= 265) {
        canvasValues.addressSize = 8;
        frontAddress1Text = createText(frontFamily, canvasValues.addressSize, canvasValues.suiteRoom, 0, 166, frontColor);
        frontAddressDividerText = createText('UniversLT49LightUltraCondensed', canvasValues.addressSize, '|', 0, 165.5, frontColor);
        frontAddress2Text = createText(frontFamily, canvasValues.addressSize, canvasValues.address2, 0, 166, frontColor);
    }

    frontDataLayer.add(frontAddress1Text);
    frontDataLayer.add(frontAddressDividerText);
    frontDataLayer.add(frontAddress2Text);

    const totalWidth = frontAddress1Text.width() + frontAddressDividerText.width() + frontAddress2Text.width() + 8 * scale;
    frontAddress1Text.x((350 * scale - totalWidth) / 2);
    frontAddressDividerText.x(frontAddress1Text.x() + frontAddress1Text.width() + 4 * scale);
    frontAddress2Text.x(frontAddressDividerText.x() + frontAddressDividerText.width() + 4 * scale);

    canvasValues.frontDividers = {
        frontAddress1: frontAddress1Text.x() / scale,
        frontAddressDivider: frontAddressDividerText.x() / scale,
        frontAddress2Text: frontAddress2Text.x() / scale,
    };
}

export const destroyFrontVariablesP9T19 = () => {
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddressDividerText) {
        frontAddressDividerText.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (mainPhoneText) {
        mainPhoneText.destroy();
    }
    if (mainDaysText) {
        mainDaysText.destroy();
    }
    if (mainDividerText) {
        mainDividerText.destroy();
    }
    if (mainHoursText) {
        mainHoursText.destroy();
    }
    frontBackgroundLayer.draw();
}

export const initP9T20FrontCanvas = () => {
    drawFrontVariablesP9T20();
}

export const drawFrontVariablesP9T20 = () => {
    let backgroundUrl = null;
    let frontColor = '#000';
    let frontFamily = 'AGaramondProRegular';
    let logoUrl = null;

    if (parseInt(canvasValues.front) === 2) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/grey-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 3) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/orange-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 4) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/blue-background-low.jpg';
    }

    logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/dentistry-logo-regular.svg';
    if (parseInt(canvasValues.front) === 2) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/dentistry-logo-orange-white.svg';
    } else if (parseInt(canvasValues.front) === 3) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/dentistry-logo-white.svg';
    } else if (parseInt(canvasValues.front) === 4) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/dentistry-logo-orange-white.svg';
    }

    let prevFront = '';
    if (canvasValues.prevFront !== '') {
        prevFront = parseInt(canvasValues.prevFront);
    }

    let prevLogo = '';
    if (canvasValues.prevLogo !== '') {
        prevLogo = parseInt(canvasValues.prevLogo);
    }

    let front = '';
    if (canvasValues.front !== '') {
        front = parseInt(canvasValues.front);
    }

    if (prevFront !== front) {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontBackgroundLayer.draw();

        if (backgroundUrl != null) {
            Konva.Image.fromURL(backgroundUrl, (image) => {
                if (frontLogo1Img != null) {
                    frontLogo1Img.destroy();
                }
                frontLogo1Img = image;

                frontBackgroundLayer.add(image);
                image.setAttrs({
                    x: -29 * scale,
                    y: -29 * scale,
                    width: 408 * scale,
                    height: 258 * scale,
                });
                frontBackgroundLayer.draw();

                canvasValues.prevFront = canvasValues.front;
            });
        } else {
            canvasValues.prevFront = 1;
        }
    }

    if (prevLogo !== front) {
        if (frontLogo2Img != null) {
            frontLogo2Img.destroy();
        }
        frontDataLayer.draw();

        Konva.Image.fromURL(logoUrl, (image) => {
            if (frontLogo2Img != null) {
                frontLogo2Img.destroy();
            }
            frontLogo2Img = image;

            frontDataLayer.add(image);
            image.setAttrs({
                x: -29 * scale,
                y: -29 * scale,
                width: 408 * scale,
                height: 258 * scale,
            });
            frontDataLayer.draw();

            canvasValues.prevLogo = canvasValues.front;
        });
    }

    canvasValues.addressSize = 9;
    frontAddress1Text = createText(frontFamily, canvasValues.addressSize, canvasValues.suiteRoom, 0, 166, frontColor);
    frontAddressDividerText = createText('UniversLT49LightUltraCondensed', canvasValues.addressSize, '|', 0, 165.5, frontColor);
    frontAddress2Text = createText(frontFamily, canvasValues.addressSize, canvasValues.address2, 0, 166, frontColor);

    let width = (frontAddress1Text.width() / scale) + (frontAddressDividerText.width() / scale) + (frontAddress2Text.width() / scale);
    if (width >= 265) {
        canvasValues.addressSize = 8;
        frontAddress1Text = createText(frontFamily, canvasValues.addressSize, canvasValues.suiteRoom, 0, 166, frontColor);
        frontAddressDividerText = createText('UniversLT49LightUltraCondensed', canvasValues.addressSize, '|', 0, 165.5, frontColor);
        frontAddress2Text = createText(frontFamily, canvasValues.addressSize, canvasValues.address2, 0, 166, frontColor);
    }

    frontDataLayer.add(frontAddress1Text);
    frontDataLayer.add(frontAddressDividerText);
    frontDataLayer.add(frontAddress2Text);

    const totalWidth = frontAddress1Text.width() + frontAddressDividerText.width() + frontAddress2Text.width() + 8 * scale;
    frontAddress1Text.x((350 * scale - totalWidth) / 2);
    frontAddressDividerText.x(frontAddress1Text.x() + frontAddress1Text.width() + 4 * scale);
    frontAddress2Text.x(frontAddressDividerText.x() + frontAddressDividerText.width() + 4 * scale);

    canvasValues.frontDividers = {
        frontAddress1: frontAddress1Text.x() / scale,
        frontAddressDivider: frontAddressDividerText.x() / scale,
        frontAddress2Text: frontAddress2Text.x() / scale,
    };
}

export const destroyFrontVariablesP9T20 = () => {
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddressDividerText) {
        frontAddressDividerText.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (mainPhoneText) {
        mainPhoneText.destroy();
    }
    if (mainDaysText) {
        mainDaysText.destroy();
    }
    if (mainDividerText) {
        mainDividerText.destroy();
    }
    if (mainHoursText) {
        mainHoursText.destroy();
    }
    frontBackgroundLayer.draw();
}

export const initP9T21FrontCanvas = () => {
    drawFrontVariablesP9T21();
}

export const drawFrontVariablesP9T21 = () => {
    let backgroundUrl = null;
    let frontColor = '#000';
    let frontFamily = 'AGaramondProRegular';
    let logoUrl = null;

    if (parseInt(canvasValues.front) === 2) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/grey-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 3) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/orange-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 4) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/blue-background-low.jpg';
    }

    logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/p9t12-front-background-regular.svg';
    if (parseInt(canvasValues.front) === 2) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/p9t12-front-background-orange-white.svg';
    } else if (parseInt(canvasValues.front) === 3) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/p9t12-front-background-white.svg';
    } else if (parseInt(canvasValues.front) === 4) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/p9t12-front-background-orange-white.svg';
    }

    let prevFront = '';
    if (canvasValues.prevFront !== '') {
        prevFront = parseInt(canvasValues.prevFront);
    }

    let prevLogo = '';
    if (canvasValues.prevLogo !== '') {
        prevLogo = parseInt(canvasValues.prevLogo);
    }

    let front = '';
    if (canvasValues.front !== '') {
        front = parseInt(canvasValues.front);
    }

    if (prevFront !== front) {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontBackgroundLayer.draw();

        if (backgroundUrl != null) {
            Konva.Image.fromURL(backgroundUrl, (image) => {
                if (frontLogo1Img != null) {
                    frontLogo1Img.destroy();
                }
                frontLogo1Img = image;

                frontBackgroundLayer.add(image);
                image.setAttrs({
                    x: -29 * scale,
                    y: -29 * scale,
                    width: 408 * scale,
                    height: 258 * scale,
                });
                frontBackgroundLayer.draw();

                canvasValues.prevFront = canvasValues.front;
            });
        } else {
            canvasValues.prevFront = 1;
        }
    }

    if (prevLogo !== front) {
        if (frontLogo2Img != null) {
            frontLogo2Img.destroy();
        }
        frontDataLayer.draw();

        Konva.Image.fromURL(logoUrl, (image) => {
            if (frontLogo2Img != null) {
                frontLogo2Img.destroy();
            }
            frontLogo2Img = image;

            frontDataLayer.add(image);
            image.setAttrs({
                x: -29 * scale,
                y: -29 * scale,
                width: 408 * scale,
                height: 258 * scale,
            });
            frontDataLayer.draw();

            canvasValues.prevLogo = canvasValues.front;
        });
    }

    canvasValues.addressSize = 9;
    frontAddress1Text = createText(frontFamily, canvasValues.addressSize, canvasValues.suiteRoom, 0, 166, frontColor);
    frontAddressDividerText = createText('UniversLT49LightUltraCondensed', canvasValues.addressSize, '|', 0, 165.5, frontColor);
    frontAddress2Text = createText(frontFamily, canvasValues.addressSize, canvasValues.address2, 0, 166, frontColor);

    let width = (frontAddress1Text.width() / scale) + (frontAddressDividerText.width() / scale) + (frontAddress2Text.width() / scale);
    if (width >= 265) {
        canvasValues.addressSize = 8;
        frontAddress1Text = createText(frontFamily, canvasValues.addressSize, canvasValues.suiteRoom, 0, 166, frontColor);
        frontAddressDividerText = createText('UniversLT49LightUltraCondensed', canvasValues.addressSize, '|', 0, 165.5, frontColor);
        frontAddress2Text = createText(frontFamily, canvasValues.addressSize, canvasValues.address2, 0, 166, frontColor);
    }

    frontDataLayer.add(frontAddress1Text);
    frontDataLayer.add(frontAddressDividerText);
    frontDataLayer.add(frontAddress2Text);

    const totalWidth = frontAddress1Text.width() + frontAddressDividerText.width() + frontAddress2Text.width() + 8 * scale;
    frontAddress1Text.x((350 * scale - totalWidth) / 2);
    frontAddressDividerText.x(frontAddress1Text.x() + frontAddress1Text.width() + 4 * scale);
    frontAddress2Text.x(frontAddressDividerText.x() + frontAddressDividerText.width() + 4 * scale);

    canvasValues.frontDividers = {
        frontAddress1: frontAddress1Text.x() / scale,
        frontAddressDivider: frontAddressDividerText.x() / scale,
        frontAddress2Text: frontAddress2Text.x() / scale,
    };
}

export const destroyFrontVariablesP9T21 = () => {
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddressDividerText) {
        frontAddressDividerText.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (mainPhoneText) {
        mainPhoneText.destroy();
    }
    if (mainDaysText) {
        mainDaysText.destroy();
    }
    if (mainDividerText) {
        mainDividerText.destroy();
    }
    if (mainHoursText) {
        mainHoursText.destroy();
    }
    frontBackgroundLayer.draw();
}

export const initP9T22FrontCanvas = () => {
    drawFrontVariablesP9T22();
}

export const drawFrontVariablesP9T22 = () => {
    let backgroundUrl = null;
    let frontColor = '#000';
    let frontFamily = 'AGaramondProRegular';
    let logoUrl = null;

    if (parseInt(canvasValues.front) === 2) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/grey-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 3) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/orange-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 4) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/blue-background-low.jpg';
    }

    logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/health-services-logo-regular.svg';
    if (parseInt(canvasValues.front) === 2) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/health-services-logo-orange-white.svg';
    } else if (parseInt(canvasValues.front) === 3) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/health-services-logo-white.svg';
    } else if (parseInt(canvasValues.front) === 4) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/health-services-logo-orange-white.svg';
    }

    let prevFront = '';
    if (canvasValues.prevFront !== '') {
        prevFront = parseInt(canvasValues.prevFront);
    }

    let prevLogo = '';
    if (canvasValues.prevLogo !== '') {
        prevLogo = parseInt(canvasValues.prevLogo);
    }

    let front = '';
    if (canvasValues.front !== '') {
        front = parseInt(canvasValues.front);
    }

    if (prevFront !== front) {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontBackgroundLayer.draw();

        if (backgroundUrl != null) {
            Konva.Image.fromURL(backgroundUrl, (image) => {
                if (frontLogo1Img != null) {
                    frontLogo1Img.destroy();
                }
                frontLogo1Img = image;

                frontBackgroundLayer.add(image);
                image.setAttrs({
                    x: -29 * scale,
                    y: -29 * scale,
                    width: 408 * scale,
                    height: 258 * scale,
                });
                frontBackgroundLayer.draw();

                canvasValues.prevFront = canvasValues.front;
            });
        } else {
            canvasValues.prevFront = 1;
        }
    }

    if (prevLogo !== front) {
        if (frontLogo2Img != null) {
            frontLogo2Img.destroy();
        }
        frontDataLayer.draw();

        Konva.Image.fromURL(logoUrl, (image) => {
            if (frontLogo2Img != null) {
                frontLogo2Img.destroy();
            }
            frontLogo2Img = image;

            frontDataLayer.add(image);
            image.setAttrs({
                x: -29 * scale,
                y: -29 * scale,
                width: 408 * scale,
                height: 258 * scale,
            });
            frontDataLayer.draw();

            canvasValues.prevLogo = canvasValues.front;
        });
    }

    mainPhoneText = createText(frontFamily, 7, '713-500-3267', 147, 127, frontColor);
    frontDataLayer.add(mainPhoneText);

    mainDaysText = createText(frontFamily, 7, 'Monday-Friday 7 am - 4 pm', 51, 139, frontColor);
    frontDataLayer.add(mainDaysText);

    mainDividerText = createText('UniversLT49LightUltraCondensed', 7, '|', 165, 138.5, frontColor);
    frontDataLayer.add(mainDividerText);

    mainHoursText = createText(frontFamily, 7, 'Open during lunch, Noon-1 pm', 173, 139, frontColor);
    frontDataLayer.add(mainHoursText);

    frontAddress1Text = createText(frontFamily, 7, canvasValues.suiteRoom, 0, 166, frontColor);
    frontDataLayer.add(frontAddress1Text);

    frontAddressDividerText = createText('UniversLT49LightUltraCondensed', 7, '|', 0, 165.5, frontColor);
    frontDataLayer.add(frontAddressDividerText);

    frontAddress2Text = createText(frontFamily, 7, canvasValues.address2, 0, 166, frontColor);
    frontDataLayer.add(frontAddress2Text);

    const totalWidth = frontAddress1Text.width() + frontAddressDividerText.width() + frontAddress2Text.width() + 8 * scale;
    frontAddress1Text.x((350 * scale - totalWidth) / 2);
    frontAddressDividerText.x(frontAddress1Text.x() + frontAddress1Text.width() + 4 * scale);
    frontAddress2Text.x(frontAddressDividerText.x() + frontAddressDividerText.width() + 4 * scale);

    canvasValues.frontDividers = {
        frontAddress1: frontAddress1Text.x() / scale,
        frontAddressDivider: frontAddressDividerText.x() / scale,
        frontAddress2Text: frontAddress2Text.x() / scale,
    };
}

export const destroyFrontVariablesP9T22 = () => {
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddressDividerText) {
        frontAddressDividerText.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (mainPhoneText) {
        mainPhoneText.destroy();
    }
    if (mainDaysText) {
        mainDaysText.destroy();
    }
    if (mainDividerText) {
        mainDividerText.destroy();
    }
    if (mainHoursText) {
        mainHoursText.destroy();
    }
    frontBackgroundLayer.draw();
}

export const initP9T23FrontCanvas = () => {
    drawFrontVariablesP9T23();
}

export const drawFrontVariablesP9T23 = () => {
    let backgroundUrl = null;
    let frontColor = '#000';
    let frontFamily = 'AGaramondProRegular';
    let logoUrl = null;

    if (parseInt(canvasValues.front) === 2) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/grey-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 3) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/orange-background-low.jpg';
    } else if (parseInt(canvasValues.front) === 4) {
        frontColor = '#fff';
        frontFamily = 'AGaramondProSemibold';
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/blue-background-low.jpg';
    }

    logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/md-anderson-logo-regular.svg';
    if (parseInt(canvasValues.front) === 2) {
        logoUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/md-anderson-logo-orange-white.svg';
    }

    let prevFront = '';
    if (canvasValues.prevFront !== '') {
        prevFront = parseInt(canvasValues.prevFront);
    }

    let prevLogo = '';
    if (canvasValues.prevLogo !== '') {
        prevLogo = parseInt(canvasValues.prevLogo);
    }

    let front = '';
    if (canvasValues.front !== '') {
        front = parseInt(canvasValues.front);
    }

    if (prevFront !== front) {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontBackgroundLayer.draw();

        if (backgroundUrl != null) {
            Konva.Image.fromURL(backgroundUrl, (image) => {
                if (frontLogo1Img != null) {
                    frontLogo1Img.destroy();
                }
                frontLogo1Img = image;

                frontBackgroundLayer.add(image);
                image.setAttrs({
                    x: -29 * scale,
                    y: -29 * scale,
                    width: 408 * scale,
                    height: 258 * scale,
                });
                frontBackgroundLayer.draw();

                canvasValues.prevFront = canvasValues.front;
            });
        } else {
            canvasValues.prevFront = 1;
        }
    }

    if (prevLogo !== front) {
        if (frontLogo2Img != null) {
            frontLogo2Img.destroy();
        }
        frontDataLayer.draw();

        Konva.Image.fromURL(logoUrl, (image) => {
            if (frontLogo2Img != null) {
                frontLogo2Img.destroy();
            }
            frontLogo2Img = image;

            frontDataLayer.add(image);
            image.setAttrs({
                x: -29 * scale,
                y: -29 * scale,
                width: 408 * scale,
                height: 258 * scale,
            });
            frontDataLayer.draw();

            canvasValues.prevLogo = canvasValues.front;
        });
    }

    canvasValues.addressSize = 8.5;
    frontAddress1Text = createText(frontFamily, canvasValues.addressSize, canvasValues.suiteRoom, 0, 166, frontColor);
    frontAddressDividerText = createText('UniversLT49LightUltraCondensed', canvasValues.addressSize, '|', 0, 165.5, frontColor);
    frontAddress2Text = createText(frontFamily, canvasValues.addressSize, canvasValues.address2, 0, 166, frontColor);

    let width = (frontAddress1Text.width() / scale) + (frontAddressDividerText.width() / scale) + (frontAddress2Text.width() / scale);
    if (width >= 265) {
        canvasValues.addressSize = 8;
        frontAddress1Text = createText(frontFamily, canvasValues.addressSize, canvasValues.suiteRoom, 0, 166, frontColor);
        frontAddressDividerText = createText('UniversLT49LightUltraCondensed', canvasValues.addressSize, '|', 0, 165.5, frontColor);
        frontAddress2Text = createText(frontFamily, canvasValues.addressSize, canvasValues.address2, 0, 166, frontColor);
    }

    width = (frontAddress1Text.width() / scale) + (frontAddressDividerText.width() / scale) + (frontAddress2Text.width() / scale);
    if (width >= 265) {
        canvasValues.addressSize = 7.5;
        frontAddress1Text = createText(frontFamily, canvasValues.addressSize, canvasValues.suiteRoom, 0, 166, frontColor);
        frontAddressDividerText = createText('UniversLT49LightUltraCondensed', canvasValues.addressSize, '|', 0, 165.5, frontColor);
        frontAddress2Text = createText(frontFamily, canvasValues.addressSize, canvasValues.address2, 0, 166, frontColor);
    }

    frontDataLayer.add(frontAddress1Text);
    frontDataLayer.add(frontAddressDividerText);
    frontDataLayer.add(frontAddress2Text);

    const totalWidth = frontAddress1Text.width() + frontAddressDividerText.width() + frontAddress2Text.width() + 8 * scale;
    frontAddress1Text.x((350 * scale - totalWidth) / 2);
    frontAddressDividerText.x(frontAddress1Text.x() + frontAddress1Text.width() + 4 * scale);
    frontAddress2Text.x(frontAddressDividerText.x() + frontAddressDividerText.width() + 4 * scale);

    canvasValues.frontDividers = {
        frontAddress1: frontAddress1Text.x() / scale,
        frontAddressDivider: frontAddressDividerText.x() / scale,
        frontAddress2Text: frontAddress2Text.x() / scale,
    };
}

export const destroyFrontVariablesP9T23 = () => {
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddressDividerText) {
        frontAddressDividerText.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (mainPhoneText) {
        mainPhoneText.destroy();
    }
    if (mainDaysText) {
        mainDaysText.destroy();
    }
    if (mainDividerText) {
        mainDividerText.destroy();
    }
    if (mainHoursText) {
        mainHoursText.destroy();
    }
    frontBackgroundLayer.draw();
}

export const initP10FrontCanvas = () => {
    let backgroundUrl = '';
    if (canvasValues.templateCode === 'p10t1') {
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/cizik-school-of-nursing-letterhead.svg';
    } else if (canvasValues.templateCode === 'p10t2') {
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/mcgovern-medical-school-letterhead.svg';
    } else if (canvasValues.templateCode === 'p10t4') {
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/school-of-biomedical-informatics-letterhead.svg';
    } else if (canvasValues.templateCode === 'p10t5') {
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/school-of-dentistry-letterhead.svg';
    } else if (canvasValues.templateCode === 'p10t6') {
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/school-of-public-health-letterhead.svg';
    } else if (canvasValues.templateCode === 'p10t7') {
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/uthealth-services-letterhead.svg';
    }

    Konva.Image.fromURL(backgroundUrl, (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 908 * scale,
            height: 1158 * scale,
        });
        frontBackgroundLayer.draw();
    });

    drawFrontVariablesP10();
}

export const drawFrontVariablesP10 = () => {
    let y = 98;
    let color = '#7a7c81';
    if (canvasValues.templateCode === 'p10t6') {
        y = 120;
    } else if (canvasValues.templateCode === 'p10t7') {
        y = 64;
        color = '#b76746';
    }

    let count = 0;
    if (!isEmpty(canvasValues.department1)) {
        frontDepartment1Text = new Konva.Text({
            text: canvasValues.department1,
            fontSize: convertPointsToPixels(17) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 0 * scale,
            y: y * scale,
            width: 776 * scale,
            fill: color,
            align: 'right',
        });
        frontDataLayer.add(frontDepartment1Text);
        y += 30;
        count++;
    }

    if (!isEmpty(canvasValues.department2)) {
        frontDepartment2Text = new Konva.Text({
            text: canvasValues.department2,
            fontSize: convertPointsToPixels(17) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 0 * scale,
            y: y * scale,
            width: 776 * scale,
            fill: color,
            align: 'right',
        });
        frontDataLayer.add(frontDepartment2Text);
        y += 30;
        count++;
    }

    if (!isEmpty(canvasValues.department3)) {
        frontDepartment3Text = new Konva.Text({
            text: canvasValues.department3,
            fontSize: convertPointsToPixels(17) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 0 * scale,
            y: y * scale,
            width: 776 * scale,
            fill: color,
            align: 'right',
        });
        frontDataLayer.add(frontDepartment3Text);
        y += 30;
        count++;
    }

    if (canvasValues.templateCode === 'p10t6') {
        y = 168;
        if (count === 2) {
            y = 194;
        }
    } else if (canvasValues.templateCode === 'p10t7') {
        y = 146;
    } else {
        y = 150;
        if (count === 2) {
            y = 170;
        } else if (count === 3) {
            y = 200;
        }
    }

    frontLine1 = new Konva.Line({
        points: [
            50 * scale, y * scale,
            775 * scale, y * scale
        ],
        stroke: '#b76746',
        strokeWidth: 0.25
    });
    frontDataLayer.add(frontLine1);

    y += 22;
    if (canvasValues.letterheadPersons.length > 0) {
        let k = 0;
        for (let i = 0; i < canvasValues.letterheadPersons.length; i++) {
            const person = canvasValues.letterheadPersons[i];
            if (!isEmpty(person.name)) {
                frontNames[i] = new Konva.Text({
                    text: person.name,
                    fontSize: convertPointsToPixels(9) * scale,
                    fontFamily: 'AGaramondProRegular',
                    x: 0 * scale,
                    y: y * scale,
                    width: 776 * scale,
                    fill: '#7a7c81',
                    align: 'right',
                });
                frontDataLayer.add(frontNames[i]);

                let isFirst = true;
                for (let j = 0; j < person.titles.length; j++) {
                    const title = person.titles[j];
                    if (!isEmpty(title)) {
                        if (isFirst) {
                            y += 16;
                            isFirst = false;
                        } else {
                            y += 14;
                        }

                        frontTitles[k] = new Konva.Text({
                            text: title,
                            fontSize: convertPointsToPixels(8) * scale,
                            fontFamily: 'AGaramondProItalic',
                            x: 0 * scale,
                            y: y * scale,
                            width: 776 * scale,
                            fill: '#7a7c81',
                            align: 'right',
                        });
                        frontDataLayer.add(frontTitles[k]);
                        k++;
                    }
                }
            }

            y += 24;
        }
    }

    canvasValues.frontDividers = {};

    y = 1042;
    if (!isEmpty(canvasValues.website)) {
        frontWebsiteText = createText('AGaramondProRegular', 9, canvasValues.website, 86, y, '#7a7c81');
        frontDataLayer.add(frontWebsiteText);
        y -= 16;
    }

    if (!isEmpty(canvasValues.address2)) {
        frontAddress2Text = createText('AGaramondProRegular', 9, canvasValues.address2, 86, y, '#7a7c81');
        frontDataLayer.add(frontAddress2Text);
        y -= 16;
    }

    if (!isEmpty(canvasValues.address)) {
        frontAddress1Text = createText('AGaramondProRegular', 9, canvasValues.address, 86, y, '#7a7c81');
        frontDataLayer.add(frontAddress1Text);
        y -= 16;
    }

    if (!isEmpty(canvasValues.email)) {
        frontEmailText = createText('AGaramondProRegular', 9, canvasValues.email, 86, y, '#7a7c81');
        frontDataLayer.add(frontEmailText);
        y -= 16;
    }

    if (!isEmpty(canvasValues.fax)) {
        const letterSpacing = 0.1;
        frontFaxText = createText('AGaramondProRegular', 9, canvasValues.fax, 86, y, '#7a7c81', letterSpacing);
        frontDataLayer.add(frontFaxText);

        let x = frontFaxText.text().length * 5.5 + 94;
        frontFaxSuffixText = createText('AGaramondProItalic', 9, 'f', x, y + 1.5, '#7a7c81');
        frontDataLayer.add(frontFaxSuffixText);
        y -= 16;

        canvasValues.frontDividers.faxSuffix = frontFaxSuffixText.x() / scale;
    }

    if (!isEmpty(canvasValues.cell)) {
        const letterSpacing = 0.1;
        frontCellText = createText('AGaramondProRegular', 9, canvasValues.cell, 86, y, '#7a7c81', letterSpacing);
        frontDataLayer.add(frontCellText);

        let x = frontCellText.text().length * 5.5 + 94;
        frontCellSuffixText = createText('AGaramondProItalic', 9, 'c', x, y + 1.5, '#7a7c81');
        frontDataLayer.add(frontCellSuffixText);
        y -= 16;

        canvasValues.frontDividers.cellSuffix = frontCellSuffixText.x() / scale;
    }

    if (!isEmpty(canvasValues.phone)) {
        const letterSpacing = 0.1;
        frontPhoneText = createText('AGaramondProRegular', 9, canvasValues.phone, 87, y, '#7a7c81', letterSpacing);
        frontDataLayer.add(frontPhoneText);

        let x = frontPhoneText.text().length * 5.5 + 94;
        frontPhoneSuffixText = createText('AGaramondProItalic', 9, 'p', x, y + 1.5, '#7a7c81');
        frontDataLayer.add(frontPhoneSuffixText);
        y -= 16;

        canvasValues.frontDividers.phoneSuffix = frontPhoneSuffixText.x() / scale;
    }

    y -= 14;
    frontLine2 = new Konva.Line({
        points: [
            50 * scale, y * scale,
            775 * scale, y * scale
        ],
        stroke: '#b76746',
        strokeWidth: 0.25
    });
    frontDataLayer.add(frontLine2);
}

export const destroyFrontVariablesP10 = () => {
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontDepartment3Text) {
        frontDepartment3Text.destroy();
    }
    if (frontNameText) {
        frontNameText.destroy();
    }
    if (frontLine1) {
        frontLine1.destroy();
    }
    if (frontLine2) {
        frontLine2.destroy();
    }
    for (let i = 0; i < frontNames.length; i++) {
        frontNames[i].destroy();
    }
    frontNames = [];
    for (let i = 0; i < frontTitles.length; i++) {
        frontTitles[i].destroy();
    }
    frontTitles = [];
    if (frontPhoneText) {
        frontPhoneText.destroy();
    }
    if (frontPhoneSuffixText) {
        frontPhoneSuffixText.destroy();
    }
    if (frontEmailText) {
        frontEmailText.destroy();
    }
    if (frontCellText) {
        frontCellText.destroy();
    }
    if (frontCellSuffixText) {
        frontCellSuffixText.destroy();
    }
    if (frontFaxText) {
        frontFaxText.destroy();
    }
    if (frontFaxSuffixText) {
        frontFaxSuffixText.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (frontWebsiteText) {
        frontWebsiteText.destroy();
    }
}

export const initP10T8FrontCanvas = () => {
    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/backgrounds/p10t8-background.svg', (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 908 * scale,
            height: 1158 * scale,
        });
        frontBackgroundLayer.draw();
    });

    drawFrontVariablesP10T8();
}

export const drawFrontVariablesP10T8 = () => {
    let y = 142;
    let color = '#7a7c81';

    let count = 0;
    if (!isEmpty(canvasValues.department1)) {
        frontDepartment1Text = new Konva.Text({
            text: canvasValues.department1,
            fontSize: convertPointsToPixels(17) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 0 * scale,
            y: y * scale,
            width: 776 * scale,
            fill: color,
            align: 'right',
        });
        frontDataLayer.add(frontDepartment1Text);
        y += 30;
        count++;
    }

    if (!isEmpty(canvasValues.department2)) {
        frontDepartment2Text = new Konva.Text({
            text: canvasValues.department2,
            fontSize: convertPointsToPixels(17) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 0 * scale,
            y: y * scale,
            width: 776 * scale,
            fill: color,
            align: 'right',
        });
        frontDataLayer.add(frontDepartment2Text);
        y += 30;
        count++;
    }

    if (!isEmpty(canvasValues.department3)) {
        frontDepartment3Text = new Konva.Text({
            text: canvasValues.department3,
            fontSize: convertPointsToPixels(17) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 0 * scale,
            y: y * scale,
            width: 776 * scale,
            fill: color,
            align: 'right',
        });
        frontDataLayer.add(frontDepartment3Text);
        y += 30;
        count++;
    }

    y = 150;
    if (count === 1) {
        y = 190;
    } else if (count === 2) {
        y = 220;
    } else if (count === 3) {
        y = 250;
    }

    frontLine1 = new Konva.Line({
        points: [
            50 * scale, y * scale,
            775 * scale, y * scale
        ],
        stroke: '#b76746',
        strokeWidth: 0.25
    });
    frontDataLayer.add(frontLine1);

    y += 22;
    if (canvasValues.letterheadPersons.length > 0) {
        let k = 0;
        for (let i = 0; i < canvasValues.letterheadPersons.length; i++) {
            const person = canvasValues.letterheadPersons[i];
            if (!isEmpty(person.name)) {
                frontNames[i] = new Konva.Text({
                    text: person.name,
                    fontSize: convertPointsToPixels(9) * scale,
                    fontFamily: 'AGaramondProRegular',
                    x: 0 * scale,
                    y: y * scale,
                    width: 776 * scale,
                    fill: '#7a7c81',
                    align: 'right',
                });
                frontDataLayer.add(frontNames[i]);

                let isFirst = true;
                for (let j = 0; j < person.titles.length; j++) {
                    const title = person.titles[j];
                    if (!isEmpty(title)) {
                        if (isFirst) {
                            y += 16;
                            isFirst = false;
                        } else {
                            y += 14;
                        }

                        frontTitles[k] = new Konva.Text({
                            text: title,
                            fontSize: convertPointsToPixels(8) * scale,
                            fontFamily: 'AGaramondProItalic',
                            x: 0 * scale,
                            y: y * scale,
                            width: 776 * scale,
                            fill: '#7a7c81',
                            align: 'right',
                        });
                        frontDataLayer.add(frontTitles[k]);
                        k++;
                    }
                }
            }

            y += 24;
        }
    }

    canvasValues.frontDividers = {};

    y = 1042;
    if (!isEmpty(canvasValues.website)) {
        frontWebsiteText = createText('AGaramondProRegular', 9, canvasValues.website, 86, y, '#7a7c81');
        frontDataLayer.add(frontWebsiteText);
        y -= 16;
    }

    if (!isEmpty(canvasValues.address2)) {
        frontAddress2Text = createText('AGaramondProRegular', 9, canvasValues.address2, 86, y, '#7a7c81');
        frontDataLayer.add(frontAddress2Text);
        y -= 16;
    }

    if (!isEmpty(canvasValues.address)) {
        frontAddress1Text = createText('AGaramondProRegular', 9, canvasValues.address, 86, y, '#7a7c81');
        frontDataLayer.add(frontAddress1Text);
        y -= 16;
    }

    if (!isEmpty(canvasValues.email)) {
        frontEmailText = createText('AGaramondProRegular', 9, canvasValues.email, 86, y, '#7a7c81');
        frontDataLayer.add(frontEmailText);
        y -= 16;
    }

    if (!isEmpty(canvasValues.fax)) {
        const letterSpacing = 0.1;
        frontFaxText = createText('AGaramondProRegular', 9, canvasValues.fax, 86, y, '#7a7c81', letterSpacing);
        frontDataLayer.add(frontFaxText);

        let x = frontFaxText.text().length * 5.5 + 94;
        frontFaxSuffixText = createText('AGaramondProItalic', 9, 'f', x, y + 1.5, '#7a7c81');
        frontDataLayer.add(frontFaxSuffixText);
        y -= 16;

        canvasValues.frontDividers.faxSuffix = frontFaxSuffixText.x() / scale;
    }

    if (!isEmpty(canvasValues.cell)) {
        const letterSpacing = 0.1;
        frontCellText = createText('AGaramondProRegular', 9, canvasValues.cell, 86, y, '#7a7c81', letterSpacing);
        frontDataLayer.add(frontCellText);

        let x = frontCellText.text().length * 5.5 + 94;
        frontCellSuffixText = createText('AGaramondProItalic', 9, 'c', x, y + 1.5, '#7a7c81');
        frontDataLayer.add(frontCellSuffixText);
        y -= 16;

        canvasValues.frontDividers.cellSuffix = frontCellSuffixText.x() / scale;
    }

    if (!isEmpty(canvasValues.phone)) {
        const letterSpacing = 0.1;
        frontPhoneText = createText('AGaramondProRegular', 9, canvasValues.phone, 87, y, '#7a7c81', letterSpacing);
        frontDataLayer.add(frontPhoneText);

        let x = frontPhoneText.text().length * 5.5 + 94;
        frontPhoneSuffixText = createText('AGaramondProItalic', 9, 'p', x, y + 1.5, '#7a7c81');
        frontDataLayer.add(frontPhoneSuffixText);
        y -= 16;

        canvasValues.frontDividers.phoneSuffix = frontPhoneSuffixText.x() / scale;
    }

    y -= 14;
    frontLine2 = new Konva.Line({
        points: [
            50 * scale, y * scale,
            775 * scale, y * scale
        ],
        stroke: '#b76746',
        strokeWidth: 0.25
    });
    frontDataLayer.add(frontLine2);
}

export const destroyFrontVariablesP10T8 = () => {
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontDepartment3Text) {
        frontDepartment3Text.destroy();
    }
    if (frontNameText) {
        frontNameText.destroy();
    }
    if (frontLine1) {
        frontLine1.destroy();
    }
    if (frontLine2) {
        frontLine2.destroy();
    }
    for (let i = 0; i < frontNames.length; i++) {
        frontNames[i].destroy();
    }
    frontNames = [];
    for (let i = 0; i < frontTitles.length; i++) {
        frontTitles[i].destroy();
    }
    frontTitles = [];
    if (frontPhoneText) {
        frontPhoneText.destroy();
    }
    if (frontPhoneSuffixText) {
        frontPhoneSuffixText.destroy();
    }
    if (frontEmailText) {
        frontEmailText.destroy();
    }
    if (frontCellText) {
        frontCellText.destroy();
    }
    if (frontCellSuffixText) {
        frontCellSuffixText.destroy();
    }
    if (frontFaxText) {
        frontFaxText.destroy();
    }
    if (frontFaxSuffixText) {
        frontFaxSuffixText.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (frontWebsiteText) {
        frontWebsiteText.destroy();
    }
}

export const initP10T9FrontCanvas = () => {
    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/backgrounds/p10t9-background.svg', (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 908 * scale,
            height: 1158 * scale,
        });
        frontBackgroundLayer.draw();
    });

    drawFrontVariablesP10T9();
}

export const drawFrontVariablesP10T9 = () => {
    let y = 98;
    let color = '#7a7c81';

    let count = 0;
    if (!isEmpty(canvasValues.department1)) {
        frontDepartment1Text = new Konva.Text({
            text: canvasValues.department1,
            fontSize: convertPointsToPixels(17) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 0 * scale,
            y: y * scale,
            width: 776 * scale,
            fill: color,
            align: 'right',
        });
        frontDataLayer.add(frontDepartment1Text);
        y += 30;
        count++;
    }

    if (!isEmpty(canvasValues.department2)) {
        frontDepartment2Text = new Konva.Text({
            text: canvasValues.department2,
            fontSize: convertPointsToPixels(17) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 0 * scale,
            y: y * scale,
            width: 776 * scale,
            fill: color,
            align: 'right',
        });
        frontDataLayer.add(frontDepartment2Text);
        y += 30;
        count++;
    }

    if (!isEmpty(canvasValues.department3)) {
        frontDepartment3Text = new Konva.Text({
            text: canvasValues.department3,
            fontSize: convertPointsToPixels(17) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 0 * scale,
            y: y * scale,
            width: 776 * scale,
            fill: color,
            align: 'right',
        });
        frontDataLayer.add(frontDepartment3Text);
        y += 30;
        count++;
    }

    y = 150;
    if (count === 2) {
        y = 170;
    } else if (count === 3) {
        y = 200;
    }

    frontLine1 = new Konva.Line({
        points: [
            50 * scale, y * scale,
            775 * scale, y * scale
        ],
        stroke: '#b76746',
        strokeWidth: 0.25
    });
    frontDataLayer.add(frontLine1);

    y += 22;
    if (canvasValues.letterheadPersons.length > 0) {
        let k = 0;
        for (let i = 0; i < canvasValues.letterheadPersons.length; i++) {
            const person = canvasValues.letterheadPersons[i];
            if (!isEmpty(person.name)) {
                frontNames[i] = new Konva.Text({
                    text: person.name,
                    fontSize: convertPointsToPixels(9) * scale,
                    fontFamily: 'AGaramondProRegular',
                    x: 0 * scale,
                    y: y * scale,
                    width: 776 * scale,
                    fill: '#7a7c81',
                    align: 'right',
                });
                frontDataLayer.add(frontNames[i]);

                let isFirst = true;
                for (let j = 0; j < person.titles.length; j++) {
                    const title = person.titles[j];
                    if (!isEmpty(title)) {
                        if (isFirst) {
                            y += 16;
                            isFirst = false;
                        } else {
                            y += 14;
                        }

                        frontTitles[k] = new Konva.Text({
                            text: title,
                            fontSize: convertPointsToPixels(8) * scale,
                            fontFamily: 'AGaramondProItalic',
                            x: 0 * scale,
                            y: y * scale,
                            width: 776 * scale,
                            fill: '#7a7c81',
                            align: 'right',
                        });
                        frontDataLayer.add(frontTitles[k]);
                        k++;
                    }
                }
            }

            y += 24;
        }
    }

    canvasValues.frontDividers = {};

    y = 1042;
    if (!isEmpty(canvasValues.website)) {
        frontWebsiteText = createText('AGaramondProRegular', 9, canvasValues.website, 86, y, '#7a7c81');
        frontDataLayer.add(frontWebsiteText);
        y -= 16;
    }

    if (!isEmpty(canvasValues.address2)) {
        frontAddress2Text = createText('AGaramondProRegular', 9, canvasValues.address2, 86, y, '#7a7c81');
        frontDataLayer.add(frontAddress2Text);
        y -= 16;
    }

    if (!isEmpty(canvasValues.address)) {
        frontAddress1Text = createText('AGaramondProRegular', 9, canvasValues.address, 86, y, '#7a7c81');
        frontDataLayer.add(frontAddress1Text);
        y -= 16;
    }

    if (!isEmpty(canvasValues.email)) {
        frontEmailText = createText('AGaramondProRegular', 9, canvasValues.email, 86, y, '#7a7c81');
        frontDataLayer.add(frontEmailText);
        y -= 16;
    }

    if (!isEmpty(canvasValues.fax)) {
        const letterSpacing = 0.1;
        frontFaxText = createText('AGaramondProRegular', 9, canvasValues.fax, 86, y, '#7a7c81', letterSpacing);
        frontDataLayer.add(frontFaxText);

        let x = frontFaxText.text().length * 5.5 + 94;
        frontFaxSuffixText = createText('AGaramondProItalic', 9, 'f', x, y + 1.5, '#7a7c81');
        frontDataLayer.add(frontFaxSuffixText);
        y -= 16;

        canvasValues.frontDividers.faxSuffix = frontFaxSuffixText.x() / scale;
    }

    if (!isEmpty(canvasValues.cell)) {
        const letterSpacing = 0.1;
        frontCellText = createText('AGaramondProRegular', 9, canvasValues.cell, 86, y, '#7a7c81', letterSpacing);
        frontDataLayer.add(frontCellText);

        let x = frontCellText.text().length * 5.5 + 94;
        frontCellSuffixText = createText('AGaramondProItalic', 9, 'c', x, y + 1.5, '#7a7c81');
        frontDataLayer.add(frontCellSuffixText);
        y -= 16;

        canvasValues.frontDividers.cellSuffix = frontCellSuffixText.x() / scale;
    }

    if (!isEmpty(canvasValues.phone)) {
        const letterSpacing = 0.1;
        frontPhoneText = createText('AGaramondProRegular', 9, canvasValues.phone, 87, y, '#7a7c81', letterSpacing);
        frontDataLayer.add(frontPhoneText);

        let x = frontPhoneText.text().length * 5.5 + 94;
        frontPhoneSuffixText = createText('AGaramondProItalic', 9, 'p', x, y + 1.5, '#7a7c81');
        frontDataLayer.add(frontPhoneSuffixText);
        y -= 16;

        canvasValues.frontDividers.phoneSuffix = frontPhoneSuffixText.x() / scale;
    }

    y -= 14;
    frontLine2 = new Konva.Line({
        points: [
            50 * scale, y * scale,
            775 * scale, y * scale
        ],
        stroke: '#b76746',
        strokeWidth: 0.25
    });
    frontDataLayer.add(frontLine2);
}

export const destroyFrontVariablesP10T9 = () => {
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontDepartment3Text) {
        frontDepartment3Text.destroy();
    }
    if (frontNameText) {
        frontNameText.destroy();
    }
    if (frontLine1) {
        frontLine1.destroy();
    }
    if (frontLine2) {
        frontLine2.destroy();
    }
    for (let i = 0; i < frontNames.length; i++) {
        frontNames[i].destroy();
    }
    frontNames = [];
    for (let i = 0; i < frontTitles.length; i++) {
        frontTitles[i].destroy();
    }
    frontTitles = [];
    if (frontPhoneText) {
        frontPhoneText.destroy();
    }
    if (frontPhoneSuffixText) {
        frontPhoneSuffixText.destroy();
    }
    if (frontEmailText) {
        frontEmailText.destroy();
    }
    if (frontCellText) {
        frontCellText.destroy();
    }
    if (frontCellSuffixText) {
        frontCellSuffixText.destroy();
    }
    if (frontFaxText) {
        frontFaxText.destroy();
    }
    if (frontFaxSuffixText) {
        frontFaxSuffixText.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (frontWebsiteText) {
        frontWebsiteText.destroy();
    }
}

export const initP10T10FrontCanvas = () => {
    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/vectors/p10t10-background.svg', (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 908 * scale,
            height: 1158 * scale,
        });
        frontBackgroundLayer.draw();
    });

    drawFrontVariablesP10T10();
}

export const drawFrontVariablesP10T10 = () => {
    let y = 140;
    let color = '#7C7C81';

    let count = 0;
    if (!isEmpty(canvasValues.department1)) {
        frontDepartment1Text = new Konva.Text({
            text: canvasValues.department1,
            fontSize: convertPointsToPixels(17) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 0 * scale,
            y: y * scale,
            width: 776 * scale,
            fill: color,
            align: 'right',
        });
        frontDataLayer.add(frontDepartment1Text);
        y += 30;
        count++;
    }

    if (!isEmpty(canvasValues.department2)) {
        frontDepartment2Text = new Konva.Text({
            text: canvasValues.department2,
            fontSize: convertPointsToPixels(17) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 0 * scale,
            y: y * scale,
            width: 776 * scale,
            fill: color,
            align: 'right',
        });
        frontDataLayer.add(frontDepartment2Text);
        y += 30;
        count++;
    }

    y = 150;
    if (count === 1) {
        y = 190;
    } else if (count === 2) {
        y = 220;
    }

    frontLine1 = new Konva.Line({
        points: [
            50 * scale, y * scale,
            775 * scale, y * scale
        ],
        stroke: '#b76746',
        strokeWidth: 0.25
    });
    frontDataLayer.add(frontLine1);

    y += 22;
    if (canvasValues.letterheadPersons.length > 0) {
        let k = 0;
        for (let i = 0; i < canvasValues.letterheadPersons.length; i++) {
            const person = canvasValues.letterheadPersons[i];
            if (!isEmpty(person.name)) {
                frontNames[i] = new Konva.Text({
                    text: person.name,
                    fontSize: convertPointsToPixels(9) * scale,
                    fontFamily: 'AGaramondProRegular',
                    x: 0 * scale,
                    y: y * scale,
                    width: 776 * scale,
                    fill: '#7C7C81',
                    align: 'right',
                });
                frontDataLayer.add(frontNames[i]);

                let isFirst = true;
                for (let j = 0; j < person.titles.length; j++) {
                    const title = person.titles[j];
                    if (!isEmpty(title)) {
                        if (isFirst) {
                            y += 16;
                            isFirst = false;
                        } else {
                            y += 14;
                        }

                        frontTitles[k] = new Konva.Text({
                            text: title,
                            fontSize: convertPointsToPixels(8) * scale,
                            fontFamily: 'AGaramondProItalic',
                            x: 0 * scale,
                            y: y * scale,
                            width: 776 * scale,
                            fill: '#7C7C81',
                            align: 'right',
                        });
                        frontDataLayer.add(frontTitles[k]);
                        k++;
                    }
                }
            }

            y += 24;
        }
    }

    canvasValues.frontDividers = {};

    y = 1042;
    if (!isEmpty(canvasValues.website)) {
        frontWebsiteText = createText('AGaramondProRegular', 9, canvasValues.website, 86, y, '#7a7c81');
        frontDataLayer.add(frontWebsiteText);
        y -= 16;
    }

    if (!isEmpty(canvasValues.address2)) {
        frontAddress2Text = createText('AGaramondProRegular', 9, canvasValues.address2, 86, y, '#7a7c81');
        frontDataLayer.add(frontAddress2Text);
        y -= 16;
    }

    if (!isEmpty(canvasValues.address)) {
        frontAddress1Text = createText('AGaramondProRegular', 9, canvasValues.address, 86, y, '#7a7c81');
        frontDataLayer.add(frontAddress1Text);
        y -= 16;
    }

    if (!isEmpty(canvasValues.email)) {
        frontEmailText = createText('AGaramondProRegular', 9, canvasValues.email, 86, y, '#7a7c81');
        frontDataLayer.add(frontEmailText);
        y -= 16;
    }

    if (!isEmpty(canvasValues.fax)) {
        const letterSpacing = 0.1;
        frontFaxText = createText('AGaramondProRegular', 9, canvasValues.fax, 86, y, '#7a7c81', letterSpacing);
        frontDataLayer.add(frontFaxText);

        let x = frontFaxText.text().length * 5.5 + 94;
        frontFaxSuffixText = createText('AGaramondProItalic', 9, 'f', x, y + 1.5, '#7a7c81');
        frontDataLayer.add(frontFaxSuffixText);
        y -= 16;

        canvasValues.frontDividers.faxSuffix = frontFaxSuffixText.x() / scale;
    }

    if (!isEmpty(canvasValues.cell)) {
        const letterSpacing = 0.1;
        frontCellText = createText('AGaramondProRegular', 9, canvasValues.cell, 86, y, '#7a7c81', letterSpacing);
        frontDataLayer.add(frontCellText);

        let x = frontCellText.text().length * 5.5 + 94;
        frontCellSuffixText = createText('AGaramondProItalic', 9, 'c', x, y + 1.5, '#7a7c81');
        frontDataLayer.add(frontCellSuffixText);
        y -= 16;

        canvasValues.frontDividers.cellSuffix = frontCellSuffixText.x() / scale;
    }

    if (!isEmpty(canvasValues.phone)) {
        const letterSpacing = 0.1;
        frontPhoneText = createText('AGaramondProRegular', 9, canvasValues.phone, 87, y, '#7a7c81', letterSpacing);
        frontDataLayer.add(frontPhoneText);

        let x = frontPhoneText.text().length * 5.5 + 94;
        frontPhoneSuffixText = createText('AGaramondProItalic', 9, 'p', x, y + 1.5, '#7a7c81');
        frontDataLayer.add(frontPhoneSuffixText);
        y -= 16;

        canvasValues.frontDividers.phoneSuffix = frontPhoneSuffixText.x() / scale;
    }

    y -= 14;
    frontLine2 = new Konva.Line({
        points: [
            50 * scale, y * scale,
            775 * scale, y * scale
        ],
        stroke: '#b76746',
        strokeWidth: 0.25
    });
    frontDataLayer.add(frontLine2);
}

export const destroyFrontVariablesP10T10 = () => {
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontDepartment3Text) {
        frontDepartment3Text.destroy();
    }
    if (frontNameText) {
        frontNameText.destroy();
    }
    if (frontLine1) {
        frontLine1.destroy();
    }
    if (frontLine2) {
        frontLine2.destroy();
    }
    for (let i = 0; i < frontNames.length; i++) {
        frontNames[i].destroy();
    }
    frontNames = [];
    for (let i = 0; i < frontTitles.length; i++) {
        frontTitles[i].destroy();
    }
    frontTitles = [];
    if (frontPhoneText) {
        frontPhoneText.destroy();
    }
    if (frontPhoneSuffixText) {
        frontPhoneSuffixText.destroy();
    }
    if (frontEmailText) {
        frontEmailText.destroy();
    }
    if (frontCellText) {
        frontCellText.destroy();
    }
    if (frontCellSuffixText) {
        frontCellSuffixText.destroy();
    }
    if (frontFaxText) {
        frontFaxText.destroy();
    }
    if (frontFaxSuffixText) {
        frontFaxSuffixText.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (frontWebsiteText) {
        frontWebsiteText.destroy();
    }
}

export const initP10T3FrontCanvas = () => {
    let backgroundUrl = '';
    if (canvasValues.templateCode === 'p10t3') {
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/md-anderson-letterhead.svg';
    }

    Konva.Image.fromURL(backgroundUrl, (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 908 * scale,
            height: 1158 * scale,
        });
        frontBackgroundLayer.draw();
    });

    drawFrontVariablesP10T3();
}

export const drawFrontVariablesP10T3 = () => {
    let count = 0;
    if (!isEmpty(canvasValues.department1)) {
        frontDepartment1Text = createText('AGaramondProRegular', 14, canvasValues.department1, 80, 194, '#7a7c81');
        frontDataLayer.add(frontDepartment1Text);
        count++;
    }

    if (!isEmpty(canvasValues.department2)) {
        frontDepartment2Text = createText('AGaramondProRegular', 14, canvasValues.department2, 80, 218, '#7a7c81');
        frontDataLayer.add(frontDepartment2Text);
        count++;
    }

    if (!isEmpty(canvasValues.department3)) {
        frontDepartment3Text = createText('AGaramondProRegular', 14, canvasValues.department3, 80, 242, '#7a7c81');
        frontDataLayer.add(frontDepartment3Text);
        count++;
    }

    let y = 196;
    if (count === 3) {
        y = 290;
    } else if (count === 2) {
        y = 264;
    } else if (count === 1) {
        y = 238;
    }
    frontLine1 = new Konva.Line({
        points: [
            50 * scale, y * scale,
            800 * scale, y * scale
        ],
        stroke: '#7a7c81',
        strokeWidth: 0.25
    });
    frontDataLayer.add(frontLine1);

    canvasValues.frontDividers = {};

    let y1 = 1040;
    if (!isEmpty(canvasValues.email)) {
        y1 -= 10;
    }
    if (canvasValues.titles.length > 0) {
        for (let i = 0; i < canvasValues.titles.length; i++) {
            if (!isEmpty(canvasValues.titles[i])) {
                y1 -= 14;
            }
        }
    }
    if (!isEmpty(canvasValues.name)) {
        y1 -= 18;
    }

    let y2 = 1040;
    if (!isEmpty(canvasValues.cell)) {
        y2 -= 18;
    }
    if (!isEmpty(canvasValues.phone)) {
        y2 -= 18;
    }

    let y3 = 1040;
    if (!isEmpty(canvasValues.website)) {
        y3 -= 16;
    }
    if (!isEmpty(canvasValues.suiteRoom)) {
        y3 -= 16;
    }
    y3 -= 16;
    y3 -= 16;

    let minY = Math.min(y1, y2, y3);
    canvasValues.frontDividers.minY = minY;

    y = minY - 18;
    frontLine2 = new Konva.Line({
        points: [
            50 * scale, y * scale,
            800 * scale, y * scale
        ],
        stroke: '#7a7c81',
        strokeWidth: 0.25
    });
    frontDataLayer.add(frontLine2);

    let x = 426;
    y = minY;
    frontLine3 = new Konva.Line({
        points: [
            x * scale, y * scale,
            x * scale, 1050 * scale
        ],
        stroke: '#7a7c81',
        strokeWidth: 0.25
    });
    frontDataLayer.add(frontLine3);

    x = 618;
    y = minY;
    frontLine4 = new Konva.Line({
        points: [
            x * scale, y * scale,
            x * scale, 1050 * scale
        ],
        stroke: '#7a7c81',
        strokeWidth: 0.25
    });
    frontDataLayer.add(frontLine4);

    y = minY;
    frontNameText = createText('AGaramondProRegular', 9, canvasValues.name, 80, y, '#7a7c81');
    frontDataLayer.add(frontNameText);
    y += 18;

    if (canvasValues.titles.length > 0) {
        for (let i = 0; i < canvasValues.titles.length; i++) {
            if (!isEmpty(canvasValues.titles[i])) {
                frontTitles[i] = createText('AGaramondProItalic', 8, canvasValues.titles[i], 80, y, '#7a7c81');
                frontDataLayer.add(frontTitles[i]);
                y += 14;
            }
        }
    }

    y += 10;
    if (!isEmpty(canvasValues.email)) {
        frontEmailText = createText('AGaramondProRegular', 7, canvasValues.email, 80, y, '#7a7c81');
        frontDataLayer.add(frontEmailText);
    }

    y = minY;
    if (!isEmpty(canvasValues.phone)) {
        const letterSpacing = 0.1;
        frontPhoneText = createText('AGaramondProRegular', 8, canvasValues.phone, 440, y, '#7a7c81', letterSpacing);
        frontDataLayer.add(frontPhoneText);

        let x = frontPhoneText.text().length * 5.5 + 446;
        frontPhoneSuffixText = createText('AGaramondProItalic', 8, 'p', x, y + 1.5, '#7a7c81');
        frontDataLayer.add(frontPhoneSuffixText);
        y += 18;

        canvasValues.frontDividers.phoneSuffix = frontPhoneSuffixText.x() / scale;
    }

    if (!isEmpty(canvasValues.cell)) {
        const letterSpacing = 0.1;
        frontCellText = createText('AGaramondProRegular', 8, canvasValues.cell, 440, y, '#7a7c81', letterSpacing);
        frontDataLayer.add(frontCellText);

        let x = frontCellText.text().length * 5.6 + 446;
        frontCellSuffixText = createText('AGaramondProItalic', 8, 'c', x, y + 1.5, '#7a7c81');
        frontDataLayer.add(frontCellSuffixText);

        canvasValues.frontDividers.cellSuffix = frontCellSuffixText.x() / scale;
    }

    y = minY;
    frontAddress1Text = createText('AGaramondProRegular', 8, '6767 Bertner Avenue', 636, y, '#7a7c81');
    frontDataLayer.add(frontAddress1Text);
    y += 16;

    if (!isEmpty(canvasValues.suiteRoom)) {
        frontSuiteRoomText = createText('AGaramondProRegular', 8, canvasValues.suiteRoom, 636, y, '#7a7c81');
        frontDataLayer.add(frontSuiteRoomText);
        y += 16;
    }

    frontAddress2Text = createText('AGaramondProRegular', 8, 'Houston, Texas 77030', 636, y, '#7a7c81');
    frontDataLayer.add(frontAddress2Text);
    y += 16;

    if (!isEmpty(canvasValues.website)) {
        frontWebsiteText = createText('AGaramondProRegular', 8, canvasValues.website, 636, y, '#7a7c81');
        frontDataLayer.add(frontWebsiteText);
        y += 16;
    }
}

export const destroyFrontVariablesP10T3 = () => {
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontDepartment3Text) {
        frontDepartment3Text.destroy();
    }
    if (frontLine1) {
        frontLine1.destroy();
    }
    if (frontLine2) {
        frontLine2.destroy();
    }
    if (frontLine3) {
        frontLine3.destroy();
    }
    if (frontLine4) {
        frontLine4.destroy();
    }
    if (frontNameText) {
        frontNameText.destroy();
    }
    for (let i = 0; i < 6; i++) {
        if (frontTitles[i]) {
            frontTitles[i].destroy();
        }
    }
    if (frontPhoneText) {
        frontPhoneText.destroy();
    }
    if (frontPhoneSuffixText) {
        frontPhoneSuffixText.destroy();
    }
    if (frontEmailText) {
        frontEmailText.destroy();
    }
    if (frontCellText) {
        frontCellText.destroy();
    }
    if (frontCellSuffixText) {
        frontCellSuffixText.destroy();
    }
    if (frontFaxText) {
        frontFaxText.destroy();
    }
    if (frontFaxSuffixText) {
        frontFaxSuffixText.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (frontWebsiteText) {
        frontWebsiteText.destroy();
    }
    if (frontSuiteRoomText) {
        frontSuiteRoomText.destroy();
    }
}

export const initP11No10FrontCanvas = () => {
    let backgroundUrl = '';
    if (canvasValues.templateCode === 'p11t1') {
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/cizik-school-of-nursing-n10-env.svg';
    } else if (canvasValues.templateCode === 'p11t2') {
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/mcgovern-medical-school-n10-env.svg';
    } else if (canvasValues.templateCode === 'p11t3') {
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/md-anderson-n10-env.svg';
    } else if (canvasValues.templateCode === 'p11t4') {
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/school-of-dentistry-n10-env.svg';
    } else if (canvasValues.templateCode === 'p11t5') {
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/school-of-public-health-n10-env.svg';
    } else if (canvasValues.templateCode === 'p11t6') {
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/school-of-biomedical-informatics-n10-env.svg';
    } else if (canvasValues.templateCode === 'p11t7') {
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/uthealth-services-n10-env.svg';
    }

    Konva.Image.fromURL(backgroundUrl, (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 1008 * scale,
            height: 471 * scale,
        });
        frontBackgroundLayer.draw();
    });

    drawFrontVariablesP11No10();
}

export const drawFrontVariablesP11No10 = () => {
    let address1 = canvasValues.suiteRoom;
    let address2 = canvasValues.address2;

    if (canvasValues.templateCode === 'p11t3') {
        let y = 170;
        if (canvasValues.department1 !== '') {
            frontDepartment1Text = createText('AGaramondProRegular', 12, canvasValues.department1, 49, y, '#717073');
            frontDataLayer.add(frontDepartment1Text);
            y += 30;
        }

        frontAddress1Text = createText('AGaramondProRegular', 9, address1, 49, y, '#717073');
        frontDataLayer.add(frontAddress1Text);
        y += 14;

        frontAddress2Text = createText('AGaramondProRegular', 9, address2, 49, y, '#717073');
        frontDataLayer.add(frontAddress2Text);
    } else if (canvasValues.templateCode === 'p11t7') {
        let y = 50;
        if (canvasValues.department1 !== '') {
            frontDepartment1Text = createText('AGaramondProRegular', 14, canvasValues.department1, 224, y, '#b76746');
            frontDataLayer.add(frontDepartment1Text);
            y += 27;
        }

        frontAddress1Text = createText('AGaramondProRegular', 9, address1, 224, y, '#717073');
        frontDataLayer.add(frontAddress1Text);
        y += 14;

        frontAddress2Text = createText('AGaramondProRegular', 9, address2, 224, y, '#717073');
        frontDataLayer.add(frontAddress2Text);
    } else {
        let y = 66;
        if (canvasValues.templateCode === 'p11t5') {
            y = 84;
        }

        if (canvasValues.department1 !== '') {
            y += 18;
            frontDepartment1Text = createText('AGaramondProRegular', 12, canvasValues.department1, 224, y, '#717073');
            frontDataLayer.add(frontDepartment1Text);

        }
        if (canvasValues.department2 !== '') {
            y += 18;
            frontDepartment2Text = createText('AGaramondProRegular', 12, canvasValues.department2, 224, y, '#717073');
            frontDataLayer.add(frontDepartment2Text);
        }

        if (canvasValues.department1 !== '' || canvasValues.department2 !== '') {
            y += 30;
        } else if (canvasValues.department1 === '' && canvasValues.department2 === '') {
            y = 84;
            if (canvasValues.templateCode === 'p11t5') {
                y = 102;
            }
        }

        frontAddress1Text = createText('AGaramondProRegular', 9, address1, 224, y, '#717073');
        frontDataLayer.add(frontAddress1Text);
        y += 14;

        frontAddress2Text = createText('AGaramondProRegular', 9, address2, 224, y, '#717073');
        frontDataLayer.add(frontAddress2Text);
    }
}

export const destroyFrontVariablesP11No10 = () => {
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
}

export const initP11T22FrontCanvas = () => {
    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/backgrounds/p11t22-background.svg', (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: 0 * scale,
            y: 0 * scale,
            width: 950 * scale,
            height: 413 * scale,
        });
        frontBackgroundLayer.draw();
    });

    drawFrontVariablesP11T22();
}

export const drawFrontVariablesP11T22 = () => {
    let y = 66;

    if (canvasValues.department1 !== '') {
        y += 18;
        frontDepartment1Text = createText('AGaramondProRegular', 12, canvasValues.department1, 224, y, '#717073');
        frontDataLayer.add(frontDepartment1Text);

    }
    if (canvasValues.department2 !== '') {
        y += 18;
        frontDepartment2Text = createText('AGaramondProRegular', 12, canvasValues.department2, 224, y, '#717073');
        frontDataLayer.add(frontDepartment2Text);
    }

    if (canvasValues.department1 !== '' || canvasValues.department2 !== '') {
        y += 30;
    } else if (canvasValues.department1 === '' && canvasValues.department2 === '') {
        y = 84;
    }

    frontAddress1Text = createText('AGaramondProRegular', 9, canvasValues.suiteRoom, 224, y, '#717073');
    frontDataLayer.add(frontAddress1Text);
    y += 14;

    frontAddress2Text = createText('AGaramondProRegular', 9, canvasValues.address2, 224, y, '#717073');
    frontDataLayer.add(frontAddress2Text);
}

export const destroyFrontVariablesP11T22 = () => {
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
}

export const initP11T23FrontCanvas = () => {
    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/backgrounds/p11t23-background.svg', (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: 0 * scale,
            y: 0 * scale,
            width: 950 * scale,
            height: 413 * scale,
        });
        frontBackgroundLayer.draw();
    });

    drawFrontVariablesP11T23();
}

export const drawFrontVariablesP11T23 = () => {
    let y = 60;

    if (canvasValues.department1 !== '') {
        y += 18;
        frontDepartment1Text = createText('AGaramondProRegular', 12, canvasValues.department1, 224, y, '#717073');
        frontDataLayer.add(frontDepartment1Text);

    }
    if (canvasValues.department2 !== '') {
        y += 18;
        frontDepartment2Text = createText('AGaramondProRegular', 12, canvasValues.department2, 224, y, '#717073');
        frontDataLayer.add(frontDepartment2Text);
    }

    if (canvasValues.department1 !== '' || canvasValues.department2 !== '') {
        y += 30;
    } else if (canvasValues.department1 === '' && canvasValues.department2 === '') {
        y = 80;
    }

    frontAddress1Text = createText('AGaramondProRegular', 9, canvasValues.suiteRoom, 224, y, '#717073');
    frontDataLayer.add(frontAddress1Text);
    y += 14;

    frontAddress2Text = createText('AGaramondProRegular', 9, canvasValues.address2, 224, y, '#717073');
    frontDataLayer.add(frontAddress2Text);
}

export const destroyFrontVariablesP11T23 = () => {
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
}

export const initP11T24FrontCanvas = () => {
    Konva.Image.fromURL('https://ac-ut-health.s3.us-east-1.amazonaws.com/vectors/p11t24-background.svg', (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: 0 * scale,
            y: 0 * scale,
            width: 650 * scale,
            height: 475 * scale,
        });
        frontBackgroundLayer.draw();
    });

    drawFrontVariablesP11T24();
}

export const drawFrontVariablesP11T24 = () => {
    let y = 90;

    frontAddress1Text = createText('AGaramondProRegular', 7, canvasValues.suiteRoom, 224, y, '#7C7C81');
    frontDataLayer.add(frontAddress1Text);
    y += 11;

    frontAddress2Text = createText('AGaramondProRegular', 7, canvasValues.address2, 224, y, '#7C7C81');
    frontDataLayer.add(frontAddress2Text);
}

export const destroyFrontVariablesP11T24 = () => {
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
}

export const initP11T25FrontCanvas = () => {
    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/vectors/p11t25-background.svg', (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: 0 * scale,
            y: 0 * scale,
            width: 950 * scale,
            height: 413 * scale,
        });
        frontBackgroundLayer.draw();
    });

    drawFrontVariablesP11T25();
}

export const drawFrontVariablesP11T25 = () => {
    let y = 60;

    if (canvasValues.department1 !== '') {
        y += 18;
        frontDepartment1Text = createText('AGaramondProRegular', 12, canvasValues.department1, 224, y, '#7C7C81');
        frontDataLayer.add(frontDepartment1Text);

    }
    if (canvasValues.department2 !== '') {
        y += 18;
        frontDepartment2Text = createText('AGaramondProRegular', 12, canvasValues.department2, 224, y, '#7C7C81');
        frontDataLayer.add(frontDepartment2Text);
    }

    if (canvasValues.department1 !== '' || canvasValues.department2 !== '') {
        y += 30;
    } else if (canvasValues.department1 === '' && canvasValues.department2 === '') {
        y = 80;
    }

    frontAddress1Text = createText('AGaramondProRegular', 9, canvasValues.suiteRoom, 224, y, '#7C7C81');
    frontDataLayer.add(frontAddress1Text);
    y += 14;

    frontAddress2Text = createText('AGaramondProRegular', 9, canvasValues.address2, 224, y, '#7C7C81');
    frontDataLayer.add(frontAddress2Text);
}

export const destroyFrontVariablesP11T25 = () => {
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
}

export const initP11A10FrontCanvas = () => {
    drawFrontVariablesP11A10();
}

export const drawFrontVariablesP11A10 = () => {
    if (['p11t9', 'p11t10', 'p11t11', 'p11t12', 'p11t13', 'p11t14'].includes(canvasValues.templateCode)) {
        let logo = 'health-science-logo-uth.svg';
        if (parseInt(canvasValues.color) === 2) {
            logo = 'health-science-logo-uth-black.svg';
        }

        Konva.Image.fromURL(require('./images/' + logo), (image) => {
            if (frontLogo1Img != null) {
                frontLogo1Img.destroy();
            }
            frontLogo1Img = image;

            frontDataLayer.add(image);
            image.setAttrs({
                x: 28 * scale,
                y: 28 * scale,
                width: 1409 * 0.11 * scale,
                height: 969 * 0.11 * scale,
            });
            frontDataLayer.draw();
        });
    } else if (['p11t8'].includes(canvasValues.templateCode)) {
        let logo = 'md-anderson-uth-no-name.svg';
        if (parseInt(canvasValues.color) === 2) {
            logo = 'md-anderson-uth-no-name-black.svg';
        }

        Konva.Image.fromURL(require('./images/' + logo), (image) => {
            if (frontLogo1Img != null) {
                frontLogo1Img.destroy();
            }
            frontLogo1Img = image;

            frontDataLayer.add(image);
            image.setAttrs({
                x: 28 * scale,
                y: 20 * scale,
                width: 275 * 1.1 * scale,
                height: 123 * 1.1 * scale,
            });
            frontDataLayer.draw();
        });
    }

    let x = 202;
    let y = 120;
    let departmentFontSize = 6;
    if (canvasValues.templateCode === 'p11t8') {
        x = 340;
        y = 94;
        frontTitle1Text = new Konva.Text({
            text: 'Graduate School of Biomedical Sciences',
            fontSize: convertPointsToPixels(7.5) * scale,
            fontFamily: 'Ariblk',
            x: 340 * scale,
            y: 70 * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontTitle1Text);
    } else if (canvasValues.templateCode === 'p11t9') {
        y = 102;
        frontLogo2Img = new Konva.Text({
            text: 'Cizik',
            fontSize: convertPointsToPixels(26) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 202 * scale,
            y: 65 * scale,
            fill: parseInt(canvasValues.color) === 2 ? '#000' : '#b66645',
        });
        frontDataLayer.add(frontLogo2Img);

        frontLogo3Img = new Konva.Text({
            text: 'School of Nursing',
            fontSize: convertPointsToPixels(15) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 285 * scale,
            y: 75 * scale,
            fill: parseInt(canvasValues.color) === 2 ? '#000' : '#b66645',
        });
        frontDataLayer.add(frontLogo3Img);
    } else if (canvasValues.templateCode === 'p11t10') {
        y = 84;
        departmentFontSize = 7.5;
    } else if (canvasValues.templateCode === 'p11t11') {
        y = 102;
        frontLogo2Img = new Konva.Text({
            text: 'McGovern',
            fontSize: convertPointsToPixels(26) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 202 * scale,
            y: 65 * scale,
            fill: parseInt(canvasValues.color) === 2 ? '#000' : '#b66645',
        });
        frontDataLayer.add(frontLogo2Img);

        frontLogo3Img = new Konva.Text({
            text: 'Medical School',
            fontSize: convertPointsToPixels(15) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 356 * scale,
            y: 75 * scale,
            fill: parseInt(canvasValues.color) === 2 ? '#000' : '#b66645',
        });
        frontDataLayer.add(frontLogo3Img);
    } else if (canvasValues.templateCode === 'p11t12') {
        y = 102;
        frontTitle1Text = new Konva.Text({
            text: 'School of Biomedical Informatics',
            fontSize: convertPointsToPixels(8) * scale,
            fontFamily: 'Ariblk',
            x: 202 * scale,
            y: 81 * scale,
            fill: parseInt(canvasValues.color) === 2 ? '#000' : '#b66645',
        });
        frontDataLayer.add(frontTitle1Text);
    } else if (canvasValues.templateCode === 'p11t13') {
        y = 102;
        frontTitle1Text = new Konva.Text({
            text: 'School of Dentistry',
            fontSize: convertPointsToPixels(8) * scale,
            fontFamily: 'Ariblk',
            x: 202 * scale,
            y: 81 * scale,
            fill: parseInt(canvasValues.color) === 2 ? '#000' : '#b66645',
        });
        frontDataLayer.add(frontTitle1Text);
    } else if (canvasValues.templateCode === 'p11t14') {
        y = 102;
        frontTitle1Text = new Konva.Text({
            text: 'School of Public Health',
            fontSize: convertPointsToPixels(8) * scale,
            fontFamily: 'Ariblk',
            x: 202 * scale,
            y: 81 * scale,
            fill: parseInt(canvasValues.color) === 2 ? '#000' : '#b66645',
        });
        frontDataLayer.add(frontTitle1Text);
    }

    if (canvasValues.department1 !== '') {
        frontDepartment1Text = new Konva.Text({
            text: canvasValues.department1,
            fontSize: convertPointsToPixels(departmentFontSize) * scale,
            fontFamily: 'Ariblk',
            x: x * scale,
            y: y * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontDepartment1Text);
        y += 18;
    }

    if (!isEmpty(canvasValues.address)) {
        frontAddress1Text = new Konva.Text({
            text: canvasValues.address,
            fontSize: convertPointsToPixels(8) * scale,
            fontFamily: 'AGaramondProRegular',
            x: x * scale,
            y: y * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontAddress1Text);
        y += 13;
    }

    if (!isEmpty(canvasValues.address2)) {
        frontAddress2Text = new Konva.Text({
            text: canvasValues.address2,
            fontSize: convertPointsToPixels(8) * scale,
            fontFamily: 'AGaramondProRegular',
            x: x * scale,
            y: y * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontAddress2Text);
        y += 13;
    }
}

export const destroyFrontVariablesP11A10 = () => {
    if (frontLogo1Img) {
        frontLogo1Img.destroy();
    }
    if (frontLogo2Img) {
        frontLogo2Img.destroy();
    }
    if (frontLogo3Img) {
        frontLogo3Img.destroy();
    }
    if (frontTitle1Text) {
        frontTitle1Text.destroy();
    }
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
}

export const initP11A6FrontCanvas = () => {
    drawFrontVariablesP11A6();
}

export const drawFrontVariablesP11A6 = () => {
    if (['p11t15', 'p11t16', 'p11t18', 'p11t19', 'p11t20', 'p11t21'].includes(canvasValues.templateCode)) {
        let logo = 'health-science-logo-uth.svg';
        if (parseInt(canvasValues.color) === 2) {
            logo = 'health-science-logo-uth-black.svg';
        }

        Konva.Image.fromURL(require('./images/' + logo), (image) => {
            if (frontLogo1Img != null) {
                frontLogo1Img.destroy();
            }
            frontLogo1Img = image;

            frontDataLayer.add(image);
            image.setAttrs({
                x: 28 * scale,
                y: 28 * scale,
                width: 1409 * 0.11 * scale,
                height: 969 * 0.11 * scale,
            });
            frontDataLayer.draw();
        });
    } else if (['p11t17'].includes(canvasValues.templateCode)) {
        let logo = 'md-anderson-uth-no-name.svg';
        if (parseInt(canvasValues.color) === 2) {
            logo = 'md-anderson-uth-no-name-black.svg';
        }

        Konva.Image.fromURL(require('./images/' + logo), (image) => {
            if (frontLogo1Img != null) {
                frontLogo1Img.destroy();
            }
            frontLogo1Img = image;

            frontDataLayer.add(image);
            image.setAttrs({
                x: 28 * scale,
                y: 20 * scale,
                width: 275 * 1 * scale,
                height: 123 * 1 * scale,
            });
            frontDataLayer.draw();
        });
    }

    let x = 202;
    let y = 120;
    let departmentFontSize = 6;
    if (canvasValues.templateCode === 'p11t15') {
        y = 102;
        frontLogo2Img = new Konva.Text({
            text: 'Cizik',
            fontSize: convertPointsToPixels(26) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 202 * scale,
            y: 65 * scale,
            fill: parseInt(canvasValues.color) === 2 ? '#000' : '#b66645',
        });
        frontDataLayer.add(frontLogo2Img);

        frontLogo3Img = new Konva.Text({
            text: 'School of Nursing',
            fontSize: convertPointsToPixels(15) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 285 * scale,
            y: 75 * scale,
            fill: parseInt(canvasValues.color) === 2 ? '#000' : '#b66645',
        });
        frontDataLayer.add(frontLogo3Img);
    } else if (canvasValues.templateCode === 'p11t16') {
        y = 102;
        frontLogo2Img = new Konva.Text({
            text: 'McGovern',
            fontSize: convertPointsToPixels(26) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 202 * scale,
            y: 65 * scale,
            fill: parseInt(canvasValues.color) === 2 ? '#000' : '#b66645',
        });
        frontDataLayer.add(frontLogo2Img);

        frontLogo3Img = new Konva.Text({
            text: 'Medical School',
            fontSize: convertPointsToPixels(15) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 356 * scale,
            y: 75 * scale,
            fill: parseInt(canvasValues.color) === 2 ? '#000' : '#b66645',
        });
        frontDataLayer.add(frontLogo3Img);
    } else if (canvasValues.templateCode === 'p11t17') {
        x = 295;
        y = 106;
        frontTitle1Text = new Konva.Text({
            text: 'Graduate School of Biomedical Sciences',
            fontSize: convertPointsToPixels(7.5) * scale,
            fontFamily: 'Ariblk',
            x: 43 * scale,
            y: 105 * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontTitle1Text);
    } else if (canvasValues.templateCode === 'p11t18') {
        y = 102;
        frontTitle1Text = new Konva.Text({
            text: 'School of Biomedical Informatics',
            fontSize: convertPointsToPixels(8) * scale,
            fontFamily: 'Ariblk',
            x: 202 * scale,
            y: 81 * scale,
            fill: parseInt(canvasValues.color) === 2 ? '#000' : '#b66645',
        });
        frontDataLayer.add(frontTitle1Text);
    } else if (canvasValues.templateCode === 'p11t19') {
        y = 102;
        frontTitle1Text = new Konva.Text({
            text: 'School of Dentistry',
            fontSize: convertPointsToPixels(8) * scale,
            fontFamily: 'Ariblk',
            x: 202 * scale,
            y: 81 * scale,
            fill: parseInt(canvasValues.color) === 2 ? '#000' : '#b66645',
        });
        frontDataLayer.add(frontTitle1Text);
    } else if (canvasValues.templateCode === 'p11t20') {
        y = 102;
        frontTitle1Text = new Konva.Text({
            text: 'School of Public Health',
            fontSize: convertPointsToPixels(8) * scale,
            fontFamily: 'Ariblk',
            x: 202 * scale,
            y: 81 * scale,
            fill: parseInt(canvasValues.color) === 2 ? '#000' : '#b66645',
        });
        frontDataLayer.add(frontTitle1Text);
    } else if (canvasValues.templateCode === 'p11t21') {
        y = 84;
        departmentFontSize = 7.5;
    }

    if (canvasValues.department1 !== '') {
        frontDepartment1Text = new Konva.Text({
            text: canvasValues.department1,
            fontSize: convertPointsToPixels(departmentFontSize) * scale,
            fontFamily: 'Ariblk',
            x: x * scale,
            y: y * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontDepartment1Text);
        y += 18;
    }

    if (!isEmpty(canvasValues.address)) {
        frontAddress1Text = new Konva.Text({
            text: canvasValues.address,
            fontSize: convertPointsToPixels(8) * scale,
            fontFamily: 'AGaramondProRegular',
            x: x * scale,
            y: y * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontAddress1Text);
        y += 13;
    }

    if (!isEmpty(canvasValues.address2)) {
        frontAddress2Text = new Konva.Text({
            text: canvasValues.address2,
            fontSize: convertPointsToPixels(8) * scale,
            fontFamily: 'AGaramondProRegular',
            x: x * scale,
            y: y * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontAddress2Text);
        y += 13;
    }
}

export const destroyFrontVariablesP11A6 = () => {
    if (frontLogo1Img) {
        frontLogo1Img.destroy();
    }
    if (frontLogo2Img) {
        frontLogo2Img.destroy();
    }
    if (frontLogo3Img) {
        frontLogo3Img.destroy();
    }
    if (frontTitle1Text) {
        frontTitle1Text.destroy();
    }
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
}

export const initP12T7FrontCanvas = () => {
    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/backgrounds/uthealth-services-a6-envelope.svg', (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 708 * scale,
            height: 533 * scale,
        });
        frontBackgroundLayer.draw();
    });

    drawFrontVariablesP12T7();
}

export const drawFrontVariablesP12T7 = () => {
    let y = 51;
    if (canvasValues.department1 !== '') {
        frontDepartment1Text = createText('AGaramondProRegular', 12, canvasValues.department1, 224, y, '#b76746');
        frontDataLayer.add(frontDepartment1Text);
        y += 23;
    }

    frontAddress1Text = createText('AGaramondProRegular', 7, canvasValues.address, 224, y, '#717073');
    frontDataLayer.add(frontAddress1Text);
    y += 11;

    frontAddress2Text = createText('AGaramondProRegular', 7, canvasValues.address2, 224, y, '#717073');
    frontDataLayer.add(frontAddress2Text);
}

export const destroyFrontVariablesP12T7 = () => {
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
}

export const initP12T8FrontCanvas = () => {
    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/backgrounds/p12t8-a6-envelope.svg', (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 708 * scale,
            height: 533 * scale,
        });
        frontBackgroundLayer.draw();
    });

    drawFrontVariablesP12T8();
}

export const drawFrontVariablesP12T8 = () => {
    let y = 90;

    frontAddress1Text = createText('AGaramondProRegular', 7, canvasValues.address, 224, y, '#717073');
    frontDataLayer.add(frontAddress1Text);
    y += 11;

    frontAddress2Text = createText('AGaramondProRegular', 7, canvasValues.address2, 224, y, '#717073');
    frontDataLayer.add(frontAddress2Text);
}

export const destroyFrontVariablesP12T8 = () => {
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
}

export const initP12T9FrontCanvas = () => {
    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/backgrounds/p12t9-a6-envelope.svg', (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: 0 * scale,
            y: 0 * scale,
            width: 650 * scale,
            height: 475 * scale,
        });
        frontBackgroundLayer.draw();
    });

    drawFrontVariablesP12T9();
}

export const drawFrontVariablesP12T9 = () => {
    let y = 74;

    frontAddress1Text = createText('AGaramondProRegular', 7, canvasValues.address, 224, y, '#717073');
    frontDataLayer.add(frontAddress1Text);
    y += 11;

    frontAddress2Text = createText('AGaramondProRegular', 7, canvasValues.address2, 224, y, '#717073');
    frontDataLayer.add(frontAddress2Text);
}

export const destroyFrontVariablesP12T9 = () => {
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
}

export const initP12T10FrontCanvas = () => {
    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/vectors/p11t24-background.svg', (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: 0 * scale,
            y: 0 * scale,
            width: 650 * scale,
            height: 475 * scale,
        });
        frontBackgroundLayer.draw();
    });

    drawFrontVariablesP12T10();
}

export const drawFrontVariablesP12T10 = () => {
    let y = 90;

    frontAddress1Text = createText('AGaramondProRegular', 7, canvasValues.address, 224, y, '#7C7C81');
    frontDataLayer.add(frontAddress1Text);
    y += 11;

    frontAddress2Text = createText('AGaramondProRegular', 7, canvasValues.address2, 224, y, '#7C7C81');
    frontDataLayer.add(frontAddress2Text);
}

export const destroyFrontVariablesP12T10 = () => {
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
}

export const initP18T2FrontCanvas = () => {
    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/backgrounds/prescription-pad.svg', (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: 0 * scale,
            y: 0 * scale,
            width: 550 * scale,
            height: 425 * scale,
        });
        frontBackgroundLayer.draw();
    });

    drawFrontVariablesP18T2();
}

export const drawFrontVariablesP18T2 = () => {
    let department = [];
    if (!isEmpty(canvasValues.department1)) {
        department.push(canvasValues.department1);
    }
    if (!isEmpty(canvasValues.title1)) {
        department.push(canvasValues.title1);
    }
    department = department.join(' - ');

    frontDepartment1Text = new Konva.Text({
        text: department,
        fontSize: convertPointsToPixels(12) * scale,
        fontFamily: 'UniversBold',
        x: 0 * scale,
        y: 38 * scale,
        fill: '#000',
        align: 'center',
        width: 550 * scale,
    });
    frontDataLayer.add(frontDepartment1Text);

    if (!isEmpty(canvasValues.address) || !isEmpty(canvasValues.address2)) {
        frontAddress1Text = new Konva.Text({
            text: canvasValues.address + ', ' + canvasValues.address2,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'UniversLTStd',
            x: 0 * scale,
            y: 60 * scale,
            fill: '#000',
            align: 'center',
            width: 550 * scale,
        });
        frontDataLayer.add(frontAddress1Text);
    }

    let phones = [];
    if (!isEmpty(canvasValues.phone)) {
        phones.push('Phone: ' + canvasValues.phone);
    }
    if (!isEmpty(canvasValues.fax)) {
        phones.push('Fax: ' + canvasValues.fax);
    }
    phones = phones.join(' | ');

    frontPhoneText = new Konva.Text({
        text: phones,
        fontSize: convertPointsToPixels(7) * scale,
        fontFamily: 'UniversLTStd',
        x: 0 * scale,
        y: 72 * scale,
        fill: '#000',
        align: 'center',
        width: 550 * scale,
    });
    frontDataLayer.add(frontPhoneText);

    let x = 38;
    let y = 90;
    for (let i = 0; i < canvasValues.prescriptionPadDoctors.length; i++) {
        const doctor = canvasValues.prescriptionPadDoctors[i];

        frontNames[i] = createText('UniversLTStd', 7, doctor.name, x, y, '#000');
        frontDataLayer.add(frontNames[i]);

        y += 12;

        let lic = '_______';
        if (!isEmpty(doctor.lic)) {
            lic = doctor.lic;
        }

        frontTitles[i] = createText('UniversLTStd', 7, 'Lic#' + lic, x, y, '#000');
        frontDataLayer.add(frontTitles[i]);

        let dea = '_______';
        if (!isEmpty(doctor.dea)) {
            dea = doctor.dea;
        }

        frontTitles2[i] = createText('UniversLTStd', 7, 'DEA#' + dea, x + 62, y, '#000');
        frontDataLayer.add(frontTitles2[i]);

        y += 13;

        if ((i + 1) % 4 === 0) {
            x += 166;
            y = 90;
        }
    }
}

export const destroyFrontVariablesP18T2 = () => {
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontPhoneText) {
        frontPhoneText.destroy();
    }
    for (let i = 0; i < frontNames.length; i++) {
        if (!empty(frontNames[i])) {
            frontNames[i].destroy();
        }
    }
    frontNames = [];
    for (let i = 0; i < frontTitles.length; i++) {
        if (!empty(frontTitles[i])) {
            frontTitles[i].destroy();
        }
    }
    frontTitles = [];
    for (let i = 0; i < frontTitles2.length; i++) {
        if (!empty(frontTitles2[i])) {
            frontTitles2[i].destroy();
        }
    }
    frontTitles2 = [];
}

export const initP18T3FrontCanvas = () => {
    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/vectors/utp-notepad-bw.svg', (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 458 * scale,
            height: 608 * scale,
        });
        frontBackgroundLayer.draw();
    });

    drawFrontVariablesP18T3();
}

export const drawFrontVariablesP18T3 = () => {
    let y = 479;

    if (canvasValues.department2 !== '') {
        frontDepartment2Text = new Konva.Text({
            text: canvasValues.department2,
            fontSize: convertPointsToPixels(8) * scale,
            fontFamily: 'UniversBold',
            x: 0 * scale,
            y: y * scale,
            fill: '#000',
            align: 'center',
            width: 400 * scale,
        });
        frontDataLayer.add(frontDepartment2Text);
        y -= 18;
    }

    frontDepartment1Text = new Konva.Text({
        text: canvasValues.department1,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'UniversBold',
        x: 0 * scale,
        y: y * scale,
        fill: '#000',
        align: 'center',
        width: 400 * scale,
    });
    frontDataLayer.add(frontDepartment1Text);

    let addressParts1 = [canvasValues.address];
    if (canvasValues.suiteRoom !== '') {
        addressParts1.push(canvasValues.suiteRoom);
    }
    let address1 = addressParts1.join(', ');

    frontAddress1Text = new Konva.Text({
        text: address1,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'LinotypeUniversLTStdLight',
        x: 0 * scale,
        y: 497 * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontAddress1Text);

    frontAddress2Text = new Konva.Text({
        text: canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip,
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'LinotypeUniversLTStdLight',
        x: 0 * scale,
        y: 497 * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontAddress2Text);

    frontDivider1Text = new Konva.Text({
        text: 'I',
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'UniversBold',
        x: 0 * scale,
        y: 497 * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontDivider1Text);

    let totalWidth = frontAddress1Text.width() + frontDivider1Text.width() + frontAddress2Text.width() + 8 * scale;
    frontAddress1Text.x((400 * scale - totalWidth) / 2);
    frontDivider1Text.x(frontAddress1Text.x() + frontAddress1Text.width() + 4 * scale);
    frontAddress2Text.x(frontDivider1Text.x() + frontDivider1Text.width() + 4 * scale);

    frontPhoneText = new Konva.Text({
        text: canvasValues.phone + ' main',
        fontSize: convertPointsToPixels(8) * scale,
        fontFamily: 'LinotypeUniversLTStdLight',
        x: 0 * scale,
        y: 515 * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontPhoneText);

    if (canvasValues.fax !== '') {
        frontFaxText = new Konva.Text({
            text: canvasValues.fax + ' fax',
            fontSize: convertPointsToPixels(8) * scale,
            fontFamily: 'LinotypeUniversLTStdLight',
            x: 0 * scale,
            y: 515 * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontFaxText);

        frontDivider2Text = new Konva.Text({
            text: 'I',
            fontSize: convertPointsToPixels(8) * scale,
            fontFamily: 'UniversBold',
            x: 0 * scale,
            y: 515 * scale,
            fill: '#000',
        });
        frontDataLayer.add(frontDivider2Text);

        totalWidth = frontPhoneText.width() + frontDivider2Text.width() + frontFaxText.width() + 8 * scale;
        frontPhoneText.x((400 * scale - totalWidth) / 2);
        frontDivider2Text.x(frontPhoneText.x() + frontPhoneText.width() + 4 * scale);
        frontFaxText.x(frontDivider2Text.x() + frontDivider2Text.width() + 4 * scale);
    } else {
        totalWidth = frontPhoneText.width();
        frontPhoneText.x((400 * scale - totalWidth) / 2);
    }
}

export const getAddressLineP18T3 = () => {
    let addressParts1 = [canvasValues.address];
    if (canvasValues.suiteRoom !== '') {
        addressParts1.push(canvasValues.suiteRoom);
    }
    let addressPart1 = addressParts1.join(', ');

    return addressPart1 + ' | ' + canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip;
}

export const destroyFrontVariablesP18T3 = () => {
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
    if (frontPhoneText) {
        frontPhoneText.destroy();
    }
    if (frontFaxText) {
        frontFaxText.destroy();
    }
    if (frontDivider1Text) {
        frontDivider1Text.destroy();
    }
    if (frontDivider2Text) {
        frontDivider2Text.destroy();
    }
}

export const initP20FrontCanvas = () => {
    let backgroundUrl = '';
    if (canvasValues.templateCode === 'p20t1') {
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/cizik-school-of-nursing-pocket-card.svg';
    } else if (canvasValues.templateCode === 'p20t2') {
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/mcgovern-medical-school-pocket-card.svg';
    } else if (canvasValues.templateCode === 'p20t3') {
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/school-of-biomedical-informatics-pocket-card.svg';
    } else if (canvasValues.templateCode === 'p20t4') {
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/school-of-dentistry-pocket-card.svg';
    } else if (canvasValues.templateCode === 'p20t5') {
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/school-of-public-health-pocket-card.svg';
    } else if (canvasValues.templateCode === 'p20t6') {
        backgroundUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/uthealth-services-pocket-card.svg';
    }

    Konva.Image.fromURL(backgroundUrl, (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 408 * scale,
            height: 658 * scale,
        });
        frontBackgroundLayer.draw();
    });

    drawFrontVariablesP20();
}

export const drawNameP20 = () => {
    let nameParts = [];
    if (!isEmpty(canvasValues.firstName)) {
        nameParts.push(canvasValues.firstName);
    }
    if (!isEmpty(canvasValues.middleName)) {
        nameParts.push(canvasValues.middleName);
    }
    if (!isEmpty(canvasValues.lastName)) {
        nameParts.push(canvasValues.lastName);
    }
    nameParts = [nameParts.join(' ')];

    if (!isEmpty(canvasValues.credentials)) {
        nameParts.push(canvasValues.credentials);
    }

    const fullName = nameParts.join(', ');
    canvasValues.name1 = fullName;
    canvasValues.name2 = '';

    frontName1Text = new Konva.Text({
        text: canvasValues.name1,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: 0 * scale,
        y: 89 * scale,
        fill: '#717073',
        align: 'center',
    });

    let lastIndex = fullName.length - 1;
    for (let i = 0; i < 20; i++) {
        if (frontName1Text.width() / scale <= 275) {
            break;
        }

        lastIndex = fullName.lastIndexOf(' ', lastIndex - 1);
        canvasValues.name1 = fullName.substring(0, lastIndex);
        canvasValues.name2 = fullName.substring(lastIndex + 1);

        frontName1Text = new Konva.Text({
            text: canvasValues.name1,
            fontSize: convertPointsToPixels(9) * scale,
            fontFamily: 'AGaramondProSemibold',
            x: 0 * scale,
            y: 89 * scale,
            fill: '#717073',
            align: 'center',
        });
    }

    frontName1Text.width(350 * scale)
    frontDataLayer.add(frontName1Text);

    frontName2Text = new Konva.Text({
        text: canvasValues.name2,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: 0 * scale,
        y: 106 * scale,
        width: 350 * scale,
        fill: '#717073',
        align: 'center',
    });
    frontDataLayer.add(frontName2Text);

    if (!isEmpty(canvasValues.name2)) {
        canvasValues.nameDivided = 1;
        return 123;
    }

    canvasValues.nameDivided = 0;
    return 106;
}

export const drawFrontVariablesP20 = () => {
    let y = drawNameP20();

    if (!isEmpty(canvasValues.primaryTitle)) {
        frontTitle1Text = new Konva.Text({
            text: canvasValues.primaryTitle,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'AGaramondProItalic',
            x: 0 * scale,
            y: y * scale,
            width: 350 * scale,
            fill: '#717073',
            align: 'center',
        });
        frontDataLayer.add(frontTitle1Text);
        y += 15;
    }

    if (!isEmpty(canvasValues.title2)) {
        frontTitle2Text = new Konva.Text({
            text: canvasValues.title2,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'AGaramondProItalic',
            x: 0 * scale,
            y: y * scale,
            width: 350 * scale,
            fill: '#717073',
            align: 'center',
        });
        frontDataLayer.add(frontTitle2Text);
        y += 15;
    }

    canvasValues.frontDividers = {};

    let phone1Label = canvasValues.phoneLabel1.toLowerCase();
    if (canvasValues.phoneLabel1 === 'Other') {
        phone1Label = canvasValues.phoneOtherLabel1.toLowerCase();
    }

    let phone2Label = canvasValues.phoneLabel2.toLowerCase();
    if (canvasValues.phoneLabel2 === 'Other') {
        phone2Label = canvasValues.phoneOtherLabel2.toLowerCase();
    }

    const letterSpacing = 0.1;
    let totalWidth = 0;
    let phoneWidth = 0;
    let cellWidth = 0;
    if (!isEmpty(canvasValues.main) && !isEmpty(canvasValues.cell)) {
        frontPhoneText = createText('AGaramondProRegular', 6.25, canvasValues.main, 0, y, '#717073', letterSpacing);
        frontDataLayer.add(frontPhoneText);
        frontPhoneSuffixText = createText('AGaramondProItalic', 6.25, phone1Label, 0, y, '#717073');
        frontDataLayer.add(frontPhoneSuffixText);

        phoneWidth = frontPhoneText.text().length * 6.7;
        totalWidth += phoneWidth + frontPhoneSuffixText.width() + 2 * scale;

        frontCellText = createText('AGaramondProRegular', 6.25, canvasValues.cell, 0, y, '#717073', letterSpacing);
        frontDataLayer.add(frontCellText);
        frontCellSuffixText = createText('AGaramondProItalic', 6.25, phone2Label, 0, y, '#717073');
        frontDataLayer.add(frontCellSuffixText);

        cellWidth = frontCellText.text().length * 6.7;
        totalWidth += cellWidth + frontCellSuffixText.width() + 2 * scale;

        frontAddressDividerText = createText('UniversLT49LightUltraCondensed', 6.25, '|', 0, y, '#717073');
        frontDataLayer.add(frontAddressDividerText);

        totalWidth += 12 * scale;

        frontPhoneText.x((350 * scale - totalWidth) / 2);
        frontPhoneSuffixText.x(frontPhoneText.x() + phoneWidth + 2 * scale);
        frontAddressDividerText.x(frontPhoneSuffixText.x() + frontPhoneSuffixText.width() + 5 * scale);
        frontCellText.x(frontAddressDividerText.x() + frontAddressDividerText.width() + 5 * scale);
        frontCellSuffixText.x(frontCellText.x() + cellWidth + 2 * scale);

        canvasValues.frontDividers.phone = frontPhoneText.x() / scale;
        canvasValues.frontDividers.phoneSuffix = frontPhoneSuffixText.x() / scale;
        canvasValues.frontDividers.divider = frontAddressDividerText.x() / scale;
        canvasValues.frontDividers.cell = frontCellText.x() / scale;
        canvasValues.frontDividers.cellSuffix = frontCellSuffixText.x() / scale;

        y += 13;
    } else if (!isEmpty(canvasValues.main)) {
        frontPhoneText = createText('AGaramondProRegular', 6.25, canvasValues.main, 0, y, '#717073', letterSpacing);
        frontDataLayer.add(frontPhoneText);
        frontPhoneSuffixText = createText('AGaramondProItalic', 6.25, phone1Label, 0, y, '#717073');
        frontDataLayer.add(frontPhoneSuffixText);

        phoneWidth = frontPhoneText.text().length * 6.7;
        totalWidth += phoneWidth + frontPhoneSuffixText.width() + 2 * scale;

        frontPhoneText.x((350 * scale - totalWidth) / 2);
        frontPhoneSuffixText.x(frontPhoneText.x() + phoneWidth + 2 * scale);

        canvasValues.frontDividers.phone = frontPhoneText.x() / scale;
        canvasValues.frontDividers.phoneSuffix = frontPhoneSuffixText.x() / scale;

        y += 13;
    } else if (!isEmpty(canvasValues.cell)) {
        frontCellText = createText('AGaramondProRegular', 6.25, canvasValues.cell, 0, y, '#717073', letterSpacing);
        frontDataLayer.add(frontCellText);
        frontCellSuffixText = createText('AGaramondProItalic', 6.25, phone2Label, 0, y, '#717073');
        frontDataLayer.add(frontCellSuffixText);

        cellWidth = frontCellText.text().length * 6.7;
        totalWidth += cellWidth + frontCellSuffixText.width() + 2 * scale;

        frontCellText.x((350 * scale - totalWidth) / 2);
        frontCellSuffixText.x(frontCellText.x() + cellWidth + 2 * scale);

        canvasValues.frontDividers.cell = frontCellText.x() / scale;
        canvasValues.frontDividers.cellSuffix = frontCellSuffixText.x() / scale;

        y += 13;
    }

    if (!isEmpty(canvasValues.email)) {
        frontEmailText = new Konva.Text({
            text: canvasValues.email,
            fontSize: convertPointsToPixels(6.25) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 0 * scale,
            y: y * scale,
            width: 350 * scale,
            fill: '#717073',
            align: 'center',
        });
        frontDataLayer.add(frontEmailText);
        y += 15;
    }

    y += 5;
    frontLine1 = new Konva.Line({
        points: [
            40 * scale, y * scale,
            310 * scale, y * scale
        ],
        stroke: '#b66645',
        strokeWidth: 0.25
    });
    frontDataLayer.add(frontLine1);
}

export const destroyFrontVariablesP20 = () => {
    if (frontName1Text) {
        frontName1Text.destroy();
    }
    if (frontName2Text) {
        frontName2Text.destroy();
    }
    if (frontTitle1Text) {
        frontTitle1Text.destroy();
    }
    if (frontTitle2Text) {
        frontTitle2Text.destroy();
    }
    if (frontPhoneText) {
        frontPhoneText.destroy();
    }
    if (frontPhoneSuffixText) {
        frontPhoneSuffixText.destroy();
    }
    if (frontCellText) {
        frontCellText.destroy();
    }
    if (frontCellSuffixText) {
        frontCellSuffixText.destroy();
    }
    if (frontAddressDividerText) {
        frontAddressDividerText.destroy();
    }
    if (frontEmailText) {
        frontEmailText.destroy();
    }
    if (frontLine1) {
        frontLine1.destroy();
    }
}

export const initP20T7FrontCanvas = () => {
    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/backgrounds/p20t7-background.svg', (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 408 * scale,
            height: 658 * scale,
        });
        frontBackgroundLayer.draw();
    });

    drawFrontVariablesP20T7();
}

export const drawNameP20T7 = () => {
    let nameParts = [];
    if (!isEmpty(canvasValues.firstName)) {
        nameParts.push(canvasValues.firstName);
    }
    if (!isEmpty(canvasValues.middleName)) {
        nameParts.push(canvasValues.middleName);
    }
    if (!isEmpty(canvasValues.lastName)) {
        nameParts.push(canvasValues.lastName);
    }
    nameParts = [nameParts.join(' ')];

    if (!isEmpty(canvasValues.credentials)) {
        nameParts.push(canvasValues.credentials);
    }

    const fullName = nameParts.join(', ');
    canvasValues.name1 = fullName;
    canvasValues.name2 = '';

    frontName1Text = new Konva.Text({
        text: canvasValues.name1,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: 0 * scale,
        y: 89 * scale,
        fill: '#717073',
        align: 'center',
    });

    let lastIndex = fullName.length - 1;
    for (let i = 0; i < 20; i++) {
        if (frontName1Text.width() / scale <= 275) {
            break;
        }

        lastIndex = fullName.lastIndexOf(' ', lastIndex - 1);
        canvasValues.name1 = fullName.substring(0, lastIndex);
        canvasValues.name2 = fullName.substring(lastIndex + 1);

        frontName1Text = new Konva.Text({
            text: canvasValues.name1,
            fontSize: convertPointsToPixels(9) * scale,
            fontFamily: 'AGaramondProSemibold',
            x: 0 * scale,
            y: 89 * scale,
            fill: '#717073',
            align: 'center',
        });
    }

    frontName1Text.width(350 * scale)
    frontDataLayer.add(frontName1Text);

    frontName2Text = new Konva.Text({
        text: canvasValues.name2,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: 0 * scale,
        y: 106 * scale,
        width: 350 * scale,
        fill: '#717073',
        align: 'center',
    });
    frontDataLayer.add(frontName2Text);

    if (!isEmpty(canvasValues.name2)) {
        canvasValues.nameDivided = 1;
        return 123;
    }

    canvasValues.nameDivided = 0;
    return 106;
}

export const drawFrontVariablesP20T7 = () => {
    let y = drawNameP20T7();

    if (!isEmpty(canvasValues.primaryTitle)) {
        frontTitle1Text = new Konva.Text({
            text: canvasValues.primaryTitle,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'AGaramondProItalic',
            x: 0 * scale,
            y: y * scale,
            width: 350 * scale,
            fill: '#717073',
            align: 'center',
        });
        frontDataLayer.add(frontTitle1Text);
        y += 15;
    }

    if (!isEmpty(canvasValues.title2)) {
        frontTitle2Text = new Konva.Text({
            text: canvasValues.title2,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'AGaramondProItalic',
            x: 0 * scale,
            y: y * scale,
            width: 350 * scale,
            fill: '#717073',
            align: 'center',
        });
        frontDataLayer.add(frontTitle2Text);
        y += 15;
    }

    canvasValues.frontDividers = {};

    let phone1Label = canvasValues.phoneLabel1.toLowerCase();
    if (canvasValues.phoneLabel1 === 'Other') {
        phone1Label = canvasValues.phoneOtherLabel1.toLowerCase();
    }

    let phone2Label = canvasValues.phoneLabel2.toLowerCase();
    if (canvasValues.phoneLabel2 === 'Other') {
        phone2Label = canvasValues.phoneOtherLabel2.toLowerCase();
    }

    const letterSpacing = 0.1;
    let totalWidth = 0;
    let phoneWidth = 0;
    let cellWidth = 0;
    if (!isEmpty(canvasValues.main) && !isEmpty(canvasValues.cell)) {
        frontPhoneText = createText('AGaramondProRegular', 6.25, canvasValues.main, 0, y, '#717073', letterSpacing);
        frontDataLayer.add(frontPhoneText);
        frontPhoneSuffixText = createText('AGaramondProItalic', 6.25, phone1Label, 0, y, '#717073');
        frontDataLayer.add(frontPhoneSuffixText);

        phoneWidth = frontPhoneText.text().length * 6.7;
        totalWidth += phoneWidth + frontPhoneSuffixText.width() + 2 * scale;

        frontCellText = createText('AGaramondProRegular', 6.25, canvasValues.cell, 0, y, '#717073', letterSpacing);
        frontDataLayer.add(frontCellText);
        frontCellSuffixText = createText('AGaramondProItalic', 6.25, phone2Label, 0, y, '#717073');
        frontDataLayer.add(frontCellSuffixText);

        cellWidth = frontCellText.text().length * 6.7;
        totalWidth += cellWidth + frontCellSuffixText.width() + 2 * scale;

        frontAddressDividerText = createText('UniversLT49LightUltraCondensed', 6.25, '|', 0, y, '#717073');
        frontDataLayer.add(frontAddressDividerText);

        totalWidth += 12 * scale;

        frontPhoneText.x((350 * scale - totalWidth) / 2);
        frontPhoneSuffixText.x(frontPhoneText.x() + phoneWidth + 2 * scale);
        frontAddressDividerText.x(frontPhoneSuffixText.x() + frontPhoneSuffixText.width() + 5 * scale);
        frontCellText.x(frontAddressDividerText.x() + frontAddressDividerText.width() + 5 * scale);
        frontCellSuffixText.x(frontCellText.x() + cellWidth + 2 * scale);

        canvasValues.frontDividers.phone = frontPhoneText.x() / scale;
        canvasValues.frontDividers.phoneSuffix = frontPhoneSuffixText.x() / scale;
        canvasValues.frontDividers.divider = frontAddressDividerText.x() / scale;
        canvasValues.frontDividers.cell = frontCellText.x() / scale;
        canvasValues.frontDividers.cellSuffix = frontCellSuffixText.x() / scale;

        y += 13;
    } else if (!isEmpty(canvasValues.main)) {
        frontPhoneText = createText('AGaramondProRegular', 6.25, canvasValues.main, 0, y, '#717073', letterSpacing);
        frontDataLayer.add(frontPhoneText);
        frontPhoneSuffixText = createText('AGaramondProItalic', 6.25, phone1Label, 0, y, '#717073');
        frontDataLayer.add(frontPhoneSuffixText);

        phoneWidth = frontPhoneText.text().length * 6.7;
        totalWidth += phoneWidth + frontPhoneSuffixText.width() + 2 * scale;

        frontPhoneText.x((350 * scale - totalWidth) / 2);
        frontPhoneSuffixText.x(frontPhoneText.x() + phoneWidth + 2 * scale);

        canvasValues.frontDividers.phone = frontPhoneText.x() / scale;
        canvasValues.frontDividers.phoneSuffix = frontPhoneSuffixText.x() / scale;

        y += 13;
    } else if (!isEmpty(canvasValues.cell)) {
        frontCellText = createText('AGaramondProRegular', 6.25, canvasValues.cell, 0, y, '#717073', letterSpacing);
        frontDataLayer.add(frontCellText);
        frontCellSuffixText = createText('AGaramondProItalic', 6.25, phone2Label, 0, y, '#717073');
        frontDataLayer.add(frontCellSuffixText);

        cellWidth = frontCellText.text().length * 6.7;
        totalWidth += cellWidth + frontCellSuffixText.width() + 2 * scale;

        frontCellText.x((350 * scale - totalWidth) / 2);
        frontCellSuffixText.x(frontCellText.x() + cellWidth + 2 * scale);

        canvasValues.frontDividers.cell = frontCellText.x() / scale;
        canvasValues.frontDividers.cellSuffix = frontCellSuffixText.x() / scale;

        y += 13;
    }

    if (!isEmpty(canvasValues.email)) {
        frontEmailText = new Konva.Text({
            text: canvasValues.email,
            fontSize: convertPointsToPixels(6.25) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 0 * scale,
            y: y * scale,
            width: 350 * scale,
            fill: '#717073',
            align: 'center',
        });
        frontDataLayer.add(frontEmailText);
        y += 15;
    }

    y += 5;
    frontLine1 = new Konva.Line({
        points: [
            40 * scale, y * scale,
            310 * scale, y * scale
        ],
        stroke: '#b66645',
        strokeWidth: 1
    });
    frontDataLayer.add(frontLine1);
}

export const destroyFrontVariablesP20T7 = () => {
    if (frontName1Text) {
        frontName1Text.destroy();
    }
    if (frontName2Text) {
        frontName2Text.destroy();
    }
    if (frontTitle1Text) {
        frontTitle1Text.destroy();
    }
    if (frontTitle2Text) {
        frontTitle2Text.destroy();
    }
    if (frontPhoneText) {
        frontPhoneText.destroy();
    }
    if (frontPhoneSuffixText) {
        frontPhoneSuffixText.destroy();
    }
    if (frontCellText) {
        frontCellText.destroy();
    }
    if (frontCellSuffixText) {
        frontCellSuffixText.destroy();
    }
    if (frontAddressDividerText) {
        frontAddressDividerText.destroy();
    }
    if (frontEmailText) {
        frontEmailText.destroy();
    }
    if (frontLine1) {
        frontLine1.destroy();
    }
}

export const initP20T8FrontCanvas = () => {
    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/backgrounds/p20t8-background.svg', (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 408 * scale,
            height: 658 * scale,
        });
        frontBackgroundLayer.draw();
    });

    drawFrontVariablesP20T8();
}

export const drawNameP20T8 = () => {
    let nameParts = [];
    if (!isEmpty(canvasValues.firstName)) {
        nameParts.push(canvasValues.firstName);
    }
    if (!isEmpty(canvasValues.middleName)) {
        nameParts.push(canvasValues.middleName);
    }
    if (!isEmpty(canvasValues.lastName)) {
        nameParts.push(canvasValues.lastName);
    }
    nameParts = [nameParts.join(' ')];

    if (!isEmpty(canvasValues.credentials)) {
        nameParts.push(canvasValues.credentials);
    }

    const fullName = nameParts.join(', ');
    canvasValues.name1 = fullName;
    canvasValues.name2 = '';

    frontName1Text = new Konva.Text({
        text: canvasValues.name1,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: 0 * scale,
        y: 89 * scale,
        fill: '#717073',
        align: 'center',
    });

    let lastIndex = fullName.length - 1;
    for (let i = 0; i < 20; i++) {
        if (frontName1Text.width() / scale <= 275) {
            break;
        }

        lastIndex = fullName.lastIndexOf(' ', lastIndex - 1);
        canvasValues.name1 = fullName.substring(0, lastIndex);
        canvasValues.name2 = fullName.substring(lastIndex + 1);

        frontName1Text = new Konva.Text({
            text: canvasValues.name1,
            fontSize: convertPointsToPixels(9) * scale,
            fontFamily: 'AGaramondProSemibold',
            x: 0 * scale,
            y: 89 * scale,
            fill: '#717073',
            align: 'center',
        });
    }

    frontName1Text.width(350 * scale)
    frontDataLayer.add(frontName1Text);

    frontName2Text = new Konva.Text({
        text: canvasValues.name2,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: 0 * scale,
        y: 106 * scale,
        width: 350 * scale,
        fill: '#717073',
        align: 'center',
    });
    frontDataLayer.add(frontName2Text);

    if (!isEmpty(canvasValues.name2)) {
        canvasValues.nameDivided = 1;
        return 123;
    }

    canvasValues.nameDivided = 0;
    return 106;
}

export const drawFrontVariablesP20T8 = () => {
    let y = drawNameP20T8();

    if (!isEmpty(canvasValues.primaryTitle)) {
        frontTitle1Text = new Konva.Text({
            text: canvasValues.primaryTitle,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'AGaramondProItalic',
            x: 0 * scale,
            y: y * scale,
            width: 350 * scale,
            fill: '#717073',
            align: 'center',
        });
        frontDataLayer.add(frontTitle1Text);
        y += 15;
    }

    if (!isEmpty(canvasValues.title2)) {
        frontTitle2Text = new Konva.Text({
            text: canvasValues.title2,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'AGaramondProItalic',
            x: 0 * scale,
            y: y * scale,
            width: 350 * scale,
            fill: '#717073',
            align: 'center',
        });
        frontDataLayer.add(frontTitle2Text);
        y += 15;
    }

    canvasValues.frontDividers = {};

    let phone1Label = canvasValues.phoneLabel1.toLowerCase();
    if (canvasValues.phoneLabel1 === 'Other') {
        phone1Label = canvasValues.phoneOtherLabel1.toLowerCase();
    }

    let phone2Label = canvasValues.phoneLabel2.toLowerCase();
    if (canvasValues.phoneLabel2 === 'Other') {
        phone2Label = canvasValues.phoneOtherLabel2.toLowerCase();
    }

    const letterSpacing = 0.1;
    let totalWidth = 0;
    let phoneWidth = 0;
    let cellWidth = 0;
    if (!isEmpty(canvasValues.main) && !isEmpty(canvasValues.cell)) {
        frontPhoneText = createText('AGaramondProRegular', 6.25, canvasValues.main, 0, y, '#717073', letterSpacing);
        frontDataLayer.add(frontPhoneText);
        frontPhoneSuffixText = createText('AGaramondProItalic', 6.25, phone1Label, 0, y, '#717073');
        frontDataLayer.add(frontPhoneSuffixText);

        phoneWidth = frontPhoneText.text().length * 6.7;
        totalWidth += phoneWidth + frontPhoneSuffixText.width() + 2 * scale;

        frontCellText = createText('AGaramondProRegular', 6.25, canvasValues.cell, 0, y, '#717073', letterSpacing);
        frontDataLayer.add(frontCellText);
        frontCellSuffixText = createText('AGaramondProItalic', 6.25, phone2Label, 0, y, '#717073');
        frontDataLayer.add(frontCellSuffixText);

        cellWidth = frontCellText.text().length * 6.7;
        totalWidth += cellWidth + frontCellSuffixText.width() + 2 * scale;

        frontAddressDividerText = createText('UniversLT49LightUltraCondensed', 6.25, '|', 0, y, '#717073');
        frontDataLayer.add(frontAddressDividerText);

        totalWidth += 12 * scale;

        frontPhoneText.x((350 * scale - totalWidth) / 2);
        frontPhoneSuffixText.x(frontPhoneText.x() + phoneWidth + 2 * scale);
        frontAddressDividerText.x(frontPhoneSuffixText.x() + frontPhoneSuffixText.width() + 5 * scale);
        frontCellText.x(frontAddressDividerText.x() + frontAddressDividerText.width() + 5 * scale);
        frontCellSuffixText.x(frontCellText.x() + cellWidth + 2 * scale);

        canvasValues.frontDividers.phone = frontPhoneText.x() / scale;
        canvasValues.frontDividers.phoneSuffix = frontPhoneSuffixText.x() / scale;
        canvasValues.frontDividers.divider = frontAddressDividerText.x() / scale;
        canvasValues.frontDividers.cell = frontCellText.x() / scale;
        canvasValues.frontDividers.cellSuffix = frontCellSuffixText.x() / scale;

        y += 13;
    } else if (!isEmpty(canvasValues.main)) {
        frontPhoneText = createText('AGaramondProRegular', 6.25, canvasValues.main, 0, y, '#717073', letterSpacing);
        frontDataLayer.add(frontPhoneText);
        frontPhoneSuffixText = createText('AGaramondProItalic', 6.25, phone1Label, 0, y, '#717073');
        frontDataLayer.add(frontPhoneSuffixText);

        phoneWidth = frontPhoneText.text().length * 6.7;
        totalWidth += phoneWidth + frontPhoneSuffixText.width() + 2 * scale;

        frontPhoneText.x((350 * scale - totalWidth) / 2);
        frontPhoneSuffixText.x(frontPhoneText.x() + phoneWidth + 2 * scale);

        canvasValues.frontDividers.phone = frontPhoneText.x() / scale;
        canvasValues.frontDividers.phoneSuffix = frontPhoneSuffixText.x() / scale;

        y += 13;
    } else if (!isEmpty(canvasValues.cell)) {
        frontCellText = createText('AGaramondProRegular', 6.25, canvasValues.cell, 0, y, '#717073', letterSpacing);
        frontDataLayer.add(frontCellText);
        frontCellSuffixText = createText('AGaramondProItalic', 6.25, phone1Label, 0, y, '#717073');
        frontDataLayer.add(frontCellSuffixText);

        cellWidth = frontCellText.text().length * 6.7;
        totalWidth += cellWidth + frontCellSuffixText.width() + 2 * scale;

        frontCellText.x((350 * scale - totalWidth) / 2);
        frontCellSuffixText.x(frontCellText.x() + cellWidth + 2 * scale);

        canvasValues.frontDividers.cell = frontCellText.x() / scale;
        canvasValues.frontDividers.cellSuffix = frontCellSuffixText.x() / scale;

        y += 13;
    }

    if (!isEmpty(canvasValues.email)) {
        frontEmailText = new Konva.Text({
            text: canvasValues.email,
            fontSize: convertPointsToPixels(6.25) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 0 * scale,
            y: y * scale,
            width: 350 * scale,
            fill: '#717073',
            align: 'center',
        });
        frontDataLayer.add(frontEmailText);
        y += 15;
    }

    y += 5;
    frontLine1 = new Konva.Line({
        points: [
            40 * scale, y * scale,
            310 * scale, y * scale
        ],
        stroke: '#b66645',
        strokeWidth: 1
    });
    frontDataLayer.add(frontLine1);
}

export const destroyFrontVariablesP20T8 = () => {
    if (frontName1Text) {
        frontName1Text.destroy();
    }
    if (frontName2Text) {
        frontName2Text.destroy();
    }
    if (frontTitle1Text) {
        frontTitle1Text.destroy();
    }
    if (frontTitle2Text) {
        frontTitle2Text.destroy();
    }
    if (frontPhoneText) {
        frontPhoneText.destroy();
    }
    if (frontPhoneSuffixText) {
        frontPhoneSuffixText.destroy();
    }
    if (frontCellText) {
        frontCellText.destroy();
    }
    if (frontCellSuffixText) {
        frontCellSuffixText.destroy();
    }
    if (frontAddressDividerText) {
        frontAddressDividerText.destroy();
    }
    if (frontEmailText) {
        frontEmailText.destroy();
    }
    if (frontLine1) {
        frontLine1.destroy();
    }
}

export const initP20T9FrontCanvas = () => {
    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/vectors/p20t9-background.svg', (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 408 * scale,
            height: 658 * scale,
        });
        frontBackgroundLayer.draw();
    });

    drawFrontVariablesP20T9();
}

export const drawNameP20T9 = () => {
    let nameParts = [];
    if (!isEmpty(canvasValues.firstName)) {
        nameParts.push(canvasValues.firstName);
    }
    if (!isEmpty(canvasValues.middleName)) {
        nameParts.push(canvasValues.middleName);
    }
    if (!isEmpty(canvasValues.lastName)) {
        nameParts.push(canvasValues.lastName);
    }
    nameParts = [nameParts.join(' ')];

    if (!isEmpty(canvasValues.credentials)) {
        nameParts.push(canvasValues.credentials);
    }

    const fullName = nameParts.join(', ');
    canvasValues.name1 = fullName;
    canvasValues.name2 = '';

    frontName1Text = new Konva.Text({
        text: canvasValues.name1,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 0 * scale,
        y: 89 * scale,
        fill: '#7C7C81',
        align: 'center',
    });

    let lastIndex = fullName.length - 1;
    for (let i = 0; i < 20; i++) {
        if (frontName1Text.width() / scale <= 275) {
            break;
        }

        lastIndex = fullName.lastIndexOf(' ', lastIndex - 1);
        canvasValues.name1 = fullName.substring(0, lastIndex);
        canvasValues.name2 = fullName.substring(lastIndex + 1);

        frontName1Text = new Konva.Text({
            text: canvasValues.name1,
            fontSize: convertPointsToPixels(9) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 0 * scale,
            y: 89 * scale,
            fill: '#7C7C81',
            align: 'center',
        });
    }

    frontName1Text.width(350 * scale)
    frontDataLayer.add(frontName1Text);

    frontName2Text = new Konva.Text({
        text: canvasValues.name2,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 0 * scale,
        y: 106 * scale,
        width: 350 * scale,
        fill: '#7C7C81',
        align: 'center',
    });
    frontDataLayer.add(frontName2Text);

    if (!isEmpty(canvasValues.name2)) {
        canvasValues.nameDivided = 1;
        return 123;
    }

    canvasValues.nameDivided = 0;
    return 106;
}

export const drawFrontVariablesP20T9 = () => {
    let y = drawNameP20T9();

    if (!isEmpty(canvasValues.primaryTitle)) {
        frontTitle1Text = new Konva.Text({
            text: canvasValues.primaryTitle,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'AGaramondProItalic',
            x: 0 * scale,
            y: y * scale,
            width: 350 * scale,
            fill: '#7C7C81',
            align: 'center',
        });
        frontDataLayer.add(frontTitle1Text);
        y += 15;
    }

    if (!isEmpty(canvasValues.title2)) {
        frontTitle2Text = new Konva.Text({
            text: canvasValues.title2,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'AGaramondProItalic',
            x: 0 * scale,
            y: y * scale,
            width: 350 * scale,
            fill: '#7C7C81',
            align: 'center',
        });
        frontDataLayer.add(frontTitle2Text);
        y += 15;
    }

    canvasValues.frontDividers = {};

    let phone1Label = canvasValues.phoneLabel1.toLowerCase();
    if (canvasValues.phoneLabel1 === 'Other') {
        phone1Label = canvasValues.phoneOtherLabel1.toLowerCase();
    }

    let phone2Label = canvasValues.phoneLabel2.toLowerCase();
    if (canvasValues.phoneLabel2 === 'Other') {
        phone2Label = canvasValues.phoneOtherLabel2.toLowerCase();
    }

    const letterSpacing = 0.1;
    let totalWidth = 0;
    let phoneWidth = 0;
    let cellWidth = 0;
    if (!isEmpty(canvasValues.main) && !isEmpty(canvasValues.cell)) {
        frontPhoneText = createText('AGaramondProRegular', 6.25, canvasValues.main, 0, y, '#7C7C81', letterSpacing);
        frontDataLayer.add(frontPhoneText);
        frontPhoneSuffixText = createText('AGaramondProItalic', 6.25, phone1Label, 0, y, '#7C7C81');
        frontDataLayer.add(frontPhoneSuffixText);

        phoneWidth = frontPhoneText.text().length * 6.7;
        totalWidth += phoneWidth + frontPhoneSuffixText.width() + 2 * scale;

        frontCellText = createText('AGaramondProRegular', 6.25, canvasValues.cell, 0, y, '#7C7C81', letterSpacing);
        frontDataLayer.add(frontCellText);
        frontCellSuffixText = createText('AGaramondProItalic', 6.25, phone2Label, 0, y, '#7C7C81');
        frontDataLayer.add(frontCellSuffixText);

        cellWidth = frontCellText.text().length * 6.7;
        totalWidth += cellWidth + frontCellSuffixText.width() + 2 * scale;

        frontAddressDividerText = createText('UniversLT49LightUltraCondensed', 6.25, '|', 0, y, '#7C7C81');
        frontDataLayer.add(frontAddressDividerText);

        totalWidth += 12 * scale;

        frontPhoneText.x((350 * scale - totalWidth) / 2);
        frontPhoneSuffixText.x(frontPhoneText.x() + phoneWidth + 2 * scale);
        frontAddressDividerText.x(frontPhoneSuffixText.x() + frontPhoneSuffixText.width() + 5 * scale);
        frontCellText.x(frontAddressDividerText.x() + frontAddressDividerText.width() + 5 * scale);
        frontCellSuffixText.x(frontCellText.x() + cellWidth + 2 * scale);

        canvasValues.frontDividers.phone = frontPhoneText.x() / scale;
        canvasValues.frontDividers.phoneSuffix = frontPhoneSuffixText.x() / scale;
        canvasValues.frontDividers.divider = frontAddressDividerText.x() / scale;
        canvasValues.frontDividers.cell = frontCellText.x() / scale;
        canvasValues.frontDividers.cellSuffix = frontCellSuffixText.x() / scale;

        y += 13;
    } else if (!isEmpty(canvasValues.main)) {
        frontPhoneText = createText('AGaramondProRegular', 6.25, canvasValues.main, 0, y, '#7C7C81', letterSpacing);
        frontDataLayer.add(frontPhoneText);
        frontPhoneSuffixText = createText('AGaramondProItalic', 6.25, phone1Label, 0, y, '#7C7C81');
        frontDataLayer.add(frontPhoneSuffixText);

        phoneWidth = frontPhoneText.text().length * 6.7;
        totalWidth += phoneWidth + frontPhoneSuffixText.width() + 2 * scale;

        frontPhoneText.x((350 * scale - totalWidth) / 2);
        frontPhoneSuffixText.x(frontPhoneText.x() + phoneWidth + 2 * scale);

        canvasValues.frontDividers.phone = frontPhoneText.x() / scale;
        canvasValues.frontDividers.phoneSuffix = frontPhoneSuffixText.x() / scale;

        y += 13;
    } else if (!isEmpty(canvasValues.cell)) {
        frontCellText = createText('AGaramondProRegular', 6.25, canvasValues.cell, 0, y, '#7C7C81', letterSpacing);
        frontDataLayer.add(frontCellText);
        frontCellSuffixText = createText('AGaramondProItalic', 6.25, phone1Label, 0, y, '#7C7C81');
        frontDataLayer.add(frontCellSuffixText);

        cellWidth = frontCellText.text().length * 6.7;
        totalWidth += cellWidth + frontCellSuffixText.width() + 2 * scale;

        frontCellText.x((350 * scale - totalWidth) / 2);
        frontCellSuffixText.x(frontCellText.x() + cellWidth + 2 * scale);

        canvasValues.frontDividers.cell = frontCellText.x() / scale;
        canvasValues.frontDividers.cellSuffix = frontCellSuffixText.x() / scale;

        y += 13;
    }

    if (!isEmpty(canvasValues.email)) {
        frontEmailText = new Konva.Text({
            text: canvasValues.email,
            fontSize: convertPointsToPixels(6.25) * scale,
            fontFamily: 'AGaramondProRegular',
            x: 0 * scale,
            y: y * scale,
            width: 350 * scale,
            fill: '#7C7C81',
            align: 'center',
        });
        frontDataLayer.add(frontEmailText);
        y += 15;
    }

    y += 5;
    frontLine1 = new Konva.Line({
        points: [
            40 * scale, y * scale,
            310 * scale, y * scale
        ],
        stroke: '#b66645',
        strokeWidth: 1
    });
    frontDataLayer.add(frontLine1);
}

export const destroyFrontVariablesP20T9 = () => {
    if (frontName1Text) {
        frontName1Text.destroy();
    }
    if (frontName2Text) {
        frontName2Text.destroy();
    }
    if (frontTitle1Text) {
        frontTitle1Text.destroy();
    }
    if (frontTitle2Text) {
        frontTitle2Text.destroy();
    }
    if (frontPhoneText) {
        frontPhoneText.destroy();
    }
    if (frontPhoneSuffixText) {
        frontPhoneSuffixText.destroy();
    }
    if (frontCellText) {
        frontCellText.destroy();
    }
    if (frontCellSuffixText) {
        frontCellSuffixText.destroy();
    }
    if (frontAddressDividerText) {
        frontAddressDividerText.destroy();
    }
    if (frontEmailText) {
        frontEmailText.destroy();
    }
    if (frontLine1) {
        frontLine1.destroy();
    }
}

export const initP21T1FrontCanvas = () => {
    drawFrontVariablesP21T1();
}

export const drawFrontVariablesP21T1 = () => {
    let color = '#b66645';
    let svgImage = 'utp-9x12-catalog-envelope-p21t1-color.svg';
    if (parseInt(canvasValues.color) === 2) {
        color = '#000';
        svgImage = 'utp-9x12-catalog-envelope-p21t1-bw.svg';
    }

    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/vectors/' + svgImage, (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontDataLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 958 * scale,
            height: 1258 * scale,
        });
        frontDataLayer.draw();
    });

    let y = 123;
    frontDepartment1Text = new Konva.Text({
        text: canvasValues.department1,
        fontSize: convertPointsToPixels(7.5) * scale,
        fontFamily: 'UniversBold',
        x: 69 * scale,
        y: y * scale,
        fill: color,
    });
    frontDataLayer.add(frontDepartment1Text);
    y += 15;

    if (canvasValues.department2 !== '') {
        frontDepartment2Text = new Konva.Text({
            text: canvasValues.department2,
            fontSize: convertPointsToPixels(7.5) * scale,
            fontFamily: 'UniversBold',
            x: 69 * scale,
            y: y * scale,
            fill: color,
        });
        frontDataLayer.add(frontDepartment2Text);
        y += 15;
    }

    y += 1;
    frontAddress1Text = new Konva.Text({
        text: getAddressLine1P21T1(),
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 69 * scale,
        y: y * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontAddress1Text);
    y += 16;

    frontAddress2Text = new Konva.Text({
        text: getAddressLine2P21T1(),
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 69 * scale,
        y: y * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontAddress2Text);
    y += 16;
}

export const getAddressLine1P21T1 = () => {
    let addressParts1 = [canvasValues.address];
    if (canvasValues.suiteRoom !== '') {
        addressParts1.push(canvasValues.suiteRoom);
    }
    return addressParts1.join(', ');
}

export const getAddressLine2P21T1 = () => {
    return canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip;
}

export const destroyFrontVariablesP21T1 = () => {
    if (frontLogo1Img) {
        frontLogo1Img.destroy();
    }
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
}

export const initP21T2FrontCanvas = () => {
    drawFrontVariablesP21T2();
}

export const drawFrontVariablesP21T2 = () => {
    let color = '#b66645';
    let svgImage = 'utp-10-13-catalog-envelope-color.svg';
    if (parseInt(canvasValues.color) === 2) {
        color = '#000';
        svgImage = 'utp-10-13-catalog-envelope-bw.svg';
    }

    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/vectors/' + svgImage, (image) => {
        if (frontLogo1Img != null) {
            frontLogo1Img.destroy();
        }
        frontLogo1Img = image;

        frontDataLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 1058 * scale,
            height: 1358 * scale,
        });
        frontDataLayer.draw();
    });

    let y = 123;
    frontDepartment1Text = new Konva.Text({
        text: canvasValues.department1,
        fontSize: convertPointsToPixels(7.5) * scale,
        fontFamily: 'UniversBold',
        x: 69 * scale,
        y: y * scale,
        fill: color,
    });
    frontDataLayer.add(frontDepartment1Text);
    y += 15;

    if (canvasValues.department2 !== '') {
        frontDepartment2Text = new Konva.Text({
            text: canvasValues.department2,
            fontSize: convertPointsToPixels(7.5) * scale,
            fontFamily: 'UniversBold',
            x: 69 * scale,
            y: y * scale,
            fill: color,
        });
        frontDataLayer.add(frontDepartment2Text);
        y += 15;
    }

    y += 1;
    frontAddress1Text = new Konva.Text({
        text: getAddressLine1P21T2(),
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 69 * scale,
        y: y * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontAddress1Text);
    y += 16;

    frontAddress2Text = new Konva.Text({
        text: getAddressLine2P21T2(),
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 69 * scale,
        y: y * scale,
        fill: '#000',
    });
    frontDataLayer.add(frontAddress2Text);
    y += 16;
}

export const getAddressLine1P21T2 = () => {
    let addressParts1 = [canvasValues.address];
    if (canvasValues.suiteRoom !== '') {
        addressParts1.push(canvasValues.suiteRoom);
    }
    return addressParts1.join(', ');
}

export const getAddressLine2P21T2 = () => {
    return canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip;
}

export const destroyFrontVariablesP21T2 = () => {
    if (frontLogo1Img) {
        frontLogo1Img.destroy();
    }
    if (frontDepartment1Text) {
        frontDepartment1Text.destroy();
    }
    if (frontDepartment2Text) {
        frontDepartment2Text.destroy();
    }
    if (frontAddress1Text) {
        frontAddress1Text.destroy();
    }
    if (frontAddress2Text) {
        frontAddress2Text.destroy();
    }
}

export const initBackCanvas = () => {
    if (['p1t1', 'p1t2', 'p1t3', 'p1t4', 'p1t5', 'p1t6', 'p1t7', 'p1t7', 'p1t13', 'p1t14', 'p1t15', 'p1t16'].includes(canvasValues.templateCode)) {
        scale = 1.5;
        canvasWidth = 350;
        canvasHeight = 200;
    }

    backStage = new Konva.Stage({
        container: 'back-canvas',
        width: canvasWidth * scale,
        height: canvasHeight * scale
    });

    backBackgroundLayer = new Konva.Layer();
    backStage.add(backBackgroundLayer);

    backDataLayer = new Konva.Layer();
    backDataLayer.moveUp();
    backStage.add(backDataLayer);

    let backgroundColor = '#ffffff';
    if (['p1t1', 'p1t2', 'p1t7'].includes(canvasValues.templateCode)) {
        backgroundColor = '#BE531C';
    } else if (['p9t1', 'p9t2', 'p9t3', 'p9t4', 'p9t5', 'p9t6', 'p9t7', 'p9t8', 'p9t9', 'p9t10', 'p9t11', 'p9t12', 'p9t13', 'p9t14', 
        'p9t15', 'p9t16', 'p9t17', 'p9t18', 'p9t19', 'p9t20', 'p9t21', 'p9t22', 'p9t23'].includes(canvasValues.templateCode)) {
        backgroundColor = '#ffffff';
    }

    let rect = new Konva.Rect({
        x: 0 * scale,
        y: 0 * scale,
        width: canvasWidth * scale,
        height: canvasHeight * scale,
        fill: backgroundColor,
    });
    backBackgroundLayer.add(rect);

    if (canvasValues.templateCode === 'p1t1' || canvasValues.templateCode === 'p1t2') {
        initP1T1BackCanvas();
    } else if (canvasValues.templateCode === 'p1t4') {
        initP1T4BackCanvas();
    } else if (canvasValues.templateCode === 'p1t5') {
        initP1T5BackCanvas();
    } else if (canvasValues.templateCode === 'p1t7') {
        initP1T7BackCanvas();
    } else if (canvasValues.templateCode === 'p1t8') {
        initP1T8BackCanvas();
    } else if (canvasValues.templateCode === 'p1t11') {
        initP1T8BackCanvas();
    } else if (canvasValues.templateCode === 'p1t9') {
        initP1T9BackCanvas();
    } else if (canvasValues.templateCode === 'p1t13') {
        initP1T13BackCanvas();
    } else if (canvasValues.templateCode === 'p1t14') {
        initP1T14BackCanvas();
    } else if (canvasValues.templateCode === 'p1t15') {
        initP1T15BackCanvas();
    } else if (canvasValues.templateCode === 'p1t16') {
        initP1T16BackCanvas();
    } else if (['p9t1', 'p9t2', 'p9t3', 'p9t4', 'p9t5', 'p9t6', 'p9t7', 'p9t8', 'p9t9', 'p9t10'].includes(canvasValues.templateCode)) {
        initP9BackCanvas();
    } else if (canvasValues.templateCode === 'p9t11') {
        initP9T11BackCanvas();
    } else if (canvasValues.templateCode === 'p9t12') {
        initP9T12BackCanvas();
    } else if (canvasValues.templateCode === 'p9t13') {
        initP9T13BackCanvas();
    } else if (canvasValues.templateCode === 'p9t14') {
        initP9T14BackCanvas();
    } else if (canvasValues.templateCode === 'p9t15') {
        initP9T15BackCanvas();
    } else if (canvasValues.templateCode === 'p9t16') {
        initP9T16BackCanvas();
    } else if (canvasValues.templateCode === 'p9t17') {
        initP9T17BackCanvas();
    } else if (canvasValues.templateCode === 'p9t18') {
        initP9T18BackCanvas();
    } else if (canvasValues.templateCode === 'p9t19') {
        initP9T19BackCanvas();
    } else if (canvasValues.templateCode === 'p9t20') {
        initP9T20BackCanvas();
    } else if (canvasValues.templateCode === 'p9t21') {
        initP9T21BackCanvas();
    } else if (canvasValues.templateCode === 'p9t22') {
        initP9T22BackCanvas();
    } else if (canvasValues.templateCode === 'p9t23') {
        initP9T23BackCanvas();
    }

    backBackgroundLayer.batchDraw();
    backDataLayer.batchDraw();
}

export const initP1T1BackCanvas = () => {
    /* ------------ Start ----------------- */
    backNameText = new Konva.Text({
        text: getFullName(),
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: (30 - 12.5) * scale,
        y: (30 - 12.5) * scale,
        fill: '#ffffff',
    });
    backDataLayer.add(backNameText);

    backTitle1Text = new Konva.Text({
        text: canvasValues.title1,
        fontSize: convertPointsToPixels(8.5) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: (30 - 12.5) * scale,
        y: (46 - 12.5) * scale,
        fill: '#ffffff',
    });
    backDataLayer.add(backTitle1Text);

    backTitle2Text = new Konva.Text({
        text: canvasValues.title2,
        fontSize: convertPointsToPixels(8.5) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: (30 - 12.5) * scale,
        y: (60 - 12.5) * scale,
        fill: '#ffffff',
    });
    backDataLayer.add(backTitle2Text);

    backTitle3Text = new Konva.Text({
        text: canvasValues.title3,
        fontSize: convertPointsToPixels(8.5) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: (30 - 12.5) * scale,
        y: (74 - 12.5) * scale,
        fill: '#ffffff',
    });
    backDataLayer.add(backTitle3Text);
    /* ------------- End ------------------ */

    /* ------------ Start ----------------- */
    let y = 110;

    let backEmail = canvasValues.email;
    if (parseInt(canvasValues.showEmail) === 2) {
        backEmail = '';
    }

    backEmailText = new Konva.Text({
        text: backEmail,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: (30 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#ffffff',
    });
    backDataLayer.add(backEmailText);

    y += 16;
    let phone = '';
    if (canvasValues.phone !== '') {
        phone = canvasValues.phone + '   Direct';
    }
    backPhoneText = new Konva.Text({
        text: phone,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: (30 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#ffffff',
    });
    backDataLayer.add(backPhoneText);

    let clinic = '';
    if (canvasValues.clinic !== '') {
        clinic = canvasValues.clinic + '   Clinic';
    }
    backClinicText = new Konva.Text({
        text: clinic,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: (206 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#ffffff',
    });
    backDataLayer.add(backClinicText);

    y += 16;
    let fax = '';
    if (canvasValues.fax !== '') {
        fax = canvasValues.fax + '   Fax';
    }
    backFaxText = new Konva.Text({
        text: fax,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: (30 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#ffffff',
    });
    backDataLayer.add(backFaxText);

    if (canvasValues.templateCode === 'p1t1') {
        let pager = '';
        if (canvasValues.pager !== '') {
            pager = canvasValues.pager + '   Pager';
        }
        backPagerText = new Konva.Text({
            text: pager,
            fontSize: convertPointsToPixels(9) * scale,
            fontFamily: 'AGaramondProSemibold',
            x: (206 - 12.5) * scale,
            y: (y - 12.5) * scale,
            fill: '#ffffff',
        });
        backDataLayer.add(backPagerText);
    } else if (canvasValues.templateCode === 'p1t2') {
        y += 16;
        let cell = '';
        if (canvasValues.cell !== '' && parseInt(canvasValues.showCell) !== 2) {
            cell = canvasValues.cell + '   Cell';
        }
        backCellText = new Konva.Text({
            text: cell,
            fontSize: convertPointsToPixels(9) * scale,
            fontFamily: 'AGaramondProSemibold',
            x: (30 - 12.5) * scale,
            y: (y - 12.5) * scale,
            fill: '#ffffff',
        });
        backDataLayer.add(backCellText);
    }

    y = canvasValues.templateCode === 'p1t1' ? 158 : 174;
    if (canvasValues.fax === '' && canvasValues.pager === '') {
        y -= 16;
    } else if (canvasValues.templateCode === 'p1t2' && canvasValues.fax === '') {
        y -= 16;
    }
    if (canvasValues.templateCode === 'p1t2' && parseInt(canvasValues.showCell) === 2) {
        y -= 16;
    }
    if (canvasValues.templateCode === 'p1t2' && canvasValues.cell === '') {
        y -= 16;
    }
    backOpen1Text = new Konva.Text({
        text: canvasValues.open1,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: (30 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#ffffff',
    });
    backDataLayer.add(backOpen1Text);

    y = canvasValues.templateCode === 'p1t1' ? 174 : 190;
    if (canvasValues.fax === '' && canvasValues.pager === '') {
        y -= 16;
    } else if (canvasValues.templateCode === 'p1t2' && canvasValues.fax === '') {
        y -= 16;
    }
    if (canvasValues.templateCode === 'p1t2' && parseInt(canvasValues.showCell) === 2) {
        y -= 16;
    }
    if (canvasValues.templateCode === 'p1t2' && canvasValues.cell === '') {
        y -= 16;
    }
    if (canvasValues.open1 === '') {
        y -= 16;
    }
    backOpen2Text = new Konva.Text({
        text: canvasValues.open2,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: (30 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#ffffff',
    });
    backDataLayer.add(backOpen2Text);

    y = canvasValues.templateCode === 'p1t1' ? 190 : 206;
    if (canvasValues.fax === '' && canvasValues.pager === '') {
        y -= 16;
    } else if (canvasValues.templateCode === 'p1t2' && canvasValues.fax === '') {
        y -= 16;
    }
    if (canvasValues.templateCode === 'p1t2' && parseInt(canvasValues.showCell) === 2) {
        y -= 16;
    }
    if (canvasValues.templateCode === 'p1t2' && canvasValues.cell === '') {
        y -= 16;
    }
    if (canvasValues.open1 === '') {
        y -= 16;
    }
    if (canvasValues.open2 === '') {
        y -= 16;
    }
    backOpen3Text = new Konva.Text({
        text: canvasValues.open3,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: (30 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#ffffff',
    });
    backDataLayer.add(backOpen3Text);
    /* ------------- End ------------------ */
}

export const initP1T4BackCanvas = () => {
    /* ------------ Start ----------------- */
    const titleText = new Konva.Text({
        text: 'APPOINTMENT',
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'Roboto',
        fontStyle: 'bold',
        x: (145 - 12.5) * scale,
        y: (40 - 12.5) * scale,
        fill: '#000',
    });
    backDataLayer.add(titleText);
    /* ------------- End ------------------ */

    /* ------------ Start ----------------- */
    let x = 50;
    let y = 70;
    const monRect = new Konva.Rect({
        x: (x - 12.5) * scale,
        y: (y - 1 - 12.5) * scale,
        width: 10 * scale,
        height: 10 * scale,
        fill: '#fff',
        stroke: '#000',
        strokeWidth: 1,
    });
    backDataLayer.add(monRect);

    x += 13;
    const monText = new Konva.Text({
        text: 'Mon',
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'Roboto',
        x: (x - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#000',
    });
    backDataLayer.add(monText);

    x += 47;
    const tueRect = new Konva.Rect({
        x: (x - 12.5) * scale,
        y: (y - 1 - 12.5) * scale,
        width: 10 * scale,
        height: 10 * scale,
        fill: '#fff',
        stroke: '#000',
        strokeWidth: 1,
    });
    backDataLayer.add(tueRect);

    x += 13;
    const tueText = new Konva.Text({
        text: 'Tues',
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'Roboto',
        x: (x - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#000',
    });
    backDataLayer.add(tueText);

    x += 47;
    const wedRect = new Konva.Rect({
        x: (x - 12.5) * scale,
        y: (y - 1 - 12.5) * scale,
        width: 10 * scale,
        height: 10 * scale,
        fill: '#fff',
        stroke: '#000',
        strokeWidth: 1,
    });
    backDataLayer.add(wedRect);

    x += 13;
    const wedText = new Konva.Text({
        text: 'Wed',
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'Roboto',
        x: (x - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#000',
    });
    backDataLayer.add(wedText);

    x += 47;
    const thuRect = new Konva.Rect({
        x: (x - 12.5) * scale,
        y: (y - 1 - 12.5) * scale,
        width: 10 * scale,
        height: 10 * scale,
        fill: '#fff',
        stroke: '#000',
        strokeWidth: 1,
    });
    backDataLayer.add(thuRect);

    x += 13;
    const thuText = new Konva.Text({
        text: 'Thurs',
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'Roboto',
        x: (x - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#000',
    });
    backDataLayer.add(thuText);

    x += 52;
    const friRect = new Konva.Rect({
        x: (x - 12.5) * scale,
        y: (y - 1 - 12.5) * scale,
        width: 10 * scale,
        height: 10 * scale,
        fill: '#fff',
        stroke: '#000',
        strokeWidth: 1,
    });
    backDataLayer.add(friRect);

    x += 13;
    const friText = new Konva.Text({
        text: 'Fri',
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'Roboto',
        x: (x - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#000',
    });
    backDataLayer.add(friText);
    /* ------------- End ------------------ */

    /* ------------ Start ----------------- */
    const dateText = new Konva.Text({
        text: 'Date:',
        fontSize: convertPointsToPixels(8.5) * scale,
        fontFamily: 'Roboto',
        x: (33 - 12.5) * scale,
        y: (110 - 12.5) * scale,
        fill: '#000',
    });
    backDataLayer.add(dateText);

    const dateLine = new Konva.Line({
        points: [
            50 * scale, 108 * scale,
            330 * scale, 108 * scale
        ],
        stroke: '#000',
        strokeWidth: 1
    });
    backDataLayer.add(dateLine);
    /* ------------- End ------------------ */

    /* ------------ Start ----------------- */
    const timeText = new Konva.Text({
        text: 'Time:',
        fontSize: convertPointsToPixels(8.5) * scale,
        fontFamily: 'Roboto',
        x: (33 - 12.5) * scale,
        y: (150 - 12.5) * scale,
        fill: '#000',
    });
    backDataLayer.add(timeText);

    const timeLine = new Konva.Line({
        points: [
            50 * scale, 148 * scale,
            330 * scale, 148 * scale
        ],
        stroke: '#000',
        strokeWidth: 1
    });
    backDataLayer.add(timeLine);
    /* ------------- End ------------------ */

    /* ------------ Start ----------------- */
    const notesText = new Konva.Text({
        text: 'If unable to keep appointment, kindly give 24 hours notice.',
        fontSize: convertPointsToPixels(8.5) * scale,
        fontFamily: 'Roboto',
        x: (33 - 12.5) * scale,
        y: (175 - 12.5) * scale,
        fill: '#000',
    });
    backDataLayer.add(notesText);
    /* ------------- End ------------------ */
}

export const initP1T5BackCanvas = () => {
    drawBackVariablesP1T5();
}

export const drawBackVariablesP1T5 = () => {
    /* ------------ Start ----------------- */
    let x = 33
    for (let i = 0; i < 3; i++) {
        let y = 85;
        backLocationNames[i] = new Konva.Text({
            text: canvasValues.locationNames[i],
            fontSize: convertPointsToPixels(6.5) * scale,
            fontFamily: 'Roboto Condensed',
            fontStyle: 'bold',
            x: (x - 12.5) * scale,
            y: (y - 12.5) * scale,
            fill: '#000',
        });
        backDataLayer.add(backLocationNames[i]);

        y += 12;
        backLocationAddresses1[i] = new Konva.Text({
            text: canvasValues.locationAddresses1[i],
            fontSize: convertPointsToPixels(6.5) * scale,
            fontFamily: 'Roboto Condensed',
            x: (x - 12.5) * scale,
            y: (y - 12.5) * scale,
            fill: '#000',
        });
        backDataLayer.add(backLocationAddresses1[i]);

        if (!isEmpty(canvasValues.locationAddresses2[i])) {
            y += 10;
            backLocationAddresses2[i] = new Konva.Text({
                text: canvasValues.locationAddresses2[i],
                fontSize: convertPointsToPixels(6.5) * scale,
                fontFamily: 'Roboto Condensed',
                x: (x - 12.5) * scale,
                y: (y - 12.5) * scale,
                fill: '#000',
            });
            backDataLayer.add(backLocationAddresses2[i]);
        }

        if (!isEmpty(canvasValues.locationAddresses3[i])) {
            y += 10;
            backLocationAddresses3[i] = new Konva.Text({
                text: canvasValues.locationAddresses3[i],
                fontSize: convertPointsToPixels(6.5) * scale,
                fontFamily: 'Roboto Condensed',
                x: (x - 12.5) * scale,
                y: (y - 12.5) * scale,
                fill: '#000',
            });
            backDataLayer.add(backLocationAddresses3[i]);
        }

        y += 10;
        backLocationStateAddresses[i] = new Konva.Text({
            text: getStateAddress(i),
            fontSize: convertPointsToPixels(6.5) * scale,
            fontFamily: 'Roboto Condensed',
            x: (x - 12.5) * scale,
            y: (y - 12.5) * scale,
            fill: '#000',
        });
        backDataLayer.add(backLocationStateAddresses[i]);

        x += 115;
    }
    /* ------------- End ------------------ */
}

export const destroyBackVariablesP1T5 = () => {
    for (let i = 0; i < 3; i++) {
        if (backLocationNames[i]) {
            backLocationNames[i].destroy();
        }
        if (backLocationAddresses1[i]) {
            backLocationAddresses1[i].destroy();
        }
        if (backLocationAddresses2[i]) {
            backLocationAddresses2[i].destroy();
        }
        if (backLocationAddresses3[i]) {
            backLocationAddresses3[i].destroy();
        }
        if (backLocationStateAddresses[i]) {
            backLocationStateAddresses[i].destroy();
        }
    }
}

export const initP1T7BackCanvas = () => {
    drawBackVariablesP1T7();
}

export const drawBackVariablesP1T7 = () => {
    backNameText = new Konva.Text({
        text: getFullName(),
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: (30 - 12.5) * scale,
        y: (30 - 12.5) * scale,
        fill: '#ffffff',
    });
    backDataLayer.add(backNameText);

    backTitle1Text = new Konva.Text({
        text: canvasValues.title1,
        fontSize: convertPointsToPixels(8.5) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: (30 - 12.5) * scale,
        y: (46 - 12.5) * scale,
        fill: '#ffffff',
    });
    backDataLayer.add(backTitle1Text);

    backDepartment2Text = new Konva.Text({
        text: canvasValues.department2,
        fontSize: convertPointsToPixels(8.5) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: (30 - 12.5) * scale,
        y: (60 - 12.5) * scale,
        fill: '#ffffff',
    });
    backDataLayer.add(backDepartment2Text);

    backDepartment3Text = new Konva.Text({
        text: canvasValues.department3,
        fontSize: convertPointsToPixels(8.5) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: (30 - 12.5) * scale,
        y: (74 - 12.5) * scale,
        fill: '#ffffff',
    });
    backDataLayer.add(backDepartment3Text);

    let y = 110;
    if (parseInt(canvasValues.showEmail) !== 2 && canvasValues.email !== '') {
        backEmailText = new Konva.Text({
            text: canvasValues.email,
            fontSize: convertPointsToPixels(9) * scale,
            fontFamily: 'AGaramondProSemibold',
            x: (30 - 12.5) * scale,
            y: (y - 12.5) * scale,
            fill: '#ffffff',
        });
        backDataLayer.add(backEmailText);
    }

    y += 16;
    let phone = '';
    if (canvasValues.phone !== '') {
        phone = canvasValues.phone + '   Direct';
    }
    backPhoneText = new Konva.Text({
        text: phone,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: (30 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#ffffff',
    });
    backDataLayer.add(backPhoneText);

    let clinic = '';
    if (canvasValues.clinic !== '') {
        clinic = canvasValues.clinic + '   Clinic';
    }
    backClinicText = new Konva.Text({
        text: clinic,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: (206 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#ffffff',
    });
    backDataLayer.add(backClinicText);

    y += 16;
    let fax = '';
    if (canvasValues.fax !== '') {
        fax = canvasValues.fax + '   Fax';
    }
    backFaxText = new Konva.Text({
        text: fax,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: (30 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#ffffff',
    });
    backDataLayer.add(backFaxText);

    let cell = '';
    if (canvasValues.cell !== '') {
        cell = canvasValues.cell + '   Cell';
    }
    backCellText = new Konva.Text({
        text: cell,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: (206 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#ffffff',
    });
    backDataLayer.add(backCellText);

    y = 158;
    if (canvasValues.fax === '' && canvasValues.cell === '') {
        y -= 16;
    }
    backOpen1Text = new Konva.Text({
        text: canvasValues.open1,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: (30 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#ffffff',
    });
    backDataLayer.add(backOpen1Text);

    y = 174;
    if (canvasValues.fax === '' && canvasValues.cell === '') {
        y -= 16;
    }
    if (canvasValues.open1 === '') {
        y -= 16;
    }
    backOpen2Text = new Konva.Text({
        text: canvasValues.open2,
        fontSize: convertPointsToPixels(9) * scale,
        fontFamily: 'AGaramondProSemibold',
        x: (30 - 12.5) * scale,
        y: (y - 12.5) * scale,
        fill: '#ffffff',
    });
    backDataLayer.add(backOpen2Text);
}

export const destroyBackVariablesP1T7 = () => {
    if (backNameText) {
        backNameText.destroy();
    }
    if (backTitle1Text) {
        backTitle1Text.destroy();
    }
    if (backDepartment2Text) {
        backDepartment2Text.destroy();
    }
    if (backDepartment3Text) {
        backDepartment3Text.destroy();
    }
    if (backEmailText) {
        backEmailText.destroy();
    }
    if (backPhoneText) {
        backPhoneText.destroy();
    }
    if (backClinicText) {
        backClinicText.destroy();
    }
    if (backFaxText) {
        backFaxText.destroy();
    }
    if (backCellText) {
        backCellText.destroy();
    }
    if (backOpen1Text) {
        backOpen1Text.destroy();
    }
    if (backOpen2Text) {
        backOpen2Text.destroy();
    }
}

export const initP1T8BackCanvas = () => {
    let appointmentForText = new Konva.Text({
        text: 'Appointment for',
        fontSize: convertPointsToPixels(6) * scale,
        fontFamily: 'Ariblk',
        x: 60 * scale,
        y: 18 * scale,
        fill: '#bb6847',
    });
    backDataLayer.add(appointmentForText);

    const line1 = new Konva.Line({
        points: [
            60 * scale, 50 * scale,
            331 * scale, 50 * scale
        ],
        stroke: '#000',
        strokeWidth: 1
    });
    backDataLayer.add(line1);

    let monText = new Konva.Text({
        text: 'Mon',
        fontSize: convertPointsToPixels(6) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 60 * scale,
        y: 66 * scale,
        fill: '#000',
    });
    backDataLayer.add(monText);

    let tueText = new Konva.Text({
        text: 'Tue',
        fontSize: convertPointsToPixels(6) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 112 * scale,
        y: 66 * scale,
        fill: '#000',
    });
    backDataLayer.add(tueText);

    let wedText = new Konva.Text({
        text: 'Wed',
        fontSize: convertPointsToPixels(6) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 162 * scale,
        y: 66 * scale,
        fill: '#000',
    });
    backDataLayer.add(wedText);

    let thuText = new Konva.Text({
        text: 'Thu',
        fontSize: convertPointsToPixels(6) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 215 * scale,
        y: 66 * scale,
        fill: '#000',
    });
    backDataLayer.add(thuText);

    let friText = new Konva.Text({
        text: 'Fri',
        fontSize: convertPointsToPixels(6) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 268 * scale,
        y: 66 * scale,
        fill: '#000',
    });
    backDataLayer.add(friText);

    let satText = new Konva.Text({
        text: 'Sat',
        fontSize: convertPointsToPixels(6) * scale,
        fontFamily: 'AGaramondProRegular',
        x: 320 * scale,
        y: 66 * scale,
        fill: '#000',
    });
    backDataLayer.add(satText);

    let dateText = new Konva.Text({
        text: 'date',
        fontSize: convertPointsToPixels(6) * scale,
        fontFamily: 'AGaramondProItalic',
        x: 18 * scale,
        y: 88 * scale,
        fill: '#000',
    });
    backDataLayer.add(dateText);

    const line2 = new Konva.Line({
        points: [
            60 * scale, 95 * scale,
            331 * scale, 95 * scale
        ],
        stroke: '#000',
        strokeWidth: 1
    });
    backDataLayer.add(line2);

    let timeText = new Konva.Text({
        text: 'time',
        fontSize: convertPointsToPixels(6) * scale,
        fontFamily: 'AGaramondProItalic',
        x: 18 * scale,
        y: 116 * scale,
        fill: '#000',
    });
    backDataLayer.add(timeText);

    const line3 = new Konva.Line({
        points: [
            60 * scale, 122 * scale,
            331 * scale, 122 * scale
        ],
        stroke: '#000',
        strokeWidth: 1
    });
    backDataLayer.add(line3);

    let withText = new Konva.Text({
        text: 'with',
        fontSize: convertPointsToPixels(6) * scale,
        fontFamily: 'AGaramondProItalic',
        x: 18 * scale,
        y: 142 * scale,
        fill: '#000',
    });
    backDataLayer.add(withText);

    const line4 = new Konva.Line({
        points: [
            60 * scale, 150 * scale,
            331 * scale, 150 * scale
        ],
        stroke: '#000',
        strokeWidth: 1
    });
    backDataLayer.add(line4);

    let disclaimerText = new Konva.Text({
        text: 'If unable to make an appointment, please give 24 hours notice.',
        fontSize: convertPointsToPixels(6) * scale,
        fontFamily: 'AGaramondProItalic',
        x: 60 * scale,
        y: 175 * scale,
        fill: '#000',
    });
    backDataLayer.add(disclaimerText);
}

export const initP1T9BackCanvas = () => {
    drawBackVariablesP1T9();
}

export const drawBackVariablesP1T9 = () => {
    let y = 20;
    let allEmpty = true;
    if (parseInt(canvasValues.locations) === 1) {
        if (!isEmpty(canvasValues.locationNames[0])) {
            backLocationNames[0] = new Konva.Text({
                text: canvasValues.locationNames[0],
                fontSize: convertPointsToPixels(6) * scale,
                fontFamily: 'Ariblk',
                x: 0 * scale,
                y: 73 * scale,
                fill: '#bb6847',
                align: 'center',
                width: 350 * scale,
            });
            backDataLayer.add(backLocationNames[0]);
            allEmpty = false;
        }

        if (!isEmpty(canvasValues.locationAddresses1[0]) || !isEmpty(canvasValues.locationSuites[0])) {
            let address = canvasValues.locationAddresses1[0];
            if (!isEmpty(canvasValues.locationSuites[0])) {
                address += ', ' + canvasValues.locationSuites[0];
            }

            backLocationAddresses1[0] = new Konva.Text({
                text: address,
                fontSize: convertPointsToPixels(6) * scale,
                fontFamily: 'AGaramondProRegular',
                x: 0 * scale,
                y: 85 * scale,
                fill: '#000',
                align: 'center',
                width: 350 * scale,
            });
            backDataLayer.add(backLocationAddresses1[0]);
            allEmpty = false;
        }

        if (!isEmpty(canvasValues.locationCities[0]) || !isEmpty(canvasValues.locationStates[0]) || !isEmpty(canvasValues.locationZips[0])) {
            let address2 = '';
            if (!isEmpty(canvasValues.locationCities[0])) {
                address2 += canvasValues.locationCities[0];
            }
            if (!isEmpty(canvasValues.locationStates[0])) {
                address2 += ', ' + canvasValues.locationStates[0];
            }
            if (!isEmpty(canvasValues.locationZips[0])) {
                address2 += ' ' + canvasValues.locationZips[0];
            }

            backLocationAddresses2[0] = new Konva.Text({
                text: address2,
                fontSize: convertPointsToPixels(6) * scale,
                fontFamily: 'AGaramondProRegular',
                x: 0 * scale,
                y: 95 * scale,
                fill: '#000',
                align: 'center',
                width: 350 * scale,
            });
            backDataLayer.add(backLocationAddresses2[0]);
            allEmpty = false;
        }

        if (!isEmpty(canvasValues.locationPhones[0])) {
            backLocationPhones[0] = new Konva.Text({
                text: 'P: ' + canvasValues.locationPhones[0],
                fontSize: convertPointsToPixels(6) * scale,
                fontFamily: 'AGaramondProRegular',
                x: 0 * scale,
                y: 105 * scale,
                fill: '#000',
                align: 'center',
                width: 350 * scale,
            });
            backDataLayer.add(backLocationPhones[0]);
            allEmpty = false;
        }

        if (!isEmpty(canvasValues.locationFaxes[0])) {
            backLocationFaxes[0] = new Konva.Text({
                text: 'F: ' + canvasValues.locationFaxes[0],
                fontSize: convertPointsToPixels(6) * scale,
                fontFamily: 'AGaramondProRegular',
                x: 0 * scale,
                y: 115 * scale,
                fill: '#000',
                align: 'center',
                width: 350 * scale,
            });
            backDataLayer.add(backLocationFaxes[0]);
            allEmpty = false;
        }
    } else if (parseInt(canvasValues.locations) === 2) {
        for (let i = 0; i < canvasValues.locations; i++) {
            if (i === 0) {
                y = 32;
            } else if (i === 1) {
                y = 98;
            }

            if (!isEmpty(canvasValues.locationNames[i])) {
                y += 10;
                backLocationNames[i] = new Konva.Text({
                    text: canvasValues.locationNames[i],
                    fontSize: convertPointsToPixels(6) * scale,
                    fontFamily: 'Ariblk',
                    x: 18 * scale,
                    y: y * scale,
                    fill: '#bb6847',
                });
                backDataLayer.add(backLocationNames[i]);
                allEmpty = false;
            }

            if (!isEmpty(canvasValues.locationAddresses1[i]) || !isEmpty(canvasValues.locationSuites[i])) {
                let address = canvasValues.locationAddresses1[i];
                if (!isEmpty(canvasValues.locationSuites[i])) {
                    address += ', ' + canvasValues.locationSuites[i];
                }

                y += 12;
                backLocationAddresses1[i] = new Konva.Text({
                    text: address,
                    fontSize: convertPointsToPixels(6) * scale,
                    fontFamily: 'AGaramondProRegular',
                    x: 18 * scale,
                    y: y * scale,
                    fill: '#000',
                });
                backDataLayer.add(backLocationAddresses1[i]);
                allEmpty = false;
            }

            if (!isEmpty(canvasValues.locationCities[i]) || !isEmpty(canvasValues.locationStates[i]) || !isEmpty(canvasValues.locationZips[i])) {
                let address2 = '';
                if (!isEmpty(canvasValues.locationCities[i])) {
                    address2 += canvasValues.locationCities[i];
                }
                if (!isEmpty(canvasValues.locationStates[i])) {
                    address2 += ', ' + canvasValues.locationStates[i];
                }
                if (!isEmpty(canvasValues.locationZips[i])) {
                    address2 += ' ' + canvasValues.locationZips[i];
                }

                y += 10;
                backLocationAddresses2[i] = new Konva.Text({
                    text: address2,
                    fontSize: convertPointsToPixels(6) * scale,
                    fontFamily: 'AGaramondProRegular',
                    x: 18 * scale,
                    y: y * scale,
                    fill: '#000',
                });
                backDataLayer.add(backLocationAddresses2[i]);
                allEmpty = false;
            }

            if (!isEmpty(canvasValues.locationPhones[i])) {
                y += 10;
                backLocationPhones[i] = new Konva.Text({
                    text: 'P: ' + canvasValues.locationPhones[i],
                    fontSize: convertPointsToPixels(6) * scale,
                    fontFamily: 'AGaramondProRegular',
                    x: 18 * scale,
                    y: y * scale,
                    fill: '#000',
                });
                backDataLayer.add(backLocationPhones[i]);
                allEmpty = false;
            }

            if (!isEmpty(canvasValues.locationFaxes[i])) {
                y += 10;
                backLocationFaxes[i] = new Konva.Text({
                    text: 'F: ' + canvasValues.locationFaxes[i],
                    fontSize: convertPointsToPixels(6) * scale,
                    fontFamily: 'AGaramondProRegular',
                    x: 18 * scale,
                    y: y * scale,
                    fill: '#000',
                });
                backDataLayer.add(backLocationFaxes[i]);
                allEmpty = false;
            }
        }
    } else if (parseInt(canvasValues.locations) === 3) {
        for (let i = 0; i < canvasValues.locations; i++) {
            if (i === 0) {
                y = 8;
            } else if (i === 1) {
                y = 66;
            } else if (i === 2) {
                y = 124;
            }

            if (!isEmpty(canvasValues.locationNames[i])) {
                y += 10;
                backLocationNames[i] = new Konva.Text({
                    text: canvasValues.locationNames[i],
                    fontSize: convertPointsToPixels(6) * scale,
                    fontFamily: 'Ariblk',
                    x: 19 * scale,
                    y: y * scale,
                    fill: '#bb6847',
                });
                backDataLayer.add(backLocationNames[i]);
                allEmpty = false;
            }

            if (!isEmpty(canvasValues.locationAddresses1[i]) || !isEmpty(canvasValues.locationSuites[i])) {
                let address = canvasValues.locationAddresses1[i];
                if (!isEmpty(canvasValues.locationSuites[i])) {
                    address += ', ' + canvasValues.locationSuites[i];
                }

                y += 12;
                backLocationAddresses1[i] = new Konva.Text({
                    text: address,
                    fontSize: convertPointsToPixels(6) * scale,
                    fontFamily: 'AGaramondProRegular',
                    x: 19 * scale,
                    y: y * scale,
                    fill: '#000',
                });
                backDataLayer.add(backLocationAddresses1[i]);
                allEmpty = false;
            }

            if (!isEmpty(canvasValues.locationCities[i]) || !isEmpty(canvasValues.locationStates[i]) || !isEmpty(canvasValues.locationZips[i])) {
                let address2 = '';
                if (!isEmpty(canvasValues.locationCities[i])) {
                    address2 += canvasValues.locationCities[i];
                }
                if (!isEmpty(canvasValues.locationStates[i])) {
                    address2 += ', ' + canvasValues.locationStates[i];
                }
                if (!isEmpty(canvasValues.locationZips[i])) {
                    address2 += ' ' + canvasValues.locationZips[i];
                }

                y += 10;
                backLocationAddresses2[i] = new Konva.Text({
                    text: address2,
                    fontSize: convertPointsToPixels(6) * scale,
                    fontFamily: 'AGaramondProRegular',
                    x: 19 * scale,
                    y: y * scale,
                    fill: '#000',
                });
                backDataLayer.add(backLocationAddresses2[i]);
                allEmpty = false;
            }

            if (!isEmpty(canvasValues.locationPhones[i])) {
                y += 10;
                backLocationPhones[i] = new Konva.Text({
                    text: 'P: ' + canvasValues.locationPhones[i],
                    fontSize: convertPointsToPixels(6) * scale,
                    fontFamily: 'AGaramondProRegular',
                    x: 19 * scale,
                    y: y * scale,
                    fill: '#000',
                });
                backDataLayer.add(backLocationPhones[i]);
                allEmpty = false;
            }

            if (!isEmpty(canvasValues.locationFaxes[i])) {
                y += 10;
                backLocationFaxes[i] = new Konva.Text({
                    text: 'F: ' + canvasValues.locationFaxes[i],
                    fontSize: convertPointsToPixels(6) * scale,
                    fontFamily: 'AGaramondProRegular',
                    x: 19 * scale,
                    y: y * scale,
                    fill: '#000',
                });
                backDataLayer.add(backLocationFaxes[i]);
                allEmpty = false;
            }
        }
    }

    if (!allEmpty) {
        if (parseInt(canvasValues.locations) === 1) {
            backOpen1Text = new Konva.Text({
                text: 'UTPhysicians.com',
                fontSize: convertPointsToPixels(8) * scale,
                fontFamily: 'AGaramondProRegular',
                x: 0 * scale,
                y: 164 * scale,
                fill: '#bb6847',
                align: 'center',
                width: 350 * scale,
            });
            backDataLayer.add(backOpen1Text);
        } else if (parseInt(canvasValues.locations) === 2) {
            backOpen1Text = new Konva.Text({
                text: 'UTPhysicians.com',
                fontSize: convertPointsToPixels(8) * scale,
                fontFamily: 'AGaramondProRegular',
                x: 252 * scale,
                y: 165 * scale,
                fill: '#bb6847',
            });
            backDataLayer.add(backOpen1Text);
        } else if (parseInt(canvasValues.locations) === 3) {
            backOpen1Text = new Konva.Text({
                text: 'UTPhysicians.com',
                fontSize: convertPointsToPixels(8) * scale,
                fontFamily: 'AGaramondProRegular',
                x: 252 * scale,
                y: 175 * scale,
                fill: '#bb6847',
            });
            backDataLayer.add(backOpen1Text);
        }
    }
}

export const destroyBackVariablesP1T9 = () => {
    for (let i = 0; i < 3; i++) {
        if (backLocationNames[i]) {
            backLocationNames[i].destroy();
        }
        if (backLocationAddresses1[i]) {
            backLocationAddresses1[i].destroy();
        }
        if (backLocationAddresses2[i]) {
            backLocationAddresses2[i].destroy();
        }
        if (backLocationPhones[i]) {
            backLocationPhones[i].destroy();
        }
        if (backLocationFaxes[i]) {
            backLocationFaxes[i].destroy();
        }
    }

    if (backOpen1Text) {
        backOpen1Text.destroy();
    }
}

export const initP1T13BackCanvas = () => {
    drawBackVariablesP1T13();
}

export const drawBackVariablesP1T13 = () => {
    let y = 0;
    for (let i = 0; i < canvasValues.locations; i++) {
        if (i === 0) {
            y = 16;
        } else if (i === 1) {
            y = 77;
        } else if (i === 2) {
            y = 139;
        }

        backLocationNames[i] = new Konva.Text({
            text: canvasValues.locationNames[i],
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'UniversBold',
            x: 18 * scale,
            y: y * scale,
            fill: '#bb6847',
        });
        backDataLayer.add(backLocationNames[i]);
        y += 12;

        let address = canvasValues.locationAddresses1[i];
        if (!isEmpty(canvasValues.locationSuites[i])) {
            address += ', ' + canvasValues.locationSuites[i];
        }

        backLocationAddresses1[i] = new Konva.Text({
            text: address,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'UniversLTStd',
            x: 18 * scale,
            y: y * scale,
            fill: '#000',
        });
        backDataLayer.add(backLocationAddresses1[i]);
        y += 11;

        let address2 = '';
        if (!isEmpty(canvasValues.locationCities[i])) {
            address2 += canvasValues.locationCities[i];
        }
        address2 += ', TX';
        if (!isEmpty(canvasValues.locationZips[i])) {
            address2 += ' ' + canvasValues.locationZips[i];
        }

        backLocationAddresses2[i] = new Konva.Text({
            text: address2,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'UniversLTStd',
            x: 18 * scale,
            y: y * scale,
            fill: '#000',
        });
        backDataLayer.add(backLocationAddresses2[i]);
        y += 11;

        if (!isEmpty(canvasValues.locationPhones[i])) {
            backLocationPhones[i] = new Konva.Text({
                text: canvasValues.locationPhones[i] + ' main',
                fontSize: convertPointsToPixels(7) * scale,
                fontFamily: 'UniversLTStd',
                x: 18 * scale,
                y: y * scale,
                fill: '#000',
            });
            backDataLayer.add(backLocationPhones[i]);
        }

        if (!isEmpty(canvasValues.locationFaxes[i])) {
            backLocationDividers[i] = new Konva.Text({
                text: 'I',
                fontSize: convertPointsToPixels(7) * scale,
                fontFamily: 'UniversBold',
                x: 18 * scale + backLocationPhones[i].width() + 4 * scale,
                y: y * scale,
                fill: '#b66645',
            });
            backDataLayer.add(backLocationDividers[i]);

            backLocationFaxes[i] = new Konva.Text({
                text: canvasValues.locationFaxes[i] + ' fax',
                fontSize: convertPointsToPixels(7) * scale,
                fontFamily: 'UniversLTStd',
                x: 18 * scale + backLocationPhones[i].width() + backLocationDividers[i].width() + 8 * scale,
                y: y * scale,
                fill: '#000',
            });
            backDataLayer.add(backLocationFaxes[i]);
        }
    }
}

export const destroyBackVariablesP1T13 = () => {
    for (let i = 0; i < 3; i++) {
        if (backLocationNames[i]) {
            backLocationNames[i].destroy();
        }
        if (backLocationAddresses1[i]) {
            backLocationAddresses1[i].destroy();
        }
        if (backLocationAddresses2[i]) {
            backLocationAddresses2[i].destroy();
        }
        if (backLocationPhones[i]) {
            backLocationPhones[i].destroy();
        }
        if (backLocationFaxes[i]) {
            backLocationFaxes[i].destroy();
        }
        if (backLocationDividers[i]) {
            backLocationDividers[i].destroy();
        }
    }

    if (backOpen1Text) {
        backOpen1Text.destroy();
    }
}

export const initP1T14BackCanvas = () => {
    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/vectors/utp-appointment-card-back.svg', (image) => {
        if (backLogo1Img != null) {
            backLogo1Img.destroy();
        }
        backLogo1Img = image;

        backBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 408 * scale,
            height: 258 * scale,
        });
        backBackgroundLayer.draw();
    });
}

export const initP1T16BackCanvas = () => {
    drawBackVariablesP1T16();
}

export const drawBackVariablesP1T16 = () => {
    let y = 0;
    for (let i = 0; i < canvasValues.locations; i++) {
        if (i === 0) {
            y = 16;
        } else if (i === 1) {
            y = 77;
        } else if (i === 2) {
            y = 139;
        }

        if (!isEmpty(canvasValues.locationNames[i])) {
            backLocationNames[i] = new Konva.Text({
                text: canvasValues.locationNames[i],
                fontSize: convertPointsToPixels(7) * scale,
                fontFamily: 'UniversBold',
                x: 18 * scale,
                y: y * scale,
                fill: '#bb6847',
            });
            backDataLayer.add(backLocationNames[i]);
            y += 12;
        }

        let address = canvasValues.locationAddresses1[i];
        if (!isEmpty(canvasValues.locationSuites[i])) {
            address += ', ' + canvasValues.locationSuites[i];
        }

        backLocationAddresses1[i] = new Konva.Text({
            text: address,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'UniversLTStd',
            x: 18 * scale,
            y: y * scale,
            fill: '#000',
        });
        backDataLayer.add(backLocationAddresses1[i]);
        y += 11;

        let address2 = '';
        if (!isEmpty(canvasValues.locationCities[i])) {
            address2 += canvasValues.locationCities[i];
        }
        address2 += ', TX';
        if (!isEmpty(canvasValues.locationZips[i])) {
            address2 += ' ' + canvasValues.locationZips[i];
        }

        backLocationAddresses2[i] = new Konva.Text({
            text: address2,
            fontSize: convertPointsToPixels(7) * scale,
            fontFamily: 'UniversLTStd',
            x: 18 * scale,
            y: y * scale,
            fill: '#000',
        });
        backDataLayer.add(backLocationAddresses2[i]);
        y += 11;

        if (!isEmpty(canvasValues.locationPhones[i])) {
            backLocationPhones[i] = new Konva.Text({
                text: canvasValues.locationPhones[i] + ' main',
                fontSize: convertPointsToPixels(7) * scale,
                fontFamily: 'UniversLTStd',
                x: 18 * scale,
                y: y * scale,
                fill: '#000',
            });
            backDataLayer.add(backLocationPhones[i]);
        }

        if (!isEmpty(canvasValues.locationFaxes[i])) {
            let phoneWidth = 0;
            if (!isEmpty(backLocationPhones[i])) {
                phoneWidth = backLocationPhones[i].width();
            }

            backLocationDividers[i] = new Konva.Text({
                text: 'I',
                fontSize: convertPointsToPixels(7) * scale,
                fontFamily: 'UniversBold',
                x: 18 * scale + phoneWidth + 4 * scale,
                y: y * scale,
                fill: '#b66645',
            });
            backDataLayer.add(backLocationDividers[i]);

            backLocationFaxes[i] = new Konva.Text({
                text: canvasValues.locationFaxes[i] + ' fax',
                fontSize: convertPointsToPixels(7) * scale,
                fontFamily: 'UniversLTStd',
                x: 18 * scale + phoneWidth + backLocationDividers[i].width() + 8 * scale,
                y: y * scale,
                fill: '#000',
            });
            backDataLayer.add(backLocationFaxes[i]);
        }

        if (!isEmpty(canvasValues.locationNursePhones[i])) {
            y += 11;
            backLocationNursePhones[i] = new Konva.Text({
                text: 'Nurse – ' + canvasValues.locationNursePhones[i],
                fontSize: convertPointsToPixels(7) * scale,
                fontFamily: 'UniversLTStd',
                x: 18 * scale,
                y: y * scale,
                fill: '#000',
            });
            backDataLayer.add(backLocationNursePhones[i]);
        }
    }
}

export const destroyBackVariablesP1T16 = () => {
    for (let i = 0; i < 3; i++) {
        if (backLocationNames[i]) {
            backLocationNames[i].destroy();
        }
        if (backLocationAddresses1[i]) {
            backLocationAddresses1[i].destroy();
        }
        if (backLocationAddresses2[i]) {
            backLocationAddresses2[i].destroy();
        }
        if (backLocationPhones[i]) {
            backLocationPhones[i].destroy();
        }
        if (backLocationFaxes[i]) {
            backLocationFaxes[i].destroy();
        }
        if (backLocationNursePhones[i]) {
            backLocationNursePhones[i].destroy();
        }
        if (backLocationDividers[i]) {
            backLocationDividers[i].destroy();
        }
    }

    if (backOpen1Text) {
        backOpen1Text.destroy();
    }
}

export const initP1T15BackCanvas = () => {
    Konva.Image.fromURL('https://ac-ut-health.s3.amazonaws.com/vectors/utp-provider-appointment-card-back.svg', (image) => {
        if (backLogo1Img != null) {
            backLogo1Img.destroy();
        }
        backLogo1Img = image;

        backBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 408 * scale,
            height: 258 * scale,
        });
        backBackgroundLayer.draw();
    });
}

export const initP9BackCanvas = () => {
    drawBackVariablesP9();
}

export const drawBackVariablesP9 = () => {
    let back = '';
    if (canvasValues.back !== '') {
        back = parseInt(canvasValues.back);
    }

    let backUrl = '';
    if (back === 1) {
        backUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/back-background.svg';
    } else if (back === 2) {
        backUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/health-services-appointment-card.svg';
    }

    Konva.Image.fromURL(backUrl, (image) => {
        if (backLogoImage != null) {
            backLogoImage.destroy();
        }
        backLogoImage = image;

        backBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 408 * scale,
            height: 258 * scale,
        });
        backBackgroundLayer.draw();

        canvasValues.prevBack = back;
    });

    if (back === 2) {
        return;
    }

    let name = canvasValues.firstName;
    if (canvasValues.middleName !== '') {
        name += ' ' + canvasValues.middleName;
    }
    name += ' ' + canvasValues.lastName;
    if (canvasValues.credentials !== '') {
        name += ', ' + canvasValues.credentials;
    }

    canvasValues.nameSize = 8;
    backNameText = createText('UniversBold', 8, name, 29, 20);
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 7.5;
        backNameText = createText('UniversBold', 7.5, name, 29, 20.5);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 7;
        backNameText = createText('UniversBold', 7, name, 29, 21);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 6.5;
        backNameText = createText('UniversBold', 6.5, name, 29, 21.5);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 6;
        backNameText = createText('UniversBold', 6, name, 29, 22);
    }
    backDataLayer.add(backNameText);

    let y = 49;
    let titleSize = calculateFontSizeForTitlesP9();
    canvasValues.titlesSize = titleSize;
    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText('UniversLTStd', titleSize, canvasValues.primaryTitle, 29, y);
        backDataLayer.add(backPrimaryTitleText);
        y += 11;
    }
    if (canvasValues.title1 !== '') {
        backTitle1Text = createText('UniversLTStd', titleSize, canvasValues.title1, 29, y);
        backDataLayer.add(backTitle1Text);
        y += 11;
    }
    if (canvasValues.title2 !== '') {
        backTitle2Text = createText('UniversLTStd', titleSize, canvasValues.title2, 29, y);
        backDataLayer.add(backTitle2Text);
        y += 11;
    }
    if (canvasValues.title3 !== '') {
        backTitle3Text = createText('UniversLTStd', titleSize, canvasValues.title3, 29, y);
        backDataLayer.add(backTitle3Text);
        y += 11;
    }

    if (y !== 49) {
        y += 5;
    }
    let yPrev = y;
    if (canvasValues.secondaryTitle !== '') {
        backSecondaryTitleText = createText('UniversLTStd', titleSize, canvasValues.secondaryTitle, 29, y);
        backDataLayer.add(backSecondaryTitleText);
        y += 11;
    }
    if (canvasValues.title4 !== '') {
        backTitle4Text = createText('UniversLTStd', titleSize, canvasValues.title4, 29, y);
        backDataLayer.add(backTitle4Text);
        y += 11;
    }

    canvasValues.backDividers = {};

    if (y !== yPrev) {
        y += 5;
    }
    if (canvasValues.email !== '') {
        backEmailText = createText('UniversLTStd', 6, canvasValues.email, 29, y);
        backDataLayer.add(backEmailText);
        y += 11;
    }
    if (canvasValues.main !== '') {
        const letterSpacing = 0.1;
        backMainText = createText('UniversLTStd', 6, canvasValues.main, 29, y, '#000', letterSpacing);
        backDataLayer.add(backMainText);

        let phoneLabel = canvasValues.phoneLabel1.toUpperCase();
        if (canvasValues.phoneLabel1 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel1.toUpperCase();
        }

        let x = backMainText.text().length * 4.5 + 33;
        backMainSuffixText = createText('UniversBold', 4.5, phoneLabel, x, y + 1.5);
        backDataLayer.add(backMainSuffixText);
        y += 11;

        canvasValues.backDividers.mainSuffix = backMainSuffixText.x() / scale;
    }
    if (canvasValues.direct !== '') {
        const letterSpacing = 0.1;
        backDirectText = createText('UniversLTStd', 6, canvasValues.direct, 29, y, '#000', letterSpacing);
        backDataLayer.add(backDirectText);

        let phoneLabel = canvasValues.phoneLabel2.toUpperCase();
        if (canvasValues.phoneLabel2 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel2.toUpperCase();
        }

        let x = backDirectText.text().length * 4.5 + 33;
        backDirectSuffixText = createText('UniversBold', 4.5, phoneLabel, x, y + 1.5);
        backDataLayer.add(backDirectSuffixText);
        y += 11;

        canvasValues.backDividers.directSuffix = backDirectSuffixText.x() / scale;
    }
    if (canvasValues.cell !== '') {
        const letterSpacing = 0.1;
        backCellText = createText('UniversLTStd', 6, canvasValues.cell, 29, y, '#000', letterSpacing);
        backDataLayer.add(backCellText);

        let phoneLabel = canvasValues.phoneLabel3.toUpperCase();
        if (canvasValues.phoneLabel3 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel3.toUpperCase();
        }

        let x = backCellText.text().length * 4.5 + 33;
        backCellSuffixText = createText('UniversBold', 4.5, phoneLabel, x, y + 1.5);
        backDataLayer.add(backCellSuffixText);
        y += 11;

        canvasValues.backDividers.cellSuffix = backCellSuffixText.x() / scale;
    }
    if (canvasValues.website !== '') {
        backWebsiteText = createText('UniversLTStd', 6, canvasValues.website, 29, y);
        backDataLayer.add(backWebsiteText);
    }
}

export const calculateFontSizeForTitlesP9 = () => {
    let sizes = [6, 6, 6, 6, 6, 6];

    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText('UniversBold', 6, canvasValues.primaryTitle, 29, 20);
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 5.5;
            backPrimaryTitleText = createText('UniversBold', 5.5, canvasValues.primaryTitle, 29, 20.5);
        }
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 5;
            backPrimaryTitleText = createText('UniversBold', 5, canvasValues.primaryTitle, 29, 21);
        }
    }

    if (canvasValues.title1 !== '') {
        backTitle1Text = createText('UniversBold', 6, canvasValues.title1, 29, 20);
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 5.5;
            backTitle1Text = createText('UniversBold', 5.5, canvasValues.title1, 29, 20.5);
        }
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 5;
            backTitle1Text = createText('UniversBold', 5, canvasValues.title1, 29, 21);
        }
    }

    if (canvasValues.title2 !== '') {
        backTitle2Text = createText('UniversBold', 6, canvasValues.title2, 29, 20);
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 5.5;
            backTitle2Text = createText('UniversBold', 5.5, canvasValues.title2, 29, 20.5);
        }
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 5;
            backTitle2Text = createText('UniversBold', 5, canvasValues.title2, 29, 21);
        }
    }

    if (canvasValues.title3 !== '') {
        backTitle3Text = createText('UniversBold', 6, canvasValues.title3, 29, 20);
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 5.5;
            backTitle3Text = createText('UniversBold', 5.5, canvasValues.title3, 29, 20.5);
        }
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 5;
            backTitle3Text = createText('UniversBold', 5, canvasValues.title3, 29, 21);
        }
    }

    if (canvasValues.secondaryTitle !== '') {
        backSecondaryTitleText = createText('UniversBold', 6, canvasValues.secondaryTitle, 29, 20);
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 5.5;
            backSecondaryTitleText = createText('UniversBold', 5.5, canvasValues.secondaryTitle, 29, 20.5);
        }
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 5;
            backSecondaryTitleText = createText('UniversBold', 5, canvasValues.secondaryTitle, 29, 21);
        }
    }

    if (canvasValues.title4 !== '') {
        backTitle4Text = createText('UniversBold', 6, canvasValues.title4, 29, 20);
        if (backTitle4Text.width() / scale > 292) {
            sizes[5] = 5.5;
            backTitle4Text = createText('UniversBold', 5.5, canvasValues.title4, 29, 20.5);
        }
        if (backTitle4Text.width() / scale > 292) {
            sizes[5] = 5;
            backTitle4Text = createText('UniversBold', 5, canvasValues.title4, 29, 21);
        }
    }

    const min = Math.min(...sizes);

    if (min < prevTitlesSize) {
        showNotification('Font size changed', 'The font size for the titles has been changed to fit your text', 'success', 6000);
    }
    if (min !== prevTitlesSize) {
        prevTitlesSize = min;
    }

    return min;
}

export const calculateFontSizeForTitlesP9T13 = () => {
    let fontFamily = 'UniversLTStd';
    let sizes = [9, 9, 9, 9, 9];
    if (canvasValues.fontType === 'serif') {
        fontFamily = 'AGaramondProRegular';
        sizes = [11, 11, 11, 11, 11];
    }

    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 20);
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 10;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 20.5);
        }
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 9;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 21);
        }
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 8;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 21);
        }
    }

    if (canvasValues.title1 !== '') {
        backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 20);
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 10;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 20.5);
        }
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 9;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 21);
        }
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 8;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 21);
        }
    }

    if (canvasValues.title2 !== '') {
        backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 20);
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 10;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 20.5);
        }
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 9;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 21);
        }
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 8;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 21);
        }
    }

    if (canvasValues.title3 !== '') {
        backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 20);
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 10;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 20.5);
        }
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 9;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 21);
        }
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 8;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 21);
        }
    }

    if (canvasValues.website !== '') {
        backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 20);
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 10;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 20.5);
        }
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 9;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 21);
        }
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 8;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 21);
        }
    }

    const min = Math.min(...sizes);

    if (canvasValues.fontType === 'serif') {
        if (min === 11) {
            return {
                titlesSize: min,
                yStep: 16,
                sectionStep: 10,
                phoneLabelSize: 8,
                phoneLabelX: 23,
                phoneLabelY: 2.2,
            };
        } else if (min === 10) {
            return {
                titlesSize: min,
                yStep: 14,
                sectionStep: 10,
                phoneLabelSize: 7,
                phoneLabelX: 27,
                phoneLabelY: 2.5,
            };
        } else if (min === 9) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 10,
                phoneLabelSize: 6.5,
                phoneLabelX: 25,
                phoneLabelY: 2.5,
            };
        } else if (min === 8) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 9,
                phoneLabelSize: 6.5,
                phoneLabelX: 17,
                phoneLabelY: 1.6,
            };
        }
    } else {
        if (min === 9) {
            return {
                titlesSize: min,
                yStep: 16,
                sectionStep: 10,
                phoneLabelSize: 6,
                phoneLabelX: 38,
                phoneLabelY: 2,
            };
        } else if (min === 8) {
            return {
                titlesSize: min,
                yStep: 14,
                sectionStep: 9,
                phoneLabelSize: 5.5,
                phoneLabelX: 36,
                phoneLabelY: 2,
            };
        } else if (min === 7) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 9,
                phoneLabelSize: 5,
                phoneLabelX: 34,
                phoneLabelY: 1.6,
            };
        }
    }

    return {
        titlesSize: min,
        yStep: 16,
        sectionStep: 10,
        phoneLabelSize: 6,
        phoneLabelX: 38,
        phoneLabelY: 2,
    };
}

export const destroyBackVariablesP9 = () => {
    if (backNameText) {
        backNameText.destroy();
    }
    if (backPrimaryTitleText) {
        backPrimaryTitleText.destroy();
    }
    if (backTitle1Text) {
        backTitle1Text.destroy();
    }
    if (backTitle2Text) {
        backTitle2Text.destroy();
    }
    if (backTitle3Text) {
        backTitle3Text.destroy();
    }
    if (backSecondaryTitleText) {
        backSecondaryTitleText.destroy();
    }
    if (backTitle4Text) {
        backTitle4Text.destroy();
    }
    if (backEmailText) {
        backEmailText.destroy();
    }
    if (backMainText) {
        backMainText.destroy();
    }
    if (backDirectText) {
        backDirectText.destroy();
    }
    if (backCellText) {
        backCellText.destroy();
    }
    if (backWebsiteText) {
        backWebsiteText.destroy();
    }
    if (backMainSuffixText) {
        backMainSuffixText.destroy();
    }
    if (backDirectSuffixText) {
        backDirectSuffixText.destroy();
    }
    if (backCellSuffixText) {
        backCellSuffixText.destroy();
    }
    if (backLogoImage) {
        backLogoImage.destroy();
    }
}

export const initP9T11BackCanvas = () => {
    drawBackVariablesP9T11();
}

export const drawBackVariablesP9T11 = () => {
    let back = '';
    if (canvasValues.back !== '') {
        back = parseInt(canvasValues.back);
    }

    let backUrl = '';
    if (back === 1) {
        backUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/back-background.svg';
    } else if (back === 2) {
        backUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/health-services-appointment-card.svg';
    }

    Konva.Image.fromURL(backUrl, (image) => {
        if (backLogoImage != null) {
            backLogoImage.destroy();
        }
        backLogoImage = image;

        backBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 408 * scale,
            height: 258 * scale,
        });
        backBackgroundLayer.draw();

        canvasValues.prevBack = back;
    });

    if (back === 2) {
        return;
    }

    let name = canvasValues.firstName;
    if (canvasValues.middleName !== '') {
        name += ' ' + canvasValues.middleName;
    }
    name += ' ' + canvasValues.lastName;
    if (canvasValues.credentials !== '') {
        name += ', ' + canvasValues.credentials;
    }

    canvasValues.nameSize = 8;
    backNameText = createText('UniversBold', 8, name, 29, 20);
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 7.5;
        backNameText = createText('UniversBold', 7.5, name, 29, 20.5);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 7;
        backNameText = createText('UniversBold', 7, name, 29, 21);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 6.5;
        backNameText = createText('UniversBold', 6.5, name, 29, 21.5);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 6;
        backNameText = createText('UniversBold', 6, name, 29, 22);
    }
    backDataLayer.add(backNameText);

    let y = 49;
    let titleSize = calculateFontSizeForTitlesP9();
    canvasValues.titlesSize = titleSize;
    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText('UniversLTStd', titleSize, canvasValues.primaryTitle, 29, y);
        backDataLayer.add(backPrimaryTitleText);
        y += 11;
    }
    if (canvasValues.title1 !== '') {
        backTitle1Text = createText('UniversLTStd', titleSize, canvasValues.title1, 29, y);
        backDataLayer.add(backTitle1Text);
        y += 11;
    }
    if (canvasValues.title2 !== '') {
        backTitle2Text = createText('UniversLTStd', titleSize, canvasValues.title2, 29, y);
        backDataLayer.add(backTitle2Text);
        y += 11;
    }
    if (canvasValues.title3 !== '') {
        backTitle3Text = createText('UniversLTStd', titleSize, canvasValues.title3, 29, y);
        backDataLayer.add(backTitle3Text);
        y += 11;
    }

    if (y !== 49) {
        y += 5;
    }
    let yPrev = y;
    if (canvasValues.secondaryTitle !== '') {
        backSecondaryTitleText = createText('UniversLTStd', titleSize, canvasValues.secondaryTitle, 29, y);
        backDataLayer.add(backSecondaryTitleText);
        y += 11;
    }
    if (canvasValues.title4 !== '') {
        backTitle4Text = createText('UniversLTStd', titleSize, canvasValues.title4, 29, y);
        backDataLayer.add(backTitle4Text);
        y += 11;
    }

    canvasValues.backDividers = {};

    if (y !== yPrev) {
        y += 5;
    }
    if (canvasValues.email !== '') {
        backEmailText = createText('UniversLTStd', 6, canvasValues.email, 29, y);
        backDataLayer.add(backEmailText);
        y += 11;
    }
    if (canvasValues.main !== '') {
        const letterSpacing = 0.1;
        backMainText = createText('UniversLTStd', 6, canvasValues.main, 29, y, '#000', letterSpacing);
        backDataLayer.add(backMainText);

        let phoneLabel = canvasValues.phoneLabel1.toUpperCase();
        if (canvasValues.phoneLabel1 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel1.toUpperCase();
        }

        let x = backMainText.text().length * 4.5 + 33;
        backMainSuffixText = createText('UniversBold', 4.5, phoneLabel, x, y + 1.5);
        backDataLayer.add(backMainSuffixText);
        y += 11;

        canvasValues.backDividers.mainSuffix = backMainSuffixText.x() / scale;
    }
    if (canvasValues.direct !== '') {
        const letterSpacing = 0.1;
        backDirectText = createText('UniversLTStd', 6, canvasValues.direct, 29, y, '#000', letterSpacing);
        backDataLayer.add(backDirectText);

        let phoneLabel = canvasValues.phoneLabel2.toUpperCase();
        if (canvasValues.phoneLabel2 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel2.toUpperCase();
        }

        let x = backDirectText.text().length * 4.5 + 33;
        backDirectSuffixText = createText('UniversBold', 4.5, phoneLabel, x, y + 1.5);
        backDataLayer.add(backDirectSuffixText);
        y += 11;

        canvasValues.backDividers.directSuffix = backDirectSuffixText.x() / scale;
    }
    if (canvasValues.cell !== '') {
        const letterSpacing = 0.1;
        backCellText = createText('UniversLTStd', 6, canvasValues.cell, 29, y, '#000', letterSpacing);
        backDataLayer.add(backCellText);

        let phoneLabel = canvasValues.phoneLabel3.toUpperCase();
        if (canvasValues.phoneLabel3 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel3.toUpperCase();
        }

        let x = backCellText.text().length * 4.5 + 33;
        backCellSuffixText = createText('UniversBold', 4.5, phoneLabel, x, y + 1.5);
        backDataLayer.add(backCellSuffixText);
        y += 11;

        canvasValues.backDividers.cellSuffix = backCellSuffixText.x() / scale;
    }
    if (canvasValues.website !== '') {
        backWebsiteText = createText('UniversLTStd', 6, canvasValues.website, 29, y);
        backDataLayer.add(backWebsiteText);
    }
}

export const destroyBackVariablesP9T11 = () => {
    if (backNameText) {
        backNameText.destroy();
    }
    if (backPrimaryTitleText) {
        backPrimaryTitleText.destroy();
    }
    if (backTitle1Text) {
        backTitle1Text.destroy();
    }
    if (backTitle2Text) {
        backTitle2Text.destroy();
    }
    if (backTitle3Text) {
        backTitle3Text.destroy();
    }
    if (backSecondaryTitleText) {
        backSecondaryTitleText.destroy();
    }
    if (backTitle4Text) {
        backTitle4Text.destroy();
    }
    if (backEmailText) {
        backEmailText.destroy();
    }
    if (backMainText) {
        backMainText.destroy();
    }
    if (backDirectText) {
        backDirectText.destroy();
    }
    if (backCellText) {
        backCellText.destroy();
    }
    if (backWebsiteText) {
        backWebsiteText.destroy();
    }
    if (backMainSuffixText) {
        backMainSuffixText.destroy();
    }
    if (backDirectSuffixText) {
        backDirectSuffixText.destroy();
    }
    if (backCellSuffixText) {
        backCellSuffixText.destroy();
    }
    if (backLogoImage) {
        backLogoImage.destroy();
    }
}

export const initP9T12BackCanvas = () => {
    drawBackVariablesP9T12();
}

export const drawBackVariablesP9T12 = () => {
    let back = '';
    if (canvasValues.back !== '') {
        back = parseInt(canvasValues.back);
    }

    let backUrl = '';
    if (back === 1) {
        backUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/back-background.svg';
    } else if (back === 2) {
        backUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/health-services-appointment-card.svg';
    }

    Konva.Image.fromURL(backUrl, (image) => {
        if (backLogoImage != null) {
            backLogoImage.destroy();
        }
        backLogoImage = image;

        backBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 408 * scale,
            height: 258 * scale,
        });
        backBackgroundLayer.draw();

        canvasValues.prevBack = back;
    });

    if (back === 2) {
        return;
    }

    let name = canvasValues.firstName;
    if (canvasValues.middleName !== '') {
        name += ' ' + canvasValues.middleName;
    }
    name += ' ' + canvasValues.lastName;
    if (canvasValues.credentials !== '') {
        name += ', ' + canvasValues.credentials;
    }

    canvasValues.nameSize = 8;
    backNameText = createText('UniversBold', 8, name, 29, 20);
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 7.5;
        backNameText = createText('UniversBold', 7.5, name, 29, 20.5);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 7;
        backNameText = createText('UniversBold', 7, name, 29, 21);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 6.5;
        backNameText = createText('UniversBold', 6.5, name, 29, 21.5);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 6;
        backNameText = createText('UniversBold', 6, name, 29, 22);
    }
    backDataLayer.add(backNameText);

    let y = 49;
    let titleSize = calculateFontSizeForTitlesP9();
    canvasValues.titlesSize = titleSize;
    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText('UniversLTStd', titleSize, canvasValues.primaryTitle, 29, y);
        backDataLayer.add(backPrimaryTitleText);
        y += 11;
    }
    if (canvasValues.title1 !== '') {
        backTitle1Text = createText('UniversLTStd', titleSize, canvasValues.title1, 29, y);
        backDataLayer.add(backTitle1Text);
        y += 11;
    }
    if (canvasValues.title2 !== '') {
        backTitle2Text = createText('UniversLTStd', titleSize, canvasValues.title2, 29, y);
        backDataLayer.add(backTitle2Text);
        y += 11;
    }
    if (canvasValues.title3 !== '') {
        backTitle3Text = createText('UniversLTStd', titleSize, canvasValues.title3, 29, y);
        backDataLayer.add(backTitle3Text);
        y += 11;
    }

    if (y !== 49) {
        y += 5;
    }
    let yPrev = y;
    if (canvasValues.secondaryTitle !== '') {
        backSecondaryTitleText = createText('UniversLTStd', titleSize, canvasValues.secondaryTitle, 29, y);
        backDataLayer.add(backSecondaryTitleText);
        y += 11;
    }
    if (canvasValues.title4 !== '') {
        backTitle4Text = createText('UniversLTStd', titleSize, canvasValues.title4, 29, y);
        backDataLayer.add(backTitle4Text);
        y += 11;
    }

    canvasValues.backDividers = {};

    if (y !== yPrev) {
        y += 5;
    }
    if (canvasValues.email !== '') {
        backEmailText = createText('UniversLTStd', 6, canvasValues.email, 29, y);
        backDataLayer.add(backEmailText);
        y += 11;
    }
    if (canvasValues.main !== '') {
        const letterSpacing = 0.1;
        backMainText = createText('UniversLTStd', 6, canvasValues.main, 29, y, '#000', letterSpacing);
        backDataLayer.add(backMainText);

        let phoneLabel = canvasValues.phoneLabel1.toUpperCase();
        if (canvasValues.phoneLabel1 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel1.toUpperCase();
        }

        let x = backMainText.text().length * 4.5 + 33;
        backMainSuffixText = createText('UniversBold', 4.5, phoneLabel, x, y + 1.5);
        backDataLayer.add(backMainSuffixText);
        y += 11;

        canvasValues.backDividers.mainSuffix = backMainSuffixText.x() / scale;
    }
    if (canvasValues.direct !== '') {
        const letterSpacing = 0.1;
        backDirectText = createText('UniversLTStd', 6, canvasValues.direct, 29, y, '#000', letterSpacing);
        backDataLayer.add(backDirectText);

        let phoneLabel = canvasValues.phoneLabel2.toUpperCase();
        if (canvasValues.phoneLabel2 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel2.toUpperCase();
        }

        let x = backDirectText.text().length * 4.5 + 33;
        backDirectSuffixText = createText('UniversBold', 4.5, phoneLabel, x, y + 1.5);
        backDataLayer.add(backDirectSuffixText);
        y += 11;

        canvasValues.backDividers.directSuffix = backDirectSuffixText.x() / scale;
    }
    if (canvasValues.cell !== '') {
        const letterSpacing = 0.1;
        backCellText = createText('UniversLTStd', 6, canvasValues.cell, 29, y, '#000', letterSpacing);
        backDataLayer.add(backCellText);

        let phoneLabel = canvasValues.phoneLabel3.toUpperCase();
        if (canvasValues.phoneLabel3 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel3.toUpperCase();
        }

        let x = backCellText.text().length * 4.5 + 33;
        backCellSuffixText = createText('UniversBold', 4.5, phoneLabel, x, y + 1.5);
        backDataLayer.add(backCellSuffixText);
        y += 11;

        canvasValues.backDividers.cellSuffix = backCellSuffixText.x() / scale;
    }
    if (canvasValues.website !== '') {
        backWebsiteText = createText('UniversLTStd', 6, canvasValues.website, 29, y);
        backDataLayer.add(backWebsiteText);
    }
}

export const destroyBackVariablesP9T12 = () => {
    if (backNameText) {
        backNameText.destroy();
    }
    if (backPrimaryTitleText) {
        backPrimaryTitleText.destroy();
    }
    if (backTitle1Text) {
        backTitle1Text.destroy();
    }
    if (backTitle2Text) {
        backTitle2Text.destroy();
    }
    if (backTitle3Text) {
        backTitle3Text.destroy();
    }
    if (backSecondaryTitleText) {
        backSecondaryTitleText.destroy();
    }
    if (backTitle4Text) {
        backTitle4Text.destroy();
    }
    if (backEmailText) {
        backEmailText.destroy();
    }
    if (backMainText) {
        backMainText.destroy();
    }
    if (backDirectText) {
        backDirectText.destroy();
    }
    if (backCellText) {
        backCellText.destroy();
    }
    if (backWebsiteText) {
        backWebsiteText.destroy();
    }
    if (backMainSuffixText) {
        backMainSuffixText.destroy();
    }
    if (backDirectSuffixText) {
        backDirectSuffixText.destroy();
    }
    if (backCellSuffixText) {
        backCellSuffixText.destroy();
    }
    if (backLogoImage) {
        backLogoImage.destroy();
    }
}

export const initP9T13BackCanvas = () => {
    drawBackVariablesP9T13();
}

export const drawBackVariablesP9T13 = () => {
    let back = '';
    if (canvasValues.back !== '') {
        back = parseInt(canvasValues.back);
    }

    let backUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/back-background.svg';

    Konva.Image.fromURL(backUrl, (image) => {
        if (backLogoImage != null) {
            backLogoImage.destroy();
        }
        backLogoImage = image;

        backBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 408 * scale,
            height: 258 * scale,
        });
        backBackgroundLayer.draw();

        canvasValues.prevBack = back;
    });

    if (back === 2) {
        return;
    }

    let name = canvasValues.firstName;
    if (canvasValues.middleName !== '') {
        name += ' ' + canvasValues.middleName;
    }
    name += ' ' + canvasValues.lastName;
    if (canvasValues.credentials !== '') {
        name += ', ' + canvasValues.credentials;
    }

    let nameFontFamily = 'UniversBold';
    let titleFontFamily = 'UniversBold';
    let bodyFontFamily = 'UniversLTStd';
    let labelFontFamily = 'UniversBold';
    if (canvasValues.fontType === 'serif') {
        nameFontFamily = 'AGaramondProBold';
        titleFontFamily = 'AGaramondProSemibold';
        bodyFontFamily = 'AGaramondProRegular';
        labelFontFamily = 'AGaramondProRegular';
    }

    canvasValues.nameSize = 12;
    if (canvasValues.fontType === 'serif') {
        canvasValues.nameSize = 13;
    }
    backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 20);
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 11;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 12;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 20.5);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 10;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 10.5;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 21);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 9;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 10;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 21.5);
    }
    backDataLayer.add(backNameText);

    let y = 49;
    const sizes = calculateFontSizeForTitlesP9T13();

    canvasValues.titlesSize = sizes.titlesSize;
    canvasValues.yStep = sizes.yStep;
    canvasValues.sectionStep = sizes.sectionStep;
    canvasValues.phoneLabelSize = sizes.phoneLabelSize;
    canvasValues.phoneLabelX = sizes.phoneLabelX;
    canvasValues.phoneLabelY = sizes.phoneLabelY;

    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText(titleFontFamily, sizes.titlesSize, canvasValues.primaryTitle, 29, y);
        backDataLayer.add(backPrimaryTitleText);
        y += sizes.yStep;
    }
    if (canvasValues.title1 !== '') {
        backTitle1Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title1, 29, y);
        backDataLayer.add(backTitle1Text);
        y += sizes.yStep;
    }
    if (canvasValues.title2 !== '') {
        backTitle2Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title2, 29, y);
        backDataLayer.add(backTitle2Text);
        y += sizes.yStep;
    }
    if (canvasValues.title3 !== '') {
        backTitle3Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title3, 29, y);
        backDataLayer.add(backTitle3Text);
        y += sizes.yStep;
    }

    canvasValues.backDividers = {};

    y += sizes.sectionStep;
    if (canvasValues.email !== '') {
        backEmailText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.email, 29, y);
        backDataLayer.add(backEmailText);
        y += sizes.yStep;
    }
    if (canvasValues.main !== '') {
        const letterSpacing = 0.1;
        backMainText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.main, 29, y, '#000', letterSpacing);
        backDataLayer.add(backMainText);

        let phoneLabel = canvasValues.phoneLabel1.toUpperCase();
        if (canvasValues.phoneLabel1 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel1.toUpperCase();
        }

        let x = backMainText.text().length * sizes.phoneLabelSize + sizes.phoneLabelX;
        backMainSuffixText = createText(labelFontFamily, sizes.phoneLabelSize, phoneLabel, x, y + sizes.phoneLabelY);
        backDataLayer.add(backMainSuffixText);
        y += sizes.yStep;

        canvasValues.backDividers.mainSuffix = backMainSuffixText.x() / scale;
    }
    if (canvasValues.cell !== '') {
        const letterSpacing = 0.1;
        backCellText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.cell, 29, y, '#000', letterSpacing);
        backDataLayer.add(backCellText);

        let phoneLabel = canvasValues.phoneLabel2.toUpperCase();
        if (canvasValues.phoneLabel2 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel2.toUpperCase();
        }

        let x = backCellText.text().length * sizes.phoneLabelSize + sizes.phoneLabelX;
        backCellSuffixText = createText(labelFontFamily, sizes.phoneLabelSize, phoneLabel, x, y + sizes.phoneLabelY);
        backDataLayer.add(backCellSuffixText);
        y += sizes.yStep;

        canvasValues.backDividers.cellSuffix = backCellSuffixText.x() / scale;
    }
    if (canvasValues.website !== '') {
        backWebsiteText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.website, 29, y);
        backDataLayer.add(backWebsiteText);
    }
}

export const destroyBackVariablesP9T13 = () => {
    if (backNameText) {
        backNameText.destroy();
    }
    if (backPrimaryTitleText) {
        backPrimaryTitleText.destroy();
    }
    if (backTitle1Text) {
        backTitle1Text.destroy();
    }
    if (backTitle2Text) {
        backTitle2Text.destroy();
    }
    if (backTitle3Text) {
        backTitle3Text.destroy();
    }
    if (backSecondaryTitleText) {
        backSecondaryTitleText.destroy();
    }
    if (backTitle4Text) {
        backTitle4Text.destroy();
    }
    if (backEmailText) {
        backEmailText.destroy();
    }
    if (backMainText) {
        backMainText.destroy();
    }
    if (backDirectText) {
        backDirectText.destroy();
    }
    if (backCellText) {
        backCellText.destroy();
    }
    if (backWebsiteText) {
        backWebsiteText.destroy();
    }
    if (backMainSuffixText) {
        backMainSuffixText.destroy();
    }
    if (backDirectSuffixText) {
        backDirectSuffixText.destroy();
    }
    if (backCellSuffixText) {
        backCellSuffixText.destroy();
    }
    if (backLogoImage) {
        backLogoImage.destroy();
    }
}

export const initP9T14BackCanvas = () => {
    drawBackVariablesP9T14();
}

export const drawBackVariablesP9T14 = () => {
    let back = '';
    if (canvasValues.back !== '') {
        back = parseInt(canvasValues.back);
    }

    let backUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/back-background.svg';

    Konva.Image.fromURL(backUrl, (image) => {
        if (backLogoImage != null) {
            backLogoImage.destroy();
        }
        backLogoImage = image;

        backBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 408 * scale,
            height: 258 * scale,
        });
        backBackgroundLayer.draw();

        canvasValues.prevBack = back;
    });

    if (back === 2) {
        return;
    }

    let name = canvasValues.firstName;
    if (canvasValues.middleName !== '') {
        name += ' ' + canvasValues.middleName;
    }
    name += ' ' + canvasValues.lastName;
    if (canvasValues.credentials !== '') {
        name += ', ' + canvasValues.credentials;
    }

    let nameFontFamily = 'UniversBold';
    let titleFontFamily = 'UniversBold';
    let bodyFontFamily = 'UniversLTStd';
    let labelFontFamily = 'UniversBold';
    if (canvasValues.fontType === 'serif') {
        nameFontFamily = 'AGaramondProBold';
        titleFontFamily = 'AGaramondProSemibold';
        bodyFontFamily = 'AGaramondProRegular';
        labelFontFamily = 'AGaramondProRegular';
    }

    canvasValues.nameSize = 12;
    if (canvasValues.fontType === 'serif') {
        canvasValues.nameSize = 13;
    }
    backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 20);
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 11;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 12;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 20.5);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 10;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 10.5;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 21);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 9;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 10;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 21.5);
    }
    backDataLayer.add(backNameText);

    let y = 49;
    const sizes = calculateFontSizeForTitlesP9T14();

    canvasValues.titlesSize = sizes.titlesSize;
    canvasValues.yStep = sizes.yStep;
    canvasValues.sectionStep = sizes.sectionStep;
    canvasValues.phoneLabelSize = sizes.phoneLabelSize;
    canvasValues.phoneLabelX = sizes.phoneLabelX;
    canvasValues.phoneLabelY = sizes.phoneLabelY;

    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText(titleFontFamily, sizes.titlesSize, canvasValues.primaryTitle, 29, y);
        backDataLayer.add(backPrimaryTitleText);
        y += sizes.yStep;
    }
    if (canvasValues.title1 !== '') {
        backTitle1Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title1, 29, y);
        backDataLayer.add(backTitle1Text);
        y += sizes.yStep;
    }
    if (canvasValues.title2 !== '') {
        backTitle2Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title2, 29, y);
        backDataLayer.add(backTitle2Text);
        y += sizes.yStep;
    }
    if (canvasValues.title3 !== '') {
        backTitle3Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title3, 29, y);
        backDataLayer.add(backTitle3Text);
        y += sizes.yStep;
    }

    canvasValues.backDividers = {};

    y += sizes.sectionStep;
    if (canvasValues.email !== '') {
        backEmailText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.email, 29, y);
        backDataLayer.add(backEmailText);
        y += sizes.yStep;
    }
    if (canvasValues.main !== '') {
        const letterSpacing = 0.1;
        backMainText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.main, 29, y, '#000', letterSpacing);
        backDataLayer.add(backMainText);

        let phoneLabel = canvasValues.phoneLabel1.toUpperCase();
        if (canvasValues.phoneLabel1 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel1.toUpperCase();
        }

        let x = backMainText.text().length * sizes.phoneLabelSize + sizes.phoneLabelX;
        backMainSuffixText = createText(labelFontFamily, sizes.phoneLabelSize, phoneLabel, x, y + sizes.phoneLabelY);
        backDataLayer.add(backMainSuffixText);
        y += sizes.yStep;

        canvasValues.backDividers.mainSuffix = backMainSuffixText.x() / scale;
    }
    if (canvasValues.cell !== '') {
        const letterSpacing = 0.1;
        backCellText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.cell, 29, y, '#000', letterSpacing);
        backDataLayer.add(backCellText);

        let phoneLabel = canvasValues.phoneLabel2.toUpperCase();
        if (canvasValues.phoneLabel2 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel2.toUpperCase();
        }

        let x = backCellText.text().length * sizes.phoneLabelSize + sizes.phoneLabelX;
        backCellSuffixText = createText(labelFontFamily, sizes.phoneLabelSize, phoneLabel, x, y + sizes.phoneLabelY);
        backDataLayer.add(backCellSuffixText);
        y += sizes.yStep;

        canvasValues.backDividers.cellSuffix = backCellSuffixText.x() / scale;
    }
    if (canvasValues.website !== '') {
        backWebsiteText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.website, 29, y);
        backDataLayer.add(backWebsiteText);
    }
}

export const calculateFontSizeForTitlesP9T14 = () => {
    let fontFamily = 'UniversLTStd';
    let sizes = [9, 9, 9, 9, 9];
    if (canvasValues.fontType === 'serif') {
        fontFamily = 'AGaramondProRegular';
        sizes = [11, 11, 11, 11, 11];
    }

    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 20);
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 10;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 20.5);
        }
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 9;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 21);
        }
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 8;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 21);
        }
    }

    if (canvasValues.title1 !== '') {
        backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 20);
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 10;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 20.5);
        }
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 9;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 21);
        }
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 8;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 21);
        }
    }

    if (canvasValues.title2 !== '') {
        backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 20);
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 10;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 20.5);
        }
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 9;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 21);
        }
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 8;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 21);
        }
    }

    if (canvasValues.title3 !== '') {
        backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 20);
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 10;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 20.5);
        }
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 9;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 21);
        }
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 8;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 21);
        }
    }

    if (canvasValues.website !== '') {
        backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 20);
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 10;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 20.5);
        }
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 9;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 21);
        }
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 8;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 21);
        }
    }

    const min = Math.min(...sizes);

    if (canvasValues.fontType === 'serif') {
        if (min === 11) {
            return {
                titlesSize: min,
                yStep: 16,
                sectionStep: 10,
                phoneLabelSize: 8,
                phoneLabelX: 23,
                phoneLabelY: 2.2,
            };
        } else if (min === 10) {
            return {
                titlesSize: min,
                yStep: 14,
                sectionStep: 10,
                phoneLabelSize: 7,
                phoneLabelX: 27,
                phoneLabelY: 2.5,
            };
        } else if (min === 9) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 10,
                phoneLabelSize: 6.5,
                phoneLabelX: 25,
                phoneLabelY: 2.5,
            };
        } else if (min === 8) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 9,
                phoneLabelSize: 6.5,
                phoneLabelX: 17,
                phoneLabelY: 1.6,
            };
        }
    } else {
        if (min === 9) {
            return {
                titlesSize: min,
                yStep: 16,
                sectionStep: 10,
                phoneLabelSize: 6,
                phoneLabelX: 38,
                phoneLabelY: 2,
            };
        } else if (min === 8) {
            return {
                titlesSize: min,
                yStep: 14,
                sectionStep: 9,
                phoneLabelSize: 5.5,
                phoneLabelX: 36,
                phoneLabelY: 2,
            };
        } else if (min === 7) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 9,
                phoneLabelSize: 5,
                phoneLabelX: 34,
                phoneLabelY: 1.6,
            };
        }
    }

    return {
        titlesSize: min,
        yStep: 16,
        sectionStep: 10,
        phoneLabelSize: 6,
        phoneLabelX: 38,
        phoneLabelY: 2,
    };
}

export const destroyBackVariablesP9T14 = () => {
    if (backNameText) {
        backNameText.destroy();
    }
    if (backPrimaryTitleText) {
        backPrimaryTitleText.destroy();
    }
    if (backTitle1Text) {
        backTitle1Text.destroy();
    }
    if (backTitle2Text) {
        backTitle2Text.destroy();
    }
    if (backTitle3Text) {
        backTitle3Text.destroy();
    }
    if (backSecondaryTitleText) {
        backSecondaryTitleText.destroy();
    }
    if (backTitle4Text) {
        backTitle4Text.destroy();
    }
    if (backEmailText) {
        backEmailText.destroy();
    }
    if (backMainText) {
        backMainText.destroy();
    }
    if (backDirectText) {
        backDirectText.destroy();
    }
    if (backCellText) {
        backCellText.destroy();
    }
    if (backWebsiteText) {
        backWebsiteText.destroy();
    }
    if (backMainSuffixText) {
        backMainSuffixText.destroy();
    }
    if (backDirectSuffixText) {
        backDirectSuffixText.destroy();
    }
    if (backCellSuffixText) {
        backCellSuffixText.destroy();
    }
    if (backLogoImage) {
        backLogoImage.destroy();
    }
}

export const initP9T15BackCanvas = () => {
    drawBackVariablesP9T15();
}

export const drawBackVariablesP9T15 = () => {
    let back = '';
    if (canvasValues.back !== '') {
        back = parseInt(canvasValues.back);
    }

    let backUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/back-background.svg';

    Konva.Image.fromURL(backUrl, (image) => {
        if (backLogoImage != null) {
            backLogoImage.destroy();
        }
        backLogoImage = image;

        backBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 408 * scale,
            height: 258 * scale,
        });
        backBackgroundLayer.draw();

        canvasValues.prevBack = back;
    });

    if (back === 2) {
        return;
    }

    let name = canvasValues.firstName;
    if (canvasValues.middleName !== '') {
        name += ' ' + canvasValues.middleName;
    }
    name += ' ' + canvasValues.lastName;
    if (canvasValues.credentials !== '') {
        name += ', ' + canvasValues.credentials;
    }

    let nameFontFamily = 'UniversBold';
    let titleFontFamily = 'UniversBold';
    let bodyFontFamily = 'UniversLTStd';
    let labelFontFamily = 'UniversBold';
    if (canvasValues.fontType === 'serif') {
        nameFontFamily = 'AGaramondProBold';
        titleFontFamily = 'AGaramondProSemibold';
        bodyFontFamily = 'AGaramondProRegular';
        labelFontFamily = 'AGaramondProRegular';
    }

    canvasValues.nameSize = 12;
    if (canvasValues.fontType === 'serif') {
        canvasValues.nameSize = 13;
    }
    backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 20);
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 11;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 12;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 20.5);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 10;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 10.5;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 21);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 9;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 10;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 21.5);
    }
    backDataLayer.add(backNameText);

    let y = 49;
    const sizes = calculateFontSizeForTitlesP9T15();

    canvasValues.titlesSize = sizes.titlesSize;
    canvasValues.yStep = sizes.yStep;
    canvasValues.sectionStep = sizes.sectionStep;
    canvasValues.phoneLabelSize = sizes.phoneLabelSize;
    canvasValues.phoneLabelX = sizes.phoneLabelX;
    canvasValues.phoneLabelY = sizes.phoneLabelY;

    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText(titleFontFamily, sizes.titlesSize, canvasValues.primaryTitle, 29, y);
        backDataLayer.add(backPrimaryTitleText);
        y += sizes.yStep;
    }
    if (canvasValues.title1 !== '') {
        backTitle1Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title1, 29, y);
        backDataLayer.add(backTitle1Text);
        y += sizes.yStep;
    }
    if (canvasValues.title2 !== '') {
        backTitle2Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title2, 29, y);
        backDataLayer.add(backTitle2Text);
        y += sizes.yStep;
    }
    if (canvasValues.title3 !== '') {
        backTitle3Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title3, 29, y);
        backDataLayer.add(backTitle3Text);
        y += sizes.yStep;
    }

    canvasValues.backDividers = {};

    y += sizes.sectionStep;
    if (canvasValues.email !== '') {
        backEmailText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.email, 29, y);
        backDataLayer.add(backEmailText);
        y += sizes.yStep;
    }
    if (canvasValues.main !== '') {
        const letterSpacing = 0.1;
        backMainText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.main, 29, y, '#000', letterSpacing);
        backDataLayer.add(backMainText);

        let phoneLabel = canvasValues.phoneLabel1.toUpperCase();
        if (canvasValues.phoneLabel1 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel1.toUpperCase();
        }

        let x = backMainText.text().length * sizes.phoneLabelSize + sizes.phoneLabelX;
        backMainSuffixText = createText(labelFontFamily, sizes.phoneLabelSize, phoneLabel, x, y + sizes.phoneLabelY);
        backDataLayer.add(backMainSuffixText);
        y += sizes.yStep;

        canvasValues.backDividers.mainSuffix = backMainSuffixText.x() / scale;
    }
    if (canvasValues.cell !== '') {
        const letterSpacing = 0.1;
        backCellText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.cell, 29, y, '#000', letterSpacing);
        backDataLayer.add(backCellText);

        let phoneLabel = canvasValues.phoneLabel2.toUpperCase();
        if (canvasValues.phoneLabel2 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel2.toUpperCase();
        }

        let x = backCellText.text().length * sizes.phoneLabelSize + sizes.phoneLabelX;
        backCellSuffixText = createText(labelFontFamily, sizes.phoneLabelSize, phoneLabel, x, y + sizes.phoneLabelY);
        backDataLayer.add(backCellSuffixText);
        y += sizes.yStep;

        canvasValues.backDividers.cellSuffix = backCellSuffixText.x() / scale;
    }
    if (canvasValues.website !== '') {
        backWebsiteText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.website, 29, y);
        backDataLayer.add(backWebsiteText);
    }
}

export const calculateFontSizeForTitlesP9T15 = () => {
    let fontFamily = 'UniversLTStd';
    let sizes = [9, 9, 9, 9, 9];
    if (canvasValues.fontType === 'serif') {
        fontFamily = 'AGaramondProRegular';
        sizes = [11, 11, 11, 11, 11];
    }

    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 20);
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 10;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 20.5);
        }
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 9;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 21);
        }
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 8;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 21);
        }
    }

    if (canvasValues.title1 !== '') {
        backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 20);
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 10;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 20.5);
        }
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 9;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 21);
        }
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 8;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 21);
        }
    }

    if (canvasValues.title2 !== '') {
        backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 20);
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 10;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 20.5);
        }
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 9;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 21);
        }
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 8;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 21);
        }
    }

    if (canvasValues.title3 !== '') {
        backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 20);
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 10;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 20.5);
        }
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 9;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 21);
        }
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 8;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 21);
        }
    }

    if (canvasValues.website !== '') {
        backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 20);
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 10;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 20.5);
        }
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 9;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 21);
        }
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 8;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 21);
        }
    }

    const min = Math.min(...sizes);

    if (canvasValues.fontType === 'serif') {
        if (min === 11) {
            return {
                titlesSize: min,
                yStep: 16,
                sectionStep: 10,
                phoneLabelSize: 8,
                phoneLabelX: 23,
                phoneLabelY: 2.2,
            };
        } else if (min === 10) {
            return {
                titlesSize: min,
                yStep: 14,
                sectionStep: 10,
                phoneLabelSize: 7,
                phoneLabelX: 27,
                phoneLabelY: 2.5,
            };
        } else if (min === 9) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 10,
                phoneLabelSize: 6.5,
                phoneLabelX: 25,
                phoneLabelY: 2.5,
            };
        } else if (min === 8) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 9,
                phoneLabelSize: 6.5,
                phoneLabelX: 17,
                phoneLabelY: 1.6,
            };
        }
    } else {
        if (min === 9) {
            return {
                titlesSize: min,
                yStep: 16,
                sectionStep: 10,
                phoneLabelSize: 6,
                phoneLabelX: 38,
                phoneLabelY: 2,
            };
        } else if (min === 8) {
            return {
                titlesSize: min,
                yStep: 14,
                sectionStep: 9,
                phoneLabelSize: 5.5,
                phoneLabelX: 36,
                phoneLabelY: 2,
            };
        } else if (min === 7) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 9,
                phoneLabelSize: 5,
                phoneLabelX: 34,
                phoneLabelY: 1.6,
            };
        }
    }

    return {
        titlesSize: min,
        yStep: 16,
        sectionStep: 10,
        phoneLabelSize: 6,
        phoneLabelX: 38,
        phoneLabelY: 2,
    };
}

export const destroyBackVariablesP9T15 = () => {
    if (backNameText) {
        backNameText.destroy();
    }
    if (backPrimaryTitleText) {
        backPrimaryTitleText.destroy();
    }
    if (backTitle1Text) {
        backTitle1Text.destroy();
    }
    if (backTitle2Text) {
        backTitle2Text.destroy();
    }
    if (backTitle3Text) {
        backTitle3Text.destroy();
    }
    if (backSecondaryTitleText) {
        backSecondaryTitleText.destroy();
    }
    if (backTitle4Text) {
        backTitle4Text.destroy();
    }
    if (backEmailText) {
        backEmailText.destroy();
    }
    if (backMainText) {
        backMainText.destroy();
    }
    if (backDirectText) {
        backDirectText.destroy();
    }
    if (backCellText) {
        backCellText.destroy();
    }
    if (backWebsiteText) {
        backWebsiteText.destroy();
    }
    if (backMainSuffixText) {
        backMainSuffixText.destroy();
    }
    if (backDirectSuffixText) {
        backDirectSuffixText.destroy();
    }
    if (backCellSuffixText) {
        backCellSuffixText.destroy();
    }
    if (backLogoImage) {
        backLogoImage.destroy();
    }
}

export const initP9T16BackCanvas = () => {
    drawBackVariablesP9T16();
}

export const drawBackVariablesP9T16 = () => {
    let back = '';
    if (canvasValues.back !== '') {
        back = parseInt(canvasValues.back);
    }

    let backUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/back-background.svg';

    Konva.Image.fromURL(backUrl, (image) => {
        if (backLogoImage != null) {
            backLogoImage.destroy();
        }
        backLogoImage = image;

        backBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 408 * scale,
            height: 258 * scale,
        });
        backBackgroundLayer.draw();

        canvasValues.prevBack = back;
    });

    if (back === 2) {
        return;
    }

    let name = canvasValues.firstName;
    if (canvasValues.middleName !== '') {
        name += ' ' + canvasValues.middleName;
    }
    name += ' ' + canvasValues.lastName;
    if (canvasValues.credentials !== '') {
        name += ', ' + canvasValues.credentials;
    }

    let nameFontFamily = 'UniversBold';
    let titleFontFamily = 'UniversBold';
    let bodyFontFamily = 'UniversLTStd';
    let labelFontFamily = 'UniversBold';
    if (canvasValues.fontType === 'serif') {
        nameFontFamily = 'AGaramondProBold';
        titleFontFamily = 'AGaramondProSemibold';
        bodyFontFamily = 'AGaramondProRegular';
        labelFontFamily = 'AGaramondProRegular';
    }

    canvasValues.nameSize = 12;
    if (canvasValues.fontType === 'serif') {
        canvasValues.nameSize = 13;
    }
    backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 20);
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 11;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 12;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 20.5);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 10;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 10.5;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 21);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 9;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 10;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 21.5);
    }
    backDataLayer.add(backNameText);

    let y = 49;
    const sizes = calculateFontSizeForTitlesP9T16();

    canvasValues.titlesSize = sizes.titlesSize;
    canvasValues.yStep = sizes.yStep;
    canvasValues.sectionStep = sizes.sectionStep;
    canvasValues.phoneLabelSize = sizes.phoneLabelSize;
    canvasValues.phoneLabelX = sizes.phoneLabelX;
    canvasValues.phoneLabelY = sizes.phoneLabelY;

    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText(titleFontFamily, sizes.titlesSize, canvasValues.primaryTitle, 29, y);
        backDataLayer.add(backPrimaryTitleText);
        y += sizes.yStep;
    }
    if (canvasValues.title1 !== '') {
        backTitle1Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title1, 29, y);
        backDataLayer.add(backTitle1Text);
        y += sizes.yStep;
    }
    if (canvasValues.title2 !== '') {
        backTitle2Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title2, 29, y);
        backDataLayer.add(backTitle2Text);
        y += sizes.yStep;
    }
    if (canvasValues.title3 !== '') {
        backTitle3Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title3, 29, y);
        backDataLayer.add(backTitle3Text);
        y += sizes.yStep;
    }

    canvasValues.backDividers = {};

    y += sizes.sectionStep;
    if (canvasValues.email !== '') {
        backEmailText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.email, 29, y);
        backDataLayer.add(backEmailText);
        y += sizes.yStep;
    }
    if (canvasValues.main !== '') {
        const letterSpacing = 0.1;
        backMainText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.main, 29, y, '#000', letterSpacing);
        backDataLayer.add(backMainText);

        let phoneLabel = canvasValues.phoneLabel1.toUpperCase();
        if (canvasValues.phoneLabel1 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel1.toUpperCase();
        }

        let x = backMainText.text().length * sizes.phoneLabelSize + sizes.phoneLabelX;
        backMainSuffixText = createText(labelFontFamily, sizes.phoneLabelSize, phoneLabel, x, y + sizes.phoneLabelY);
        backDataLayer.add(backMainSuffixText);
        y += sizes.yStep;

        canvasValues.backDividers.mainSuffix = backMainSuffixText.x() / scale;
    }
    if (canvasValues.cell !== '') {
        const letterSpacing = 0.1;
        backCellText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.cell, 29, y, '#000', letterSpacing);
        backDataLayer.add(backCellText);

        let phoneLabel = canvasValues.phoneLabel2.toUpperCase();
        if (canvasValues.phoneLabel2 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel2.toUpperCase();
        }

        let x = backCellText.text().length * sizes.phoneLabelSize + sizes.phoneLabelX;
        backCellSuffixText = createText(labelFontFamily, sizes.phoneLabelSize, phoneLabel, x, y + sizes.phoneLabelY);
        backDataLayer.add(backCellSuffixText);
        y += sizes.yStep;

        canvasValues.backDividers.cellSuffix = backCellSuffixText.x() / scale;
    }
    if (canvasValues.website !== '') {
        backWebsiteText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.website, 29, y);
        backDataLayer.add(backWebsiteText);
    }
}

export const calculateFontSizeForTitlesP9T16 = () => {
    let fontFamily = 'UniversLTStd';
    let sizes = [9, 9, 9, 9, 9];
    if (canvasValues.fontType === 'serif') {
        fontFamily = 'AGaramondProRegular';
        sizes = [11, 11, 11, 11, 11];
    }

    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 20);
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 10;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 20.5);
        }
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 9;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 21);
        }
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 8;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 21);
        }
    }

    if (canvasValues.title1 !== '') {
        backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 20);
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 10;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 20.5);
        }
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 9;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 21);
        }
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 8;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 21);
        }
    }

    if (canvasValues.title2 !== '') {
        backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 20);
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 10;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 20.5);
        }
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 9;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 21);
        }
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 8;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 21);
        }
    }

    if (canvasValues.title3 !== '') {
        backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 20);
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 10;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 20.5);
        }
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 9;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 21);
        }
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 8;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 21);
        }
    }

    if (canvasValues.website !== '') {
        backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 20);
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 10;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 20.5);
        }
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 9;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 21);
        }
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 8;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 21);
        }
    }

    const min = Math.min(...sizes);

    if (canvasValues.fontType === 'serif') {
        if (min === 11) {
            return {
                titlesSize: min,
                yStep: 16,
                sectionStep: 10,
                phoneLabelSize: 8,
                phoneLabelX: 23,
                phoneLabelY: 2.2,
            };
        } else if (min === 10) {
            return {
                titlesSize: min,
                yStep: 14,
                sectionStep: 10,
                phoneLabelSize: 7,
                phoneLabelX: 27,
                phoneLabelY: 2.5,
            };
        } else if (min === 9) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 10,
                phoneLabelSize: 6.5,
                phoneLabelX: 25,
                phoneLabelY: 2.5,
            };
        } else if (min === 8) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 9,
                phoneLabelSize: 6.5,
                phoneLabelX: 17,
                phoneLabelY: 1.6,
            };
        }
    } else {
        if (min === 9) {
            return {
                titlesSize: min,
                yStep: 16,
                sectionStep: 10,
                phoneLabelSize: 6,
                phoneLabelX: 38,
                phoneLabelY: 2,
            };
        } else if (min === 8) {
            return {
                titlesSize: min,
                yStep: 14,
                sectionStep: 9,
                phoneLabelSize: 5.5,
                phoneLabelX: 36,
                phoneLabelY: 2,
            };
        } else if (min === 7) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 9,
                phoneLabelSize: 5,
                phoneLabelX: 34,
                phoneLabelY: 1.6,
            };
        }
    }

    return {
        titlesSize: min,
        yStep: 16,
        sectionStep: 10,
        phoneLabelSize: 6,
        phoneLabelX: 38,
        phoneLabelY: 2,
    };
}

export const destroyBackVariablesP9T16 = () => {
    if (backNameText) {
        backNameText.destroy();
    }
    if (backPrimaryTitleText) {
        backPrimaryTitleText.destroy();
    }
    if (backTitle1Text) {
        backTitle1Text.destroy();
    }
    if (backTitle2Text) {
        backTitle2Text.destroy();
    }
    if (backTitle3Text) {
        backTitle3Text.destroy();
    }
    if (backSecondaryTitleText) {
        backSecondaryTitleText.destroy();
    }
    if (backTitle4Text) {
        backTitle4Text.destroy();
    }
    if (backEmailText) {
        backEmailText.destroy();
    }
    if (backMainText) {
        backMainText.destroy();
    }
    if (backDirectText) {
        backDirectText.destroy();
    }
    if (backCellText) {
        backCellText.destroy();
    }
    if (backWebsiteText) {
        backWebsiteText.destroy();
    }
    if (backMainSuffixText) {
        backMainSuffixText.destroy();
    }
    if (backDirectSuffixText) {
        backDirectSuffixText.destroy();
    }
    if (backCellSuffixText) {
        backCellSuffixText.destroy();
    }
    if (backLogoImage) {
        backLogoImage.destroy();
    }
}

export const initP9T17BackCanvas = () => {
    drawBackVariablesP9T17();
}

export const drawBackVariablesP9T17 = () => {
    let back = '';
    if (canvasValues.back !== '') {
        back = parseInt(canvasValues.back);
    }

    let backUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/back-background.svg';

    Konva.Image.fromURL(backUrl, (image) => {
        if (backLogoImage != null) {
            backLogoImage.destroy();
        }
        backLogoImage = image;

        backBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 408 * scale,
            height: 258 * scale,
        });
        backBackgroundLayer.draw();

        canvasValues.prevBack = back;
    });

    if (back === 2) {
        return;
    }

    let name = canvasValues.firstName;
    if (canvasValues.middleName !== '') {
        name += ' ' + canvasValues.middleName;
    }
    name += ' ' + canvasValues.lastName;
    if (canvasValues.credentials !== '') {
        name += ', ' + canvasValues.credentials;
    }

    let nameFontFamily = 'UniversBold';
    let titleFontFamily = 'UniversBold';
    let bodyFontFamily = 'UniversLTStd';
    let labelFontFamily = 'UniversBold';
    if (canvasValues.fontType === 'serif') {
        nameFontFamily = 'AGaramondProBold';
        titleFontFamily = 'AGaramondProSemibold';
        bodyFontFamily = 'AGaramondProRegular';
        labelFontFamily = 'AGaramondProRegular';
    }

    canvasValues.nameSize = 12;
    if (canvasValues.fontType === 'serif') {
        canvasValues.nameSize = 13;
    }
    backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 20);
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 11;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 12;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 20.5);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 10;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 10.5;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 21);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 9;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 10;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 21.5);
    }
    backDataLayer.add(backNameText);

    let y = 49;
    const sizes = calculateFontSizeForTitlesP9T17();

    canvasValues.titlesSize = sizes.titlesSize;
    canvasValues.yStep = sizes.yStep;
    canvasValues.sectionStep = sizes.sectionStep;
    canvasValues.phoneLabelSize = sizes.phoneLabelSize;
    canvasValues.phoneLabelX = sizes.phoneLabelX;
    canvasValues.phoneLabelY = sizes.phoneLabelY;

    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText(titleFontFamily, sizes.titlesSize, canvasValues.primaryTitle, 29, y);
        backDataLayer.add(backPrimaryTitleText);
        y += sizes.yStep;
    }
    if (canvasValues.title1 !== '') {
        backTitle1Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title1, 29, y);
        backDataLayer.add(backTitle1Text);
        y += sizes.yStep;
    }
    if (canvasValues.title2 !== '') {
        backTitle2Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title2, 29, y);
        backDataLayer.add(backTitle2Text);
        y += sizes.yStep;
    }
    if (canvasValues.title3 !== '') {
        backTitle3Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title3, 29, y);
        backDataLayer.add(backTitle3Text);
        y += sizes.yStep;
    }

    canvasValues.backDividers = {};

    y += sizes.sectionStep;
    if (canvasValues.email !== '') {
        backEmailText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.email, 29, y);
        backDataLayer.add(backEmailText);
        y += sizes.yStep;
    }
    if (canvasValues.main !== '') {
        const letterSpacing = 0.1;
        backMainText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.main, 29, y, '#000', letterSpacing);
        backDataLayer.add(backMainText);

        let phoneLabel = canvasValues.phoneLabel1.toUpperCase();
        if (canvasValues.phoneLabel1 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel1.toUpperCase();
        }

        let x = backMainText.text().length * sizes.phoneLabelSize + sizes.phoneLabelX;
        backMainSuffixText = createText(labelFontFamily, sizes.phoneLabelSize, phoneLabel, x, y + sizes.phoneLabelY);
        backDataLayer.add(backMainSuffixText);
        y += sizes.yStep;

        canvasValues.backDividers.mainSuffix = backMainSuffixText.x() / scale;
    }
    if (canvasValues.cell !== '') {
        const letterSpacing = 0.1;
        backCellText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.cell, 29, y, '#000', letterSpacing);
        backDataLayer.add(backCellText);

        let phoneLabel = canvasValues.phoneLabel2.toUpperCase();
        if (canvasValues.phoneLabel2 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel2.toUpperCase();
        }

        let x = backCellText.text().length * sizes.phoneLabelSize + sizes.phoneLabelX;
        backCellSuffixText = createText(labelFontFamily, sizes.phoneLabelSize, phoneLabel, x, y + sizes.phoneLabelY);
        backDataLayer.add(backCellSuffixText);
        y += sizes.yStep;

        canvasValues.backDividers.cellSuffix = backCellSuffixText.x() / scale;
    }
    if (canvasValues.website !== '') {
        backWebsiteText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.website, 29, y);
        backDataLayer.add(backWebsiteText);
    }
}

export const calculateFontSizeForTitlesP9T17 = () => {
    let fontFamily = 'UniversLTStd';
    let sizes = [9, 9, 9, 9, 9];
    if (canvasValues.fontType === 'serif') {
        fontFamily = 'AGaramondProRegular';
        sizes = [11, 11, 11, 11, 11];
    }

    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 20);
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 10;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 20.5);
        }
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 9;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 21);
        }
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 8;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 21);
        }
    }

    if (canvasValues.title1 !== '') {
        backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 20);
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 10;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 20.5);
        }
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 9;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 21);
        }
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 8;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 21);
        }
    }

    if (canvasValues.title2 !== '') {
        backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 20);
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 10;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 20.5);
        }
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 9;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 21);
        }
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 8;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 21);
        }
    }

    if (canvasValues.title3 !== '') {
        backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 20);
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 10;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 20.5);
        }
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 9;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 21);
        }
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 8;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 21);
        }
    }

    if (canvasValues.website !== '') {
        backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 20);
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 10;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 20.5);
        }
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 9;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 21);
        }
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 8;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 21);
        }
    }

    const min = Math.min(...sizes);

    if (canvasValues.fontType === 'serif') {
        if (min === 11) {
            return {
                titlesSize: min,
                yStep: 16,
                sectionStep: 10,
                phoneLabelSize: 8,
                phoneLabelX: 23,
                phoneLabelY: 2.2,
            };
        } else if (min === 10) {
            return {
                titlesSize: min,
                yStep: 14,
                sectionStep: 10,
                phoneLabelSize: 7,
                phoneLabelX: 27,
                phoneLabelY: 2.5,
            };
        } else if (min === 9) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 10,
                phoneLabelSize: 6.5,
                phoneLabelX: 25,
                phoneLabelY: 2.5,
            };
        } else if (min === 8) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 9,
                phoneLabelSize: 6.5,
                phoneLabelX: 17,
                phoneLabelY: 1.6,
            };
        }
    } else {
        if (min === 9) {
            return {
                titlesSize: min,
                yStep: 16,
                sectionStep: 10,
                phoneLabelSize: 6,
                phoneLabelX: 38,
                phoneLabelY: 2,
            };
        } else if (min === 8) {
            return {
                titlesSize: min,
                yStep: 14,
                sectionStep: 9,
                phoneLabelSize: 5.5,
                phoneLabelX: 36,
                phoneLabelY: 2,
            };
        } else if (min === 7) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 9,
                phoneLabelSize: 5,
                phoneLabelX: 34,
                phoneLabelY: 1.6,
            };
        }
    }

    return {
        titlesSize: min,
        yStep: 16,
        sectionStep: 10,
        phoneLabelSize: 6,
        phoneLabelX: 38,
        phoneLabelY: 2,
    };
}

export const destroyBackVariablesP9T17 = () => {
    if (backNameText) {
        backNameText.destroy();
    }
    if (backPrimaryTitleText) {
        backPrimaryTitleText.destroy();
    }
    if (backTitle1Text) {
        backTitle1Text.destroy();
    }
    if (backTitle2Text) {
        backTitle2Text.destroy();
    }
    if (backTitle3Text) {
        backTitle3Text.destroy();
    }
    if (backSecondaryTitleText) {
        backSecondaryTitleText.destroy();
    }
    if (backTitle4Text) {
        backTitle4Text.destroy();
    }
    if (backEmailText) {
        backEmailText.destroy();
    }
    if (backMainText) {
        backMainText.destroy();
    }
    if (backDirectText) {
        backDirectText.destroy();
    }
    if (backCellText) {
        backCellText.destroy();
    }
    if (backWebsiteText) {
        backWebsiteText.destroy();
    }
    if (backMainSuffixText) {
        backMainSuffixText.destroy();
    }
    if (backDirectSuffixText) {
        backDirectSuffixText.destroy();
    }
    if (backCellSuffixText) {
        backCellSuffixText.destroy();
    }
    if (backLogoImage) {
        backLogoImage.destroy();
    }
}

export const initP9T18BackCanvas = () => {
    drawBackVariablesP9T18();
}

export const drawBackVariablesP9T18 = () => {
    let back = '';
    if (canvasValues.back !== '') {
        back = parseInt(canvasValues.back);
    }

    let backUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/back-background.svg';

    Konva.Image.fromURL(backUrl, (image) => {
        if (backLogoImage != null) {
            backLogoImage.destroy();
        }
        backLogoImage = image;

        backBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 408 * scale,
            height: 258 * scale,
        });
        backBackgroundLayer.draw();

        canvasValues.prevBack = back;
    });

    if (back === 2) {
        return;
    }

    let name = canvasValues.firstName;
    if (canvasValues.middleName !== '') {
        name += ' ' + canvasValues.middleName;
    }
    name += ' ' + canvasValues.lastName;
    if (canvasValues.credentials !== '') {
        name += ', ' + canvasValues.credentials;
    }

    let nameFontFamily = 'UniversBold';
    let titleFontFamily = 'UniversBold';
    let bodyFontFamily = 'UniversLTStd';
    let labelFontFamily = 'UniversBold';
    if (canvasValues.fontType === 'serif') {
        nameFontFamily = 'AGaramondProBold';
        titleFontFamily = 'AGaramondProSemibold';
        bodyFontFamily = 'AGaramondProRegular';
        labelFontFamily = 'AGaramondProRegular';
    }

    canvasValues.nameSize = 12;
    if (canvasValues.fontType === 'serif') {
        canvasValues.nameSize = 13;
    }
    backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 20);
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 11;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 12;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 20.5);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 10;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 10.5;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 21);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 9;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 10;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 21.5);
    }
    backDataLayer.add(backNameText);

    let y = 49;
    const sizes = calculateFontSizeForTitlesP9T18();

    canvasValues.titlesSize = sizes.titlesSize;
    canvasValues.yStep = sizes.yStep;
    canvasValues.sectionStep = sizes.sectionStep;
    canvasValues.phoneLabelSize = sizes.phoneLabelSize;
    canvasValues.phoneLabelX = sizes.phoneLabelX;
    canvasValues.phoneLabelY = sizes.phoneLabelY;

    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText(titleFontFamily, sizes.titlesSize, canvasValues.primaryTitle, 29, y);
        backDataLayer.add(backPrimaryTitleText);
        y += sizes.yStep;
    }
    if (canvasValues.title1 !== '') {
        backTitle1Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title1, 29, y);
        backDataLayer.add(backTitle1Text);
        y += sizes.yStep;
    }
    if (canvasValues.title2 !== '') {
        backTitle2Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title2, 29, y);
        backDataLayer.add(backTitle2Text);
        y += sizes.yStep;
    }
    if (canvasValues.title3 !== '') {
        backTitle3Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title3, 29, y);
        backDataLayer.add(backTitle3Text);
        y += sizes.yStep;
    }

    canvasValues.backDividers = {};

    y += sizes.sectionStep;
    if (canvasValues.email !== '') {
        backEmailText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.email, 29, y);
        backDataLayer.add(backEmailText);
        y += sizes.yStep;
    }
    if (canvasValues.main !== '') {
        const letterSpacing = 0.1;
        backMainText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.main, 29, y, '#000', letterSpacing);
        backDataLayer.add(backMainText);

        let phoneLabel = canvasValues.phoneLabel1.toUpperCase();
        if (canvasValues.phoneLabel1 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel1.toUpperCase();
        }

        let x = backMainText.text().length * sizes.phoneLabelSize + sizes.phoneLabelX;
        backMainSuffixText = createText(labelFontFamily, sizes.phoneLabelSize, phoneLabel, x, y + sizes.phoneLabelY);
        backDataLayer.add(backMainSuffixText);
        y += sizes.yStep;

        canvasValues.backDividers.mainSuffix = backMainSuffixText.x() / scale;
    }
    if (canvasValues.cell !== '') {
        const letterSpacing = 0.1;
        backCellText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.cell, 29, y, '#000', letterSpacing);
        backDataLayer.add(backCellText);

        let phoneLabel = canvasValues.phoneLabel2.toUpperCase();
        if (canvasValues.phoneLabel2 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel2.toUpperCase();
        }

        let x = backCellText.text().length * sizes.phoneLabelSize + sizes.phoneLabelX;
        backCellSuffixText = createText(labelFontFamily, sizes.phoneLabelSize, phoneLabel, x, y + sizes.phoneLabelY);
        backDataLayer.add(backCellSuffixText);
        y += sizes.yStep;

        canvasValues.backDividers.cellSuffix = backCellSuffixText.x() / scale;
    }
    if (canvasValues.website !== '') {
        backWebsiteText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.website, 29, y);
        backDataLayer.add(backWebsiteText);
    }
}

export const calculateFontSizeForTitlesP9T18 = () => {
    let fontFamily = 'UniversLTStd';
    let sizes = [9, 9, 9, 9, 9];
    if (canvasValues.fontType === 'serif') {
        fontFamily = 'AGaramondProRegular';
        sizes = [11, 11, 11, 11, 11];
    }

    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 20);
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 10;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 20.5);
        }
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 9;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 21);
        }
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 8;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 21);
        }
    }

    if (canvasValues.title1 !== '') {
        backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 20);
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 10;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 20.5);
        }
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 9;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 21);
        }
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 8;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 21);
        }
    }

    if (canvasValues.title2 !== '') {
        backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 20);
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 10;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 20.5);
        }
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 9;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 21);
        }
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 8;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 21);
        }
    }

    if (canvasValues.title3 !== '') {
        backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 20);
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 10;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 20.5);
        }
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 9;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 21);
        }
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 8;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 21);
        }
    }

    if (canvasValues.website !== '') {
        backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 20);
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 10;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 20.5);
        }
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 9;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 21);
        }
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 8;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 21);
        }
    }

    const min = Math.min(...sizes);

    if (canvasValues.fontType === 'serif') {
        if (min === 11) {
            return {
                titlesSize: min,
                yStep: 16,
                sectionStep: 10,
                phoneLabelSize: 8,
                phoneLabelX: 23,
                phoneLabelY: 2.2,
            };
        } else if (min === 10) {
            return {
                titlesSize: min,
                yStep: 14,
                sectionStep: 10,
                phoneLabelSize: 7,
                phoneLabelX: 27,
                phoneLabelY: 2.5,
            };
        } else if (min === 9) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 10,
                phoneLabelSize: 6.5,
                phoneLabelX: 25,
                phoneLabelY: 2.5,
            };
        } else if (min === 8) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 9,
                phoneLabelSize: 6.5,
                phoneLabelX: 17,
                phoneLabelY: 1.6,
            };
        }
    } else {
        if (min === 9) {
            return {
                titlesSize: min,
                yStep: 16,
                sectionStep: 10,
                phoneLabelSize: 6,
                phoneLabelX: 38,
                phoneLabelY: 2,
            };
        } else if (min === 8) {
            return {
                titlesSize: min,
                yStep: 14,
                sectionStep: 9,
                phoneLabelSize: 5.5,
                phoneLabelX: 36,
                phoneLabelY: 2,
            };
        } else if (min === 7) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 9,
                phoneLabelSize: 5,
                phoneLabelX: 34,
                phoneLabelY: 1.6,
            };
        }
    }

    return {
        titlesSize: min,
        yStep: 16,
        sectionStep: 10,
        phoneLabelSize: 6,
        phoneLabelX: 38,
        phoneLabelY: 2,
    };
}

export const destroyBackVariablesP9T18 = () => {
    if (backNameText) {
        backNameText.destroy();
    }
    if (backPrimaryTitleText) {
        backPrimaryTitleText.destroy();
    }
    if (backTitle1Text) {
        backTitle1Text.destroy();
    }
    if (backTitle2Text) {
        backTitle2Text.destroy();
    }
    if (backTitle3Text) {
        backTitle3Text.destroy();
    }
    if (backSecondaryTitleText) {
        backSecondaryTitleText.destroy();
    }
    if (backTitle4Text) {
        backTitle4Text.destroy();
    }
    if (backEmailText) {
        backEmailText.destroy();
    }
    if (backMainText) {
        backMainText.destroy();
    }
    if (backDirectText) {
        backDirectText.destroy();
    }
    if (backCellText) {
        backCellText.destroy();
    }
    if (backWebsiteText) {
        backWebsiteText.destroy();
    }
    if (backMainSuffixText) {
        backMainSuffixText.destroy();
    }
    if (backDirectSuffixText) {
        backDirectSuffixText.destroy();
    }
    if (backCellSuffixText) {
        backCellSuffixText.destroy();
    }
    if (backLogoImage) {
        backLogoImage.destroy();
    }
}

export const initP9T19BackCanvas = () => {
    drawBackVariablesP9T19();
}

export const drawBackVariablesP9T19 = () => {
    let back = '';
    if (canvasValues.back !== '') {
        back = parseInt(canvasValues.back);
    }

    let backUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/back-background.svg';

    Konva.Image.fromURL(backUrl, (image) => {
        if (backLogoImage != null) {
            backLogoImage.destroy();
        }
        backLogoImage = image;

        backBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 408 * scale,
            height: 258 * scale,
        });
        backBackgroundLayer.draw();

        canvasValues.prevBack = back;
    });

    if (back === 2) {
        return;
    }

    let name = canvasValues.firstName;
    if (canvasValues.middleName !== '') {
        name += ' ' + canvasValues.middleName;
    }
    name += ' ' + canvasValues.lastName;
    if (canvasValues.credentials !== '') {
        name += ', ' + canvasValues.credentials;
    }

    let nameFontFamily = 'UniversBold';
    let titleFontFamily = 'UniversBold';
    let bodyFontFamily = 'UniversLTStd';
    let labelFontFamily = 'UniversBold';
    if (canvasValues.fontType === 'serif') {
        nameFontFamily = 'AGaramondProBold';
        titleFontFamily = 'AGaramondProSemibold';
        bodyFontFamily = 'AGaramondProRegular';
        labelFontFamily = 'AGaramondProRegular';
    }

    canvasValues.nameSize = 12;
    if (canvasValues.fontType === 'serif') {
        canvasValues.nameSize = 13;
    }
    backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 20);
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 11;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 12;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 20.5);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 10;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 10.5;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 21);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 9;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 10;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 21.5);
    }
    backDataLayer.add(backNameText);

    let y = 49;
    const sizes = calculateFontSizeForTitlesP9T19();

    canvasValues.titlesSize = sizes.titlesSize;
    canvasValues.yStep = sizes.yStep;
    canvasValues.sectionStep = sizes.sectionStep;
    canvasValues.phoneLabelSize = sizes.phoneLabelSize;
    canvasValues.phoneLabelX = sizes.phoneLabelX;
    canvasValues.phoneLabelY = sizes.phoneLabelY;

    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText(titleFontFamily, sizes.titlesSize, canvasValues.primaryTitle, 29, y);
        backDataLayer.add(backPrimaryTitleText);
        y += sizes.yStep;
    }
    if (canvasValues.title1 !== '') {
        backTitle1Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title1, 29, y);
        backDataLayer.add(backTitle1Text);
        y += sizes.yStep;
    }
    if (canvasValues.title2 !== '') {
        backTitle2Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title2, 29, y);
        backDataLayer.add(backTitle2Text);
        y += sizes.yStep;
    }
    if (canvasValues.title3 !== '') {
        backTitle3Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title3, 29, y);
        backDataLayer.add(backTitle3Text);
        y += sizes.yStep;
    }

    canvasValues.backDividers = {};

    y += sizes.sectionStep;
    if (canvasValues.email !== '') {
        backEmailText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.email, 29, y);
        backDataLayer.add(backEmailText);
        y += sizes.yStep;
    }
    if (canvasValues.main !== '') {
        const letterSpacing = 0.1;
        backMainText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.main, 29, y, '#000', letterSpacing);
        backDataLayer.add(backMainText);

        let phoneLabel = canvasValues.phoneLabel1.toUpperCase();
        if (canvasValues.phoneLabel1 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel1.toUpperCase();
        }

        let x = backMainText.text().length * sizes.phoneLabelSize + sizes.phoneLabelX;
        backMainSuffixText = createText(labelFontFamily, sizes.phoneLabelSize, phoneLabel, x, y + sizes.phoneLabelY);
        backDataLayer.add(backMainSuffixText);
        y += sizes.yStep;

        canvasValues.backDividers.mainSuffix = backMainSuffixText.x() / scale;
    }
    if (canvasValues.cell !== '') {
        const letterSpacing = 0.1;
        backCellText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.cell, 29, y, '#000', letterSpacing);
        backDataLayer.add(backCellText);

        let phoneLabel = canvasValues.phoneLabel2.toUpperCase();
        if (canvasValues.phoneLabel2 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel2.toUpperCase();
        }

        let x = backCellText.text().length * sizes.phoneLabelSize + sizes.phoneLabelX;
        backCellSuffixText = createText(labelFontFamily, sizes.phoneLabelSize, phoneLabel, x, y + sizes.phoneLabelY);
        backDataLayer.add(backCellSuffixText);
        y += sizes.yStep;

        canvasValues.backDividers.cellSuffix = backCellSuffixText.x() / scale;
    }
    if (canvasValues.website !== '') {
        backWebsiteText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.website, 29, y);
        backDataLayer.add(backWebsiteText);
    }
}

export const calculateFontSizeForTitlesP9T19 = () => {
    let fontFamily = 'UniversLTStd';
    let sizes = [9, 9, 9, 9, 9];
    if (canvasValues.fontType === 'serif') {
        fontFamily = 'AGaramondProRegular';
        sizes = [11, 11, 11, 11, 11];
    }

    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 20);
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 10;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 20.5);
        }
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 9;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 21);
        }
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 8;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 21);
        }
    }

    if (canvasValues.title1 !== '') {
        backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 20);
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 10;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 20.5);
        }
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 9;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 21);
        }
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 8;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 21);
        }
    }

    if (canvasValues.title2 !== '') {
        backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 20);
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 10;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 20.5);
        }
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 9;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 21);
        }
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 8;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 21);
        }
    }

    if (canvasValues.title3 !== '') {
        backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 20);
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 10;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 20.5);
        }
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 9;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 21);
        }
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 8;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 21);
        }
    }

    if (canvasValues.website !== '') {
        backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 20);
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 10;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 20.5);
        }
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 9;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 21);
        }
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 8;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 21);
        }
    }

    const min = Math.min(...sizes);

    if (canvasValues.fontType === 'serif') {
        if (min === 11) {
            return {
                titlesSize: min,
                yStep: 16,
                sectionStep: 10,
                phoneLabelSize: 8,
                phoneLabelX: 23,
                phoneLabelY: 2.2,
            };
        } else if (min === 10) {
            return {
                titlesSize: min,
                yStep: 14,
                sectionStep: 10,
                phoneLabelSize: 7,
                phoneLabelX: 27,
                phoneLabelY: 2.5,
            };
        } else if (min === 9) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 10,
                phoneLabelSize: 6.5,
                phoneLabelX: 25,
                phoneLabelY: 2.5,
            };
        } else if (min === 8) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 9,
                phoneLabelSize: 6.5,
                phoneLabelX: 17,
                phoneLabelY: 1.6,
            };
        }
    } else {
        if (min === 9) {
            return {
                titlesSize: min,
                yStep: 16,
                sectionStep: 10,
                phoneLabelSize: 6,
                phoneLabelX: 38,
                phoneLabelY: 2,
            };
        } else if (min === 8) {
            return {
                titlesSize: min,
                yStep: 14,
                sectionStep: 9,
                phoneLabelSize: 5.5,
                phoneLabelX: 36,
                phoneLabelY: 2,
            };
        } else if (min === 7) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 9,
                phoneLabelSize: 5,
                phoneLabelX: 34,
                phoneLabelY: 1.6,
            };
        }
    }

    return {
        titlesSize: min,
        yStep: 16,
        sectionStep: 10,
        phoneLabelSize: 6,
        phoneLabelX: 38,
        phoneLabelY: 2,
    };
}

export const destroyBackVariablesP9T19 = () => {
    if (backNameText) {
        backNameText.destroy();
    }
    if (backPrimaryTitleText) {
        backPrimaryTitleText.destroy();
    }
    if (backTitle1Text) {
        backTitle1Text.destroy();
    }
    if (backTitle2Text) {
        backTitle2Text.destroy();
    }
    if (backTitle3Text) {
        backTitle3Text.destroy();
    }
    if (backSecondaryTitleText) {
        backSecondaryTitleText.destroy();
    }
    if (backTitle4Text) {
        backTitle4Text.destroy();
    }
    if (backEmailText) {
        backEmailText.destroy();
    }
    if (backMainText) {
        backMainText.destroy();
    }
    if (backDirectText) {
        backDirectText.destroy();
    }
    if (backCellText) {
        backCellText.destroy();
    }
    if (backWebsiteText) {
        backWebsiteText.destroy();
    }
    if (backMainSuffixText) {
        backMainSuffixText.destroy();
    }
    if (backDirectSuffixText) {
        backDirectSuffixText.destroy();
    }
    if (backCellSuffixText) {
        backCellSuffixText.destroy();
    }
    if (backLogoImage) {
        backLogoImage.destroy();
    }
}

export const initP9T20BackCanvas = () => {
    drawBackVariablesP9T20();
}

export const drawBackVariablesP9T20 = () => {
    let back = '';
    if (canvasValues.back !== '') {
        back = parseInt(canvasValues.back);
    }

    let backUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/back-background.svg';

    Konva.Image.fromURL(backUrl, (image) => {
        if (backLogoImage != null) {
            backLogoImage.destroy();
        }
        backLogoImage = image;

        backBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 408 * scale,
            height: 258 * scale,
        });
        backBackgroundLayer.draw();

        canvasValues.prevBack = back;
    });

    if (back === 2) {
        return;
    }

    let name = canvasValues.firstName;
    if (canvasValues.middleName !== '') {
        name += ' ' + canvasValues.middleName;
    }
    name += ' ' + canvasValues.lastName;
    if (canvasValues.credentials !== '') {
        name += ', ' + canvasValues.credentials;
    }

    let nameFontFamily = 'UniversBold';
    let titleFontFamily = 'UniversBold';
    let bodyFontFamily = 'UniversLTStd';
    let labelFontFamily = 'UniversBold';
    if (canvasValues.fontType === 'serif') {
        nameFontFamily = 'AGaramondProBold';
        titleFontFamily = 'AGaramondProSemibold';
        bodyFontFamily = 'AGaramondProRegular';
        labelFontFamily = 'AGaramondProRegular';
    }

    canvasValues.nameSize = 12;
    if (canvasValues.fontType === 'serif') {
        canvasValues.nameSize = 13;
    }
    backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 20);
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 11;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 12;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 20.5);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 10;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 10.5;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 21);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 9;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 10;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 21.5);
    }
    backDataLayer.add(backNameText);

    let y = 49;
    const sizes = calculateFontSizeForTitlesP9T20();

    canvasValues.titlesSize = sizes.titlesSize;
    canvasValues.yStep = sizes.yStep;
    canvasValues.sectionStep = sizes.sectionStep;
    canvasValues.phoneLabelSize = sizes.phoneLabelSize;
    canvasValues.phoneLabelX = sizes.phoneLabelX;
    canvasValues.phoneLabelY = sizes.phoneLabelY;

    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText(titleFontFamily, sizes.titlesSize, canvasValues.primaryTitle, 29, y);
        backDataLayer.add(backPrimaryTitleText);
        y += sizes.yStep;
    }
    if (canvasValues.title1 !== '') {
        backTitle1Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title1, 29, y);
        backDataLayer.add(backTitle1Text);
        y += sizes.yStep;
    }
    if (canvasValues.title2 !== '') {
        backTitle2Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title2, 29, y);
        backDataLayer.add(backTitle2Text);
        y += sizes.yStep;
    }
    if (canvasValues.title3 !== '') {
        backTitle3Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title3, 29, y);
        backDataLayer.add(backTitle3Text);
        y += sizes.yStep;
    }

    canvasValues.backDividers = {};

    y += sizes.sectionStep;
    if (canvasValues.email !== '') {
        backEmailText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.email, 29, y);
        backDataLayer.add(backEmailText);
        y += sizes.yStep;
    }
    if (canvasValues.main !== '') {
        const letterSpacing = 0.1;
        backMainText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.main, 29, y, '#000', letterSpacing);
        backDataLayer.add(backMainText);

        let phoneLabel = canvasValues.phoneLabel1.toUpperCase();
        if (canvasValues.phoneLabel1 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel1.toUpperCase();
        }

        let x = backMainText.text().length * sizes.phoneLabelSize + sizes.phoneLabelX;
        backMainSuffixText = createText(labelFontFamily, sizes.phoneLabelSize, phoneLabel, x, y + sizes.phoneLabelY);
        backDataLayer.add(backMainSuffixText);
        y += sizes.yStep;

        canvasValues.backDividers.mainSuffix = backMainSuffixText.x() / scale;
    }
    if (canvasValues.cell !== '') {
        const letterSpacing = 0.1;
        backCellText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.cell, 29, y, '#000', letterSpacing);
        backDataLayer.add(backCellText);

        let phoneLabel = canvasValues.phoneLabel2.toUpperCase();
        if (canvasValues.phoneLabel2 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel2.toUpperCase();
        }

        let x = backCellText.text().length * sizes.phoneLabelSize + sizes.phoneLabelX;
        backCellSuffixText = createText(labelFontFamily, sizes.phoneLabelSize, phoneLabel, x, y + sizes.phoneLabelY);
        backDataLayer.add(backCellSuffixText);
        y += sizes.yStep;

        canvasValues.backDividers.cellSuffix = backCellSuffixText.x() / scale;
    }
    if (canvasValues.website !== '') {
        backWebsiteText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.website, 29, y);
        backDataLayer.add(backWebsiteText);
    }
}

export const calculateFontSizeForTitlesP9T20 = () => {
    let fontFamily = 'UniversLTStd';
    let sizes = [9, 9, 9, 9, 9];
    if (canvasValues.fontType === 'serif') {
        fontFamily = 'AGaramondProRegular';
        sizes = [11, 11, 11, 11, 11];
    }

    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 20);
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 10;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 20.5);
        }
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 9;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 21);
        }
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 8;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 21);
        }
    }

    if (canvasValues.title1 !== '') {
        backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 20);
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 10;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 20.5);
        }
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 9;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 21);
        }
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 8;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 21);
        }
    }

    if (canvasValues.title2 !== '') {
        backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 20);
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 10;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 20.5);
        }
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 9;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 21);
        }
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 8;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 21);
        }
    }

    if (canvasValues.title3 !== '') {
        backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 20);
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 10;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 20.5);
        }
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 9;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 21);
        }
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 8;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 21);
        }
    }

    if (canvasValues.website !== '') {
        backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 20);
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 10;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 20.5);
        }
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 9;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 21);
        }
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 8;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 21);
        }
    }

    const min = Math.min(...sizes);

    if (canvasValues.fontType === 'serif') {
        if (min === 11) {
            return {
                titlesSize: min,
                yStep: 16,
                sectionStep: 10,
                phoneLabelSize: 8,
                phoneLabelX: 23,
                phoneLabelY: 2.2,
            };
        } else if (min === 10) {
            return {
                titlesSize: min,
                yStep: 14,
                sectionStep: 10,
                phoneLabelSize: 7,
                phoneLabelX: 27,
                phoneLabelY: 2.5,
            };
        } else if (min === 9) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 10,
                phoneLabelSize: 6.5,
                phoneLabelX: 25,
                phoneLabelY: 2.5,
            };
        } else if (min === 8) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 9,
                phoneLabelSize: 6.5,
                phoneLabelX: 17,
                phoneLabelY: 1.6,
            };
        }
    } else {
        if (min === 9) {
            return {
                titlesSize: min,
                yStep: 16,
                sectionStep: 10,
                phoneLabelSize: 6,
                phoneLabelX: 38,
                phoneLabelY: 2,
            };
        } else if (min === 8) {
            return {
                titlesSize: min,
                yStep: 14,
                sectionStep: 9,
                phoneLabelSize: 5.5,
                phoneLabelX: 36,
                phoneLabelY: 2,
            };
        } else if (min === 7) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 9,
                phoneLabelSize: 5,
                phoneLabelX: 34,
                phoneLabelY: 1.6,
            };
        }
    }

    return {
        titlesSize: min,
        yStep: 16,
        sectionStep: 10,
        phoneLabelSize: 6,
        phoneLabelX: 38,
        phoneLabelY: 2,
    };
}

export const destroyBackVariablesP9T20 = () => {
    if (backNameText) {
        backNameText.destroy();
    }
    if (backPrimaryTitleText) {
        backPrimaryTitleText.destroy();
    }
    if (backTitle1Text) {
        backTitle1Text.destroy();
    }
    if (backTitle2Text) {
        backTitle2Text.destroy();
    }
    if (backTitle3Text) {
        backTitle3Text.destroy();
    }
    if (backSecondaryTitleText) {
        backSecondaryTitleText.destroy();
    }
    if (backTitle4Text) {
        backTitle4Text.destroy();
    }
    if (backEmailText) {
        backEmailText.destroy();
    }
    if (backMainText) {
        backMainText.destroy();
    }
    if (backDirectText) {
        backDirectText.destroy();
    }
    if (backCellText) {
        backCellText.destroy();
    }
    if (backWebsiteText) {
        backWebsiteText.destroy();
    }
    if (backMainSuffixText) {
        backMainSuffixText.destroy();
    }
    if (backDirectSuffixText) {
        backDirectSuffixText.destroy();
    }
    if (backCellSuffixText) {
        backCellSuffixText.destroy();
    }
    if (backLogoImage) {
        backLogoImage.destroy();
    }
}

export const initP9T21BackCanvas = () => {
    drawBackVariablesP9T21();
}

export const drawBackVariablesP9T21 = () => {
    let back = '';
    if (canvasValues.back !== '') {
        back = parseInt(canvasValues.back);
    }

    let backUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/back-background.svg';

    Konva.Image.fromURL(backUrl, (image) => {
        if (backLogoImage != null) {
            backLogoImage.destroy();
        }
        backLogoImage = image;

        backBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 408 * scale,
            height: 258 * scale,
        });
        backBackgroundLayer.draw();

        canvasValues.prevBack = back;
    });

    if (back === 2) {
        return;
    }

    let name = canvasValues.firstName;
    if (canvasValues.middleName !== '') {
        name += ' ' + canvasValues.middleName;
    }
    name += ' ' + canvasValues.lastName;
    if (canvasValues.credentials !== '') {
        name += ', ' + canvasValues.credentials;
    }

    let nameFontFamily = 'UniversBold';
    let titleFontFamily = 'UniversBold';
    let bodyFontFamily = 'UniversLTStd';
    let labelFontFamily = 'UniversBold';
    if (canvasValues.fontType === 'serif') {
        nameFontFamily = 'AGaramondProBold';
        titleFontFamily = 'AGaramondProSemibold';
        bodyFontFamily = 'AGaramondProRegular';
        labelFontFamily = 'AGaramondProRegular';
    }

    canvasValues.nameSize = 12;
    if (canvasValues.fontType === 'serif') {
        canvasValues.nameSize = 13;
    }
    backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 20);
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 11;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 12;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 20.5);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 10;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 10.5;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 21);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 9;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 10;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 21.5);
    }
    backDataLayer.add(backNameText);

    let y = 49;
    const sizes = calculateFontSizeForTitlesP9T21();

    canvasValues.titlesSize = sizes.titlesSize;
    canvasValues.yStep = sizes.yStep;
    canvasValues.sectionStep = sizes.sectionStep;
    canvasValues.phoneLabelSize = sizes.phoneLabelSize;
    canvasValues.phoneLabelX = sizes.phoneLabelX;
    canvasValues.phoneLabelY = sizes.phoneLabelY;

    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText(titleFontFamily, sizes.titlesSize, canvasValues.primaryTitle, 29, y);
        backDataLayer.add(backPrimaryTitleText);
        y += sizes.yStep;
    }
    if (canvasValues.title1 !== '') {
        backTitle1Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title1, 29, y);
        backDataLayer.add(backTitle1Text);
        y += sizes.yStep;
    }
    if (canvasValues.title2 !== '') {
        backTitle2Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title2, 29, y);
        backDataLayer.add(backTitle2Text);
        y += sizes.yStep;
    }
    if (canvasValues.title3 !== '') {
        backTitle3Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title3, 29, y);
        backDataLayer.add(backTitle3Text);
        y += sizes.yStep;
    }

    canvasValues.backDividers = {};

    y += sizes.sectionStep;
    if (canvasValues.email !== '') {
        backEmailText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.email, 29, y);
        backDataLayer.add(backEmailText);
        y += sizes.yStep;
    }
    if (canvasValues.main !== '') {
        const letterSpacing = 0.1;
        backMainText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.main, 29, y, '#000', letterSpacing);
        backDataLayer.add(backMainText);

        let phoneLabel = canvasValues.phoneLabel1.toUpperCase();
        if (canvasValues.phoneLabel1 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel1.toUpperCase();
        }

        let x = backMainText.text().length * sizes.phoneLabelSize + sizes.phoneLabelX;
        backMainSuffixText = createText(labelFontFamily, sizes.phoneLabelSize, phoneLabel, x, y + sizes.phoneLabelY);
        backDataLayer.add(backMainSuffixText);
        y += sizes.yStep;

        canvasValues.backDividers.mainSuffix = backMainSuffixText.x() / scale;
    }
    if (canvasValues.cell !== '') {
        const letterSpacing = 0.1;
        backCellText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.cell, 29, y, '#000', letterSpacing);
        backDataLayer.add(backCellText);

        let phoneLabel = canvasValues.phoneLabel2.toUpperCase();
        if (canvasValues.phoneLabel2 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel2.toUpperCase();
        }

        let x = backCellText.text().length * sizes.phoneLabelSize + sizes.phoneLabelX;
        backCellSuffixText = createText(labelFontFamily, sizes.phoneLabelSize, phoneLabel, x, y + sizes.phoneLabelY);
        backDataLayer.add(backCellSuffixText);
        y += sizes.yStep;

        canvasValues.backDividers.cellSuffix = backCellSuffixText.x() / scale;
    }
    if (canvasValues.website !== '') {
        backWebsiteText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.website, 29, y);
        backDataLayer.add(backWebsiteText);
    }
}

export const calculateFontSizeForTitlesP9T21 = () => {
    let fontFamily = 'UniversLTStd';
    let sizes = [9, 9, 9, 9, 9];
    if (canvasValues.fontType === 'serif') {
        fontFamily = 'AGaramondProRegular';
        sizes = [11, 11, 11, 11, 11];
    }

    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 20);
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 10;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 20.5);
        }
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 9;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 21);
        }
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 8;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 21);
        }
    }

    if (canvasValues.title1 !== '') {
        backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 20);
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 10;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 20.5);
        }
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 9;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 21);
        }
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 8;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 21);
        }
    }

    if (canvasValues.title2 !== '') {
        backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 20);
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 10;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 20.5);
        }
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 9;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 21);
        }
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 8;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 21);
        }
    }

    if (canvasValues.title3 !== '') {
        backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 20);
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 10;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 20.5);
        }
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 9;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 21);
        }
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 8;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 21);
        }
    }

    if (canvasValues.website !== '') {
        backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 20);
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 10;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 20.5);
        }
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 9;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 21);
        }
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 8;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 21);
        }
    }

    const min = Math.min(...sizes);

    if (canvasValues.fontType === 'serif') {
        if (min === 11) {
            return {
                titlesSize: min,
                yStep: 16,
                sectionStep: 10,
                phoneLabelSize: 8,
                phoneLabelX: 23,
                phoneLabelY: 2.2,
            };
        } else if (min === 10) {
            return {
                titlesSize: min,
                yStep: 14,
                sectionStep: 10,
                phoneLabelSize: 7,
                phoneLabelX: 27,
                phoneLabelY: 2.5,
            };
        } else if (min === 9) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 10,
                phoneLabelSize: 6.5,
                phoneLabelX: 25,
                phoneLabelY: 2.5,
            };
        } else if (min === 8) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 9,
                phoneLabelSize: 6.5,
                phoneLabelX: 17,
                phoneLabelY: 1.6,
            };
        }
    } else {
        if (min === 9) {
            return {
                titlesSize: min,
                yStep: 16,
                sectionStep: 10,
                phoneLabelSize: 6,
                phoneLabelX: 38,
                phoneLabelY: 2,
            };
        } else if (min === 8) {
            return {
                titlesSize: min,
                yStep: 14,
                sectionStep: 9,
                phoneLabelSize: 5.5,
                phoneLabelX: 36,
                phoneLabelY: 2,
            };
        } else if (min === 7) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 9,
                phoneLabelSize: 5,
                phoneLabelX: 34,
                phoneLabelY: 1.6,
            };
        }
    }

    return {
        titlesSize: min,
        yStep: 16,
        sectionStep: 10,
        phoneLabelSize: 6,
        phoneLabelX: 38,
        phoneLabelY: 2,
    };
}

export const destroyBackVariablesP9T21 = () => {
    if (backNameText) {
        backNameText.destroy();
    }
    if (backPrimaryTitleText) {
        backPrimaryTitleText.destroy();
    }
    if (backTitle1Text) {
        backTitle1Text.destroy();
    }
    if (backTitle2Text) {
        backTitle2Text.destroy();
    }
    if (backTitle3Text) {
        backTitle3Text.destroy();
    }
    if (backSecondaryTitleText) {
        backSecondaryTitleText.destroy();
    }
    if (backTitle4Text) {
        backTitle4Text.destroy();
    }
    if (backEmailText) {
        backEmailText.destroy();
    }
    if (backMainText) {
        backMainText.destroy();
    }
    if (backDirectText) {
        backDirectText.destroy();
    }
    if (backCellText) {
        backCellText.destroy();
    }
    if (backWebsiteText) {
        backWebsiteText.destroy();
    }
    if (backMainSuffixText) {
        backMainSuffixText.destroy();
    }
    if (backDirectSuffixText) {
        backDirectSuffixText.destroy();
    }
    if (backCellSuffixText) {
        backCellSuffixText.destroy();
    }
    if (backLogoImage) {
        backLogoImage.destroy();
    }
}

export const initP9T22BackCanvas = () => {
    drawBackVariablesP9T22();
}

export const drawBackVariablesP9T22 = () => {
    let back = '';
    if (canvasValues.back !== '') {
        back = parseInt(canvasValues.back);
    }

    let backUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/back-background.svg';
    if (back === 1) {
        backUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/back-background.svg';
    } else if (back === 2) {
        backUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/health-services-appointment-card.svg';
    }

    Konva.Image.fromURL(backUrl, (image) => {
        if (backLogoImage != null) {
            backLogoImage.destroy();
        }
        backLogoImage = image;

        backBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 408 * scale,
            height: 258 * scale,
        });
        backBackgroundLayer.draw();

        canvasValues.prevBack = back;
    });

    if (back === 2) {
        return;
    }

    let name = canvasValues.firstName;
    if (canvasValues.middleName !== '') {
        name += ' ' + canvasValues.middleName;
    }
    name += ' ' + canvasValues.lastName;
    if (canvasValues.credentials !== '') {
        name += ', ' + canvasValues.credentials;
    }

    let nameFontFamily = 'UniversBold';
    let titleFontFamily = 'UniversBold';
    let bodyFontFamily = 'UniversLTStd';
    let labelFontFamily = 'UniversBold';
    if (canvasValues.fontType === 'serif') {
        nameFontFamily = 'AGaramondProBold';
        titleFontFamily = 'AGaramondProSemibold';
        bodyFontFamily = 'AGaramondProRegular';
        labelFontFamily = 'AGaramondProRegular';
    }

    canvasValues.nameSize = 12;
    if (canvasValues.fontType === 'serif') {
        canvasValues.nameSize = 13;
    }
    backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 20);
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 11;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 12;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 20.5);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 10;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 10.5;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 21);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 9;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 10;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 21.5);
    }
    backDataLayer.add(backNameText);

    let y = 49;
    const sizes = calculateFontSizeForTitlesP9T22();

    canvasValues.titlesSize = sizes.titlesSize;
    canvasValues.yStep = sizes.yStep;
    canvasValues.sectionStep = sizes.sectionStep;
    canvasValues.phoneLabelSize = sizes.phoneLabelSize;
    canvasValues.phoneLabelX = sizes.phoneLabelX;
    canvasValues.phoneLabelY = sizes.phoneLabelY;

    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText(titleFontFamily, sizes.titlesSize, canvasValues.primaryTitle, 29, y);
        backDataLayer.add(backPrimaryTitleText);
        y += sizes.yStep;
    }
    if (canvasValues.title1 !== '') {
        backTitle1Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title1, 29, y);
        backDataLayer.add(backTitle1Text);
        y += sizes.yStep;
    }
    if (canvasValues.title2 !== '') {
        backTitle2Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title2, 29, y);
        backDataLayer.add(backTitle2Text);
        y += sizes.yStep;
    }
    if (canvasValues.title3 !== '') {
        backTitle3Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title3, 29, y);
        backDataLayer.add(backTitle3Text);
        y += sizes.yStep;
    }

    canvasValues.backDividers = {};

    y += sizes.sectionStep;
    if (canvasValues.email !== '') {
        backEmailText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.email, 29, y);
        backDataLayer.add(backEmailText);
        y += sizes.yStep;
    }
    if (canvasValues.main !== '') {
        const letterSpacing = 0.1;
        backMainText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.main, 29, y, '#000', letterSpacing);
        backDataLayer.add(backMainText);

        let phoneLabel = canvasValues.phoneLabel1.toUpperCase();
        if (canvasValues.phoneLabel1 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel1.toUpperCase();
        }

        let x = backMainText.text().length * sizes.phoneLabelSize + sizes.phoneLabelX;
        backMainSuffixText = createText(labelFontFamily, sizes.phoneLabelSize, phoneLabel, x, y + sizes.phoneLabelY);
        backDataLayer.add(backMainSuffixText);
        y += sizes.yStep;

        canvasValues.backDividers.mainSuffix = backMainSuffixText.x() / scale;
    }
    if (canvasValues.cell !== '') {
        const letterSpacing = 0.1;
        backCellText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.cell, 29, y, '#000', letterSpacing);
        backDataLayer.add(backCellText);

        let phoneLabel = canvasValues.phoneLabel2.toUpperCase();
        if (canvasValues.phoneLabel2 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel2.toUpperCase();
        }

        let x = backCellText.text().length * sizes.phoneLabelSize + sizes.phoneLabelX;
        backCellSuffixText = createText(labelFontFamily, sizes.phoneLabelSize, phoneLabel, x, y + sizes.phoneLabelY);
        backDataLayer.add(backCellSuffixText);
        y += sizes.yStep;

        canvasValues.backDividers.cellSuffix = backCellSuffixText.x() / scale;
    }
    if (canvasValues.website !== '') {
        backWebsiteText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.website, 29, y);
        backDataLayer.add(backWebsiteText);
    }
}

export const calculateFontSizeForTitlesP9T22 = () => {
    let fontFamily = 'UniversLTStd';
    let sizes = [9, 9, 9, 9, 9];
    if (canvasValues.fontType === 'serif') {
        fontFamily = 'AGaramondProRegular';
        sizes = [11, 11, 11, 11, 11];
    }

    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 20);
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 10;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 20.5);
        }
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 9;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 21);
        }
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 8;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 21);
        }
    }

    if (canvasValues.title1 !== '') {
        backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 20);
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 10;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 20.5);
        }
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 9;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 21);
        }
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 8;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 21);
        }
    }

    if (canvasValues.title2 !== '') {
        backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 20);
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 10;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 20.5);
        }
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 9;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 21);
        }
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 8;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 21);
        }
    }

    if (canvasValues.title3 !== '') {
        backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 20);
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 10;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 20.5);
        }
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 9;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 21);
        }
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 8;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 21);
        }
    }

    if (canvasValues.website !== '') {
        backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 20);
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 10;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 20.5);
        }
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 9;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 21);
        }
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 8;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 21);
        }
    }

    const min = Math.min(...sizes);

    if (canvasValues.fontType === 'serif') {
        if (min === 11) {
            return {
                titlesSize: min,
                yStep: 16,
                sectionStep: 10,
                phoneLabelSize: 8,
                phoneLabelX: 23,
                phoneLabelY: 2.2,
            };
        } else if (min === 10) {
            return {
                titlesSize: min,
                yStep: 14,
                sectionStep: 10,
                phoneLabelSize: 7,
                phoneLabelX: 27,
                phoneLabelY: 2.5,
            };
        } else if (min === 9) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 10,
                phoneLabelSize: 6.5,
                phoneLabelX: 25,
                phoneLabelY: 2.5,
            };
        } else if (min === 8) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 9,
                phoneLabelSize: 6.5,
                phoneLabelX: 17,
                phoneLabelY: 1.6,
            };
        }
    } else {
        if (min === 9) {
            return {
                titlesSize: min,
                yStep: 16,
                sectionStep: 10,
                phoneLabelSize: 6,
                phoneLabelX: 38,
                phoneLabelY: 2,
            };
        } else if (min === 8) {
            return {
                titlesSize: min,
                yStep: 14,
                sectionStep: 9,
                phoneLabelSize: 5.5,
                phoneLabelX: 36,
                phoneLabelY: 2,
            };
        } else if (min === 7) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 9,
                phoneLabelSize: 5,
                phoneLabelX: 34,
                phoneLabelY: 1.6,
            };
        }
    }

    return {
        titlesSize: min,
        yStep: 16,
        sectionStep: 10,
        phoneLabelSize: 6,
        phoneLabelX: 38,
        phoneLabelY: 2,
    };
}

export const destroyBackVariablesP9T22 = () => {
    if (backNameText) {
        backNameText.destroy();
    }
    if (backPrimaryTitleText) {
        backPrimaryTitleText.destroy();
    }
    if (backTitle1Text) {
        backTitle1Text.destroy();
    }
    if (backTitle2Text) {
        backTitle2Text.destroy();
    }
    if (backTitle3Text) {
        backTitle3Text.destroy();
    }
    if (backSecondaryTitleText) {
        backSecondaryTitleText.destroy();
    }
    if (backTitle4Text) {
        backTitle4Text.destroy();
    }
    if (backEmailText) {
        backEmailText.destroy();
    }
    if (backMainText) {
        backMainText.destroy();
    }
    if (backDirectText) {
        backDirectText.destroy();
    }
    if (backCellText) {
        backCellText.destroy();
    }
    if (backWebsiteText) {
        backWebsiteText.destroy();
    }
    if (backMainSuffixText) {
        backMainSuffixText.destroy();
    }
    if (backDirectSuffixText) {
        backDirectSuffixText.destroy();
    }
    if (backCellSuffixText) {
        backCellSuffixText.destroy();
    }
    if (backLogoImage) {
        backLogoImage.destroy();
    }
}

export const initP9T23BackCanvas = () => {
    drawBackVariablesP9T23();
}

export const drawBackVariablesP9T23 = () => {
    let back = '';
    if (canvasValues.back !== '') {
        back = parseInt(canvasValues.back);
    }

    let backUrl = 'https://ac-ut-health.s3.amazonaws.com/backgrounds/back-background.svg';

    Konva.Image.fromURL(backUrl, (image) => {
        if (backLogoImage != null) {
            backLogoImage.destroy();
        }
        backLogoImage = image;

        backBackgroundLayer.add(image);
        image.setAttrs({
            x: -29 * scale,
            y: -29 * scale,
            width: 408 * scale,
            height: 258 * scale,
        });
        backBackgroundLayer.draw();

        canvasValues.prevBack = back;
    });

    if (back === 2) {
        return;
    }

    let name = canvasValues.firstName;
    if (canvasValues.middleName !== '') {
        name += ' ' + canvasValues.middleName;
    }
    name += ' ' + canvasValues.lastName;
    if (canvasValues.credentials !== '') {
        name += ', ' + canvasValues.credentials;
    }

    let nameFontFamily = 'UniversBold';
    let titleFontFamily = 'UniversBold';
    let bodyFontFamily = 'UniversLTStd';
    let labelFontFamily = 'UniversBold';
    if (canvasValues.fontType === 'serif') {
        nameFontFamily = 'AGaramondProBold';
        titleFontFamily = 'AGaramondProSemibold';
        bodyFontFamily = 'AGaramondProRegular';
        labelFontFamily = 'AGaramondProRegular';
    }

    canvasValues.nameSize = 12;
    if (canvasValues.fontType === 'serif') {
        canvasValues.nameSize = 13;
    }
    backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 20);
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 11;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 12;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 20.5);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 10;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 10.5;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 21);
    }
    if (backNameText.width() / scale > 292) {
        canvasValues.nameSize = 9;
        if (canvasValues.fontType === 'serif') {
            canvasValues.nameSize = 10;
        }
        backNameText = createText(nameFontFamily, canvasValues.nameSize, name, 29, 21.5);
    }
    backDataLayer.add(backNameText);

    let y = 49;
    const sizes = calculateFontSizeForTitlesP9T23();

    canvasValues.titlesSize = sizes.titlesSize;
    canvasValues.yStep = sizes.yStep;
    canvasValues.sectionStep = sizes.sectionStep;
    canvasValues.phoneLabelSize = sizes.phoneLabelSize;
    canvasValues.phoneLabelX = sizes.phoneLabelX;
    canvasValues.phoneLabelY = sizes.phoneLabelY;

    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText(titleFontFamily, sizes.titlesSize, canvasValues.primaryTitle, 29, y);
        backDataLayer.add(backPrimaryTitleText);
        y += sizes.yStep;
    }
    if (canvasValues.title1 !== '') {
        backTitle1Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title1, 29, y);
        backDataLayer.add(backTitle1Text);
        y += sizes.yStep;
    }
    if (canvasValues.title2 !== '') {
        backTitle2Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title2, 29, y);
        backDataLayer.add(backTitle2Text);
        y += sizes.yStep;
    }
    if (canvasValues.title3 !== '') {
        backTitle3Text = createText(bodyFontFamily, sizes.titlesSize, canvasValues.title3, 29, y);
        backDataLayer.add(backTitle3Text);
        y += sizes.yStep;
    }

    canvasValues.backDividers = {};

    y += sizes.sectionStep;
    if (canvasValues.email !== '') {
        backEmailText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.email, 29, y);
        backDataLayer.add(backEmailText);
        y += sizes.yStep;
    }
    if (canvasValues.main !== '') {
        const letterSpacing = 0.1;
        backMainText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.main, 29, y, '#000', letterSpacing);
        backDataLayer.add(backMainText);

        let phoneLabel = canvasValues.phoneLabel1.toUpperCase();
        if (canvasValues.phoneLabel1 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel1.toUpperCase();
        }

        let x = backMainText.text().length * sizes.phoneLabelSize + sizes.phoneLabelX;
        backMainSuffixText = createText(labelFontFamily, sizes.phoneLabelSize, phoneLabel, x, y + sizes.phoneLabelY);
        backDataLayer.add(backMainSuffixText);
        y += sizes.yStep;

        canvasValues.backDividers.mainSuffix = backMainSuffixText.x() / scale;
    }
    if (canvasValues.cell !== '') {
        const letterSpacing = 0.1;
        backCellText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.cell, 29, y, '#000', letterSpacing);
        backDataLayer.add(backCellText);

        let phoneLabel = canvasValues.phoneLabel2.toUpperCase();
        if (canvasValues.phoneLabel2 === 'Other') {
            phoneLabel = canvasValues.phoneOtherLabel2.toUpperCase();
        }

        let x = backCellText.text().length * sizes.phoneLabelSize + sizes.phoneLabelX;
        backCellSuffixText = createText(labelFontFamily, sizes.phoneLabelSize, phoneLabel, x, y + sizes.phoneLabelY);
        backDataLayer.add(backCellSuffixText);
        y += sizes.yStep;

        canvasValues.backDividers.cellSuffix = backCellSuffixText.x() / scale;
    }
    if (canvasValues.website !== '') {
        backWebsiteText = createText(bodyFontFamily, sizes.titlesSize, canvasValues.website, 29, y);
        backDataLayer.add(backWebsiteText);
    }
}

export const calculateFontSizeForTitlesP9T23 = () => {
    let fontFamily = 'UniversLTStd';
    let sizes = [9, 9, 9, 9, 9];
    if (canvasValues.fontType === 'serif') {
        fontFamily = 'AGaramondProRegular';
        sizes = [11, 11, 11, 11, 11];
    }

    if (canvasValues.primaryTitle !== '') {
        backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 20);
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 10;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 20.5);
        }
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 9;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 21);
        }
        if (backPrimaryTitleText.width() / scale > 292) {
            sizes[0] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[0] = 8;
            }
            backPrimaryTitleText = createText(fontFamily, sizes[0], canvasValues.primaryTitle, 29, 21);
        }
    }

    if (canvasValues.title1 !== '') {
        backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 20);
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 10;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 20.5);
        }
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 9;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 21);
        }
        if (backTitle1Text.width() / scale > 292) {
            sizes[1] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[1] = 8;
            }
            backTitle1Text = createText(fontFamily, sizes[1], canvasValues.title1, 29, 21);
        }
    }

    if (canvasValues.title2 !== '') {
        backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 20);
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 10;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 20.5);
        }
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 9;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 21);
        }
        if (backTitle2Text.width() / scale > 292) {
            sizes[2] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[2] = 8;
            }
            backTitle2Text = createText(fontFamily, sizes[2], canvasValues.title2, 29, 21);
        }
    }

    if (canvasValues.title3 !== '') {
        backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 20);
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 10;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 20.5);
        }
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 9;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 21);
        }
        if (backTitle3Text.width() / scale > 292) {
            sizes[3] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[3] = 8;
            }
            backTitle3Text = createText(fontFamily, sizes[3], canvasValues.title3, 29, 21);
        }
    }

    if (canvasValues.website !== '') {
        backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 20);
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 8;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 10;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 20.5);
        }
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 9;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 21);
        }
        if (backSecondaryTitleText.width() / scale > 292) {
            sizes[4] = 7;
            if (canvasValues.fontType === 'serif') {
                sizes[4] = 8;
            }
            backSecondaryTitleText = createText(fontFamily, sizes[4], canvasValues.website, 29, 21);
        }
    }

    const min = Math.min(...sizes);

    if (canvasValues.fontType === 'serif') {
        if (min === 11) {
            return {
                titlesSize: min,
                yStep: 16,
                sectionStep: 10,
                phoneLabelSize: 8,
                phoneLabelX: 23,
                phoneLabelY: 2.2,
            };
        } else if (min === 10) {
            return {
                titlesSize: min,
                yStep: 14,
                sectionStep: 10,
                phoneLabelSize: 7,
                phoneLabelX: 27,
                phoneLabelY: 2.5,
            };
        } else if (min === 9) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 10,
                phoneLabelSize: 6.5,
                phoneLabelX: 25,
                phoneLabelY: 2.5,
            };
        } else if (min === 8) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 9,
                phoneLabelSize: 6.5,
                phoneLabelX: 17,
                phoneLabelY: 1.6,
            };
        }
    } else {
        if (min === 9) {
            return {
                titlesSize: min,
                yStep: 16,
                sectionStep: 10,
                phoneLabelSize: 6,
                phoneLabelX: 38,
                phoneLabelY: 2,
            };
        } else if (min === 8) {
            return {
                titlesSize: min,
                yStep: 14,
                sectionStep: 9,
                phoneLabelSize: 5.5,
                phoneLabelX: 36,
                phoneLabelY: 2,
            };
        } else if (min === 7) {
            return {
                titlesSize: min,
                yStep: 13,
                sectionStep: 9,
                phoneLabelSize: 5,
                phoneLabelX: 34,
                phoneLabelY: 1.6,
            };
        }
    }

    return {
        titlesSize: min,
        yStep: 16,
        sectionStep: 10,
        phoneLabelSize: 6,
        phoneLabelX: 38,
        phoneLabelY: 2,
    };
}

export const destroyBackVariablesP9T23 = () => {
    if (backNameText) {
        backNameText.destroy();
    }
    if (backPrimaryTitleText) {
        backPrimaryTitleText.destroy();
    }
    if (backTitle1Text) {
        backTitle1Text.destroy();
    }
    if (backTitle2Text) {
        backTitle2Text.destroy();
    }
    if (backTitle3Text) {
        backTitle3Text.destroy();
    }
    if (backSecondaryTitleText) {
        backSecondaryTitleText.destroy();
    }
    if (backTitle4Text) {
        backTitle4Text.destroy();
    }
    if (backEmailText) {
        backEmailText.destroy();
    }
    if (backMainText) {
        backMainText.destroy();
    }
    if (backDirectText) {
        backDirectText.destroy();
    }
    if (backCellText) {
        backCellText.destroy();
    }
    if (backWebsiteText) {
        backWebsiteText.destroy();
    }
    if (backMainSuffixText) {
        backMainSuffixText.destroy();
    }
    if (backDirectSuffixText) {
        backDirectSuffixText.destroy();
    }
    if (backCellSuffixText) {
        backCellSuffixText.destroy();
    }
    if (backLogoImage) {
        backLogoImage.destroy();
    }
}

export const createImage = (options) => {
    let imageObj = new Image();
    imageObj.onload = function () {
        let ref = options.ref;
        if (ref == null) {
            ref = { current: null };
        }

        ref.current = new Konva.Image({
            width: options.width * options.scale * scale,
            height: options.height * options.scale * scale,
            image: imageObj,
            x: options.x * scale,
            y: options.y * scale,
            // draggable: true,
        });
        // ref.current.on('dragend', function (e) {
        //     console.log(e.target.attrs.x, e.target.attrs.y)
        // });

        options.layer.add(ref.current);
        options.layer.batchDraw();
    };
    imageObj.crossOrigin = 'Anonymous';
    imageObj.src = 'https://' + process.env.REACT_APP_VDP_S3_BUCKET + '.s3.amazonaws.com/' + options.url;
}

export const drawName = () => {
    let fullName = getFullName();

    frontNameText.text(fullName);
    if (frontNameText.width() > nameLimit) {
        frontNameText.text(canvasValues.name);
        frontCredentialsText.text(canvasValues.credentials);

        if (canvasValues.credentials !== '') {
            frontTitle1Text.y((60 - 12.5) * scale);
        } else {
            frontTitle1Text.y((47 - 12.5) * scale);
        }

        canvasValues.nameDivided = 1;
    } else {
        frontNameText.text(fullName);
        frontCredentialsText.text('');
        frontTitle1Text.y((47 - 12.5) * scale);
        canvasValues.nameDivided = 0;
    }
    backNameText.text(fullName);
}

export const changeNameAll = (value) => {
    canvasValues.name = value;
    redrawFront();
    redrawBack();
}

export const changeName = (value) => {
    canvasValues.name = value;
    if (frontNameText == null || backNameText == null || frontCredentialsText == null || frontTitle1Text == null) {
        return;
    }

    drawName();
    frontDataLayer.batchDraw();
    backDataLayer.batchDraw();
}

export const changeNameP1T3 = (value) => {
    canvasValues.name = value;
    if (frontNameText == null) {
        return;
    }

    frontNameText.text(getFullName());
    frontDataLayer.batchDraw();
}

export const changeNameP1T4 = (value) => {
    canvasValues.name = value;
    redrawFront();
    redrawBack();
}

export const changeNameP1T7 = (value) => {
    canvasValues.name = value;
    redrawFront();
    redrawBack();
}

export const changeCredentialsAll = (value) => {
    canvasValues.credentials = value;
    redrawFront();
    redrawBack();
}

export const changeCredentials = (value) => {
    canvasValues.credentials = value;
    if (frontNameText == null || frontCredentialsText == null || frontTitle1Text == null || backNameText == null) {
        return;
    }

    drawName();
    frontDataLayer.batchDraw();
    backDataLayer.batchDraw();
}

export const changeCredentialsP1T3 = (value) => {
    canvasValues.credentials = value;
    if (frontNameText == null) {
        return;
    }

    frontNameText.text(getFullName());
    frontDataLayer.batchDraw();
}

export const changeCredentialsP1T4 = (value) => {
    canvasValues.credentials = value;
    redrawFront();
    redrawBack();
}

export const changeCredentialsP1T7 = (value) => {
    canvasValues.credentials = value;
    redrawFront();
    redrawBack();
}

export const changeTitle1All = (value) => {
    canvasValues.title1 = value;
    redrawFront();
    redrawBack();
}

export const changeTitle1 = (value) => {
    canvasValues.title1 = value;
    if (frontTitle1Text == null || backTitle1Text == null) {
        return;
    }

    frontTitle1Text.text(value);
    backTitle1Text.text(value);
    frontDataLayer.batchDraw();
    backDataLayer.batchDraw();
}

export const changeTitle1P1T3 = (value) => {
    canvasValues.title1 = value;
    if (frontTitle1Text == null) {
        return;
    }

    frontTitle1Text.text(value);
    frontDataLayer.batchDraw();
}

export const changeTitle1P1T4 = (value) => {
    canvasValues.title1 = value;
    redrawFront();
    redrawBack();
}

export const changeTitle1P1T7 = (value) => {
    canvasValues.title1 = value;
    redrawFront();
    redrawBack();
}

export const changeTitle2All = (value) => {
    canvasValues.title2 = value;
    redrawFront();
    redrawBack();
}

export const changeTitle2 = (value) => {
    canvasValues.title2 = value;
    if (backTitle2Text == null) {
        return;
    }

    backTitle2Text.text(value);
    backDataLayer.batchDraw();
}

export const changeTitle2P1T7 = (value) => {
    canvasValues.title2 = value;
    redrawFront();
    redrawBack();
}

export const changeTitle3All = (value) => {
    canvasValues.title3 = value;
    redrawFront();
    redrawBack();
}

export const changeTitle3 = (value) => {
    canvasValues.title3 = value;
    if (backTitle3Text == null) {
        return;
    }

    backTitle3Text.text(value);
    backDataLayer.batchDraw();
}

export const changeTitle3P1T7 = (value) => {
    canvasValues.title3 = value;
    redrawFront();
    redrawBack();
}

export const changeDepartment1All = (value) => {
    canvasValues.department1 = value;
    redrawFront();
    redrawBack();
}

export const changeDepartment1 = (value) => {
    canvasValues.department1 = value;
    if (frontDepartment1Text == null) {
        return;
    }

    frontDepartment1Text.text(value);
    frontDataLayer.batchDraw();
}

export const changeDepartment1P1T4 = (value) => {
    canvasValues.department1 = value;
    redrawFront();
    redrawBack();
}

export const changeDepartment1P1T7 = (value) => {
    canvasValues.department1 = value;
    redrawFront();
    redrawBack();
}

export const changeDepartment2All = (value) => {
    canvasValues.department2 = value;
    redrawFront();
    redrawBack();
}

export const changeDepartment2 = (value) => {
    canvasValues.department2 = value;
    if (frontDepartment2Text == null) {
        return;
    }

    frontDepartment2Text.text(value);
    frontDataLayer.batchDraw();
}

export const changeDepartment2P1T4 = (value) => {
    canvasValues.department2 = value;
    redrawFront();
    redrawBack();
}

export const changeDepartment2P1T7 = (value) => {
    canvasValues.department2 = value;
    redrawFront();
    redrawBack();
}

export const changeDepartment3All = (value) => {
    canvasValues.department3 = value;
    redrawFront();
    redrawBack();
}

export const changeDepartment3P1T5 = (value) => {
    canvasValues.department3 = value;
    redrawFront();
    redrawBack();
}

export const changeDepartment3P1T7 = (value) => {
    canvasValues.department3 = value;
    redrawFront();
    redrawBack();
}

export const changePhoneAll = (value) => {
    canvasValues.phone = value;
    redrawFront();
    redrawBack();
}

export const changePhone = (value) => {
    canvasValues.phone = value;
    if (frontPhoneText == null || backPhoneText == null) {
        return;
    }

    let phone = '';
    if (value !== '') {
        phone = value + '   Direct';
    }

    frontPhoneText.text(value);
    backPhoneText.text(phone);
    frontDataLayer.batchDraw();
    backDataLayer.batchDraw();
}

export const changePhoneP1T3 = (value) => {
    canvasValues.phone = value;
    if (frontPhoneText == null || frontPhoneType == null) {
        return;
    }

    if (value === '') {
        frontPhoneType.text('');
    } else {
        frontPhoneType.text('main');
    }

    frontPhoneText.text(value);
    frontDataLayer.batchDraw();
}

export const changePhoneP1T4 = (value) => {
    canvasValues.phone = value;
    redrawFront();
    redrawBack();
}

export const changePhoneP1T7 = (value) => {
    canvasValues.phone = value;
    redrawFront();
    redrawBack();
}

export const changeClinicAll = (value) => {
    canvasValues.clinic = value;
    redrawFront();
    redrawBack();
}

export const changeClinic = (value) => {
    canvasValues.clinic = value;
    if (backClinicText == null) {
        return;
    }

    let clinic = '';
    if (value !== '') {
        clinic = value + '   Clinic';
    }

    backClinicText.text(clinic);
    backDataLayer.batchDraw();
}

export const changeClinicP1T3 = (value) => {
    canvasValues.clinic = value;
    if (frontClinicText == null) {
        return;
    }

    if (value === '') {
        frontClinicType.text('');
    } else {
        frontClinicType.text('direct');
    }

    frontClinicText.text(value);
    frontDataLayer.batchDraw();
}

export const changeClinicP1T4 = (value) => {
    canvasValues.clinic = value;
    redrawFront();
    redrawBack();
}

export const changeClinicP1T7 = (value) => {
    canvasValues.clinic = value;
    redrawFront();
    redrawBack();
}

export const changeFaxAll = (value) => {
    canvasValues.fax = value;
    redrawFront();
    redrawBack();
}

export const changeFax = (value) => {
    canvasValues.fax = value;
    if (backFaxText == null) {
        return;
    }

    let fax = '';
    if (value !== '') {
        fax = value + '   Fax';
    }

    backFaxText.text(fax);
    backDataLayer.batchDraw();

    changeOpen1(canvasValues.open1);
    changeOpen2(canvasValues.open2);
    changeOpen3(canvasValues.open3);

    if (canvasValues.templateCode === 'p1t2') {
        changeCell(canvasValues.cell);
    }
}

export const changeFaxP1T3 = (value) => {
    canvasValues.fax = value;
    if (frontDataLayer === null) {
        return;
    }

    if (frontFaxText) {
        frontFaxText.destroy();
    }
    if (frontFaxType) {
        frontFaxType.destroy();
    }

    if (!isEmpty(canvasValues.fax)) {
        frontFaxText = new Konva.Text({
            text: canvasValues.fax,
            fontSize: convertPointsToPixels(8.5) * scale,
            fontFamily: 'AGaramondProRegular',
            x: (245 - 12.5) * scale,
            y: (161 - 12.5) * scale,
            fill: '#BE531C',
        });
        frontDataLayer.add(frontFaxText);

        frontFaxType = new Konva.Text({
            text: 'fax',
            fontSize: convertPointsToPixels(8.5) * scale,
            fontFamily: 'AGaramondProItalic',
            x: (320 - 12.5) * scale,
            y: (161 - 12.5) * scale,
            fill: '#BE531C',
        });
        frontDataLayer.add(frontFaxType);
    }

    frontDataLayer.batchDraw();
}

export const changeFaxP1T4 = (value) => {
    canvasValues.fax = value;
    redrawFront();
    redrawBack();
}

export const changeFaxP1T7 = (value) => {
    canvasValues.fax = value;
    redrawFront();
    redrawBack();
}

export const changeNursePhoneAll = (value) => {
    canvasValues.nursePhone = value;
    redrawFront();
    redrawBack();
}

export const changeFontTypeAll = (value) => {
    canvasValues.fontType = value;
    redrawFront();
    redrawBack();
}

export const changePagerAll = (value) => {
    canvasValues.pager = value;
    redrawFront();
    redrawBack();
}

export const changePager = (value) => {
    canvasValues.pager = value;
    if (backPagerText == null) {
        return;
    }

    let pager = '';
    if (value !== '') {
        pager = value + '   Pager';
    }

    backPagerText.text(pager);
    backDataLayer.batchDraw();

    changeOpen1(canvasValues.open1);
    changeOpen2(canvasValues.open2);
    changeOpen3(canvasValues.open3);
}

export const changeCellAll = (value) => {
    canvasValues.cell = value;
    redrawFront();
    redrawBack();
}

export const changeCell = (value) => {
    canvasValues.cell = value;
    if (parseInt(canvasValues.showCell) !== 1 && frontCellText == null) {
        return;
    }
    if (parseInt(canvasValues.showCell) !== 2 && backCellText == null) {
        return;
    }

    let cell = '';
    if (value !== '') {
        cell = value + '   Cell';
    }

    let frontY = 183;
    if (canvasValues.templateCode === 'p1t2' && parseInt(canvasValues.showEmail) === 1) {
        frontY -= 12;
    }

    let backY = 158;
    if (canvasValues.templateCode === 'p1t2' && canvasValues.fax === '') {
        backY -= 16;
    }

    if (frontCellText != null) {
        frontCellText.y((frontY - 12.5) * scale);
        if (parseInt(canvasValues.showCell) !== 1) {
            frontCellText.text(cell);
        } else {
            frontCellText.text('');
        }
    }

    if (backCellText != null) {
        backCellText.y((backY - 12.5) * scale);
        if (parseInt(canvasValues.showCell) !== 2) {
            backCellText.text(cell);
        } else {
            backCellText.text('');
        }
    }

    backDataLayer.batchDraw();
    frontDataLayer.batchDraw();

    changeOpen1(canvasValues.open1);
    changeOpen2(canvasValues.open2);
}

export const changeCellP1T7 = (value) => {
    canvasValues.cell = value;
    redrawFront();
    redrawBack();
}

export const changeAddressAll = (value) => {
    canvasValues.address = value;
    redrawFront();
    redrawBack();
}

export const changeAddress = (value) => {
    canvasValues.address = value;
    if (frontAddress1Text == null) {
        return;
    }

    frontAddress1Text.text(value);
    frontDataLayer.batchDraw();
}

export const changeAddressP1T4 = (value) => {
    canvasValues.address = value;
    redrawFront();
    redrawBack();
}

export const changeAddressP1T7 = (value) => {
    canvasValues.address = value;
    redrawFront();
    redrawBack();
}

export const changeAddress2All = (value) => {
    canvasValues.address2 = value;
    redrawFront();
    redrawBack();
}

export const changeAddress2P1T4 = (value) => {
    canvasValues.address2 = value;
    redrawFront();
    redrawBack();
}

export const changeAddress3P1T4 = (value) => {
    canvasValues.address3 = value;
    redrawFront();
    redrawBack();
}

export const changeCityAll = (value) => {
    canvasValues.city = value;
    redrawFront();
    redrawBack();
}

export const changeCity = (value) => {
    canvasValues.city = value;
    if (frontLocationText == null) {
        return;
    }

    frontLocationText.text(canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip);
    frontDataLayer.batchDraw();
}

export const changeCityP1T4 = (value) => {
    canvasValues.city = value;
    redrawFront();
    redrawBack();
}

export const changeCityP1T7 = (value) => {
    canvasValues.city = value;
    redrawFront();
    redrawBack();
}

export const changeStateAll = (value) => {
    canvasValues.state = value;
    redrawFront();
    redrawBack();
}

export const changeState = (value) => {
    canvasValues.state = value;
    if (frontLocationText == null) {
        return;
    }

    frontLocationText.text(canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip);
    frontDataLayer.batchDraw();
}

export const changeStateP1T4 = (value) => {
    canvasValues.state = value;
    redrawFront();
    redrawBack();
}

export const changeStateP1T7 = (value) => {
    canvasValues.state = value;
    redrawFront();
    redrawBack();
}

export const changeZipAll = (value) => {
    canvasValues.zip = value;
    redrawFront();
    redrawBack();
}

export const changeAdditionalFieldAll = (value) => {
    canvasValues.additionalField = value;
    redrawFront();
    redrawBack();
}

export const changeZip = (value) => {
    canvasValues.zip = value;
    if (frontLocationText == null) {
        return;
    }

    frontLocationText.text(canvasValues.city + ', ' + canvasValues.state + ' ' + canvasValues.zip);
    frontDataLayer.batchDraw();
}

export const changeZipP1T4 = (value) => {
    canvasValues.zip = value;
    redrawFront();
    redrawBack();
}

export const changeZipP1T7 = (value) => {
    canvasValues.zip = value;
    redrawFront();
    redrawBack();
}

export const changeEmailAll = (value) => {
    canvasValues.email = value;
    redrawFront();
    redrawBack();
}

export const changeEmail = (value) => {
    canvasValues.email = value;
    if (parseInt(canvasValues.showEmail) !== 1 || frontEmailText == null) {
        return;
    }
    if (backEmailText == null) {
        return;
    }

    if (parseInt(canvasValues.showEmail) !== 1) {
        frontEmailText.text(value);
    } else {
        frontEmailText.text('');
    }

    if (parseInt(canvasValues.showEmail) !== 2) {
        backEmailText.text(value);
    } else {
        backEmailText.text('');
    }

    frontDataLayer.batchDraw();
    backDataLayer.batchDraw();
}

export const changeEmailP1T3 = (value) => {
    canvasValues.email = value;
    if (frontEmailText == null) {
        return;
    }

    frontEmailText.text(value);
    frontDataLayer.batchDraw();
}

export const changeEmailP1T7 = (value) => {
    canvasValues.email = value;
    redrawFront();
    redrawBack();
}

export const changeOpen1All = (value) => {
    canvasValues.open1 = value;
    redrawFront();
    redrawBack();
}

export const changeOpen1 = (value) => {
    canvasValues.open1 = value;
    if (backOpen1Text == null) {
        return;
    }

    let y = canvasValues.templateCode === 'p1t1' ? 158 : 174;
    if (canvasValues.templateCode === 'p1t1' && canvasValues.fax === '' && canvasValues.pager === '') {
        y -= 16;
    } else if (canvasValues.templateCode === 'p1t2' && canvasValues.fax === '') {
        y -= 16;
    }

    if (canvasValues.templateCode === 'p1t2' && parseInt(canvasValues.showCell) === 2) {
        y -= 16;
    }
    if (canvasValues.templateCode === 'p1t2' && canvasValues.cell === '') {
        y -= 16;
    }

    backOpen1Text.y((y - 12.5) * scale);
    backOpen1Text.text(value);
    backDataLayer.batchDraw();

    changeOpen2(canvasValues.open2);
    changeOpen3(canvasValues.open3);
}

export const changeOpen1P1T3 = (value) => {
    canvasValues.open1 = value;
    if (frontOpen1Text == null) {
        return;
    }

    frontOpen1Text.text(value);
    frontDataLayer.batchDraw();
}

export const changeOpen1P1T7 = (value) => {
    canvasValues.open1 = value;
    redrawFront();
    redrawBack();
}

export const changeOpen2All = (value) => {
    canvasValues.open2 = value;
    redrawFront();
    redrawBack();
}

export const changeOpen2 = (value) => {
    canvasValues.open2 = value;
    if (backOpen2Text == null) {
        return;
    }

    let y = canvasValues.templateCode === 'p1t1' ? 174 : 190;
    if (canvasValues.templateCode === 'p1t1' && canvasValues.fax === '' && canvasValues.pager === '') {
        y -= 16;
    } else if (canvasValues.templateCode === 'p1t2' && canvasValues.fax === '') {
        y -= 16;
    }

    if (canvasValues.templateCode === 'p1t2' && parseInt(canvasValues.showCell) === 2) {
        y -= 16;
    }
    if (canvasValues.templateCode === 'p1t2' && canvasValues.cell === '') {
        y -= 16;
    }
    if (canvasValues.open1 === '') {
        y -= 16;
    }

    backOpen2Text.y((y - 12.5) * scale);
    backOpen2Text.text(value);
    backDataLayer.batchDraw();

    changeOpen3(canvasValues.open3);
}

export const changeOpen2P1T7 = (value) => {
    canvasValues.open2 = value;
    redrawFront();
    redrawBack();
}

export const changeOpen3All = (value) => {
    canvasValues.open3 = value;
    redrawFront();
    redrawBack();
}

export const changeOpen3 = (value) => {
    canvasValues.open3 = value;
    if (backOpen3Text == null) {
        return;
    }

    let y = canvasValues.templateCode === 'p1t1' ? 190 : 206;
    if (canvasValues.templateCode === 'p1t1' && canvasValues.fax === '' && canvasValues.pager === '') {
        y -= 16;
    } else if (canvasValues.templateCode === 'p1t2' && canvasValues.fax === '') {
        y -= 16;
    }

    if (canvasValues.templateCode === 'p1t2' && parseInt(canvasValues.showCell) === 2) {
        y -= 16;
    }
    if (canvasValues.templateCode === 'p1t2' && canvasValues.cell === '') {
        y -= 16;
    }
    if (canvasValues.open1 === '') {
        y -= 16;
    }
    if (canvasValues.open2 === '') {
        y -= 16;
    }

    backOpen3Text.y((y - 12.5) * scale);
    backOpen3Text.text(value);
    backDataLayer.batchDraw();
}

export const changeShowEmail = (value) => {
    canvasValues.showEmail = parseInt(value);
    changeEmail(canvasValues.email);
    changeCell(canvasValues.cell);
}

export const changeShowEmailP1T7 = (value) => {
    canvasValues.showEmail = value;
    redrawFront();
    redrawBack();
}

export const changeShowCell = (value) => {
    canvasValues.showCell = parseInt(value);
    changeCell(canvasValues.cell);
}

export const getCanvasValues = () => {
    return canvasValues;
}

export const convertPointsToPixels = (points) => {
    return points * 4 / 3 + 0.5;
}

export const getCanvasFrontDataUrl = (ratio = 1) => {
    if (frontStage == null) {
        return null;
    }

    return frontStage.toDataURL({ pixelRatio: ratio });
}

export const getCanvasBackDataUrl = (ratio = 1) => {
    if (backStage == null) {
        return null;
    }

    return backStage.toDataURL({ pixelRatio: ratio });
}

export const getFullName = () => {
    let fullName = canvasValues.name;
    if (canvasValues.credentials !== '') {
        fullName += ', ' + canvasValues.credentials;
    }
    return fullName;
}

export const changeLocationNamesAll = (value) => {
    canvasValues.locationNames = value;
    redrawFront();
    redrawBack();
}

export const changeLocationNamesP1T5 = (value) => {
    canvasValues.locationNames = value;
    redrawFront();
    redrawBack();
}

export const changeLocationNamesP1T6 = (value) => {
    canvasValues.locationNames = value;
    redrawFront();
    redrawBack();
}

export const changeLocationPhonesAll = (value) => {
    canvasValues.locationPhones = value;
    redrawFront();
    redrawBack();
}

export const changeLocationPhonesP1T5 = (value) => {
    canvasValues.locationPhones = value;
    redrawFront();
    redrawBack();
}

export const changeLocationPhonesP1T6 = (value) => {
    canvasValues.locationPhones = value;
    redrawFront();
    redrawBack();
}

export const changeLocationFaxesAll = (value) => {
    canvasValues.locationFaxes = value;
    redrawFront();
    redrawBack();
}

export const changeLocationNursePhonesAll = (value) => {
    canvasValues.locationNursePhones = value;
    redrawFront();
    redrawBack();
}

export const changeLocationFaxesP1T5 = (value) => {
    canvasValues.locationFaxes = value;
    redrawFront();
    redrawBack();
}

export const changeLocationFaxesP1T6 = (value) => {
    canvasValues.locationFaxes = value;
    redrawFront();
    redrawBack();
}

export const changeLocationAddresses1All = (value) => {
    canvasValues.locationAddresses1 = value;
    redrawFront();
    redrawBack();
}

export const changeLocationAddresses1P1T5 = (value) => {
    canvasValues.locationAddresses1 = value;
    redrawFront();
    redrawBack();
}

export const changeLocationAddresses1P1T6 = (value) => {
    canvasValues.locationAddresses1 = value;
    redrawFront();
    redrawBack();
}

export const changeLocationAddresses2All = (value) => {
    canvasValues.locationAddresses2 = value;
    redrawFront();
    redrawBack();
}

export const changeLocationAddresses2P1T5 = (value) => {
    canvasValues.locationAddresses2 = value;
    redrawFront();
    redrawBack();
}

export const changeLocationAddresses2P1T6 = (value) => {
    canvasValues.locationAddresses2 = value;
    redrawFront();
    redrawBack();
}

export const changeLocationAddresses3All = (value) => {
    canvasValues.locationAddresses3 = value;
    redrawFront();
    redrawBack();
}

export const changeLocationCitiesAll = (value) => {
    canvasValues.locationCities = value;
    redrawFront();
    redrawBack();
}

export const changeLocationStatesAll = (value) => {
    canvasValues.locationStates = value;
    redrawFront();
    redrawBack();
}

export const changeLocationZipsAll = (value) => {
    canvasValues.locationZips = value;
    redrawFront();
    redrawBack();
}

export const changeLocationSuitesAll = (value) => {
    canvasValues.locationSuites = value;
    redrawFront();
    redrawBack();
}

export const changeLocationAddresses3P1T5 = (value) => {
    canvasValues.locationAddresses3 = value;
    redrawFront();
    redrawBack();
}

export const changeFrontAll = (value) => {
    canvasValues.front = value;
    redrawFront();
    redrawBack();
}

export const changeBackAll = (value) => {
    canvasValues.back = value;
    redrawFront();
    redrawBack();
}

export const changePrevFrontAll = (value) => {
    canvasValues.prevFront = value;
    redrawFront();
    redrawBack();
}

export const changePrevBackAll = (value) => {
    canvasValues.prevBack = value;
    redrawFront();
    redrawBack();
}

export const changePrevLogoAll = (value) => {
    canvasValues.prevLogo = value;
    redrawFront();
    redrawBack();
}

export const changeSuiteRoomAll = (value) => {
    canvasValues.suiteRoom = value;
    redrawFront();
    redrawBack();
}

export const changeFirstNameAll = (value) => {
    canvasValues.firstName = value;
    redrawFront();
    redrawBack();
}

export const changeMiddleNameAll = (value) => {
    canvasValues.middleName = value;
    redrawFront();
    redrawBack();
}

export const changeLastNameAll = (value) => {
    canvasValues.lastName = value;
    redrawFront();
    redrawBack();
}

export const changePrimaryTitleAll = (value) => {
    canvasValues.primaryTitle = value;
    redrawFront();
    redrawBack();
}

export const changeSecondaryTitleAll = (value) => {
    canvasValues.secondaryTitle = value;
    redrawFront();
    redrawBack();
}

export const changeTitle4All = (value) => {
    canvasValues.title4 = value;
    redrawFront();
    redrawBack();
}

export const changeMainAll = (value) => {
    canvasValues.main = value;
    redrawFront();
    redrawBack();
}

export const changeDirectAll = (value) => {
    canvasValues.direct = value;
    redrawFront();
    redrawBack();
}

export const changeWebsiteAll = (value) => {
    canvasValues.website = value;
    redrawFront();
    redrawBack();
}

export const changeShowSocialMediaIconsAll = (value) => {
    canvasValues.showSocialMediaIcons = value;
    redrawFront();
    redrawBack();
}

export const getStateAddress = (index) => {
    let stateAddress1 = [];

    if (!isEmpty(canvasValues.locationCities[index])) {
        stateAddress1.push(canvasValues.locationCities[index]);
    }

    let stateAddress2 = [];
    if (!isEmpty(canvasValues.locationStates[index])) {
        stateAddress2.push(canvasValues.locationStates[index]);
    }
    if (!isEmpty(canvasValues.locationZips[index])) {
        stateAddress2.push(canvasValues.locationZips[index]);
    }

    if (stateAddress2.length > 0) {
        stateAddress1.push(stateAddress2.join(' '));
    }

    if (stateAddress1.length === 0) {
        return '';
    }

    return stateAddress1.join(', ');
}

export const changeLocationCitiesP1T5 = (value) => {
    canvasValues.locationCities = value;
    redrawFront();
    redrawBack();
}

export const changeLocationCitiesP1T6 = (value) => {
    canvasValues.locationCities = value;
    redrawFront();
    redrawBack();
}

export const changeLocationStatesP1T5 = (value) => {
    canvasValues.locationStates = value;
    redrawFront();
    redrawBack();
}

export const changeLocationStatesP1T6 = (value) => {
    canvasValues.locationStates = value;
    redrawFront();
    redrawBack();
}

export const changeLocationZipsP1T5 = (value) => {
    canvasValues.locationZips = value;
    redrawFront();
    redrawBack();
}

export const changeLocationZipsP1T6 = (value) => {
    canvasValues.locationZips = value;
    redrawFront();
    redrawBack();
}

export const changeTitlesAll = (value) => {
    canvasValues.titles = value;
    redrawFront();
    redrawBack();
}

export const changePersonsNamesAll = (value) => {
    canvasValues.personsNames = value;
    redrawFront();
    redrawBack();
}

export const changePersonsTitlesAll = (value) => {
    canvasValues.personsTitles = value;
    redrawFront();
    redrawBack();
}

export const changeColorAll = (value) => {
    canvasValues.color = value;
    redrawFront();
    redrawBack();
}

export const changeContact1PhoneAll = (value) => {
    canvasValues.contact1Phone = value;
    redrawFront();
    redrawBack();
}

export const changeContact1TypeAll = (value) => {
    canvasValues.contact1Type = value;
    redrawFront();
    redrawBack();
}

export const changeContact2PhoneAll = (value) => {
    canvasValues.contact2Phone = value;
    redrawFront();
    redrawBack();
}

export const changeContact2TypeAll = (value) => {
    canvasValues.contact2Type = value;
    redrawFront();
    redrawBack();
}

export const changeLocationsAll = (value) => {
    canvasValues.locations = value;
    redrawFront();
    redrawBack();
}

export const changeLetterheadPersonsAll = (value) => {
    canvasValues.letterheadPersons = value;
    redrawFront();
    redrawBack();
}

export const changePrescriptionPadDoctorsAll = (value) => {
    canvasValues.prescriptionPadDoctors = value;
    redrawFront();
    redrawBack();
}

export const changePhoneLabel1All = (value) => {
    canvasValues.phoneLabel1 = value;
    redrawFront();
    redrawBack();
}

export const changePhoneLabel2All = (value) => {
    canvasValues.phoneLabel2 = value;
    redrawFront();
    redrawBack();
}

export const changePhoneLabel3All = (value) => {
    canvasValues.phoneLabel3 = value;
    redrawFront();
    redrawBack();
}

export const changePhoneOtherLabel1All = (value) => {
    canvasValues.phoneOtherLabel1 = value;
    redrawFront();
    redrawBack();
}

export const changePhoneOtherLabel2All = (value) => {
    canvasValues.phoneOtherLabel2 = value;
    redrawFront();
    redrawBack();
}

export const changePhoneOtherLabel3All = (value) => {
    canvasValues.phoneOtherLabel3 = value;
    redrawFront();
    redrawBack();
}

export const setUser = (value) => {
    canvasValues.user = value;
}

export const redrawFront = () => {
    if (frontDataLayer == null) {
        return;
    }

    if (canvasValues.templateCode === 'p1t4') {
        destroyFrontVariablesP1T4();
        drawFrontVariablesP1T4();
    } if (canvasValues.templateCode === 'p1t5') {
        destroyFrontVariablesP1T5();
        drawFrontVariablesP1T5();
    } else if (canvasValues.templateCode === 'p1t6') {
        destroyFrontVariablesP1T6();
        drawFrontVariablesP1T6();
    } else if (canvasValues.templateCode === 'p1t7') {
        destroyFrontVariablesP1T7();
        drawFrontVariablesP1T7();
    } else if (canvasValues.templateCode === 'p1t8') {
        destroyFrontVariablesP1T8();
        drawFrontVariablesP1T8();
    } else if (canvasValues.templateCode === 'p1t9') {
        destroyFrontVariablesP1T9();
        drawFrontVariablesP1T9();
    } else if (canvasValues.templateCode === 'p1t11') {
        destroyFrontVariablesP1T11();
        drawFrontVariablesP1T11();
    } else if (canvasValues.templateCode === 'p1t13') {
        destroyFrontVariablesP1T13();
        drawFrontVariablesP1T13();
    } else if (canvasValues.templateCode === 'p1t14') {
        destroyFrontVariablesP1T14();
        drawFrontVariablesP1T14();
    } else if (canvasValues.templateCode === 'p1t16') {
        destroyFrontVariablesP1T16();
        drawFrontVariablesP1T16();
    } else if (canvasValues.templateCode === 'p1t15') {
        destroyFrontVariablesP1T15();
        drawFrontVariablesP1T15();
    } else if (canvasValues.templateCode === 'p2t1') {
        destroyFrontVariablesP2T1();
        drawFrontVariablesP2T1();
    } else if (canvasValues.templateCode === 'p2t3') {
        destroyFrontVariablesP2T3();
        drawFrontVariablesP2T3();
    } else if (canvasValues.templateCode === 'p3t1') {
        destroyFrontVariablesP3T1();
        drawFrontVariablesP3T1();
    } else if (canvasValues.templateCode === 'p3t2') {
        destroyFrontVariablesP3T2();
        drawFrontVariablesP3T2();
    } else if (canvasValues.templateCode === 'p3t3') {
        destroyFrontVariablesP3T3();
        drawFrontVariablesP3T3();
    } else if (canvasValues.templateCode === 'p3t4') {
        destroyFrontVariablesP3T4();
        drawFrontVariablesP3T4();
    } else if (canvasValues.templateCode === 'p3t5') {
        destroyFrontVariablesP3T5();
        drawFrontVariablesP3T5();
    } else if (canvasValues.templateCode === 'p3t6') {
        destroyFrontVariablesP3T6();
        drawFrontVariablesP3T6();
    } else if (canvasValues.templateCode === 'p4t1') {
        destroyFrontVariablesP4T1();
        drawFrontVariablesP4T1();
    } else if (['p9t1', 'p9t2', 'p9t3', 'p9t4', 'p9t5', 'p9t6', 'p9t7', 'p9t8', 'p9t9', 'p9t10'].includes(canvasValues.templateCode)) {
        destroyFrontVariablesP9();
        drawFrontVariablesP9();
    } else if (canvasValues.templateCode === 'p9t11') {
        destroyFrontVariablesP9T11();
        drawFrontVariablesP9T11();
    } else if (canvasValues.templateCode === 'p9t12') {
        destroyFrontVariablesP9T12();
        drawFrontVariablesP9T12();
    } else if (canvasValues.templateCode === 'p9t13') {
        destroyFrontVariablesP9T13();
        drawFrontVariablesP9T13();
    } else if (canvasValues.templateCode === 'p9t14') {
        destroyFrontVariablesP9T14();
        drawFrontVariablesP9T14();
    } else if (canvasValues.templateCode === 'p9t15') {
        destroyFrontVariablesP9T15();
        drawFrontVariablesP9T15();
    } else if (canvasValues.templateCode === 'p9t16') {
        destroyFrontVariablesP9T16();
        drawFrontVariablesP9T16();
    } else if (canvasValues.templateCode === 'p9t17') {
        destroyFrontVariablesP9T17();
        drawFrontVariablesP9T17();
    } else if (canvasValues.templateCode === 'p9t18') {
        destroyFrontVariablesP9T18();
        drawFrontVariablesP9T18();
    } else if (canvasValues.templateCode === 'p9t19') {
        destroyFrontVariablesP9T19();
        drawFrontVariablesP9T19();
    } else if (canvasValues.templateCode === 'p9t20') {
        destroyFrontVariablesP9T20();
        drawFrontVariablesP9T20();
    } else if (canvasValues.templateCode === 'p9t21') {
        destroyFrontVariablesP9T21();
        drawFrontVariablesP9T21();
    } else if (canvasValues.templateCode === 'p9t22') {
        destroyFrontVariablesP9T22();
        drawFrontVariablesP9T22();
    } else if (canvasValues.templateCode === 'p9t23') {
        destroyFrontVariablesP9T23();
        drawFrontVariablesP9T23();
    } else if (['p10t1', 'p10t2', 'p10t4', 'p10t5', 'p10t6', 'p10t7'].includes(canvasValues.templateCode)) {
        destroyFrontVariablesP10();
        drawFrontVariablesP10();
    } else if (canvasValues.templateCode === 'p10t8') {
        destroyFrontVariablesP10T8();
        drawFrontVariablesP10T8();
    } else if (canvasValues.templateCode === 'p10t9') {
        destroyFrontVariablesP10T9();
        drawFrontVariablesP10T9();
    } else if (canvasValues.templateCode === 'p10t10') {
        destroyFrontVariablesP10T10();
        drawFrontVariablesP10T10();
    } else if (['p10t3'].includes(canvasValues.templateCode)) {
        destroyFrontVariablesP10T3();
        drawFrontVariablesP10T3();
    } else if (['p11t1', 'p11t2', 'p11t3', 'p11t4', 'p11t5', 'p11t6', 'p11t7'].includes(canvasValues.templateCode)) {
        destroyFrontVariablesP11No10();
        drawFrontVariablesP11No10();
    } else if (['p11t22'].includes(canvasValues.templateCode)) {
        destroyFrontVariablesP11T22();
        drawFrontVariablesP11T22();
    } else if (['p11t23'].includes(canvasValues.templateCode)) {
        destroyFrontVariablesP11T23();
        drawFrontVariablesP11T23();
    } else if (['p11t24'].includes(canvasValues.templateCode)) {
        destroyFrontVariablesP11T24();
        drawFrontVariablesP11T24();
    } else if (['p11t25'].includes(canvasValues.templateCode)) {
        destroyFrontVariablesP11T25();
        drawFrontVariablesP11T25();
    } else if (['p11t8', 'p11t9', 'p11t10', 'p11t11', 'p11t12', 'p11t13', 'p11t14'].includes(canvasValues.templateCode)) {
        destroyFrontVariablesP11A10();
        drawFrontVariablesP11A10();
    } else if (['p11t15', 'p11t16', 'p11t17', 'p11t18', 'p11t19', 'p11t20', 'p11t21'].includes(canvasValues.templateCode)) {
        destroyFrontVariablesP11A6();
        drawFrontVariablesP11A6();
    } else if (['p12t7'].includes(canvasValues.templateCode)) {
        destroyFrontVariablesP12T7();
        drawFrontVariablesP12T7();
    } else if (['p12t8'].includes(canvasValues.templateCode)) {
        destroyFrontVariablesP12T8();
        drawFrontVariablesP12T8();
    } else if (['p12t9'].includes(canvasValues.templateCode)) {
        destroyFrontVariablesP12T9();
        drawFrontVariablesP12T9();
    } else if (['p12t10'].includes(canvasValues.templateCode)) {
        destroyFrontVariablesP12T10();
        drawFrontVariablesP12T10();
    } else if (['p18t2'].includes(canvasValues.templateCode)) {
        destroyFrontVariablesP18T2();
        drawFrontVariablesP18T2();
    } else if (['p18t3'].includes(canvasValues.templateCode)) {
        destroyFrontVariablesP18T3();
        drawFrontVariablesP18T3();
    } else if (['p20t1', 'p20t2', 'p20t3', 'p20t4', 'p20t5', 'p20t6'].includes(canvasValues.templateCode)) {
        destroyFrontVariablesP20();
        drawFrontVariablesP20();
    } else if (canvasValues.templateCode === 'p20t7') {
        destroyFrontVariablesP20T7();
        drawFrontVariablesP20T7();
    } else if (canvasValues.templateCode === 'p20t8') {
        destroyFrontVariablesP20T8();
        drawFrontVariablesP20T8();
    } else if (canvasValues.templateCode === 'p20t9') {
        destroyFrontVariablesP20T9();
        drawFrontVariablesP20T9();
    } else if (canvasValues.templateCode === 'p21t1') {
        destroyFrontVariablesP21T1();
        drawFrontVariablesP21T1();
    } else if (canvasValues.templateCode === 'p21t2') {
        destroyFrontVariablesP21T2();
        drawFrontVariablesP21T2();
    }

    frontDataLayer.batchDraw();
}

export const redrawBack = () => {
    if (backDataLayer == null) {
        return;
    }

    if (canvasValues.templateCode === 'p1t5') {
        destroyBackVariablesP1T5();
        drawBackVariablesP1T5();
    } else if (canvasValues.templateCode === 'p1t7') {
        destroyBackVariablesP1T7();
        drawBackVariablesP1T7();
    } else if (canvasValues.templateCode === 'p1t9') {
        destroyBackVariablesP1T9();
        drawBackVariablesP1T9();
    } else if (canvasValues.templateCode === 'p1t13') {
        destroyBackVariablesP1T13();
        drawBackVariablesP1T13();
    } else if (canvasValues.templateCode === 'p1t16') {
        destroyBackVariablesP1T16();
        drawBackVariablesP1T16();
    } else if (['p9t1', 'p9t2', 'p9t3', 'p9t4', 'p9t5', 'p9t6', 'p9t7', 'p9t8', 'p9t9', 'p9t10'].includes(canvasValues.templateCode)) {
        destroyBackVariablesP9();
        drawBackVariablesP9();
    } else if (canvasValues.templateCode === 'p9t11') {
        destroyBackVariablesP9T11();
        drawBackVariablesP9T11();
    } else if (canvasValues.templateCode === 'p9t12') {
        destroyBackVariablesP9T12();
        drawBackVariablesP9T12();
    } else if (canvasValues.templateCode === 'p9t13') {
        destroyBackVariablesP9T13();
        drawBackVariablesP9T13();
    } else if (canvasValues.templateCode === 'p9t14') {
        destroyBackVariablesP9T14();
        drawBackVariablesP9T14();
    } else if (canvasValues.templateCode === 'p9t15') {
        destroyBackVariablesP9T15();
        drawBackVariablesP9T15();
    } else if (canvasValues.templateCode === 'p9t16') {
        destroyBackVariablesP9T16();
        drawBackVariablesP9T16();
    } else if (canvasValues.templateCode === 'p9t17') {
        destroyBackVariablesP9T17();
        drawBackVariablesP9T17();
    } else if (canvasValues.templateCode === 'p9t18') {
        destroyBackVariablesP9T18();
        drawBackVariablesP9T18();
    } else if (canvasValues.templateCode === 'p9t19') {
        destroyBackVariablesP9T19();
        drawBackVariablesP9T19();
    } else if (canvasValues.templateCode === 'p9t20') {
        destroyBackVariablesP9T20();
        drawBackVariablesP9T20();
    } else if (canvasValues.templateCode === 'p9t21') {
        destroyBackVariablesP9T21();
        drawBackVariablesP9T21();
    } else if (canvasValues.templateCode === 'p9t22') {
        destroyBackVariablesP9T22();
        drawBackVariablesP9T22();
    } else if (canvasValues.templateCode === 'p9t23') {
        destroyBackVariablesP9T23();
        drawBackVariablesP9T23();
    }

    backDataLayer.batchDraw();
}

export const isEmpty = (element) => {
    if (typeof element == 'undefined' || !element || element === '') {
        return true;
    }
    return false;
}

export const cleanCanvas = () => {
    if (frontLogo1Img != null) {
        frontLogo1Img.destroy();
    }
    if (frontLogo2Img != null) {
        frontLogo2Img.destroy();
    }
    if (frontStage != null) {
        frontStage.destroy();
        frontStage.batchDraw();
    }
    if (backStage != null) {
        backStage.destroy();
        backStage.batchDraw();
    }
    if (frontBackgroundLayer != null) {
        frontBackgroundLayer.destroy();
        frontBackgroundLayer.batchDraw();
    }
    if (frontDataLayer != null) {
        frontDataLayer.destroy();
        frontDataLayer.batchDraw();
    }
    if (backBackgroundLayer != null) {
        backBackgroundLayer.destroy();
        backBackgroundLayer.batchDraw();
    }
    if (backDataLayer != null) {
        backDataLayer.destroy();
        backDataLayer.batchDraw();
    }
}

export const createText = (fontFamily, fontSize, text, x, y, color = '#000', letterSpacing = null) => {
    return new Konva.Text({
        text: text,
        fontSize: convertPointsToPixels(fontSize) * scale,
        fontFamily: fontFamily,
        x: x * scale,
        y: y * scale,
        fill: color,
        letterSpacing: letterSpacing * scale,
    });
}